/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: Date; output: Date; }
  /** The `Decimal` scalar type represents signed unlimited-precision fractional values. */
  Decimal: { input: string; output: string; }
  /** The `Int64` scalar type represents non-fractional signed whole numeric values. Int can represent values between -2^63 and 2^63 - 1. */
  Int64: { input: number; output: number; }
  /** The `JSON` scalar type represents arbitrary JSON values. */
  JSON: { input: string; output: string; }
};

export type AcceptBillPayInput = {
  alternativePaymentOptions: Array<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  minimumDiscountPercent: Scalars['Int']['input'];
  savingsPreference: Scalars['String']['input'];
  successFeePercent: Scalars['Int']['input'];
};

export type AcceptBillPaymentEventInput = {
  eventId: Scalars['ID']['input'];
};

export enum AccountDeletionError {
  ALREADY_REQUESTED = 'ALREADY_REQUESTED',
  MANAGED_MFA = 'MANAGED_MFA',
  USER_NOT_FOUND = 'USER_NOT_FOUND'
}

export type AccountDeletionFailure = {
  __typename: 'AccountDeletionFailure';
  error: AccountDeletionError;
};

export type AccountDeletionResponse = AccountDeletionFailure | AccountDeletionSuccess;

export type AccountDeletionSuccess = {
  __typename: 'AccountDeletionSuccess';
  userId: Scalars['String']['output'];
};

export type AddBeneficiaryInput = {
  /**
   * Optional delivery handle the beneficiary arrived against. Null when not
   * known at registration time.
   */
  deliveryId?: InputMaybe<Scalars['ID']['input']>;
  /** Slug of the source the beneficiary came through. Set once at add time. */
  sourceSlug: Scalars['String']['input'];
};

export type AddUserQuitFeedbackInput = {
  executionId?: InputMaybe<Scalars['String']['input']>;
  feedback: Scalars['String']['input'];
};

export type AdditionalSection = {
  __typename: 'AdditionalSection';
  fields: Array<FieldAttributes>;
  name: Scalars['String']['output'];
};

export type AddressAutocompleteInput = {
  /** Country/region filter (e.g., country:us) */
  components?: InputMaybe<Scalars['String']['input']>;
  /** Search term (minimum 2 characters) */
  input: Scalars['String']['input'];
  /** Language code (default: en) */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Optional lat/lng to bias results geographically */
  location?: InputMaybe<LocationInput>;
  /** Search radius in meters (default: 50000) */
  radius?: InputMaybe<Scalars['Int']['input']>;
  /** Optional UUID for billing optimization when paired with addressDetails */
  sessionToken?: InputMaybe<Scalars['String']['input']>;
  /** Result types (default: address) */
  types?: InputMaybe<Scalars['String']['input']>;
};

export type AddressAutocompleteResponse = {
  __typename: 'AddressAutocompleteResponse';
  /** Number of predictions returned (0-5) */
  count: Scalars['Int']['output'];
  /** Maximum 5 results (Google's limit) */
  predictions: Array<AddressPrediction>;
};

export type AddressDetails = {
  __typename: 'AddressDetails';
  city?: Maybe<Scalars['String']['output']>;
  /** Country code */
  country?: Maybe<Scalars['String']['output']>;
  /** Full formatted address */
  formattedAddress: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  placeId: Scalars['String']['output'];
  /** State/province code */
  state?: Maybe<Scalars['String']['output']>;
  /** Street address (number and name) */
  street?: Maybe<Scalars['String']['output']>;
  /** Postal/zip code */
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressDetailsInput = {
  /** Specific fields to retrieve (affects pricing) */
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Language code (default: en) */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Place ID from autocomplete results */
  placeId: Scalars['String']['input'];
  /** Optional UUID matching the one used in autocomplete */
  sessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type AddressPrediction = {
  __typename: 'AddressPrediction';
  /** Full address description */
  description: Scalars['String']['output'];
  /** Primary text (usually street address) */
  mainText: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  /** Secondary text (usually city, state, country) */
  secondaryText: Scalars['String']['output'];
  /** Place types from Google Places API */
  types: Array<Scalars['String']['output']>;
};

export type ApplyEpicEndpointChangesInput = {
  epicJsonData: Scalars['String']['input'];
};

export type ApplyEpicEndpointChangesResponse = {
  __typename: 'ApplyEpicEndpointChangesResponse';
  success: Scalars['Boolean']['output'];
};

export type ApplyPromoCodeUsageInput = {
  code: Scalars['String']['input'];
  issueId: Scalars['ID']['input'];
};

export type ApplyPromoCodeUsageResponse = ApplyPromoCodeUsageSuccess | FormError;

export type ApplyPromoCodeUsageSuccess = {
  __typename: 'ApplyPromoCodeUsageSuccess';
  promoCodeUsage: PromoCodeUsageInfo;
};

export type ApproveSuggestedActionInput = {
  actionId: Scalars['ID']['input'];
};

export type ApproveSuggestedActionResult = {
  __typename: 'ApproveSuggestedActionResult';
  actionId: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type ArchiveConsentReleaseInput = {
  templateReleaseId: Scalars['String']['input'];
};

export type ArchiveConsentReleaseResult = ArchiveConsentReleaseSuccess | FormError;

export type ArchiveConsentReleaseSuccess = {
  __typename: 'ArchiveConsentReleaseSuccess';
  templateReleaseId: Scalars['String']['output'];
};

export type ArchiveTemplateError = {
  __typename: 'ArchiveTemplateError';
  errors: Array<Scalars['String']['output']>;
  templateId: Scalars['String']['output'];
};

export type ArchiveTemplateInput = {
  templateId: Scalars['String']['input'];
};

export type ArchiveTemplateResult = ArchiveTemplateError | ArchiveTemplateSuccess;

export type ArchiveTemplateSuccess = {
  __typename: 'ArchiveTemplateSuccess';
  templateId: Scalars['String']['output'];
};

export type AssignPersonToPersonalInput = {
  personId: Scalars['ID']['input'];
  personalId: Scalars['ID']['input'];
};

export type AssignUserSegmentInput = {
  assignments: Array<UserSegmentAssignment>;
};

export type AssignUserSegmentResult = {
  __typename: 'AssignUserSegmentResult';
  assignedCount: Scalars['Int']['output'];
};

export type AttemptStatus = {
  __typename: 'AttemptStatus';
  dataTypes: DataTypesStatus;
  executionId: Scalars['ID']['output'];
};

export type AuthUser = {
  __typename: 'AuthUser';
  adminUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isShadow: Scalars['Boolean']['output'];
};

export type AuthUserResult = AuthUser | FormError;

export type AuthenticateError = {
  __typename: 'AuthenticateError';
  errorType: AuthenticateResultErrorType;
  success: Scalars['Boolean']['output'];
};

export type AuthenticateInput = {
  /**
   * Anonymous session ID (JWT) from a prior pre-auth session.
   * When provided, the anonymous user record is converted to a full user on login.
   */
  anonymousSessionId?: InputMaybe<Scalars['String']['input']>;
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  /** Method of authentication (e.g., magic link, oauth). */
  method: AuthenticateMethod;
  /** Source of the registration (e.g., ios, android, web). */
  sourcePlatform?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  /** User segmentation data for the onboarding flow. */
  userSegmentationData?: InputMaybe<UserSegmentationData>;
};

export type AuthenticateMagicLinkInput = {
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type AuthenticateMagicLinkResult = {
  __typename: 'AuthenticateMagicLinkResult';
  errorType?: Maybe<AuthenticateMagicLinkResultErrorType>;
  firstAuthentication?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<AuthUser>;
};

export enum AuthenticateMagicLinkResultErrorType {
  INVALID_PKCE_CODE_CHALLENGE = 'INVALID_PKCE_CODE_CHALLENGE',
  UNABLE_TO_AUTH_MAGIC_LINK = 'UNABLE_TO_AUTH_MAGIC_LINK',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

export enum AuthenticateMethod {
  MAGIC_LINK = 'MAGIC_LINK',
  OAUTH = 'OAUTH'
}

export type AuthenticateResult = AuthenticateError | AuthenticateSuccess;

export enum AuthenticateResultErrorType {
  INVALID_AUTH_OAUTH = 'INVALID_AUTH_OAUTH',
  INVALID_PKCE_CODE_CHALLENGE = 'INVALID_PKCE_CODE_CHALLENGE',
  UNABLE_TO_AUTH_MAGIC_LINK = 'UNABLE_TO_AUTH_MAGIC_LINK',
  UNABLE_TO_AUTH_OAUTH = 'UNABLE_TO_AUTH_OAUTH',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

export type AuthenticateSuccess = {
  __typename: 'AuthenticateSuccess';
  email?: Maybe<Scalars['String']['output']>;
  firstAuthentication: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  user: AuthUser;
};

/** Root object type. */
export type BaseObject = {
  id: Scalars['ID']['output'];
};

export type BaseUpdatesPrompt = {
  count: Scalars['Int']['output'];
  type: UpdatesPromptType;
};

export type BasicSuccessResponse = {
  __typename: 'BasicSuccessResponse';
  success: Scalars['Boolean']['output'];
};

export type BatchGenerateBenefitsSummaryInput = {
  entities: Array<BenefitsSummaryEntity>;
};

export type BatchIndexDocumentsInput = {
  executionIds: Array<Scalars['ID']['input']>;
  reclassify?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BatchReprocessIngestionInput = {
  documentFilter?: InputMaybe<DocumentFilter>;
  ids: Array<Scalars['ID']['input']>;
  reclassify?: InputMaybe<Scalars['Boolean']['input']>;
  type: IngestionType;
};

/**
 * A person sourced from a partner, before they become a Granted user. PHI —
 * held in the isolated restricted Gel instance, never the shared store.
 */
export type Beneficiary = {
  __typename: 'Beneficiary';
  createdAt: Scalars['DateTime']['output'];
  /** The delivery handle the beneficiary arrived against. Null when not supplied. */
  deliveryId?: Maybe<Scalars['ID']['output']>;
  /** The beneficiary id (the event-sourced aggregate id). */
  id: Scalars['ID']['output'];
  /** Slug of the source the beneficiary came through. Set once at add time. */
  sourceSlug: Scalars['String']['output'];
  /**
   * Lifecycle stage, derived in Gel (read-only). Reflects whether the
   * beneficiary has been onboarded.
   */
  stage: BeneficiaryStage;
  updatedAt: Scalars['DateTime']['output'];
  /** The onboarding user, set once the beneficiary is onboarded. Null before then. */
  userId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Lifecycle stage of a beneficiary, derived in Gel from whether a user has
 * been bound.
 */
export enum BeneficiaryStage {
  ONBOARDED = 'ONBOARDED',
  RECEIVED = 'RECEIVED'
}

export type BenefitSummaryCreated = {
  __typename: 'BenefitSummaryCreated';
  caseId: Scalars['String']['output'];
  executionId: Scalars['ID']['output'];
  status: DataTypeStatus;
};

export type BenefitsSummaryEntity = {
  documentId: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type BillingSubscription = {
  __typename: 'BillingSubscription';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentPeriodEnd?: Maybe<Scalars['String']['output']>;
  currentPeriodStart?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: SubscriptionStatusGql;
  stripePriceId: Scalars['String']['output'];
  stripeSubscriptionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type BillsToReviewUpdatesPrompt = BaseUpdatesPrompt & {
  __typename: 'BillsToReviewUpdatesPrompt';
  count: Scalars['Int']['output'];
  type: UpdatesPromptType;
};

export type BrowserbaseBrowserSettings = {
  advancedStealth?: InputMaybe<Scalars['Boolean']['input']>;
  blockAds?: InputMaybe<Scalars['Boolean']['input']>;
  fingerprint?: InputMaybe<BrowserbaseFingerprint>;
  os?: InputMaybe<Scalars['String']['input']>;
  viewport?: InputMaybe<BrowserbaseViewport>;
};

export type BrowserbaseConfig = {
  sessionOverrides?: InputMaybe<BrowserbaseSessionOverrides>;
};

export type BrowserbaseFingerprint = {
  browsers?: InputMaybe<Array<Scalars['String']['input']>>;
  devices?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  operatingSystems?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BrowserbaseProxyConfig = {
  geolocation?: InputMaybe<BrowserbaseProxyGeolocation>;
  type: Scalars['String']['input'];
};

export type BrowserbaseProxyGeolocation = {
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type BrowserbaseSessionOverrides = {
  browserSettings?: InputMaybe<BrowserbaseBrowserSettings>;
  proxies?: InputMaybe<Array<BrowserbaseProxyConfig>>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type BrowserbaseViewport = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type BulkUpdateEndpointSupportLevelsInput = {
  endpointIds: Array<Scalars['ID']['input']>;
  supportLevel: webAgent__EndpointSupportLevel;
};

export type BusinessRule = {
  __typename: 'BusinessRule';
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  dimension: dataQuality__Dimension;
  enabled: Scalars['Boolean']['output'];
  expression?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minScore?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  owner: User;
  priority: Scalars['Int']['output'];
  resourceType: fhirext__ResourceType;
};

export type BusinessRuleFilter = {
  category?: InputMaybe<Scalars['String']['input']>;
  dimension?: InputMaybe<dataQuality__Dimension>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  resourceType?: InputMaybe<fhirext__ResourceType>;
};

export type CancelEligibilityEnrollmentInput = {
  /**
   * Free-form admin annotation captured on the
   * `EligibilityEnrollmentEnded` event for audit. Optional.
   */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** User to remove from the eligibility program. */
  userId: Scalars['ID']['input'];
};

export type CancelEligibilityEnrollmentResult = {
  __typename: 'CancelEligibilityEnrollmentResult';
  /**
   * True when the dispatch succeeded. The aggregate's decide is
   * idempotent, so this is true regardless of whether the user was
   * enrolled or already-not-enrolled at dispatch time. Failures
   * surface as GraphQL errors rather than `ok: false`.
   */
  ok: Scalars['Boolean']['output'];
  /** User the cancellation was dispatched against. */
  userId: Scalars['ID']['output'];
};

export type CancelSubscriptionInput = {
  atPeriodEnd?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancelSubscriptionResponse = {
  __typename: 'CancelSubscriptionResponse';
  subscription: BillingSubscription;
};

export type CancelTailgateInput = {
  sessionId: Scalars['String']['input'];
};

export type CardDetails = {
  __typename: 'CardDetails';
  brand: Scalars['String']['output'];
  last4: Scalars['String']['output'];
  walletType?: Maybe<Scalars['String']['output']>;
};

export type CaseAdvisorChatInput = {
  caseId: Scalars['ID']['input'];
  messages: Array<CaseAdvisorMessageInput>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type CaseAdvisorChatResult = {
  __typename: 'CaseAdvisorChatResult';
  content: Scalars['String']['output'];
  inputTokens: Scalars['Int']['output'];
  outputTokens: Scalars['Int']['output'];
  toolCalls: Array<CaseAdvisorToolCall>;
};

export type CaseAdvisorMessageInput = {
  content: Scalars['String']['input'];
  role: CaseAdvisorMessageRole;
};

export enum CaseAdvisorMessageRole {
  assistant = 'assistant',
  user = 'user'
}

export type CaseAdvisorToolCall = {
  __typename: 'CaseAdvisorToolCall';
  label: Scalars['String']['output'];
  toolName: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type CaseRecommendation = {
  __typename: 'CaseRecommendation';
  evidence: Array<CaseRecommendationEvidence>;
  fallback?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  providerSummary?: Maybe<Scalars['String']['output']>;
  stepGroups: Array<CaseRecommendationStepGroup>;
  /** One-sentence HA-facing summary of the case state + recommended path. */
  summary: Scalars['String']['output'];
  tactic: CaseRecommendationTactic;
};

export type CaseRecommendationEvidence = {
  __typename: 'CaseRecommendationEvidence';
  kind: CaseRecommendationEvidenceKind;
  signal: Scalars['String']['output'];
};

export enum CaseRecommendationEvidenceKind {
  CONFIRMED = 'CONFIRMED',
  GAP = 'GAP'
}

export type CaseRecommendationPhoneCallDetails = {
  __typename: 'CaseRecommendationPhoneCallDetails';
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CaseRecommendationSendFormDetails = {
  __typename: 'CaseRecommendationSendFormDetails';
  formSender: Scalars['String']['output'];
  formType: Scalars['String']['output'];
  recipient?: Maybe<Scalars['String']['output']>;
  sendingMethod: Scalars['String']['output'];
};

export type CaseRecommendationStep = {
  __typename: 'CaseRecommendationStep';
  dependsOn?: Maybe<Array<Scalars['String']['output']>>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  phoneCall?: Maybe<CaseRecommendationPhoneCallDetails>;
  /** Surfaced in the HA panel for prioritization. */
  priority: CaseRecommendationStepPriority;
  sendForm?: Maybe<CaseRecommendationSendFormDetails>;
  taskType: CaseRecommendationStepTaskType;
  title: Scalars['String']['output'];
};

export type CaseRecommendationStepGroup = {
  __typename: 'CaseRecommendationStepGroup';
  category: Scalars['String']['output'];
  label: Scalars['String']['output'];
  steps: Array<CaseRecommendationStep>;
};

export enum CaseRecommendationStepPriority {
  LATER = 'LATER',
  NEXT = 'NEXT',
  NOW = 'NOW'
}

export enum CaseRecommendationStepTaskType {
  FOLLOW_UP_USER_UNRESPONSIVE = 'FOLLOW_UP_USER_UNRESPONSIVE',
  GENERAL = 'GENERAL',
  ISSUE_USER_MESSAGING = 'ISSUE_USER_MESSAGING',
  PHONE_CALL = 'PHONE_CALL',
  SEND_FORM = 'SEND_FORM'
}

export type CaseRecommendationTactic = {
  __typename: 'CaseRecommendationTactic';
  confidence: CaseRecommendationTacticConfidence;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reasoning: Scalars['String']['output'];
};

/**
 * Enums mirror the Zod source of truth in
 * `ts/apps/api/src/case-resolution/schemas.ts`. Keep these in lockstep —
 * adding a Zod enum value without adding it here means the resolver will
 * return a string the gateway rejects at response time.
 */
export enum CaseRecommendationTacticConfidence {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export type ChargeBillPaymentInput = {
  billAmount: Scalars['Decimal']['input'];
  eventId: Scalars['ID']['input'];
};

export type ChargeBillPaymentResponse = {
  __typename: 'ChargeBillPaymentResponse';
  paymentIntentId: Scalars['String']['output'];
  successEventId: Scalars['String']['output'];
};

export type ChargeNegotiatedBillInput = {
  issueId: Scalars['ID']['input'];
  negotiatedBillAmount: Scalars['Decimal']['input'];
  /**
   * When true, charge only the success fee (skip the negotiated bill payment line item).
   * Use when the provider won't accept payment from us, or the user opted out of having
   * us pay the bill, but we still negotiated savings.
   */
  successFeeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChargeNegotiatedBillResponse = {
  __typename: 'ChargeNegotiatedBillResponse';
  billAmount: Scalars['Decimal']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  successFeeAmount: Scalars['Decimal']['output'];
  totalCharged: Scalars['Decimal']['output'];
};

export type ChargePaymentProfileInput = {
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  issueId?: InputMaybe<Scalars['ID']['input']>;
};

export type ChargePaymentProfileResponse = {
  __typename: 'ChargePaymentProfileResponse';
  paymentIntentId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CheckClientVersionInput = {
  /**
   * Expected to take the value of Platform.OS from React Native.
   * One of "web", "ios", "android".
   * Currently, we only expect "ios".
   */
  os: Scalars['String']['input'];
  /** EAS Update ID for the JS bundle, if applicable. */
  updateId?: InputMaybe<Scalars['String']['input']>;
  /** Native application version. */
  version: Scalars['String']['input'];
};

export type CheckClientVersionResponse = {
  __typename: 'CheckClientVersionResponse';
  /**
   * Indicates whether the application binary is supported by the API service.
   * If false, the user needs to update the application from the app store or similar.
   */
  isSupportedBinary: Scalars['Boolean']['output'];
  /**
   * Indicates whether the JS bundle is supported by the API service.
   * If false, the user needs to close and reopen the application.
   */
  isSupportedBundle: Scalars['Boolean']['output'];
};

export type CheckPersonMatchInput = {
  dob: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClientSupportedVersionResponse = {
  __typename: 'ClientSupportedVersionResponse';
  /**
   * The most recent version of the application to ensure the EAS update block
   * only executes on the latest version of the application.
   */
  latestClientVersion: Scalars['String']['output'];
  /**
   * Current EAS Update ID for the JS bundle, if applicable. Will be empty if new
   * version was published and there is not a current update.
   */
  supportedClientUpdateId?: Maybe<Scalars['String']['output']>;
  /** Indicates the version of the client that is supported by the API service. */
  supportedClientVersion: Scalars['String']['output'];
};

export type CloseIssueInput = {
  caseManagementClosureReason: Scalars['String']['input'];
  issueId: Scalars['ID']['input'];
};

/** Input type for generating a snapshot of a FHIR resource */
export type ComputeResourceSnapshotInput = {
  resourceId: Scalars['ID']['input'];
  resourceType: fhirext__ResourceType;
};

export enum ConversationEventType {
  STREAM_END = 'STREAM_END',
  TOKEN = 'TOKEN',
  TOOL_CALL_START = 'TOOL_CALL_START',
  TURN_COMPLETED = 'TURN_COMPLETED',
  TURN_FAILED = 'TURN_FAILED',
  TURN_STARTED = 'TURN_STARTED'
}

export type ConversationSubscriptionEvent = {
  __typename: 'ConversationSubscriptionEvent';
  error?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  toolName?: Maybe<Scalars['String']['output']>;
  turnId: Scalars['String']['output'];
  type: ConversationEventType;
};

/** Input fields for editing a Coverage resource */
export type CoverageEditInput = {
  coverageType?: InputMaybe<fhir__CoverageType>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  insuranceName?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<fhirEdit__CoverageRelationship>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateApplePayIntentResponse = {
  __typename: 'CreateApplePayIntentResponse';
  clientSecret: Scalars['String']['output'];
};

export type CreateBillPayRequestedEventInput = {
  issueId: Scalars['ID']['input'];
};

export type CreateBusinessRuleInput = {
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  dimension: dataQuality__Dimension;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expression?: InputMaybe<Scalars['String']['input']>;
  minScore?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  resourceType: fhirext__ResourceType;
};

export type CreateDataQualityFlagTaskInput = {
  description: Scalars['String']['input'];
  dueDate: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  resourceId: Scalars['ID']['input'];
  sourceName: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateDataQualityTaskInput = {
  assessmentId: Scalars['ID']['input'];
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  dimension: dataQuality__Dimension;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  ruleId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type CreateDocumentInput = {
  caseIntake?: InputMaybe<Scalars['Boolean']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Optional document type (e.g. bill, EOB, member ID) to skip ingestion classification. */
  dataType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional isInternal flag for uploading internal documents that are initially
   * hidden by the user.
   */
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /**
   * Optional owner for the new document. If not specified, the owner is assumed to
   * be the user who uploaded the document. Only admin users may specify an owner
   * other than themselves. If the document is finalized with an issue, the issue's
   * owner will be overridden as the document's owner no matter what.
   */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Defaults to USER if not specified. */
  participant?: InputMaybe<Participant>;
  sizeBytes?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDocumentResult = {
  __typename: 'CreateDocumentResult';
  document: document__Document;
  s3Key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CreateFeedbackResult = {
  __typename: 'CreateFeedbackResult';
  success: Scalars['Boolean']['output'];
};

export type CreateFileInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sizeBytes?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateFileResult = {
  __typename: 'CreateFileResult';
  name: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CreateFlexpaLinkInput = {
  publicToken: Scalars['String']['input'];
};

export type CreateGeneralFeedbackInput = {
  rating: Scalars['Int']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
  selectedOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateIssueBillPaymentRequestedEventInput = {
  issueId: Scalars['ID']['input'];
};

export type CreateIssueChatEventInput = {
  actionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  chatBody: Scalars['String']['input'];
  issueId: Scalars['ID']['input'];
  userVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateIssueClosurePaymentRequestedEventInput = {
  chargeDelayDays?: InputMaybe<Scalars['Int']['input']>;
  dollarAmountSaved?: InputMaybe<Scalars['Decimal']['input']>;
  issueId: Scalars['ID']['input'];
  successFee?: InputMaybe<Scalars['Decimal']['input']>;
  totalBillDollarAmount?: InputMaybe<Scalars['Decimal']['input']>;
  userId: Scalars['ID']['input'];
};

export type CreateIssueCommentEventInput = {
  comment: Scalars['String']['input'];
  issueId: Scalars['ID']['input'];
};

export type CreateIssueConnectAccountRequestedEventInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  chatBody?: InputMaybe<Scalars['String']['input']>;
  endpointType: webAgent__EndpointType;
  issueId: Scalars['ID']['input'];
  showSkipButton?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateIssueFeedbackInput = {
  issueId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
  selectedOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateIssuePaymentAgreementRequestedEventInput = {
  issueId: Scalars['ID']['input'];
};

export type CreateIssueTaskInput = {
  additionalDetailsRequested?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['String']['input'];
  formSender?: InputMaybe<Scalars['String']['input']>;
  formType?: InputMaybe<Scalars['String']['input']>;
  hasAllInformation?: InputMaybe<Scalars['Boolean']['input']>;
  issueId: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  /**
   * When source === CRI_RECOMMENDATION, the id of the recommendation step
   * the HA clicked Create Task on. Logged only — not persisted.
   */
  recommendationStepId?: InputMaybe<Scalars['String']['input']>;
  sendingMethod?: InputMaybe<Scalars['String']['input']>;
  /**
   * Where this task creation originated. Logged for analytics; not persisted
   * on the Task. When set to CRI_RECOMMENDATION, recommendationStepId should
   * also be provided so we can correlate per-step engagement.
   */
  source?: InputMaybe<TaskCreationSource>;
  taskType?: InputMaybe<taskManagement__TaskType>;
  title: Scalars['String']['input'];
};

export type CreateIssueTemplateReleaseRequestedEventInput = {
  issueId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export type CreateMultiFileDocumentInput = {
  /** Optional document type (e.g. bill, EOB, member ID) to skip ingestion classification. */
  dataType?: InputMaybe<Scalars['String']['input']>;
  files: Array<CreateFileInput>;
  /** Name of the entire document. */
  name: Scalars['String']['input'];
  /**
   * Optional owner for the new document. If not specified, the owner is assumed to
   * be the user who uploaded the document. Only admin users may specify an owner
   * other than themselves. If the document is finalized with an issue, the issue's
   * owner will be overridden as the document's owner no matter what.
   */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Defaults to USER if not specified. */
  participant?: InputMaybe<Participant>;
};

export type CreateMultiFileDocumentResult = {
  __typename: 'CreateMultiFileDocumentResult';
  document: document__Document;
  files: Array<CreateFileResult>;
};

/** Input for creating a navigator specialist instruction */
export type CreateNavigatorSpecialistInstructionsInput = {
  /** The endpoint ID this instruction belongs to */
  endpointId: Scalars['ID']['input'];
  /** The instruction content */
  instructions: Scalars['String']['input'];
  /** Optional slug for the instruction. If not provided, will be auto-generated */
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePartnerGroupInput = {
  /**
   * The partner's own identifier for the group in their system. Optional when
   * the id is not known at registration time.
   */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Group name, unique within the partner. */
  name: Scalars['String']['input'];
};

export type CreatePartnerInput = {
  /**
   * Groups to create alongside the partner. Optional — groups can also be added
   * later.
   */
  groups?: InputMaybe<Array<CreatePartnerGroupInput>>;
  /** Partner display name. Unique across all partners. */
  name: Scalars['String']['input'];
  /**
   * Stable, human-readable handle. Unique, supplied explicitly (not derived from
   * the name). Lowercase kebab-case: a-z, 0-9, and hyphens.
   */
  slug: Scalars['String']['input'];
};

export type CreatePaymentProfileResponse = {
  __typename: 'CreatePaymentProfileResponse';
  clientSecret: Scalars['String']['output'];
};

export type CreatePersonInput = {
  address?: InputMaybe<PersonAddress>;
  dob: Scalars['String']['input'];
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenNames?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreatePhoneCallInput = {
  aircallId: Scalars['String']['input'];
  aircallSessionId?: InputMaybe<Scalars['String']['input']>;
  callDate: Scalars['String']['input'];
  callType?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Float']['input'];
  hasVoicemail?: InputMaybe<Scalars['Boolean']['input']>;
  isInbound?: InputMaybe<Scalars['Boolean']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  taskId: Scalars['ID']['input'];
};

export type CreatePromoCodeInput = {
  code: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreatePromoCodeResponse = {
  __typename: 'CreatePromoCodeResponse';
  promoCode: payment__PromoCode_Type;
};

export type CreateProviderInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<ProviderContactPointInput>>;
  county?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  faPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<provider__ProviderKind>;
  notes?: InputMaybe<Array<Scalars['String']['input']>>;
  npi?: InputMaybe<Scalars['String']['input']>;
  partOfId?: InputMaybe<Scalars['ID']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  systemName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProxyConfigInput = {
  password: Scalars['String']['input'];
  server: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateProxyConfigResponse = {
  __typename: 'CreateProxyConfigResponse';
  proxyConfigId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Base input type for creating resource edits */
export type CreateResourceEditInput = {
  coverageEdit?: InputMaybe<CoverageEditInput>;
  explanationOfBenefitEdit?: InputMaybe<ExplanationOfBenefitEditInput>;
  rationale: Scalars['String']['input'];
  resourceId: Scalars['ID']['input'];
  resourceType: fhirext__ResourceType;
};

export type CreateRetoolNotificationInput = {
  description: Scalars['String']['input'];
  issueId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateReviewPaymentAcceptanceIssueTaskInput = {
  issueId: Scalars['ID']['input'];
};

export type CreateSegmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  key: Scalars['String']['input'];
  owningTeam: Scalars['String']['input'];
};

export type CreateSegmentResult = {
  __typename: 'CreateSegmentResult';
  segmentId: Scalars['String']['output'];
};

export type CreateSetupIntentResponse = {
  __typename: 'CreateSetupIntentResponse';
  clientSecret: Scalars['String']['output'];
};

export type CreateSubscriptionInput = {
  priceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  trialPeriodDays?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSubscriptionResponse = {
  __typename: 'CreateSubscriptionResponse';
  id: Scalars['ID']['output'];
};

export type CreateTaskCommentInput = {
  comment: Scalars['String']['input'];
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  taskId: Scalars['ID']['input'];
};

export type CreateTemplateError = {
  __typename: 'CreateTemplateError';
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateTemplateInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  s3Bucket: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  templateType: TemplateType;
};

export type CreateTemplateResult = CreateTemplateError | CreateTemplateSuccess;

export type CreateTemplateSuccess = {
  __typename: 'CreateTemplateSuccess';
  success: Scalars['Boolean']['output'];
  templateId: Scalars['String']['output'];
};

export type CreateWebAgentEndpointInput = {
  cdpProvider?: InputMaybe<webAgent__CDPProvider>;
  dashboardUrl?: InputMaybe<Scalars['String']['input']>;
  defaultProxy?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  displayUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isIngestionSupported?: InputMaybe<Scalars['Boolean']['input']>;
  loginUrl: Scalars['String']['input'];
  portalGuideUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWebAgentEndpointResult = {
  __typename: 'CreateWebAgentEndpointResult';
  endpointId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Credentials = {
  password: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type DataTypeNotSupported = {
  __typename: 'DataTypeNotSupported';
  executionId: Scalars['ID']['output'];
  status: DataTypeStatus;
};

export type DataTypeProcessing = {
  __typename: 'DataTypeProcessing';
  executionId: Scalars['ID']['output'];
  status: DataTypeStatus;
};

export enum DataTypeStatus {
  FAILED = 'FAILED',
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  UNAVAILABLE = 'UNAVAILABLE'
}

export type DataTypesStatus = {
  __typename: 'DataTypesStatus';
  executionId: Scalars['ID']['output'];
  planDocuments: PlanDocumentsDataTypeStatus;
};

export type DeclineBillPayInput = {
  eventId: Scalars['ID']['input'];
};

/** Input for deleting a navigator specialist page discovery */
export type DeleteNavigatorSpecialistPageDiscoveryInput = {
  id: Scalars['ID']['input'];
};

export type DeletePaymentProfileResponse = {
  __typename: 'DeletePaymentProfileResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteUserDocumentInput = {
  documentId: Scalars['ID']['input'];
  /** When set, the document must have an internal upload event on this issue. */
  issueId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type DeleteUserDocumentResult = {
  __typename: 'DeleteUserDocumentResult';
  deletedDocumentId: Scalars['ID']['output'];
};

export type DirectAwaitLoginResultInput = {
  linkId: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

export type DirectLoginToInstitutionResult = FailedLoginMaxReached | InvalidCredentials | LoginSuccess | MfaRequired | RpaError | SecurityQuestionRequired | SelectMfaMethodResponse;

export type DirectRequestNewMfaCodeResult = RpaError | SelectMfaMethodResponse;

export type DirectSelectMfaMethodResult = RpaError | SelectMfaMethodResponse;

export type DirectStartRelinkResult = {
  __typename: 'DirectStartRelinkResult';
  workflowId: Scalars['String']['output'];
};

export type DirectSubmitMfaCodeResult = InvalidCredentials | LoginSuccess | RpaError;

export type DirectSubmitSecurityAnswerResult = LoginSuccess | RpaError | SecurityQuestionRequired;

export type DismissFindingInput = {
  findingId: Scalars['ID']['input'];
};

export type DocumentFilter = {
  excludeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  includeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DocumentSummaryResult = {
  __typename: 'DocumentSummaryResult';
  documentId: Scalars['String']['output'];
  summary: Scalars['JSON']['output'];
};

/**
 * A single accumulator row — one (type, tier, network) combination
 * with its current numeric state.
 */
export type EligibilityAccumulator = {
  __typename: 'EligibilityAccumulator';
  limitAmount?: Maybe<Scalars['Float']['output']>;
  metAmount?: Maybe<Scalars['Float']['output']>;
  network: Scalars['String']['output'];
  period?: Maybe<Scalars['String']['output']>;
  remainingAmount?: Maybe<Scalars['Float']['output']>;
  serviceCategory?: Maybe<Scalars['String']['output']>;
  tier: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/**
 * Financial accumulator values extracted from a single eligibility
 * response for one membership. Contains plan year boundaries and the
 * set of accumulator rows (deductible, OOP max, coinsurance, copay)
 * broken down by tier, network, and service category.
 */
export type EligibilityAccumulatorSnapshot = {
  __typename: 'EligibilityAccumulatorSnapshot';
  accumulators: Array<EligibilityAccumulator>;
  planYearEnd?: Maybe<Scalars['String']['output']>;
  planYearStart?: Maybe<Scalars['String']['output']>;
};

/**
 * Structured error rendered on a SKIPPED or FAILED
 * `EligibilityCheckOutcome`. The field set is intentionally small and
 * action-oriented. Rich debugging context (HTTP status codes, zod
 * issues, vendor response headers, trading partner IDs, etc.) lives
 * in server-side logs and Sentry extras, not in the GraphQL response.
 */
export type EligibilityCheckError = {
  __typename: 'EligibilityCheckError';
  /**
   * Stable class-level identifier. Always the server-side error class
   * name — safe for programmatic branching on the client and for
   * Sentry issue grouping.
   */
  code: Scalars['String']['output'];
  /**
   * Human-readable message. Stable per `(code, subCode)` tuple — the
   * same combination always produces the same string. Safe to display
   * without further formatting.
   */
  message: Scalars['String']['output'];
  /**
   * Whether retrying the same request is likely to succeed without
   * human intervention. False for conditions requiring an upstream
   * data or configuration fix (missing member data, unresolved payer,
   * exhausted NPI tiers). True for transient vendor failures
   * (timeouts, rate limits, 5xx).
   */
  retryable: Scalars['Boolean']['output'];
  /**
   * Optional finer-grained classification within a `code`. Populated
   * for errors that have meaningful sub-conditions (e.g.
   * MemberDataInsufficientError's `EMPTY_MEMBER_ID`,
   * `INVALID_DATE_OF_BIRTH`). Null when the class is itself the
   * terminal classification.
   */
  subCode?: Maybe<Scalars['String']['output']>;
};

export type EligibilityCheckInput = {
  /**
   * When true, dispatch `receiveAccumulator` for memberships whose
   * snapshot differs from the latest projection. When false (the default),
   * returns the parsed snapshot without mutating any state.
   */
  dispatch?: Scalars['Boolean']['input'];
  /**
   * Force a `DeductibleChanged` domain event to be dispatched even when
   * the deductible has not actually changed. Requires `dispatch: true` to
   * take effect. A forced event carries `forced: true` through the reactor
   * and the NotificationAggregate, bypassing both the reactor threshold
   * (`minDeltaDollars`) and the aggregate suppression window — an
   * immediate notification delivery is produced regardless of LaunchDarkly
   * threshold settings. Intended for exercising the notification pipeline
   * end-to-end against real user data; not meant for production operations.
   */
  forceDeductibleChangeEvent?: Scalars['Boolean']['input'];
  /**
   * Override: use this payer ID verbatim, skipping the payer resolver.
   * When omitted, the resolver walks OVERRIDE → CARD → SEARCH tiers.
   */
  payerIdOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: use this payer name verbatim. Primarily needed when
   * synthesizing a check for a user with zero memberships — a membership
   * always carries a payer name, so patching it on an existing membership
   * is rarely useful.
   */
  payerNameOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: use this 10-digit NPI verbatim, skipping the NPI resolver.
   * When omitted, the resolver walks the user's historical data.
   *
   * Stedi requires a provider name alongside the NPI on every 270 — a
   * bare NPI is rejected with HTTP 400. When supplying this override,
   * the caller must also supply `providerOrganizationNameOverride` (or
   * populate the NPI registry with an entry matching this NPI
   * so the resolver fallback can attach a name).
   */
  providerNpiOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: organization name to send alongside `providerNpiOverride`.
   * Required when the NPI override is set; otherwise Stedi rejects the
   * request as missing the provider name. Only the organization-name
   * branch is exposed via override — individual-provider names
   * (firstName + lastName) are sourced from the NPI registry.
   */
  providerOrganizationNameOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: use this DOB (YYYY-MM-DD) verbatim, skipping the subscriber resolver.
   * When omitted, the resolver walks OVERRIDE → MEMBER → PERSON tiers.
   */
  subscriberDateOfBirthOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: use this first name verbatim, skipping the subscriber resolver.
   * When omitted, the resolver walks OVERRIDE → MEMBER → PERSON tiers.
   */
  subscriberFirstNameOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: use this last name verbatim, skipping the subscriber resolver.
   * When omitted, the resolver walks OVERRIDE → MEMBER → PERSON tiers.
   */
  subscriberLastNameOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: use this subscriber member ID verbatim, skipping the value
   * carried on the membership. When synthesizing a check for a user with
   * zero memberships, this is the member ID the 270 request is built with.
   *
   * Overrides apply to every membership the check runs against. The
   * automated refresh flow is always "run all memberships for this user,"
   * and admin-targeted single-membership checks are not a first-class
   * surface — use overrides only when you intend them to fan out.
   */
  subscriberMemberIdOverride?: InputMaybe<Scalars['String']['input']>;
  /** User whose memberships should be checked. */
  userId: Scalars['ID']['input'];
};

export type EligibilityCheckOutcome = {
  __typename: 'EligibilityCheckOutcome';
  /**
   * Coverage type of the membership being checked (MEDICAL, DENTAL, VISION,
   * PHARMACY, OTHER). Null when the member projection row does not carry one.
   */
  coverageType?: Maybe<Scalars['String']['output']>;
  /**
   * Stable reason code for the dispatch decision. One of:
   * `DRY_RUN` (input.dispatch was false),
   * `EMPTY_SNAPSHOT` (live dispatch, but vendor returned no accumulator rows),
   * `UNCHANGED` (values equal, no events fired),
   * `CHANGED` (values differ — accumulator event emitted),
   * `BASELINE` (no prior snapshot — first event for this materialization key),
   * `FORCED` (accumulator unchanged, but `forceDeductibleChangeEvent` caused a
   * `DeductibleChanged` to fire anyway).
   */
  dispatchReason?: Maybe<Scalars['String']['output']>;
  /**
   * Whether any domain event fired for this membership — either a
   * `receiveAccumulator` (when values changed) or an `observeDeductibleChange`
   * (when the deductible moved, or when `forceDeductibleChangeEvent` bypassed
   * the gate). Null when `input.dispatch` was false.
   */
  dispatched?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Structured error describing why this outcome is SKIPPED or FAILED.
   * Null when status = CHECKED.
   */
  error?: Maybe<EligibilityCheckError>;
  memberId: Scalars['String']['output'];
  payerName: Scalars['String']['output'];
  /**
   * Accumulator snapshot extracted from the eligibility response. Populated
   * when status = CHECKED; null for SKIPPED and FAILED outcomes.
   */
  snapshot?: Maybe<EligibilityAccumulatorSnapshot>;
  /**
   * CHECKED: the eligibility call succeeded and `snapshot` is populated.
   * SKIPPED: the membership lacked required data; `error` describes why.
   * FAILED:  the eligibility call or extraction threw; `error` carries the structured cause.
   */
  status: EligibilityCheckStatus;
  /**
   * Opaque response id from the eligibility vendor — useful for
   * support/debugging and cross-referencing vendor logs.
   */
  vendorResponseId?: Maybe<Scalars['String']['output']>;
};

export type EligibilityCheckResult = {
  __typename: 'EligibilityCheckResult';
  /**
   * Top-level pre-flight error. Populated when the check could not be
   * attempted for any membership at all (e.g. the user has zero memberships,
   * or a targeted memberId didn't match). Distinct from per-outcome errors,
   * which describe why a specific membership was SKIPPED or FAILED.
   */
  error?: Maybe<EligibilityCheckError>;
  /** One outcome per membership that was considered (checked, skipped, or failed). */
  outcomes: Array<EligibilityCheckOutcome>;
  summary: EligibilityCheckSummary;
};

export enum EligibilityCheckStatus {
  CHECKED = 'CHECKED',
  FAILED = 'FAILED',
  SKIPPED = 'SKIPPED'
}

export type EligibilityCheckSummary = {
  __typename: 'EligibilityCheckSummary';
  checked: Scalars['Int']['output'];
  considered: Scalars['Int']['output'];
  dispatched: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type EndpointCapabilityInput = {
  dataLatency: webAgent__DataLatency;
  dataType: webAgent__DataType;
  isSupported: Scalars['Boolean']['input'];
};

export type EndpointSlug = {
  __typename: 'EndpointSlug';
  id?: Maybe<Scalars['ID']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type EpicEndpointChange = EpicEndpointCreate | EpicEndpointDeactivate | EpicEndpointUpdateLoginUrl | EpicEndpointUpdateMetadata | EpicEndpointUpdateName;

export type EpicEndpointCreate = {
  __typename: 'EpicEndpointCreate';
  epicExternalId: Scalars['String']['output'];
  loginUrl: Scalars['String']['output'];
  metadata: Array<EpicMetadataEntry>;
  name: Scalars['String']['output'];
};

export type EpicEndpointDeactivate = {
  __typename: 'EpicEndpointDeactivate';
  epicExternalId: Scalars['String']['output'];
};

export type EpicEndpointUpdateLoginUrl = {
  __typename: 'EpicEndpointUpdateLoginUrl';
  epicExternalId: Scalars['String']['output'];
  newLoginUrl: Scalars['String']['output'];
  oldLoginUrl: Scalars['String']['output'];
};

export type EpicEndpointUpdateMetadata = {
  __typename: 'EpicEndpointUpdateMetadata';
  epicExternalId: Scalars['String']['output'];
  newMetadata: Array<EpicMetadataEntry>;
  oldMetadata: Array<EpicMetadataEntry>;
};

export type EpicEndpointUpdateName = {
  __typename: 'EpicEndpointUpdateName';
  epicExternalId: Scalars['String']['output'];
  newName: Scalars['String']['output'];
  oldName: Scalars['String']['output'];
};

export type EpicMetadataEntry = {
  __typename: 'EpicMetadataEntry';
  key: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type EventTrackingResult = {
  __typename: 'EventTrackingResult';
  success: Scalars['Boolean']['output'];
};

export type ExecutionDocumentType = {
  __typename: 'ExecutionDocumentType';
  contentType: Scalars['String']['output'];
};

export type ExecutionResultArtifact = {
  __typename: 'ExecutionResultArtifact';
  artifactType: Scalars['String']['output'];
  crawlType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
};

export type ExecutionResultDocument = {
  __typename: 'ExecutionResultDocument';
  dataType?: Maybe<Scalars['String']['output']>;
  files: Array<ExecutionDocumentType>;
};

/** Input fields for editing an ExplanationOfBenefit resource */
export type ExplanationOfBenefitEditInput = {
  billablePeriodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  billablePeriodStart?: InputMaybe<Scalars['DateTime']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  decision?: InputMaybe<fhirEdit__ExplanationOfBenefitDecision>;
  network?: InputMaybe<fhirEdit__ExplanationOfBenefitNetwork>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FailedLoginMaxReached = {
  __typename: 'FailedLoginMaxReached';
  signInUrl: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type FairMarketValueResponse = {
  __typename: 'FairMarketValueResponse';
  code: Scalars['String']['output'];
  percentile50: SimpleMoney;
};

export type FieldAttributes = {
  __typename: 'FieldAttributes';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FieldError = {
  __typename: 'FieldError';
  /** Typically the message will be displayed to the user inline on the form field. */
  message: Scalars['String']['output'];
  /**
   * Indicates the field which has an error.
   * For nested fields (e.g. arrays or objects), use a period-separated path, e.g.:
   *   "user.email" or "user.addresses.0.street"
   */
  path: Scalars['String']['output'];
};

export type FillTemplateError = {
  __typename: 'FillTemplateError';
  errors: Array<Scalars['String']['output']>;
  formError?: Maybe<FormError>;
  success: Scalars['Boolean']['output'];
};

export type FillTemplateInput = {
  filledFields: Array<FilledField>;
  formOptions?: InputMaybe<FormOptions>;
  templateId: Scalars['String']['input'];
};

export type FillTemplateResult = FillTemplateError | FillTemplateSuccess;

export type FillTemplateSuccess = {
  __typename: 'FillTemplateSuccess';
  previewUrl: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FilledField = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FilterBaseObject = {
  and?: InputMaybe<Array<FilterBaseObject>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<FilterBaseObject>;
  or?: InputMaybe<Array<FilterBaseObject>>;
};

export type FilterBoolean = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterDecimal = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
};

export type FilterFloat = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterID = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  neq?: InputMaybe<Scalars['ID']['input']>;
};

export type FilterInt = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterInt64 = {
  eq?: InputMaybe<Scalars['Int64']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Int64']['input']>;
  gte?: InputMaybe<Scalars['Int64']['input']>;
  in?: InputMaybe<Array<Scalars['Int64']['input']>>;
  lt?: InputMaybe<Scalars['Int64']['input']>;
  lte?: InputMaybe<Scalars['Int64']['input']>;
  neq?: InputMaybe<Scalars['Int64']['input']>;
};

export type FilterJSON = {
  eq?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  neq?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterObject = {
  and?: InputMaybe<Array<FilterObject>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<FilterObject>;
  or?: InputMaybe<Array<FilterObject>>;
};

export type FilterOwned = {
  and?: InputMaybe<Array<FilterOwned>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<FilterOwned>;
  or?: InputMaybe<Array<FilterOwned>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type FilterParticipant = {
  eq?: InputMaybe<Participant>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Participant>;
  gte?: InputMaybe<Participant>;
  in?: InputMaybe<Array<Participant>>;
  lt?: InputMaybe<Participant>;
  lte?: InputMaybe<Participant>;
  neq?: InputMaybe<Participant>;
};

export type FilterPerson = {
  addresses?: InputMaybe<person__NestedFilterAddress>;
  and?: InputMaybe<Array<FilterPerson>>;
  createdAt?: InputMaybe<FilterString>;
  dateOfBirth?: InputMaybe<FilterString>;
  emailAddress?: InputMaybe<FilterString>;
  familyName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<FilterPerson>;
  or?: InputMaybe<Array<FilterPerson>>;
  owner?: InputMaybe<NestedFilterUser>;
  phoneNumber?: InputMaybe<FilterString>;
  primary?: InputMaybe<FilterBoolean>;
  primaryAddress?: InputMaybe<person__NestedFilterAddress>;
};

export type FilterPersonal = {
  and?: InputMaybe<Array<FilterPersonal>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<FilterPersonal>;
  or?: InputMaybe<Array<FilterPersonal>>;
  person?: InputMaybe<NestedFilterPerson>;
};

export type FilterSlugged = {
  and?: InputMaybe<Array<FilterSlugged>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<FilterSlugged>;
  or?: InputMaybe<Array<FilterSlugged>>;
  slug?: InputMaybe<FilterString>;
};

export type FilterString = {
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUser = {
  accounts?: InputMaybe<fhirext__NestedFilterAccountVersion>;
  and?: InputMaybe<Array<FilterUser>>;
  anonymousConvertedAt?: InputMaybe<FilterString>;
  anonymousSessionId?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  deletionRequestedAt?: InputMaybe<FilterString>;
  emails?: InputMaybe<user__NestedFilterEmail>;
  explanationOfBenefits?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitVersion>;
  flexpaLinks?: InputMaybe<flexpa__NestedFilterLink>;
  hasSeenHome?: InputMaybe<FilterBoolean>;
  hipaaRelease?: InputMaybe<consent__NestedFilterHipaaRelease>;
  id?: InputMaybe<FilterID>;
  invoices?: InputMaybe<fhirext__NestedFilterInvoiceVersion>;
  isAdmin?: InputMaybe<FilterBoolean>;
  isAnonymous?: InputMaybe<FilterBoolean>;
  issues?: InputMaybe<issue__NestedFilterIssue>;
  lastAuthenticatedAt?: InputMaybe<FilterString>;
  lastSessionRefreshedAt?: InputMaybe<FilterString>;
  not?: InputMaybe<FilterUser>;
  notesAsHtml?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<FilterUser>>;
  persons?: InputMaybe<NestedFilterPerson>;
  primaryEmail?: InputMaybe<FilterString>;
  primaryPerson?: InputMaybe<NestedFilterPerson>;
  profile?: InputMaybe<user__NestedFilterProfile>;
  promoCodeUsages?: InputMaybe<payment__NestedFilterIssuePromoCodeUsage>;
  registrationSource?: InputMaybe<FilterString>;
  segmentationData?: InputMaybe<user__NestedFilterSegmentationData>;
  source?: InputMaybe<partner__NestedFilterPartner>;
  stytchId?: InputMaybe<FilterString>;
  tasks?: InputMaybe<taskManagement__NestedFilterTask>;
  templateReleases?: InputMaybe<consent__NestedFilterTemplateRelease>;
  userExitInsuranceLinkFeedback?: InputMaybe<webAgent__NestedFilterUserExitInsuranceLinkFeedback>;
  webAgentLinks?: InputMaybe<webAgent__NestedFilterLink>;
};

export type FiltercaseFact__FactSource = {
  eq?: InputMaybe<caseFact__FactSource>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<caseFact__FactSource>;
  gte?: InputMaybe<caseFact__FactSource>;
  in?: InputMaybe<Array<caseFact__FactSource>>;
  lt?: InputMaybe<caseFact__FactSource>;
  lte?: InputMaybe<caseFact__FactSource>;
  neq?: InputMaybe<caseFact__FactSource>;
};

export type FiltercaseFact__FactStatus = {
  eq?: InputMaybe<caseFact__FactStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<caseFact__FactStatus>;
  gte?: InputMaybe<caseFact__FactStatus>;
  in?: InputMaybe<Array<caseFact__FactStatus>>;
  lt?: InputMaybe<caseFact__FactStatus>;
  lte?: InputMaybe<caseFact__FactStatus>;
  neq?: InputMaybe<caseFact__FactStatus>;
};

export type Filterconsent__ConsentType = {
  eq?: InputMaybe<consent__ConsentType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<consent__ConsentType>;
  gte?: InputMaybe<consent__ConsentType>;
  in?: InputMaybe<Array<consent__ConsentType>>;
  lt?: InputMaybe<consent__ConsentType>;
  lte?: InputMaybe<consent__ConsentType>;
  neq?: InputMaybe<consent__ConsentType>;
};

export type FilterdataQuality__Dimension = {
  eq?: InputMaybe<dataQuality__Dimension>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<dataQuality__Dimension>;
  gte?: InputMaybe<dataQuality__Dimension>;
  in?: InputMaybe<Array<dataQuality__Dimension>>;
  lt?: InputMaybe<dataQuality__Dimension>;
  lte?: InputMaybe<dataQuality__Dimension>;
  neq?: InputMaybe<dataQuality__Dimension>;
};

export type Filterdocument__TemplateType = {
  eq?: InputMaybe<document__TemplateType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<document__TemplateType>;
  gte?: InputMaybe<document__TemplateType>;
  in?: InputMaybe<Array<document__TemplateType>>;
  lt?: InputMaybe<document__TemplateType>;
  lte?: InputMaybe<document__TemplateType>;
  neq?: InputMaybe<document__TemplateType>;
};

export type FiltereventTracking__EventType = {
  eq?: InputMaybe<eventTracking__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<eventTracking__EventType>;
  gte?: InputMaybe<eventTracking__EventType>;
  in?: InputMaybe<Array<eventTracking__EventType>>;
  lt?: InputMaybe<eventTracking__EventType>;
  lte?: InputMaybe<eventTracking__EventType>;
  neq?: InputMaybe<eventTracking__EventType>;
};

export type FiltereventTracking__LinkAttemptAbandonedReason = {
  eq?: InputMaybe<eventTracking__LinkAttemptAbandonedReason>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<eventTracking__LinkAttemptAbandonedReason>;
  gte?: InputMaybe<eventTracking__LinkAttemptAbandonedReason>;
  in?: InputMaybe<Array<eventTracking__LinkAttemptAbandonedReason>>;
  lt?: InputMaybe<eventTracking__LinkAttemptAbandonedReason>;
  lte?: InputMaybe<eventTracking__LinkAttemptAbandonedReason>;
  neq?: InputMaybe<eventTracking__LinkAttemptAbandonedReason>;
};

export type FiltereventTracking__LinkAttemptStatus = {
  eq?: InputMaybe<eventTracking__LinkAttemptStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<eventTracking__LinkAttemptStatus>;
  gte?: InputMaybe<eventTracking__LinkAttemptStatus>;
  in?: InputMaybe<Array<eventTracking__LinkAttemptStatus>>;
  lt?: InputMaybe<eventTracking__LinkAttemptStatus>;
  lte?: InputMaybe<eventTracking__LinkAttemptStatus>;
  neq?: InputMaybe<eventTracking__LinkAttemptStatus>;
};

export type Filterfeedback__AreaType = {
  eq?: InputMaybe<feedback__AreaType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<feedback__AreaType>;
  gte?: InputMaybe<feedback__AreaType>;
  in?: InputMaybe<Array<feedback__AreaType>>;
  lt?: InputMaybe<feedback__AreaType>;
  lte?: InputMaybe<feedback__AreaType>;
  neq?: InputMaybe<feedback__AreaType>;
};

export type Filterfeedback__SentimentType = {
  eq?: InputMaybe<feedback__SentimentType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<feedback__SentimentType>;
  gte?: InputMaybe<feedback__SentimentType>;
  in?: InputMaybe<Array<feedback__SentimentType>>;
  lt?: InputMaybe<feedback__SentimentType>;
  lte?: InputMaybe<feedback__SentimentType>;
  neq?: InputMaybe<feedback__SentimentType>;
};

export type FilterfhirEdit__CoverageRelationship = {
  eq?: InputMaybe<fhirEdit__CoverageRelationship>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhirEdit__CoverageRelationship>;
  gte?: InputMaybe<fhirEdit__CoverageRelationship>;
  in?: InputMaybe<Array<fhirEdit__CoverageRelationship>>;
  lt?: InputMaybe<fhirEdit__CoverageRelationship>;
  lte?: InputMaybe<fhirEdit__CoverageRelationship>;
  neq?: InputMaybe<fhirEdit__CoverageRelationship>;
};

export type FilterfhirEdit__ExplanationOfBenefitDecision = {
  eq?: InputMaybe<fhirEdit__ExplanationOfBenefitDecision>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhirEdit__ExplanationOfBenefitDecision>;
  gte?: InputMaybe<fhirEdit__ExplanationOfBenefitDecision>;
  in?: InputMaybe<Array<fhirEdit__ExplanationOfBenefitDecision>>;
  lt?: InputMaybe<fhirEdit__ExplanationOfBenefitDecision>;
  lte?: InputMaybe<fhirEdit__ExplanationOfBenefitDecision>;
  neq?: InputMaybe<fhirEdit__ExplanationOfBenefitDecision>;
};

export type FilterfhirEdit__ExplanationOfBenefitNetwork = {
  eq?: InputMaybe<fhirEdit__ExplanationOfBenefitNetwork>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhirEdit__ExplanationOfBenefitNetwork>;
  gte?: InputMaybe<fhirEdit__ExplanationOfBenefitNetwork>;
  in?: InputMaybe<Array<fhirEdit__ExplanationOfBenefitNetwork>>;
  lt?: InputMaybe<fhirEdit__ExplanationOfBenefitNetwork>;
  lte?: InputMaybe<fhirEdit__ExplanationOfBenefitNetwork>;
  neq?: InputMaybe<fhirEdit__ExplanationOfBenefitNetwork>;
};

export type FilterfhirEdit__ResourceEditStatus = {
  eq?: InputMaybe<fhirEdit__ResourceEditStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhirEdit__ResourceEditStatus>;
  gte?: InputMaybe<fhirEdit__ResourceEditStatus>;
  in?: InputMaybe<Array<fhirEdit__ResourceEditStatus>>;
  lt?: InputMaybe<fhirEdit__ResourceEditStatus>;
  lte?: InputMaybe<fhirEdit__ResourceEditStatus>;
  neq?: InputMaybe<fhirEdit__ResourceEditStatus>;
};

export type Filterfhir__AccountStatus = {
  eq?: InputMaybe<fhir__AccountStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__AccountStatus>;
  gte?: InputMaybe<fhir__AccountStatus>;
  in?: InputMaybe<Array<fhir__AccountStatus>>;
  lt?: InputMaybe<fhir__AccountStatus>;
  lte?: InputMaybe<fhir__AccountStatus>;
  neq?: InputMaybe<fhir__AccountStatus>;
};

export type Filterfhir__ChargeItemStatus = {
  eq?: InputMaybe<fhir__ChargeItemStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__ChargeItemStatus>;
  gte?: InputMaybe<fhir__ChargeItemStatus>;
  in?: InputMaybe<Array<fhir__ChargeItemStatus>>;
  lt?: InputMaybe<fhir__ChargeItemStatus>;
  lte?: InputMaybe<fhir__ChargeItemStatus>;
  neq?: InputMaybe<fhir__ChargeItemStatus>;
};

export type Filterfhir__ClaimUse = {
  eq?: InputMaybe<fhir__ClaimUse>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__ClaimUse>;
  gte?: InputMaybe<fhir__ClaimUse>;
  in?: InputMaybe<Array<fhir__ClaimUse>>;
  lt?: InputMaybe<fhir__ClaimUse>;
  lte?: InputMaybe<fhir__ClaimUse>;
  neq?: InputMaybe<fhir__ClaimUse>;
};

export type Filterfhir__CoverageKind = {
  eq?: InputMaybe<fhir__CoverageKind>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__CoverageKind>;
  gte?: InputMaybe<fhir__CoverageKind>;
  in?: InputMaybe<Array<fhir__CoverageKind>>;
  lt?: InputMaybe<fhir__CoverageKind>;
  lte?: InputMaybe<fhir__CoverageKind>;
  neq?: InputMaybe<fhir__CoverageKind>;
};

export type Filterfhir__CoverageType = {
  eq?: InputMaybe<fhir__CoverageType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__CoverageType>;
  gte?: InputMaybe<fhir__CoverageType>;
  in?: InputMaybe<Array<fhir__CoverageType>>;
  lt?: InputMaybe<fhir__CoverageType>;
  lte?: InputMaybe<fhir__CoverageType>;
  neq?: InputMaybe<fhir__CoverageType>;
};

export type Filterfhir__ExplanationOfBenefitStatus = {
  eq?: InputMaybe<fhir__ExplanationOfBenefitStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__ExplanationOfBenefitStatus>;
  gte?: InputMaybe<fhir__ExplanationOfBenefitStatus>;
  in?: InputMaybe<Array<fhir__ExplanationOfBenefitStatus>>;
  lt?: InputMaybe<fhir__ExplanationOfBenefitStatus>;
  lte?: InputMaybe<fhir__ExplanationOfBenefitStatus>;
  neq?: InputMaybe<fhir__ExplanationOfBenefitStatus>;
};

export type Filterfhir__FinancialResourceStatus = {
  eq?: InputMaybe<fhir__FinancialResourceStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__FinancialResourceStatus>;
  gte?: InputMaybe<fhir__FinancialResourceStatus>;
  in?: InputMaybe<Array<fhir__FinancialResourceStatus>>;
  lt?: InputMaybe<fhir__FinancialResourceStatus>;
  lte?: InputMaybe<fhir__FinancialResourceStatus>;
  neq?: InputMaybe<fhir__FinancialResourceStatus>;
};

export type Filterfhir__InvoiceStatus = {
  eq?: InputMaybe<fhir__InvoiceStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__InvoiceStatus>;
  gte?: InputMaybe<fhir__InvoiceStatus>;
  in?: InputMaybe<Array<fhir__InvoiceStatus>>;
  lt?: InputMaybe<fhir__InvoiceStatus>;
  lte?: InputMaybe<fhir__InvoiceStatus>;
  neq?: InputMaybe<fhir__InvoiceStatus>;
};

export type Filterfhir__PriceComponentType = {
  eq?: InputMaybe<fhir__PriceComponentType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__PriceComponentType>;
  gte?: InputMaybe<fhir__PriceComponentType>;
  in?: InputMaybe<Array<fhir__PriceComponentType>>;
  lt?: InputMaybe<fhir__PriceComponentType>;
  lte?: InputMaybe<fhir__PriceComponentType>;
  neq?: InputMaybe<fhir__PriceComponentType>;
};

export type Filterfhirext__FindingType = {
  eq?: InputMaybe<fhirext__FindingType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhirext__FindingType>;
  gte?: InputMaybe<fhirext__FindingType>;
  in?: InputMaybe<Array<fhirext__FindingType>>;
  lt?: InputMaybe<fhirext__FindingType>;
  lte?: InputMaybe<fhirext__FindingType>;
  neq?: InputMaybe<fhirext__FindingType>;
};

export type Filterfhirext__ResourceType = {
  eq?: InputMaybe<fhirext__ResourceType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhirext__ResourceType>;
  gte?: InputMaybe<fhirext__ResourceType>;
  in?: InputMaybe<Array<fhirext__ResourceType>>;
  lt?: InputMaybe<fhirext__ResourceType>;
  lte?: InputMaybe<fhirext__ResourceType>;
  neq?: InputMaybe<fhirext__ResourceType>;
};

export type Filterfhirext__ReviewStatus = {
  eq?: InputMaybe<fhirext__ReviewStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhirext__ReviewStatus>;
  gte?: InputMaybe<fhirext__ReviewStatus>;
  in?: InputMaybe<Array<fhirext__ReviewStatus>>;
  lt?: InputMaybe<fhirext__ReviewStatus>;
  lte?: InputMaybe<fhirext__ReviewStatus>;
  neq?: InputMaybe<fhirext__ReviewStatus>;
};

export type Filterflexpa__EndpointMode = {
  eq?: InputMaybe<flexpa__EndpointMode>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<flexpa__EndpointMode>;
  gte?: InputMaybe<flexpa__EndpointMode>;
  in?: InputMaybe<Array<flexpa__EndpointMode>>;
  lt?: InputMaybe<flexpa__EndpointMode>;
  lte?: InputMaybe<flexpa__EndpointMode>;
  neq?: InputMaybe<flexpa__EndpointMode>;
};

export type Filterflexpa__FlexpaImportStatus = {
  eq?: InputMaybe<flexpa__FlexpaImportStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<flexpa__FlexpaImportStatus>;
  gte?: InputMaybe<flexpa__FlexpaImportStatus>;
  in?: InputMaybe<Array<flexpa__FlexpaImportStatus>>;
  lt?: InputMaybe<flexpa__FlexpaImportStatus>;
  lte?: InputMaybe<flexpa__FlexpaImportStatus>;
  neq?: InputMaybe<flexpa__FlexpaImportStatus>;
};

export type Filterflexpa__LinkDeactivatedReason = {
  eq?: InputMaybe<flexpa__LinkDeactivatedReason>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<flexpa__LinkDeactivatedReason>;
  gte?: InputMaybe<flexpa__LinkDeactivatedReason>;
  in?: InputMaybe<Array<flexpa__LinkDeactivatedReason>>;
  lt?: InputMaybe<flexpa__LinkDeactivatedReason>;
  lte?: InputMaybe<flexpa__LinkDeactivatedReason>;
  neq?: InputMaybe<flexpa__LinkDeactivatedReason>;
};

export type Filterflexpa__OrganizationType = {
  eq?: InputMaybe<flexpa__OrganizationType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<flexpa__OrganizationType>;
  gte?: InputMaybe<flexpa__OrganizationType>;
  in?: InputMaybe<Array<flexpa__OrganizationType>>;
  lt?: InputMaybe<flexpa__OrganizationType>;
  lte?: InputMaybe<flexpa__OrganizationType>;
  neq?: InputMaybe<flexpa__OrganizationType>;
};

export type Filtergeolocation__State = {
  eq?: InputMaybe<geolocation__State>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<geolocation__State>;
  gte?: InputMaybe<geolocation__State>;
  in?: InputMaybe<Array<geolocation__State>>;
  lt?: InputMaybe<geolocation__State>;
  lte?: InputMaybe<geolocation__State>;
  neq?: InputMaybe<geolocation__State>;
};

export type Filteringestion__DistillationStatus = {
  eq?: InputMaybe<ingestion__DistillationStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<ingestion__DistillationStatus>;
  gte?: InputMaybe<ingestion__DistillationStatus>;
  in?: InputMaybe<Array<ingestion__DistillationStatus>>;
  lt?: InputMaybe<ingestion__DistillationStatus>;
  lte?: InputMaybe<ingestion__DistillationStatus>;
  neq?: InputMaybe<ingestion__DistillationStatus>;
};

export type Filteringestion__ExtractionType = {
  eq?: InputMaybe<ingestion__ExtractionType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<ingestion__ExtractionType>;
  gte?: InputMaybe<ingestion__ExtractionType>;
  in?: InputMaybe<Array<ingestion__ExtractionType>>;
  lt?: InputMaybe<ingestion__ExtractionType>;
  lte?: InputMaybe<ingestion__ExtractionType>;
  neq?: InputMaybe<ingestion__ExtractionType>;
};

export type Filteringestion__IngestionStatus = {
  eq?: InputMaybe<ingestion__IngestionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<ingestion__IngestionStatus>;
  gte?: InputMaybe<ingestion__IngestionStatus>;
  in?: InputMaybe<Array<ingestion__IngestionStatus>>;
  lt?: InputMaybe<ingestion__IngestionStatus>;
  lte?: InputMaybe<ingestion__IngestionStatus>;
  neq?: InputMaybe<ingestion__IngestionStatus>;
};

export type Filteringestion__IngestionStepType = {
  eq?: InputMaybe<ingestion__IngestionStepType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<ingestion__IngestionStepType>;
  gte?: InputMaybe<ingestion__IngestionStepType>;
  in?: InputMaybe<Array<ingestion__IngestionStepType>>;
  lt?: InputMaybe<ingestion__IngestionStepType>;
  lte?: InputMaybe<ingestion__IngestionStepType>;
  neq?: InputMaybe<ingestion__IngestionStepType>;
};

export type Filteringestion__IngestionStrategy = {
  eq?: InputMaybe<ingestion__IngestionStrategy>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<ingestion__IngestionStrategy>;
  gte?: InputMaybe<ingestion__IngestionStrategy>;
  in?: InputMaybe<Array<ingestion__IngestionStrategy>>;
  lt?: InputMaybe<ingestion__IngestionStrategy>;
  lte?: InputMaybe<ingestion__IngestionStrategy>;
  neq?: InputMaybe<ingestion__IngestionStrategy>;
};

export type Filteringestion__ResolutionStatus = {
  eq?: InputMaybe<ingestion__ResolutionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<ingestion__ResolutionStatus>;
  gte?: InputMaybe<ingestion__ResolutionStatus>;
  in?: InputMaybe<Array<ingestion__ResolutionStatus>>;
  lt?: InputMaybe<ingestion__ResolutionStatus>;
  lte?: InputMaybe<ingestion__ResolutionStatus>;
  neq?: InputMaybe<ingestion__ResolutionStatus>;
};

export type Filterissue__DocumentAnalysisStatus = {
  eq?: InputMaybe<issue__DocumentAnalysisStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__DocumentAnalysisStatus>;
  gte?: InputMaybe<issue__DocumentAnalysisStatus>;
  in?: InputMaybe<Array<issue__DocumentAnalysisStatus>>;
  lt?: InputMaybe<issue__DocumentAnalysisStatus>;
  lte?: InputMaybe<issue__DocumentAnalysisStatus>;
  neq?: InputMaybe<issue__DocumentAnalysisStatus>;
};

export type Filterissue__EventType = {
  eq?: InputMaybe<issue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__EventType>;
  gte?: InputMaybe<issue__EventType>;
  in?: InputMaybe<Array<issue__EventType>>;
  lt?: InputMaybe<issue__EventType>;
  lte?: InputMaybe<issue__EventType>;
  neq?: InputMaybe<issue__EventType>;
};

export type Filterissue__SavingsPreference = {
  eq?: InputMaybe<issue__SavingsPreference>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__SavingsPreference>;
  gte?: InputMaybe<issue__SavingsPreference>;
  in?: InputMaybe<Array<issue__SavingsPreference>>;
  lt?: InputMaybe<issue__SavingsPreference>;
  lte?: InputMaybe<issue__SavingsPreference>;
  neq?: InputMaybe<issue__SavingsPreference>;
};

export type FiltermodelExecution__LLMProvider = {
  eq?: InputMaybe<modelExecution__LLMProvider>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<modelExecution__LLMProvider>;
  gte?: InputMaybe<modelExecution__LLMProvider>;
  in?: InputMaybe<Array<modelExecution__LLMProvider>>;
  lt?: InputMaybe<modelExecution__LLMProvider>;
  lte?: InputMaybe<modelExecution__LLMProvider>;
  neq?: InputMaybe<modelExecution__LLMProvider>;
};

export type Filterpayment__PaymentStatus = {
  eq?: InputMaybe<payment__PaymentStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<payment__PaymentStatus>;
  gte?: InputMaybe<payment__PaymentStatus>;
  in?: InputMaybe<Array<payment__PaymentStatus>>;
  lt?: InputMaybe<payment__PaymentStatus>;
  lte?: InputMaybe<payment__PaymentStatus>;
  neq?: InputMaybe<payment__PaymentStatus>;
};

export type Filterpayment__PaymentTransactionType = {
  eq?: InputMaybe<payment__PaymentTransactionType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<payment__PaymentTransactionType>;
  gte?: InputMaybe<payment__PaymentTransactionType>;
  in?: InputMaybe<Array<payment__PaymentTransactionType>>;
  lt?: InputMaybe<payment__PaymentTransactionType>;
  lte?: InputMaybe<payment__PaymentTransactionType>;
  neq?: InputMaybe<payment__PaymentTransactionType>;
};

export type Filterpayment__SubscriptionStatus = {
  eq?: InputMaybe<payment__SubscriptionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<payment__SubscriptionStatus>;
  gte?: InputMaybe<payment__SubscriptionStatus>;
  in?: InputMaybe<Array<payment__SubscriptionStatus>>;
  lt?: InputMaybe<payment__SubscriptionStatus>;
  lte?: InputMaybe<payment__SubscriptionStatus>;
  neq?: InputMaybe<payment__SubscriptionStatus>;
};

export type Filterplan__PlanStatus = {
  eq?: InputMaybe<plan__PlanStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<plan__PlanStatus>;
  gte?: InputMaybe<plan__PlanStatus>;
  in?: InputMaybe<Array<plan__PlanStatus>>;
  lt?: InputMaybe<plan__PlanStatus>;
  lte?: InputMaybe<plan__PlanStatus>;
  neq?: InputMaybe<plan__PlanStatus>;
};

export type Filterplan__PlanType = {
  eq?: InputMaybe<plan__PlanType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<plan__PlanType>;
  gte?: InputMaybe<plan__PlanType>;
  in?: InputMaybe<Array<plan__PlanType>>;
  lt?: InputMaybe<plan__PlanType>;
  lte?: InputMaybe<plan__PlanType>;
  neq?: InputMaybe<plan__PlanType>;
};

export type Filterprojection__CaseLifecycle = {
  eq?: InputMaybe<projection__CaseLifecycle>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__CaseLifecycle>;
  gte?: InputMaybe<projection__CaseLifecycle>;
  in?: InputMaybe<Array<projection__CaseLifecycle>>;
  lt?: InputMaybe<projection__CaseLifecycle>;
  lte?: InputMaybe<projection__CaseLifecycle>;
  neq?: InputMaybe<projection__CaseLifecycle>;
};

export type Filterprojection__CdpProvider = {
  eq?: InputMaybe<projection__CdpProvider>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__CdpProvider>;
  gte?: InputMaybe<projection__CdpProvider>;
  in?: InputMaybe<Array<projection__CdpProvider>>;
  lt?: InputMaybe<projection__CdpProvider>;
  lte?: InputMaybe<projection__CdpProvider>;
  neq?: InputMaybe<projection__CdpProvider>;
};

export type Filterprojection__EligibilityCheckDispatchReason = {
  eq?: InputMaybe<projection__EligibilityCheckDispatchReason>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__EligibilityCheckDispatchReason>;
  gte?: InputMaybe<projection__EligibilityCheckDispatchReason>;
  in?: InputMaybe<Array<projection__EligibilityCheckDispatchReason>>;
  lt?: InputMaybe<projection__EligibilityCheckDispatchReason>;
  lte?: InputMaybe<projection__EligibilityCheckDispatchReason>;
  neq?: InputMaybe<projection__EligibilityCheckDispatchReason>;
};

export type Filterprojection__EligibilityCheckOutcome = {
  eq?: InputMaybe<projection__EligibilityCheckOutcome>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__EligibilityCheckOutcome>;
  gte?: InputMaybe<projection__EligibilityCheckOutcome>;
  in?: InputMaybe<Array<projection__EligibilityCheckOutcome>>;
  lt?: InputMaybe<projection__EligibilityCheckOutcome>;
  lte?: InputMaybe<projection__EligibilityCheckOutcome>;
  neq?: InputMaybe<projection__EligibilityCheckOutcome>;
};

export type Filterprojection__EnrichmentConfidence = {
  eq?: InputMaybe<projection__EnrichmentConfidence>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__EnrichmentConfidence>;
  gte?: InputMaybe<projection__EnrichmentConfidence>;
  in?: InputMaybe<Array<projection__EnrichmentConfidence>>;
  lt?: InputMaybe<projection__EnrichmentConfidence>;
  lte?: InputMaybe<projection__EnrichmentConfidence>;
  neq?: InputMaybe<projection__EnrichmentConfidence>;
};

export type Filterprojection__EnrichmentPriceRating = {
  eq?: InputMaybe<projection__EnrichmentPriceRating>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__EnrichmentPriceRating>;
  gte?: InputMaybe<projection__EnrichmentPriceRating>;
  in?: InputMaybe<Array<projection__EnrichmentPriceRating>>;
  lt?: InputMaybe<projection__EnrichmentPriceRating>;
  lte?: InputMaybe<projection__EnrichmentPriceRating>;
  neq?: InputMaybe<projection__EnrichmentPriceRating>;
};

export type Filterprojection__ProxyStrategy = {
  eq?: InputMaybe<projection__ProxyStrategy>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__ProxyStrategy>;
  gte?: InputMaybe<projection__ProxyStrategy>;
  in?: InputMaybe<Array<projection__ProxyStrategy>>;
  lt?: InputMaybe<projection__ProxyStrategy>;
  lte?: InputMaybe<projection__ProxyStrategy>;
  neq?: InputMaybe<projection__ProxyStrategy>;
};

export type Filterprojection__RpaConnectionStatus = {
  eq?: InputMaybe<projection__RpaConnectionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__RpaConnectionStatus>;
  gte?: InputMaybe<projection__RpaConnectionStatus>;
  in?: InputMaybe<Array<projection__RpaConnectionStatus>>;
  lt?: InputMaybe<projection__RpaConnectionStatus>;
  lte?: InputMaybe<projection__RpaConnectionStatus>;
  neq?: InputMaybe<projection__RpaConnectionStatus>;
};

export type Filterprojection__RpaSessionStatus = {
  eq?: InputMaybe<projection__RpaSessionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__RpaSessionStatus>;
  gte?: InputMaybe<projection__RpaSessionStatus>;
  in?: InputMaybe<Array<projection__RpaSessionStatus>>;
  lt?: InputMaybe<projection__RpaSessionStatus>;
  lte?: InputMaybe<projection__RpaSessionStatus>;
  neq?: InputMaybe<projection__RpaSessionStatus>;
};

export type Filterprojection__RpaTaskKind = {
  eq?: InputMaybe<projection__RpaTaskKind>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__RpaTaskKind>;
  gte?: InputMaybe<projection__RpaTaskKind>;
  in?: InputMaybe<Array<projection__RpaTaskKind>>;
  lt?: InputMaybe<projection__RpaTaskKind>;
  lte?: InputMaybe<projection__RpaTaskKind>;
  neq?: InputMaybe<projection__RpaTaskKind>;
};

export type Filterprojection__RpaTaskStatus = {
  eq?: InputMaybe<projection__RpaTaskStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__RpaTaskStatus>;
  gte?: InputMaybe<projection__RpaTaskStatus>;
  in?: InputMaybe<Array<projection__RpaTaskStatus>>;
  lt?: InputMaybe<projection__RpaTaskStatus>;
  lte?: InputMaybe<projection__RpaTaskStatus>;
  neq?: InputMaybe<projection__RpaTaskStatus>;
};

export type Filterprojection__StealthStrategy = {
  eq?: InputMaybe<projection__StealthStrategy>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__StealthStrategy>;
  gte?: InputMaybe<projection__StealthStrategy>;
  in?: InputMaybe<Array<projection__StealthStrategy>>;
  lt?: InputMaybe<projection__StealthStrategy>;
  lte?: InputMaybe<projection__StealthStrategy>;
  neq?: InputMaybe<projection__StealthStrategy>;
};

export type Filterprovider__ContactKind = {
  eq?: InputMaybe<provider__ContactKind>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__ContactKind>;
  gte?: InputMaybe<provider__ContactKind>;
  in?: InputMaybe<Array<provider__ContactKind>>;
  lt?: InputMaybe<provider__ContactKind>;
  lte?: InputMaybe<provider__ContactKind>;
  neq?: InputMaybe<provider__ContactKind>;
};

export type Filterprovider__ContactPurpose = {
  eq?: InputMaybe<provider__ContactPurpose>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__ContactPurpose>;
  gte?: InputMaybe<provider__ContactPurpose>;
  in?: InputMaybe<Array<provider__ContactPurpose>>;
  lt?: InputMaybe<provider__ContactPurpose>;
  lte?: InputMaybe<provider__ContactPurpose>;
  neq?: InputMaybe<provider__ContactPurpose>;
};

export type Filterprovider__FormType = {
  eq?: InputMaybe<provider__FormType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__FormType>;
  gte?: InputMaybe<provider__FormType>;
  in?: InputMaybe<Array<provider__FormType>>;
  lt?: InputMaybe<provider__FormType>;
  lte?: InputMaybe<provider__FormType>;
  neq?: InputMaybe<provider__FormType>;
};

export type Filterprovider__NegotiationStance = {
  eq?: InputMaybe<provider__NegotiationStance>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__NegotiationStance>;
  gte?: InputMaybe<provider__NegotiationStance>;
  in?: InputMaybe<Array<provider__NegotiationStance>>;
  lt?: InputMaybe<provider__NegotiationStance>;
  lte?: InputMaybe<provider__NegotiationStance>;
  neq?: InputMaybe<provider__NegotiationStance>;
};

export type Filterprovider__Ownership = {
  eq?: InputMaybe<provider__Ownership>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__Ownership>;
  gte?: InputMaybe<provider__Ownership>;
  in?: InputMaybe<Array<provider__Ownership>>;
  lt?: InputMaybe<provider__Ownership>;
  lte?: InputMaybe<provider__Ownership>;
  neq?: InputMaybe<provider__Ownership>;
};

export type Filterprovider__ProviderKind = {
  eq?: InputMaybe<provider__ProviderKind>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__ProviderKind>;
  gte?: InputMaybe<provider__ProviderKind>;
  in?: InputMaybe<Array<provider__ProviderKind>>;
  lt?: InputMaybe<provider__ProviderKind>;
  lte?: InputMaybe<provider__ProviderKind>;
  neq?: InputMaybe<provider__ProviderKind>;
};

export type Filterprovider__Source = {
  eq?: InputMaybe<provider__Source>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__Source>;
  gte?: InputMaybe<provider__Source>;
  in?: InputMaybe<Array<provider__Source>>;
  lt?: InputMaybe<provider__Source>;
  lte?: InputMaybe<provider__Source>;
  neq?: InputMaybe<provider__Source>;
};

export type Filterprovider__SubmissionChannel = {
  eq?: InputMaybe<provider__SubmissionChannel>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__SubmissionChannel>;
  gte?: InputMaybe<provider__SubmissionChannel>;
  in?: InputMaybe<Array<provider__SubmissionChannel>>;
  lt?: InputMaybe<provider__SubmissionChannel>;
  lte?: InputMaybe<provider__SubmissionChannel>;
  neq?: InputMaybe<provider__SubmissionChannel>;
};

export type Filtersegment__SegmentSource = {
  eq?: InputMaybe<segment__SegmentSource>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<segment__SegmentSource>;
  gte?: InputMaybe<segment__SegmentSource>;
  in?: InputMaybe<Array<segment__SegmentSource>>;
  lt?: InputMaybe<segment__SegmentSource>;
  lte?: InputMaybe<segment__SegmentSource>;
  neq?: InputMaybe<segment__SegmentSource>;
};

export type Filtersegment__SegmentStatus = {
  eq?: InputMaybe<segment__SegmentStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<segment__SegmentStatus>;
  gte?: InputMaybe<segment__SegmentStatus>;
  in?: InputMaybe<Array<segment__SegmentStatus>>;
  lt?: InputMaybe<segment__SegmentStatus>;
  lte?: InputMaybe<segment__SegmentStatus>;
  neq?: InputMaybe<segment__SegmentStatus>;
};

export type Filtersuggestion__SuggestedActionStatus = {
  eq?: InputMaybe<suggestion__SuggestedActionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<suggestion__SuggestedActionStatus>;
  gte?: InputMaybe<suggestion__SuggestedActionStatus>;
  in?: InputMaybe<Array<suggestion__SuggestedActionStatus>>;
  lt?: InputMaybe<suggestion__SuggestedActionStatus>;
  lte?: InputMaybe<suggestion__SuggestedActionStatus>;
  neq?: InputMaybe<suggestion__SuggestedActionStatus>;
};

export type FiltertaskManagement__TaskStatus = {
  eq?: InputMaybe<taskManagement__TaskStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<taskManagement__TaskStatus>;
  gte?: InputMaybe<taskManagement__TaskStatus>;
  in?: InputMaybe<Array<taskManagement__TaskStatus>>;
  lt?: InputMaybe<taskManagement__TaskStatus>;
  lte?: InputMaybe<taskManagement__TaskStatus>;
  neq?: InputMaybe<taskManagement__TaskStatus>;
};

export type FiltertaskManagement__TaskType = {
  eq?: InputMaybe<taskManagement__TaskType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<taskManagement__TaskType>;
  gte?: InputMaybe<taskManagement__TaskType>;
  in?: InputMaybe<Array<taskManagement__TaskType>>;
  lt?: InputMaybe<taskManagement__TaskType>;
  lte?: InputMaybe<taskManagement__TaskType>;
  neq?: InputMaybe<taskManagement__TaskType>;
};

export type FilterwebAgent__AiDiscoveryCrawlObjectiveResult = {
  eq?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
  gte?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
  in?: InputMaybe<Array<webAgent__AiDiscoveryCrawlObjectiveResult>>;
  lt?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
  lte?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
  neq?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
};

export type FilterwebAgent__AiDiscoveryCrawlObjectiveType = {
  eq?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveType>;
  gte?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveType>;
  in?: InputMaybe<Array<webAgent__AiDiscoveryCrawlObjectiveType>>;
  lt?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveType>;
  lte?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveType>;
  neq?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveType>;
};

export type FilterwebAgent__AiDiscoveryCrawlStatus = {
  eq?: InputMaybe<webAgent__AiDiscoveryCrawlStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__AiDiscoveryCrawlStatus>;
  gte?: InputMaybe<webAgent__AiDiscoveryCrawlStatus>;
  in?: InputMaybe<Array<webAgent__AiDiscoveryCrawlStatus>>;
  lt?: InputMaybe<webAgent__AiDiscoveryCrawlStatus>;
  lte?: InputMaybe<webAgent__AiDiscoveryCrawlStatus>;
  neq?: InputMaybe<webAgent__AiDiscoveryCrawlStatus>;
};

export type FilterwebAgent__BrowserbaseProxyStrategy = {
  eq?: InputMaybe<webAgent__BrowserbaseProxyStrategy>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__BrowserbaseProxyStrategy>;
  gte?: InputMaybe<webAgent__BrowserbaseProxyStrategy>;
  in?: InputMaybe<Array<webAgent__BrowserbaseProxyStrategy>>;
  lt?: InputMaybe<webAgent__BrowserbaseProxyStrategy>;
  lte?: InputMaybe<webAgent__BrowserbaseProxyStrategy>;
  neq?: InputMaybe<webAgent__BrowserbaseProxyStrategy>;
};

export type FilterwebAgent__BrowserbaseStealthStrategy = {
  eq?: InputMaybe<webAgent__BrowserbaseStealthStrategy>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__BrowserbaseStealthStrategy>;
  gte?: InputMaybe<webAgent__BrowserbaseStealthStrategy>;
  in?: InputMaybe<Array<webAgent__BrowserbaseStealthStrategy>>;
  lt?: InputMaybe<webAgent__BrowserbaseStealthStrategy>;
  lte?: InputMaybe<webAgent__BrowserbaseStealthStrategy>;
  neq?: InputMaybe<webAgent__BrowserbaseStealthStrategy>;
};

export type FilterwebAgent__CDPProvider = {
  eq?: InputMaybe<webAgent__CDPProvider>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__CDPProvider>;
  gte?: InputMaybe<webAgent__CDPProvider>;
  in?: InputMaybe<Array<webAgent__CDPProvider>>;
  lt?: InputMaybe<webAgent__CDPProvider>;
  lte?: InputMaybe<webAgent__CDPProvider>;
  neq?: InputMaybe<webAgent__CDPProvider>;
};

export type FilterwebAgent__CrawlType = {
  eq?: InputMaybe<webAgent__CrawlType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__CrawlType>;
  gte?: InputMaybe<webAgent__CrawlType>;
  in?: InputMaybe<Array<webAgent__CrawlType>>;
  lt?: InputMaybe<webAgent__CrawlType>;
  lte?: InputMaybe<webAgent__CrawlType>;
  neq?: InputMaybe<webAgent__CrawlType>;
};

export type FilterwebAgent__DataLatency = {
  eq?: InputMaybe<webAgent__DataLatency>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__DataLatency>;
  gte?: InputMaybe<webAgent__DataLatency>;
  in?: InputMaybe<Array<webAgent__DataLatency>>;
  lt?: InputMaybe<webAgent__DataLatency>;
  lte?: InputMaybe<webAgent__DataLatency>;
  neq?: InputMaybe<webAgent__DataLatency>;
};

export type FilterwebAgent__DataType = {
  eq?: InputMaybe<webAgent__DataType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__DataType>;
  gte?: InputMaybe<webAgent__DataType>;
  in?: InputMaybe<Array<webAgent__DataType>>;
  lt?: InputMaybe<webAgent__DataType>;
  lte?: InputMaybe<webAgent__DataType>;
  neq?: InputMaybe<webAgent__DataType>;
};

export type FilterwebAgent__EndpointSupportLevel = {
  eq?: InputMaybe<webAgent__EndpointSupportLevel>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__EndpointSupportLevel>;
  gte?: InputMaybe<webAgent__EndpointSupportLevel>;
  in?: InputMaybe<Array<webAgent__EndpointSupportLevel>>;
  lt?: InputMaybe<webAgent__EndpointSupportLevel>;
  lte?: InputMaybe<webAgent__EndpointSupportLevel>;
  neq?: InputMaybe<webAgent__EndpointSupportLevel>;
};

export type FilterwebAgent__EndpointType = {
  eq?: InputMaybe<webAgent__EndpointType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__EndpointType>;
  gte?: InputMaybe<webAgent__EndpointType>;
  in?: InputMaybe<Array<webAgent__EndpointType>>;
  lt?: InputMaybe<webAgent__EndpointType>;
  lte?: InputMaybe<webAgent__EndpointType>;
  neq?: InputMaybe<webAgent__EndpointType>;
};

export type FilterwebAgent__ExecutionOrigin = {
  eq?: InputMaybe<webAgent__ExecutionOrigin>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__ExecutionOrigin>;
  gte?: InputMaybe<webAgent__ExecutionOrigin>;
  in?: InputMaybe<Array<webAgent__ExecutionOrigin>>;
  lt?: InputMaybe<webAgent__ExecutionOrigin>;
  lte?: InputMaybe<webAgent__ExecutionOrigin>;
  neq?: InputMaybe<webAgent__ExecutionOrigin>;
};

export type FilterwebAgent__LinkDeactivatedReason = {
  eq?: InputMaybe<webAgent__LinkDeactivatedReason>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__LinkDeactivatedReason>;
  gte?: InputMaybe<webAgent__LinkDeactivatedReason>;
  in?: InputMaybe<Array<webAgent__LinkDeactivatedReason>>;
  lt?: InputMaybe<webAgent__LinkDeactivatedReason>;
  lte?: InputMaybe<webAgent__LinkDeactivatedReason>;
  neq?: InputMaybe<webAgent__LinkDeactivatedReason>;
};

export type FilterwebAgent__ManagedMfaOutcomeType = {
  eq?: InputMaybe<webAgent__ManagedMfaOutcomeType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__ManagedMfaOutcomeType>;
  gte?: InputMaybe<webAgent__ManagedMfaOutcomeType>;
  in?: InputMaybe<Array<webAgent__ManagedMfaOutcomeType>>;
  lt?: InputMaybe<webAgent__ManagedMfaOutcomeType>;
  lte?: InputMaybe<webAgent__ManagedMfaOutcomeType>;
  neq?: InputMaybe<webAgent__ManagedMfaOutcomeType>;
};

export type FilterwebAgent__MfaMethod = {
  eq?: InputMaybe<webAgent__MfaMethod>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__MfaMethod>;
  gte?: InputMaybe<webAgent__MfaMethod>;
  in?: InputMaybe<Array<webAgent__MfaMethod>>;
  lt?: InputMaybe<webAgent__MfaMethod>;
  lte?: InputMaybe<webAgent__MfaMethod>;
  neq?: InputMaybe<webAgent__MfaMethod>;
};

export type FilterwebAgent__MfaRequirement = {
  eq?: InputMaybe<webAgent__MfaRequirement>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__MfaRequirement>;
  gte?: InputMaybe<webAgent__MfaRequirement>;
  in?: InputMaybe<Array<webAgent__MfaRequirement>>;
  lt?: InputMaybe<webAgent__MfaRequirement>;
  lte?: InputMaybe<webAgent__MfaRequirement>;
  neq?: InputMaybe<webAgent__MfaRequirement>;
};

export type FilterwebAgent__MfaSupportLevel = {
  eq?: InputMaybe<webAgent__MfaSupportLevel>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__MfaSupportLevel>;
  gte?: InputMaybe<webAgent__MfaSupportLevel>;
  in?: InputMaybe<Array<webAgent__MfaSupportLevel>>;
  lt?: InputMaybe<webAgent__MfaSupportLevel>;
  lte?: InputMaybe<webAgent__MfaSupportLevel>;
  neq?: InputMaybe<webAgent__MfaSupportLevel>;
};

export type FilterwebAgent__SignInAnalysisCategory = {
  eq?: InputMaybe<webAgent__SignInAnalysisCategory>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__SignInAnalysisCategory>;
  gte?: InputMaybe<webAgent__SignInAnalysisCategory>;
  in?: InputMaybe<Array<webAgent__SignInAnalysisCategory>>;
  lt?: InputMaybe<webAgent__SignInAnalysisCategory>;
  lte?: InputMaybe<webAgent__SignInAnalysisCategory>;
  neq?: InputMaybe<webAgent__SignInAnalysisCategory>;
};

export type FilterwebAgent__SignInRobotType = {
  eq?: InputMaybe<webAgent__SignInRobotType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__SignInRobotType>;
  gte?: InputMaybe<webAgent__SignInRobotType>;
  in?: InputMaybe<Array<webAgent__SignInRobotType>>;
  lt?: InputMaybe<webAgent__SignInRobotType>;
  lte?: InputMaybe<webAgent__SignInRobotType>;
  neq?: InputMaybe<webAgent__SignInRobotType>;
};

export type FilterwebAgent__WebAgentExecutionArtifactType = {
  eq?: InputMaybe<webAgent__WebAgentExecutionArtifactType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__WebAgentExecutionArtifactType>;
  gte?: InputMaybe<webAgent__WebAgentExecutionArtifactType>;
  in?: InputMaybe<Array<webAgent__WebAgentExecutionArtifactType>>;
  lt?: InputMaybe<webAgent__WebAgentExecutionArtifactType>;
  lte?: InputMaybe<webAgent__WebAgentExecutionArtifactType>;
  neq?: InputMaybe<webAgent__WebAgentExecutionArtifactType>;
};

export type FilterwebAgent__WebAgentExecutionEventType = {
  eq?: InputMaybe<webAgent__WebAgentExecutionEventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__WebAgentExecutionEventType>;
  gte?: InputMaybe<webAgent__WebAgentExecutionEventType>;
  in?: InputMaybe<Array<webAgent__WebAgentExecutionEventType>>;
  lt?: InputMaybe<webAgent__WebAgentExecutionEventType>;
  lte?: InputMaybe<webAgent__WebAgentExecutionEventType>;
  neq?: InputMaybe<webAgent__WebAgentExecutionEventType>;
};

export type FilterwebAgent__WebExecutionStatus = {
  eq?: InputMaybe<webAgent__WebExecutionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__WebExecutionStatus>;
  gte?: InputMaybe<webAgent__WebExecutionStatus>;
  in?: InputMaybe<Array<webAgent__WebExecutionStatus>>;
  lt?: InputMaybe<webAgent__WebExecutionStatus>;
  lte?: InputMaybe<webAgent__WebExecutionStatus>;
  neq?: InputMaybe<webAgent__WebExecutionStatus>;
};

export type FilterwebAgent__WebExecutionType = {
  eq?: InputMaybe<webAgent__WebExecutionType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__WebExecutionType>;
  gte?: InputMaybe<webAgent__WebExecutionType>;
  in?: InputMaybe<Array<webAgent__WebExecutionType>>;
  lt?: InputMaybe<webAgent__WebExecutionType>;
  lte?: InputMaybe<webAgent__WebExecutionType>;
  neq?: InputMaybe<webAgent__WebExecutionType>;
};

export type FinalizeDocumentInput = {
  /** If true, the event occurred during case intake. */
  caseIntake?: InputMaybe<Scalars['Boolean']['input']>;
  documentId: Scalars['ID']['input'];
  /**
   * Document Label relates to the type of document that is being uploaded.
   *
   * e.g. InsuranceCard, ExplanationOfBenefits
   */
  documentLabel?: InputMaybe<Scalars['String']['input']>;
  /**
   * If present with issueId, will generate a internalDocumentUploaded
   * Id, if not this will be only added at the user level.
   */
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If present, will also generate a new document uploaded event for
   * the issue.
   */
  issueId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Optional flag. Set to false to prevent initial document upload events from
   * showing up in the user's chat list.
   */
  userVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinalizeDocumentResult = {
  __typename: 'FinalizeDocumentResult';
  document: document__Document;
};

export type ForceDeactivateLinkInput = {
  linkId: Scalars['String']['input'];
  pushNotify?: InputMaybe<Scalars['Boolean']['input']>;
  requestManagedMfa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormError = {
  __typename: 'FormError';
  /** Fields denotes specific fields that have an issue. */
  fields?: Maybe<Array<FieldError>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormOptions = {
  isDependent?: InputMaybe<Scalars['Boolean']['input']>;
  isNotSubscriber?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormOptionsV2 = {
  patientIsSelf?: InputMaybe<Scalars['Boolean']['input']>;
  patientIsSubscriber?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GenerateBenefitsSummaryInput = {
  documentId: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GeoLocation = {
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
};

export type GetAttemptStatusInput = {
  executionId: Scalars['ID']['input'];
};

export type GetPersonalizedPromptsResponse = {
  __typename: 'GetPersonalizedPromptsResponse';
  prompts: Array<PersonalizedPrompt>;
};

export type GetTemplateReleaseInput = {
  templateId: Scalars['String']['input'];
};

export type GetTemplateReleaseResult = {
  __typename: 'GetTemplateReleaseResult';
  templateAdditionalSections: Array<AdditionalSection>;
  templateFields: Array<FieldAttributes>;
  templateId: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
  templateOrgDisplayName?: Maybe<Scalars['String']['output']>;
  templateOrgDisplayUrl?: Maybe<Scalars['String']['output']>;
  templateOrgLoginUrl?: Maybe<Scalars['String']['output']>;
  templateOrgSlug?: Maybe<Scalars['String']['output']>;
};

export type ImportFlexpaDataInput = {
  flexpaLinkId: Scalars['ID']['input'];
};

export type IndexDocumentsInput = {
  executionId: Scalars['ID']['input'];
  reclassify?: InputMaybe<Scalars['Boolean']['input']>;
  sourceObjectiveId?: InputMaybe<Scalars['ID']['input']>;
};

export enum IngestionType {
  DOCUMENT = 'DOCUMENT',
  FLEXPA_IMPORT = 'FLEXPA_IMPORT',
  WEB_AGENT_EXECUTION = 'WEB_AGENT_EXECUTION'
}

export type InvalidCredentials = {
  __typename: 'InvalidCredentials';
  error: FormError;
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type InviteBeneficiaryInput = {
  /** Beneficiary to mint an invite token for. */
  beneficiaryId: Scalars['ID']['input'];
};

/** Non-PHI partner identity surfaced by an invite-token resolution. */
export type InviteTokenPartner = {
  __typename: 'InviteTokenPartner';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

/**
 * The non-PHI partner a beneficiary came through, plus the onboarding user once
 * the token has been redeemed.
 */
export type InviteTokenResolution = {
  __typename: 'InviteTokenResolution';
  partner: InviteTokenPartner;
  /** Null while the invite is outstanding; set once the token is redeemed. */
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum IssueType {
  BILL_DISPUTE = 'BILL_DISPUTE',
  DOCTOR_VISIT = 'DOCTOR_VISIT',
  MEDICAL_BILL = 'MEDICAL_BILL',
  ONBOARDING = 'ONBOARDING',
  OPEN_ENROLLMENT = 'OPEN_ENROLLMENT',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN'
}

export type LatestDiscoveryCrawl = {
  __typename: 'LatestDiscoveryCrawl';
  id: Scalars['ID']['output'];
  objectives?: Maybe<Array<LatestDiscoveryCrawlObjective>>;
};

export type LatestDiscoveryCrawlObjective = {
  __typename: 'LatestDiscoveryCrawlObjective';
  dataSlug: Scalars['String']['output'];
  status: webAgent__AiDiscoveryCrawlObjectiveResult;
};

export type LatestIngestion = {
  __typename: 'LatestIngestion';
  id: Scalars['ID']['output'];
  status?: Maybe<ingestion__IngestionStatus>;
};

export type LlmInput = {
  /**
   * Optional instructions for the LLM to setup context. E.g. 'You are an assistant helping users with their medical bills'.
   * While this can be done within the prompt as well, this is advanatgeous to keep separate as we develop more complex LLM interactions
   */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum number of tokens to generate. The model will stop once it generates this many tokens, unless it generates an end-of-text token first.
   * If not specified, defaults to 4096.
   */
  maxResponseTokens?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<LlmModel>;
  /** The prompt to send to the LLM. E.g. 'provide summary of the following EOB' */
  prompt: Scalars['String']['input'];
};

export enum LlmModel {
  GPT3 = 'GPT3',
  GPT4 = 'GPT4'
}

export type LlmResponse = {
  __typename: 'LlmResponse';
  completionTokens: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  promptTokens: Scalars['Int']['output'];
};

export type LocationInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type LoginSuccess = {
  __typename: 'LoginSuccess';
  configureManagedMfa?: Maybe<Scalars['Boolean']['output']>;
  linkId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type LoginToInstitutionInput = {
  encryptedCredentials: Credentials;
  endpointId: Scalars['String']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  workflowId: Scalars['String']['input'];
};

export type ManagedMfaApprovalRequired = {
  __typename: 'ManagedMfaApprovalRequired';
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type ManagedMfaConfigurationInput = {
  isSupported: Scalars['Boolean']['input'];
  supportedMethods: Array<webAgent__MfaMethod>;
};

export type ManuallyEscalateIssueInput = {
  issueId: Scalars['ID']['input'];
};

export type MarkPromoCodeUsageAsUnusedInput = {
  issueId: Scalars['ID']['input'];
};

export type MarkPromoCodeUsageAsUnusedResponse = {
  __typename: 'MarkPromoCodeUsageAsUnusedResponse';
  promoCodeUsage?: Maybe<PromoCodeUsageInfo>;
};

export type MarkRetoolNotificationAsReadInput = {
  notificationId: Scalars['ID']['input'];
};

export type MatchingPersonResult = FormError | NoMatchingPerson | Person_Type;

export type MemberInput = {
  endpointId: Scalars['String']['input'];
  portalUsername: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MergePersonsInput = {
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};

export type MetabaseResource = {
  dashboard: Scalars['Int']['input'];
};

export type MetabaseSignedUrl = {
  __typename: 'MetabaseSignedUrl';
  url: Scalars['String']['output'];
};

export type MetabaseSignedUrlInput = {
  resource: MetabaseResource;
};

export enum MfaMethodType {
  AUTHENTICATOR = 'AUTHENTICATOR',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  SMS = 'SMS'
}

export type MfaOption = {
  __typename: 'MfaOption';
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  method: MfaMethodType;
};

export type MfaRequired = {
  __typename: 'MfaRequired';
  mfaOptions: Array<MfaOption>;
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type Mutation = {
  __typename: 'Mutation';
  acceptBillPay?: Maybe<issue__BillPayRequestedEvent>;
  acceptBillPaymentEvent?: Maybe<issue__BillPaymentRequestedEvent>;
  /**
   * Admin-only: register a new beneficiary before onboarding and return its id.
   * Mints the aggregate id and records the optional delivery handle; the PHI
   * projection materializes asynchronously in the restricted Gel instance.
   * Available temporarily for testing only. TODO: remove once the ingestion pipeline registers beneficiaries from partner deliveries.
   */
  addBeneficiary: Scalars['ID']['output'];
  addUserQuitFeedback: BasicSuccessResponse;
  applyEpicEndpointChanges: ApplyEpicEndpointChangesResponse;
  applyPromoCodeUsage: ApplyPromoCodeUsageResponse;
  approveSuggestedAction: ApproveSuggestedActionResult;
  archiveConsentRelease: ArchiveConsentReleaseResult;
  archiveTemplate: ArchiveTemplateResult;
  assignPersonToPersonal?: Maybe<Personal>;
  assignUserSegment: AssignUserSegmentResult;
  authenticate: AuthenticateResult;
  /** @deprecated Use authenticate instead */
  authenticateMagicLink: AuthenticateMagicLinkResult;
  batchGenerateBenefitsSummary: Scalars['Boolean']['output'];
  batchIndexDocuments: Scalars['Boolean']['output'];
  batchReprocessIngestion: Scalars['Boolean']['output'];
  /** Bulk update the support level for multiple endpoints */
  bulkUpdateEndpointSupportLevels: BasicSuccessResponse;
  /**
   * Admin-only: remove a user from the eligibility program by emitting
   * `EligibilityEnrollmentEnded`. Idempotent — calling on an unenrolled
   * user is a no-op.
   */
  cancelEligibilityEnrollment: CancelEligibilityEnrollmentResult;
  cancelSubscription: CancelSubscriptionResponse;
  /** Cancel an active tailgate session */
  cancelTailgate: BasicSuccessResponse;
  caseAdvisorChat: CaseAdvisorChatResult;
  chargeBillPayment?: Maybe<ChargeBillPaymentResponse>;
  chargeNegotiatedBill?: Maybe<ChargeNegotiatedBillResponse>;
  chargePaymentProfile: ChargePaymentProfileResponse;
  checkAllInsuranceLinks?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Admin-only: run an eligibility verification for a user, optionally
   * dispatching the resulting accumulator snapshot as a domain event.
   * Used for manual end-to-end verification and one-off debug checks.
   */
  checkEligibility: EligibilityCheckResult;
  checkPersonMatch?: Maybe<MatchingPersonResult>;
  closeIssue?: Maybe<issue__Issue>;
  /** Generate a snapshot of a FHIR resource. */
  computeResourceSnapshot: ResourceSnapshotResult;
  createApplePayIntent: CreateApplePayIntentResponse;
  createBillPayRequestedEvent?: Maybe<issue__BillPayRequestedEvent>;
  createBusinessRule: BusinessRule;
  createCohort: Scalars['String']['output'];
  createDataQualityFlagTask?: Maybe<taskManagement__Task>;
  createDataQualityTask?: Maybe<taskManagement__Task>;
  /**
   * This is called first to create the initial document record, and
   * to get a presigned URL to upload the document to.
   */
  createDocument: CreateDocumentResult;
  createFlexpaLink?: Maybe<flexpa__Link>;
  createGeneralFeedback: CreateFeedbackResult;
  createIssueBillPaymentRequestedEvent?: Maybe<issue__BillPaymentRequestedEvent>;
  createIssueChatEvent?: Maybe<issue__ChatEvent>;
  createIssueClosurePaymentRequestedEvent?: Maybe<issue__ClosurePaymentRequestedEvent>;
  createIssueCommentEvent?: Maybe<issue__CommentEvent>;
  createIssueConnectAccountRequestedEvent?: Maybe<issue__ConnectAccountRequestedEvent>;
  createIssueFeedback: CreateFeedbackResult;
  createIssuePaymentAgreementRequestedEvent?: Maybe<issue__PaymentAgreementRequestedEvent>;
  createIssueTask?: Maybe<taskManagement__Task>;
  createIssueTemplateReleaseRequestedEvent?: Maybe<issue__TemplateReleaseRequestedEvent>;
  /**
   * Similar to createDocument, but allows for multiple files to be uploaded for a
   * single document.
   */
  createMultiFileDocument: CreateMultiFileDocumentResult;
  /** Create a new navigator specialist instruction */
  createNavigatorSpecialistInstructions: BasicSuccessResponse;
  /**
   * Admin-only: register a partner and, optionally, its groups in one call.
   * Fails if a partner with the same name already exists — names are unique and
   * a duplicate is rejected rather than merged.
   */
  createPartner: Partner;
  createPaymentProfile: CreatePaymentProfileResponse;
  createPerson?: Maybe<PersonResult>;
  createPhoneCall?: Maybe<taskManagement__PhoneCall>;
  createPromoCode: CreatePromoCodeResponse;
  createProvider?: Maybe<ProviderResult>;
  createProxyConfig?: Maybe<CreateProxyConfigResponse>;
  /**
   * Create a manual edit to a FHIR resource. This is used to correct errors
   * or add missing data to a FHIR resource that was ingested from an original source.
   */
  createResourceEdit: Scalars['ID']['output'];
  createRetoolNotification: notification__RetoolNotification;
  createReviewPaymentAcceptanceIssueTask?: Maybe<taskManagement__Task>;
  createSegment: CreateSegmentResult;
  createSetupIntent: CreateSetupIntentResponse;
  createSubscription: CreateSubscriptionResponse;
  createTaskComment?: Maybe<taskManagement__TaskComment>;
  createTemplate: CreateTemplateResult;
  /** Create a new web agent endpoint */
  createWebAgentEndpoint: CreateWebAgentEndpointResult;
  declineBillPay?: Maybe<issue__BillPayRequestedEvent>;
  deleteBusinessRule: Scalars['Boolean']['output'];
  /** Delete a navigator specialist page discovery */
  deleteNavigatorSpecialistPageDiscovery: BasicSuccessResponse;
  deletePaymentProfile: DeletePaymentProfileResponse;
  deleteQualityAssessment: Scalars['Boolean']['output'];
  /**
   * Removes an internal or not-yet-visible document from a user's account (admin only).
   * Fails if the document was already sent to the user as a normal upload, is linked to
   * automation sources, or does not belong to the given user.
   */
  deleteUserDocument: DeleteUserDocumentResult;
  directAwaitLoginResult: DirectLoginToInstitutionResult;
  directLoginToInstitution: DirectLoginToInstitutionResult;
  directRequestNewMfaCode: DirectRequestNewMfaCodeResult;
  directSelectMfaMethod: DirectSelectMfaMethodResult;
  directStartLinkCreation: StartLinkCreationResult;
  directStartRelink: DirectStartRelinkResult;
  directSubmitMfaCode: DirectSubmitMfaCodeResult;
  directSubmitSecurityAnswer: DirectSubmitSecurityAnswerResult;
  dismissFinding: Scalars['Boolean']['output'];
  /**
   * Run the currently-scheduled turn now (collapses its dispatchAt wait). The
   * scheduler is a singleton, so this expedites whatever turn is Scheduled;
   * no-op if none is pending. For operator/manual stepping.
   */
  expediteSchedulerTurn: Scalars['Boolean']['output'];
  fillTemplate: FillTemplateResult;
  /** This is called after the document has been successfully uploaded. */
  finalizeDocument: FinalizeDocumentResult;
  /** Deactivate a link forcing the user to relink it, optionally with a push notification */
  forceDeactivateLink?: Maybe<BasicSuccessResponse>;
  generateBenefitsSummary: Scalars['String']['output'];
  generateCaseRecommendation: Scalars['Boolean']['output'];
  generateMetabaseSignedUrl: MetabaseSignedUrl;
  headlessLogin: AuthenticateResult;
  importFlexpaData?: Maybe<Scalars['Boolean']['output']>;
  /** Non user-specific endpoint to retrieve existing users from Stytch. */
  importStytchUsers: StytchImportResult;
  indexDocuments: Scalars['Boolean']['output'];
  initiateAccountDeletion: Scalars['Boolean']['output'];
  initiateAccountDeletionV2: AccountDeletionResponse;
  /**
   * Admin-only: mint an invite token for a beneficiary. The token is NOT
   * returned — it rides the BeneficiaryInvited event into the restricted
   * instance and is read out-of-band from Gel to drive resolve/redeem.
   * Temporarily available for testing only. TODO: remove once the onboarding invite flow is wired.
   */
  inviteBeneficiary: Scalars['Boolean']['output'];
  logout: Scalars['Boolean']['output'];
  manuallyEscalateIssue?: Maybe<issue__Issue>;
  markPromoCodeUsageAsUnused?: Maybe<MarkPromoCodeUsageAsUnusedResponse>;
  markRetoolNotificationAsRead: notification__RetoolNotification;
  mergePersons?: Maybe<PersonResult>;
  /**
   * Admin-only: bind a beneficiary to the user who onboarded. Idempotent by
   * beneficiary id — a second onboard of an already-onboarded beneficiary is a
   * no-op.
   */
  onboardBeneficiary: Beneficiary;
  openNewIssue?: Maybe<issue__Issue>;
  openNewIssueFromPreview?: Maybe<issue__Issue>;
  processDocumentForAnalysis: ProcessDocumentForAnalysisResult;
  /**
   * General purpose free from interface to an LLM to facilitate prototyping and RnD.
   * Estabilished LLM mutations should be moved to their appropriate graphs
   */
  queryOpenai: LlmResponse;
  /**
   * Admin-only: sweep every user with eligibility-relevant data and
   * re-evaluate enrollment against the current readiness predicate.
   * Dispatches `enrollInEligibility` per user; the aggregate's decide
   * is the gate, so users who pass the predicate AND aren't already
   * enrolled get enrolled, and everyone else is a no-op. Idempotent —
   * safe to re-run after data backfills or readiness-logic changes.
   */
  recalculateEligibilityEnrollment: StartEligibilityWorkflowResult;
  recordIssueEventFeedback: CreateFeedbackResult;
  /**
   * Admin-only: redeem an invite token for a user — records the beneficiary's
   * onboarding and sets the user's source to the partner.
   * Temporarily available for testing only. TODO: remove once the onboarding invite flow is wired.
   */
  redeemInviteToken: InviteTokenResolution;
  refreshCodes: Scalars['Boolean']['output'];
  refreshFlexpaEndpoints?: Maybe<Scalars['Boolean']['output']>;
  removeProviderContactPoint?: Maybe<ProviderResult>;
  removeUserSegment: RemoveUserSegmentResult;
  reprocessDocument: Scalars['Boolean']['output'];
  reprocessFlexpaImport: Scalars['Boolean']['output'];
  reprocessIngestion: Scalars['Boolean']['output'];
  reprocessResourceAnalysis: Scalars['Boolean']['output'];
  reprocessResources: Scalars['Boolean']['output'];
  reprocessWebAgentExecution: Scalars['Boolean']['output'];
  resendMagicLink: ResendMagicLinkResult;
  /**
   * Admin-only: resolve an invite token to its partner and, once redeemed, the
   * onboarding user, without consuming it.
   * Temporarily available for testing only. TODO: remove once the onboarding invite flow is wired.
   */
  resolveInviteToken: InviteTokenResolution;
  /**
   * The ingestion pipeline generates a series of findings that we currently
   * expects staff members to review and approve.
   */
  reviewFinding: fhirext__Finding_Type;
  revokeFlexpaLink?: Maybe<Scalars['Boolean']['output']>;
  runAllHealthChecks: BasicSuccessResponse;
  saveNotes: SaveNotesResponse;
  scheduleDelayedCharge: ScheduleDelayedChargeResponse;
  selectPlanForEvent?: Maybe<issue__PlanSelectionEvent>;
  sendDocumentToUser: SendDocumentToUserResult;
  /**
   * Sends multiple documents to the user on the same issue in one request.
   * Each document gets a distinct `sentAt` on its upload event so ordering is stable.
   */
  sendDocumentsToUser: SendDocumentsToUserResult;
  sendMagicLink: SendMagicLinkResult;
  setDefaultEndpointProxyConfig?: Maybe<BasicSuccessResponse>;
  setDefaultLinkProxyConfig?: Maybe<BasicSuccessResponse>;
  setEndpointCdpProvider?: Maybe<BasicSuccessResponse>;
  setWebAgentEndpointIngestionSupported?: Maybe<BasicSuccessResponse>;
  /**
   * Admin-only endpoint to convert an existing session to a shadow login session.
   * Throws an error if the current user is not an admin.
   * Returns a FormError if the target user does not exist.
   * The new session token will appear in the usual place on the response - either as
   * a cookie, or in the response extensions.
   */
  shadowLogin: AuthUserResult;
  signAndSaveTemplate: SignAndSaveTemplateResult;
  /**
   * Signs an anonymous session ID to create a JWT with 24-hour expiration.
   * The client should generate a UUID, call this mutation to sign it, then use
   * the returned token as the X-Anonymous-Session-ID header.
   */
  signAnonymousSession: Scalars['String']['output'];
  /** Users give us consent to have access to their medical records by signing a HIPAA release form. */
  signHipaaRelease: SignHipaaReleaseResult;
  signTemplate: SignTemplateResult;
  staffOpenNewIssue?: Maybe<issue__Issue>;
  startBackfill: StartBackfillResult;
  startEventReplay: StartBackfillResult;
  startExperiment: Scalars['String']['output'];
  startHealthCheck: BasicSuccessResponse;
  /**
   * Walk every user with at least one active synced webagent link and
   * dispatch `MemberReceived` per (user, link) pair using payer info
   * from the link's endpoint and subscriber identity from the user's
   * HIPAA Person row. Idempotent — the aggregate's structural-equality
   * decide drops events for memberships already at the same key.
   * Card-derived Member rows are never overwritten because the
   * materialization key shape is deliberately disjoint.
   */
  startLinkBackfill: StartBackfillResult;
  startLinkSignIn?: Maybe<StartLinkSignInResponse>;
  startPersonBackfill: StartBackfillResult;
  /** Start RPA Debug workflow */
  startRPADebug: StartRPADebugResponse;
  /** Trigger a recrawl by looking up the link from an execution ID */
  startRecrawlFromExecution: StartRecrawlResponse;
  /** Trigger a recrawl for a specific link by link ID */
  startRecrawlFromLink: StartRecrawlResponse;
  /** Start a tailgate session (ES-first: dispatches domain command, reactor starts workflow) */
  startTailgate: StartTailgateResult;
  stopExperiment: Scalars['Boolean']['output'];
  /** Stop RPA Debug workflow */
  stopRPADebug: BasicSuccessResponse;
  submitManagedMfaApproval: RpaCommandResult;
  submitMessage: RedisResponse;
  submitRecommendationFeedback: Scalars['Boolean']['output'];
  summarizeDocument: DocumentSummaryResult;
  trackInsuranceLinkAttempt: EventTrackingResult;
  triggerNotifyUsersOfFindings: NotifyUsersOfFindingsResult;
  updateBusinessRule: BusinessRule;
  /** Update the crawl objective review for a web agent */
  updateCrawlObjectiveReview: BasicSuccessResponse;
  /** Update the crawl review for a web agent */
  updateCrawlReview: BasicSuccessResponse;
  updateDefaultTemplate: UpdateDefaultTemplateResult;
  updateDocumentName: UpdateDocumentNameResult;
  /** Update a capability for an endpoint */
  updateEndpointCapability: BasicSuccessResponse;
  /** Update the support level for an endpoint */
  updateEndpointSupportLevel: BasicSuccessResponse;
  updateFileName: UpdateFileNameResult;
  updateFinding: Scalars['Boolean']['output'];
  updateIngestionResolutionStatus: Scalars['Boolean']['output'];
  updateInsuranceLinkAttemptInvestigationUrls: Array<Maybe<UpdateInsuranceLinkAttemptInvestigationUrlResult>>;
  updateIssue?: Maybe<issue__Issue>;
  updateIssueCommentEventPinned?: Maybe<issue__CommentEvent>;
  updateIssueEvent?: Maybe<issue__Event>;
  /** Update an existing navigator specialist instruction */
  updateNavigatorSpecialistInstructions: BasicSuccessResponse;
  /** Update the isActive flag for a navigator specialist page discovery */
  updateNavigatorSpecialistPageDiscoveryIsActive: BasicSuccessResponse;
  /** Update the discovery JSON for a navigator specialist page discovery */
  updateNavigatorSpecialistPageDiscoveryJson: BasicSuccessResponse;
  updatePaymentAgreementEvent?: Maybe<issue__PaymentAgreementRequestedEvent>;
  updatePaymentProfile: UpdatePaymentProfileResponse;
  updatePerson?: Maybe<PersonResult>;
  updatePersonAddress?: Maybe<PersonResult>;
  updatePromoCode: UpdatePromoCodeResponse;
  updateProvider?: Maybe<ProviderResult>;
  /** Update the sign-in review for a web agent execution */
  updateSignInReview: UpdateSignInReviewResult;
  updateSubscriptionPaymentMethod: UpdateSubscriptionPaymentMethodResponse;
  updateTask?: Maybe<taskManagement__Task>;
  updateTaskComment?: Maybe<taskManagement__TaskComment>;
  updateTaskCommentPinned?: Maybe<taskManagement__TaskComment>;
  updateTemplates: UpdateTemplatesResult;
  /** Update an existing web agent endpoint */
  updateWebAgentEndpoint: BasicSuccessResponse;
  upsertProviderContactPoint?: Maybe<ProviderResult>;
  upsertUserSegmentationData: user__SegmentationData;
  validateTemplate: ValidateTemplateResult;
};


export type MutationacceptBillPayArgs = {
  input: AcceptBillPayInput;
};


export type MutationacceptBillPaymentEventArgs = {
  input?: InputMaybe<AcceptBillPaymentEventInput>;
};


export type MutationaddBeneficiaryArgs = {
  input: AddBeneficiaryInput;
};


export type MutationaddUserQuitFeedbackArgs = {
  input: AddUserQuitFeedbackInput;
};


export type MutationapplyEpicEndpointChangesArgs = {
  input: ApplyEpicEndpointChangesInput;
};


export type MutationapplyPromoCodeUsageArgs = {
  input: ApplyPromoCodeUsageInput;
};


export type MutationapproveSuggestedActionArgs = {
  input: ApproveSuggestedActionInput;
};


export type MutationarchiveConsentReleaseArgs = {
  input: ArchiveConsentReleaseInput;
};


export type MutationarchiveTemplateArgs = {
  input: ArchiveTemplateInput;
};


export type MutationassignPersonToPersonalArgs = {
  input: AssignPersonToPersonalInput;
};


export type MutationassignUserSegmentArgs = {
  input: AssignUserSegmentInput;
};


export type MutationauthenticateArgs = {
  input: AuthenticateInput;
};


export type MutationauthenticateMagicLinkArgs = {
  input: AuthenticateMagicLinkInput;
};


export type MutationbatchGenerateBenefitsSummaryArgs = {
  input: BatchGenerateBenefitsSummaryInput;
};


export type MutationbatchIndexDocumentsArgs = {
  input: BatchIndexDocumentsInput;
};


export type MutationbatchReprocessIngestionArgs = {
  input: BatchReprocessIngestionInput;
};


export type MutationbulkUpdateEndpointSupportLevelsArgs = {
  input: BulkUpdateEndpointSupportLevelsInput;
};


export type MutationcancelEligibilityEnrollmentArgs = {
  input: CancelEligibilityEnrollmentInput;
};


export type MutationcancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationcancelTailgateArgs = {
  input: CancelTailgateInput;
};


export type MutationcaseAdvisorChatArgs = {
  input: CaseAdvisorChatInput;
};


export type MutationchargeBillPaymentArgs = {
  input: ChargeBillPaymentInput;
};


export type MutationchargeNegotiatedBillArgs = {
  input: ChargeNegotiatedBillInput;
};


export type MutationchargePaymentProfileArgs = {
  input: ChargePaymentProfileInput;
};


export type MutationcheckEligibilityArgs = {
  input: EligibilityCheckInput;
};


export type MutationcheckPersonMatchArgs = {
  input: CheckPersonMatchInput;
};


export type MutationcloseIssueArgs = {
  input?: InputMaybe<CloseIssueInput>;
};


export type MutationcomputeResourceSnapshotArgs = {
  input: ComputeResourceSnapshotInput;
};


export type MutationcreateBillPayRequestedEventArgs = {
  input: CreateBillPayRequestedEventInput;
};


export type MutationcreateBusinessRuleArgs = {
  input: CreateBusinessRuleInput;
};


export type MutationcreateCohortArgs = {
  members: Array<MemberInput>;
  name: Scalars['String']['input'];
};


export type MutationcreateDataQualityFlagTaskArgs = {
  input: CreateDataQualityFlagTaskInput;
};


export type MutationcreateDataQualityTaskArgs = {
  input: CreateDataQualityTaskInput;
};


export type MutationcreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationcreateFlexpaLinkArgs = {
  input?: InputMaybe<CreateFlexpaLinkInput>;
};


export type MutationcreateGeneralFeedbackArgs = {
  input: CreateGeneralFeedbackInput;
};


export type MutationcreateIssueBillPaymentRequestedEventArgs = {
  input?: InputMaybe<CreateIssueBillPaymentRequestedEventInput>;
};


export type MutationcreateIssueChatEventArgs = {
  input?: InputMaybe<CreateIssueChatEventInput>;
};


export type MutationcreateIssueClosurePaymentRequestedEventArgs = {
  input?: InputMaybe<CreateIssueClosurePaymentRequestedEventInput>;
};


export type MutationcreateIssueCommentEventArgs = {
  input?: InputMaybe<CreateIssueCommentEventInput>;
};


export type MutationcreateIssueConnectAccountRequestedEventArgs = {
  input?: InputMaybe<CreateIssueConnectAccountRequestedEventInput>;
};


export type MutationcreateIssueFeedbackArgs = {
  input: CreateIssueFeedbackInput;
};


export type MutationcreateIssuePaymentAgreementRequestedEventArgs = {
  input?: InputMaybe<CreateIssuePaymentAgreementRequestedEventInput>;
};


export type MutationcreateIssueTaskArgs = {
  input: CreateIssueTaskInput;
};


export type MutationcreateIssueTemplateReleaseRequestedEventArgs = {
  input?: InputMaybe<CreateIssueTemplateReleaseRequestedEventInput>;
};


export type MutationcreateMultiFileDocumentArgs = {
  input: CreateMultiFileDocumentInput;
};


export type MutationcreateNavigatorSpecialistInstructionsArgs = {
  input: CreateNavigatorSpecialistInstructionsInput;
};


export type MutationcreatePartnerArgs = {
  input: CreatePartnerInput;
};


export type MutationcreatePersonArgs = {
  input: CreatePersonInput;
};


export type MutationcreatePhoneCallArgs = {
  input: CreatePhoneCallInput;
};


export type MutationcreatePromoCodeArgs = {
  input: CreatePromoCodeInput;
};


export type MutationcreateProviderArgs = {
  input: CreateProviderInput;
};


export type MutationcreateProxyConfigArgs = {
  input?: InputMaybe<CreateProxyConfigInput>;
};


export type MutationcreateResourceEditArgs = {
  input: CreateResourceEditInput;
};


export type MutationcreateRetoolNotificationArgs = {
  input: CreateRetoolNotificationInput;
};


export type MutationcreateReviewPaymentAcceptanceIssueTaskArgs = {
  input: CreateReviewPaymentAcceptanceIssueTaskInput;
};


export type MutationcreateSegmentArgs = {
  input: CreateSegmentInput;
};


export type MutationcreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationcreateTaskCommentArgs = {
  input: CreateTaskCommentInput;
};


export type MutationcreateTemplateArgs = {
  input: CreateTemplateInput;
};


export type MutationcreateWebAgentEndpointArgs = {
  input?: InputMaybe<CreateWebAgentEndpointInput>;
};


export type MutationdeclineBillPayArgs = {
  input: DeclineBillPayInput;
};


export type MutationdeleteBusinessRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteNavigatorSpecialistPageDiscoveryArgs = {
  input?: InputMaybe<DeleteNavigatorSpecialistPageDiscoveryInput>;
};


export type MutationdeleteQualityAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteUserDocumentArgs = {
  input: DeleteUserDocumentInput;
};


export type MutationdirectAwaitLoginResultArgs = {
  input: DirectAwaitLoginResultInput;
};


export type MutationdirectLoginToInstitutionArgs = {
  input: LoginToInstitutionInput;
};


export type MutationdirectRequestNewMfaCodeArgs = {
  input: RequestNewMfaCodeInput;
};


export type MutationdirectSelectMfaMethodArgs = {
  input: SelectMfaMethodInput;
};


export type MutationdirectStartLinkCreationArgs = {
  input: StartLinkCreationInput;
};


export type MutationdirectStartRelinkArgs = {
  input: StartLinkRelinkInput;
};


export type MutationdirectSubmitMfaCodeArgs = {
  input: SubmitMfaCodeInput;
};


export type MutationdirectSubmitSecurityAnswerArgs = {
  input: SubmitSecurityAnswerInput;
};


export type MutationdismissFindingArgs = {
  input: DismissFindingInput;
};


export type MutationfillTemplateArgs = {
  input: FillTemplateInput;
};


export type MutationfinalizeDocumentArgs = {
  input: FinalizeDocumentInput;
};


export type MutationforceDeactivateLinkArgs = {
  input?: InputMaybe<ForceDeactivateLinkInput>;
};


export type MutationgenerateBenefitsSummaryArgs = {
  input: GenerateBenefitsSummaryInput;
};


export type MutationgenerateCaseRecommendationArgs = {
  issueId: Scalars['ID']['input'];
};


export type MutationgenerateMetabaseSignedUrlArgs = {
  input: MetabaseSignedUrlInput;
};


export type MutationheadlessLoginArgs = {
  email: Scalars['String']['input'];
  passkey: Scalars['String']['input'];
};


export type MutationimportFlexpaDataArgs = {
  input?: InputMaybe<ImportFlexpaDataInput>;
};


export type MutationindexDocumentsArgs = {
  input: IndexDocumentsInput;
};


export type MutationinviteBeneficiaryArgs = {
  input: InviteBeneficiaryInput;
};


export type MutationmanuallyEscalateIssueArgs = {
  input: ManuallyEscalateIssueInput;
};


export type MutationmarkPromoCodeUsageAsUnusedArgs = {
  input: MarkPromoCodeUsageAsUnusedInput;
};


export type MutationmarkRetoolNotificationAsReadArgs = {
  input: MarkRetoolNotificationAsReadInput;
};


export type MutationmergePersonsArgs = {
  input: MergePersonsInput;
};


export type MutationonboardBeneficiaryArgs = {
  input: OnboardBeneficiaryInput;
};


export type MutationopenNewIssueArgs = {
  input?: InputMaybe<OpenNewIssueInput>;
};


export type MutationopenNewIssueFromPreviewArgs = {
  input?: InputMaybe<OpenNewIssueFromPreviewInput>;
};


export type MutationprocessDocumentForAnalysisArgs = {
  input: ProcessDocumentForAnalysisInput;
};


export type MutationqueryOpenaiArgs = {
  input: LlmInput;
};


export type MutationrecalculateEligibilityEnrollmentArgs = {
  input: RecalculateEligibilityEnrollmentInput;
};


export type MutationrecordIssueEventFeedbackArgs = {
  input: RecordIssueEventFeedbackInput;
};


export type MutationredeemInviteTokenArgs = {
  input: RedeemInviteTokenInput;
};


export type MutationremoveProviderContactPointArgs = {
  input: RemoveProviderContactPointInput;
};


export type MutationremoveUserSegmentArgs = {
  input: RemoveUserSegmentInput;
};


export type MutationreprocessDocumentArgs = {
  input: ReprocessDocumentInput;
};


export type MutationreprocessFlexpaImportArgs = {
  input: ReprocessFlexpaImportInput;
};


export type MutationreprocessIngestionArgs = {
  input: ReprocessIngestionInput;
};


export type MutationreprocessResourceAnalysisArgs = {
  input: reprocessResourceAnalysisInput;
};


export type MutationreprocessResourcesArgs = {
  input: ReprocessResourcesInput;
};


export type MutationreprocessWebAgentExecutionArgs = {
  input: ReprocessWebAgentExecutionInput;
};


export type MutationresendMagicLinkArgs = {
  input: ResendMagicLinkInput;
};


export type MutationresolveInviteTokenArgs = {
  input: ResolveInviteTokenInput;
};


export type MutationreviewFindingArgs = {
  input: ReviewFindingInput;
};


export type MutationrevokeFlexpaLinkArgs = {
  input?: InputMaybe<RevokeFlexpaLinkInput>;
};


export type MutationrunAllHealthChecksArgs = {
  input?: InputMaybe<RunAllHealthChecksInput>;
};


export type MutationsaveNotesArgs = {
  input: SaveNotesInput;
};


export type MutationscheduleDelayedChargeArgs = {
  input: ScheduleDelayedChargeInput;
};


export type MutationselectPlanForEventArgs = {
  input: SelectPlanForEventInput;
};


export type MutationsendDocumentToUserArgs = {
  input: SendDocumentToUserInput;
};


export type MutationsendDocumentsToUserArgs = {
  input: SendDocumentsToUserInput;
};


export type MutationsendMagicLinkArgs = {
  input: SendMagicLinkInput;
};


export type MutationsetDefaultEndpointProxyConfigArgs = {
  input?: InputMaybe<SetDefaultEndpointProxyConfigInput>;
};


export type MutationsetDefaultLinkProxyConfigArgs = {
  input?: InputMaybe<SetDefaultLinkProxyConfigInput>;
};


export type MutationsetEndpointCdpProviderArgs = {
  input?: InputMaybe<SetEndpointCdpProviderInput>;
};


export type MutationsetWebAgentEndpointIngestionSupportedArgs = {
  input?: InputMaybe<SetWebAgentEndpointIngestionSupportedInput>;
};


export type MutationshadowLoginArgs = {
  input: ShadowLoginInput;
};


export type MutationsignAndSaveTemplateArgs = {
  input: SignAndSaveTemplateInput;
};


export type MutationsignAnonymousSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationsignHipaaReleaseArgs = {
  input: SignHipaaReleaseInput;
};


export type MutationsignTemplateArgs = {
  input: SignTemplateInput;
};


export type MutationstaffOpenNewIssueArgs = {
  input?: InputMaybe<StaffOpenNewIssueInput>;
};


export type MutationstartBackfillArgs = {
  input: StartBackfillInput;
};


export type MutationstartEventReplayArgs = {
  input: StartEventReplayInput;
};


export type MutationstartExperimentArgs = {
  cohortId: Scalars['String']['input'];
  initialState?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationstartHealthCheckArgs = {
  input?: InputMaybe<StartHealthCheckInput>;
};


export type MutationstartLinkBackfillArgs = {
  input: StartLinkBackfillInput;
};


export type MutationstartLinkSignInArgs = {
  input?: InputMaybe<StartLinkSignInInput>;
};


export type MutationstartPersonBackfillArgs = {
  input: StartPersonBackfillInput;
};


export type MutationstartRPADebugArgs = {
  input: StartRPADebugInput;
};


export type MutationstartRecrawlFromExecutionArgs = {
  input: StartRecrawlFromExecutionInput;
};


export type MutationstartRecrawlFromLinkArgs = {
  input: StartRecrawlFromLinkInput;
};


export type MutationstartTailgateArgs = {
  input: StartTailgateInput;
};


export type MutationstopExperimentArgs = {
  experimentId: Scalars['String']['input'];
};


export type MutationstopRPADebugArgs = {
  input: StopRPADebugInput;
};


export type MutationsubmitManagedMfaApprovalArgs = {
  input?: InputMaybe<SubmitManagedMfaApprovalInput>;
};


export type MutationsubmitMessageArgs = {
  input: RedisMessage;
};


export type MutationsubmitRecommendationFeedbackArgs = {
  input: RecommendationFeedbackInput;
};


export type MutationsummarizeDocumentArgs = {
  input: SummarizeDocumentInput;
};


export type MutationtrackInsuranceLinkAttemptArgs = {
  input: TrackInsuranceLinkAttemptInput;
};


export type MutationupdateBusinessRuleArgs = {
  input: UpdateBusinessRuleInput;
};


export type MutationupdateCrawlObjectiveReviewArgs = {
  input: UpdateCrawlObjectiveReviewInput;
};


export type MutationupdateCrawlReviewArgs = {
  input: UpdateCrawlReviewInput;
};


export type MutationupdateDefaultTemplateArgs = {
  input: UpdateDefaultTemplateInput;
};


export type MutationupdateDocumentNameArgs = {
  input: UpdateDocumentNameInput;
};


export type MutationupdateEndpointCapabilityArgs = {
  input: UpdateEndpointCapabilityInput;
};


export type MutationupdateEndpointSupportLevelArgs = {
  input: UpdateEndpointSupportLevelInput;
};


export type MutationupdateFileNameArgs = {
  input: UpdateFileNameInput;
};


export type MutationupdateFindingArgs = {
  input: UpdateFindingInput;
};


export type MutationupdateIngestionResolutionStatusArgs = {
  input: UpdateIngestionResolutionStatusInput;
};


export type MutationupdateInsuranceLinkAttemptInvestigationUrlsArgs = {
  input: Array<InputMaybe<UpdateInsuranceLinkAttemptInvestigationUrlInput>>;
};


export type MutationupdateIssueArgs = {
  input?: InputMaybe<UpdateIssueInput>;
};


export type MutationupdateIssueCommentEventPinnedArgs = {
  input: UpdateIssueCommentEventPinnedInput;
};


export type MutationupdateIssueEventArgs = {
  input?: InputMaybe<UpdateIssueEventInput>;
};


export type MutationupdateNavigatorSpecialistInstructionsArgs = {
  input: UpdateNavigatorSpecialistInstructionsInput;
};


export type MutationupdateNavigatorSpecialistPageDiscoveryIsActiveArgs = {
  input?: InputMaybe<UpdateNavigatorSpecialistPageDiscoveryIsActiveInput>;
};


export type MutationupdateNavigatorSpecialistPageDiscoveryJsonArgs = {
  input?: InputMaybe<UpdateNavigatorSpecialistPageDiscoveryJsonInput>;
};


export type MutationupdatePaymentAgreementEventArgs = {
  input?: InputMaybe<UpdatePaymentAgreementEventInput>;
};


export type MutationupdatePaymentProfileArgs = {
  input: UpdatePaymentProfileInput;
};


export type MutationupdatePersonArgs = {
  input: UpdatePersonInput;
};


export type MutationupdatePersonAddressArgs = {
  input: UpdatePersonAddressInput;
};


export type MutationupdatePromoCodeArgs = {
  input: UpdatePromoCodeInput;
};


export type MutationupdateProviderArgs = {
  input: UpdateProviderInput;
};


export type MutationupdateSignInReviewArgs = {
  input: UpdateSignInReviewInput;
};


export type MutationupdateSubscriptionPaymentMethodArgs = {
  input: UpdateSubscriptionPaymentMethodInput;
};


export type MutationupdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationupdateTaskCommentArgs = {
  input: UpdateTaskCommentInput;
};


export type MutationupdateTaskCommentPinnedArgs = {
  input: UpdateTaskCommentPinnedInput;
};


export type MutationupdateTemplatesArgs = {
  input: UpdateTemplatesInput;
};


export type MutationupdateWebAgentEndpointArgs = {
  input?: InputMaybe<UpdateWebAgentEndpointInput>;
};


export type MutationupsertProviderContactPointArgs = {
  input: UpsertProviderContactPointInput;
};


export type MutationupsertUserSegmentationDataArgs = {
  input: UpsertUserSegmentationDataInput;
};


export type MutationvalidateTemplateArgs = {
  input: ValidateTemplateInput;
};

export type NestedFilterPerson = {
  addresses?: InputMaybe<person__NestedFilterAddress>;
  createdAt?: InputMaybe<FilterString>;
  dateOfBirth?: InputMaybe<FilterString>;
  emailAddress?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  familyName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  phoneNumber?: InputMaybe<FilterString>;
  primary?: InputMaybe<FilterBoolean>;
  primaryAddress?: InputMaybe<person__NestedFilterAddress>;
};

export type NestedFilterUser = {
  accounts?: InputMaybe<fhirext__NestedFilterAccountVersion>;
  anonymousConvertedAt?: InputMaybe<FilterString>;
  anonymousSessionId?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  deletionRequestedAt?: InputMaybe<FilterString>;
  emails?: InputMaybe<user__NestedFilterEmail>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  explanationOfBenefits?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitVersion>;
  flexpaLinks?: InputMaybe<flexpa__NestedFilterLink>;
  hasSeenHome?: InputMaybe<FilterBoolean>;
  hipaaRelease?: InputMaybe<consent__NestedFilterHipaaRelease>;
  id?: InputMaybe<FilterID>;
  invoices?: InputMaybe<fhirext__NestedFilterInvoiceVersion>;
  isAdmin?: InputMaybe<FilterBoolean>;
  isAnonymous?: InputMaybe<FilterBoolean>;
  issues?: InputMaybe<issue__NestedFilterIssue>;
  lastAuthenticatedAt?: InputMaybe<FilterString>;
  lastSessionRefreshedAt?: InputMaybe<FilterString>;
  notesAsHtml?: InputMaybe<FilterString>;
  persons?: InputMaybe<NestedFilterPerson>;
  primaryEmail?: InputMaybe<FilterString>;
  primaryPerson?: InputMaybe<NestedFilterPerson>;
  profile?: InputMaybe<user__NestedFilterProfile>;
  promoCodeUsages?: InputMaybe<payment__NestedFilterIssuePromoCodeUsage>;
  registrationSource?: InputMaybe<FilterString>;
  segmentationData?: InputMaybe<user__NestedFilterSegmentationData>;
  source?: InputMaybe<partner__NestedFilterPartner>;
  stytchId?: InputMaybe<FilterString>;
  tasks?: InputMaybe<taskManagement__NestedFilterTask>;
  templateReleases?: InputMaybe<consent__NestedFilterTemplateRelease>;
  userExitInsuranceLinkFeedback?: InputMaybe<webAgent__NestedFilterUserExitInsuranceLinkFeedback>;
  webAgentLinks?: InputMaybe<webAgent__NestedFilterLink>;
};

export type NoMatchingPerson = {
  __typename: 'NoMatchingPerson';
  dob: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type NotifyUsersOfFindingsResult = {
  __typename: 'NotifyUsersOfFindingsResult';
  success: Scalars['Boolean']['output'];
  workflowId?: Maybe<Scalars['String']['output']>;
};

/** Root object type for user-defined types */
export type Object = {
  id: Scalars['ID']['output'];
};

export type OnboardBeneficiaryInput = {
  /** The beneficiary being onboarded. */
  beneficiaryId: Scalars['ID']['input'];
  /** The user who onboarded. Recorded on the beneficiary. */
  userId: Scalars['ID']['input'];
};

export type OpenNewIssueFromPreviewInput = {
  caseType: Scalars['String']['input'];
  /** @deprecated The endpoint now supports document uploads as part of the messages array. This flag should be false in those cases and will be removed in a future release. */
  isFromUpload?: InputMaybe<Scalars['Boolean']['input']>;
  messages: Array<PreviewMessage>;
  title: Scalars['String']['input'];
};

export type OpenNewIssueInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  benefitsCoverage?: InputMaybe<Scalars['String']['input']>;
  benefitsInclude?: InputMaybe<Array<Scalars['String']['input']>>;
  benefitsPrice?: InputMaybe<Scalars['String']['input']>;
  benefitsQuestionType?: InputMaybe<Scalars['String']['input']>;
  billDisputeType?: InputMaybe<Scalars['String']['input']>;
  caseType?: InputMaybe<Scalars['String']['input']>;
  eobId?: InputMaybe<Scalars['String']['input']>;
  healthRecordKey?: InputMaybe<Scalars['String']['input']>;
  healthRecordKind?: InputMaybe<Scalars['String']['input']>;
  includeInitialSystemMessage?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  issueType?: InputMaybe<IssueType>;
  personId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  withUserMessage?: InputMaybe<Scalars['String']['input']>;
};

export type OrderBaseObject = {
  id?: InputMaybe<Ordering>;
};

export type OrderObject = {
  id?: InputMaybe<Ordering>;
};

export type OrderOwned = {
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type OrderPerson = {
  createdAt?: InputMaybe<Ordering>;
  dateOfBirth?: InputMaybe<Ordering>;
  emailAddress?: InputMaybe<Ordering>;
  familyName?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  phoneNumber?: InputMaybe<Ordering>;
  primary?: InputMaybe<Ordering>;
  primaryAddress?: InputMaybe<person__OrderAddress>;
};

export type OrderPersonal = {
  id?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
};

export type OrderSlugged = {
  id?: InputMaybe<Ordering>;
  slug?: InputMaybe<Ordering>;
};

export type OrderUser = {
  anonymousConvertedAt?: InputMaybe<Ordering>;
  anonymousSessionId?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  deletionRequestedAt?: InputMaybe<Ordering>;
  hasSeenHome?: InputMaybe<Ordering>;
  hipaaRelease?: InputMaybe<consent__OrderHipaaRelease>;
  id?: InputMaybe<Ordering>;
  isAdmin?: InputMaybe<Ordering>;
  isAnonymous?: InputMaybe<Ordering>;
  lastAuthenticatedAt?: InputMaybe<Ordering>;
  lastSessionRefreshedAt?: InputMaybe<Ordering>;
  notesAsHtml?: InputMaybe<Ordering>;
  primaryEmail?: InputMaybe<Ordering>;
  primaryPerson?: InputMaybe<OrderPerson>;
  profile?: InputMaybe<user__OrderProfile>;
  registrationSource?: InputMaybe<Ordering>;
  segmentationData?: InputMaybe<user__OrderSegmentationData>;
  source?: InputMaybe<partner__OrderPartner>;
  stytchId?: InputMaybe<Ordering>;
};

export type Ordering = {
  dir: directionEnum;
  nulls?: InputMaybe<nullsOrderingEnum>;
};

export type Owned = {
  id: Scalars['ID']['output'];
  owner: User;
};


export type OwnedownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum Participant {
  SERVICE = 'SERVICE',
  STAFF = 'STAFF',
  USER = 'USER'
}

/**
 * An external organization Granted has a partnership with. Non-PHI
 * configuration.
 */
export type Partner = {
  __typename: 'Partner';
  createdAt: Scalars['DateTime']['output'];
  groups: Array<PartnerGroup>;
  id: Scalars['ID']['output'];
  /**
   * False when the partner has been deactivated. Deactivated partners are
   * retained so existing links and lineage survive.
   */
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Stable, human-readable handle derived from the name at creation. Unique. */
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A group or unit within a partner. */
export type PartnerGroup = {
  __typename: 'PartnerGroup';
  createdAt: Scalars['DateTime']['output'];
  /**
   * The partner's own identifier for the group in their system. Null when not
   * yet known.
   */
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentProfile = {
  __typename: 'PaymentProfile';
  cardDetails?: Maybe<CardDetails>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  hasPaymentMethod: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stripeCustomerId: Scalars['String']['output'];
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type Person = {
  addresses?: Maybe<Array<person__Address>>;
  createdAt: Scalars['String']['output'];
  dateOfBirth: Scalars['String']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenNames?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  matchKeys: Array<Scalars['String']['output']>;
  owner: User;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  primaryAddress?: Maybe<person__Address>;
};


export type PersonaddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<person__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<person__OrderAddress>;
};


export type PersonownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type PersonprimaryAddressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<person__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<person__OrderAddress>;
};

export type PersonAddress = {
  city: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type PersonAddressUpsertInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type PersonResult = FormError | Person_Type;

export type PersonUpsertInput = {
  address?: InputMaybe<PersonAddressUpsertInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenNames?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Person_Type = BaseObject & Object & Owned & Person & {
  __typename: 'Person_Type';
  addresses?: Maybe<Array<person__Address>>;
  createdAt: Scalars['String']['output'];
  dateOfBirth: Scalars['String']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenNames?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  matchKeys: Array<Scalars['String']['output']>;
  owner: User;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  primaryAddress?: Maybe<person__Address>;
};


export type Person_TypeaddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<person__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<person__OrderAddress>;
};


export type Person_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type Person_TypeprimaryAddressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<person__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<person__OrderAddress>;
};

export type Personal = {
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
};


export type PersonalpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};

export type PersonalizedPrompt = {
  __typename: 'PersonalizedPrompt';
  caseType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  response: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type PlanDocumentsDataTypeStatus = BenefitSummaryCreated | DataTypeNotSupported | DataTypeProcessing;

export type PlanEpicEndpointChangesInput = {
  epicJsonData: Scalars['String']['input'];
};

export type PlanEpicEndpointChangesResponse = {
  __typename: 'PlanEpicEndpointChangesResponse';
  changes: Array<EpicEndpointChange>;
};

export type PreviewMessage = {
  systemMessageInfo?: InputMaybe<SystemPreviewMessage>;
  type: PreviewMessageType;
  userMessageInfo?: InputMaybe<UserPreviewMessage>;
};

export enum PreviewMessageType {
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}

export type ProcessDocumentForAnalysisInput = {
  /** Document ID for the analysis */
  documentId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Optional event ID to retry. If not provided, a new event will be created.
   * If provided, the workflow will reuse this event for tracking.
   */
  eventId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Deprecated: a failed analysis is now handled by the bill-checker agent
   * rather than auto-escalation, so the upload workflow no longer reads this.
   * Kept optional for backward compatibility with existing clients.
   * @deprecated No longer influences workflow behavior; use domain events for future retries instead
   */
  isRetry?: InputMaybe<Scalars['Boolean']['input']>;
  /** Issue ID the document belongs to */
  issueId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProcessDocumentForAnalysisResult = {
  __typename: 'ProcessDocumentForAnalysisResult';
  event?: Maybe<issue__DocumentAnalysisEvent>;
  /** Whether the workflow was started successfully */
  success: Scalars['Boolean']['output'];
  /** The Temporal workflow ID that was started */
  workflowId: Scalars['String']['output'];
};

export type PromoCodeUsageInfo = {
  __typename: 'PromoCodeUsageInfo';
  id: Scalars['ID']['output'];
  issueId?: Maybe<Scalars['ID']['output']>;
  promoCode: payment__PromoCode_Type;
  usedAt?: Maybe<Scalars['String']['output']>;
};

export type ProviderContactPointInput = {
  kind: provider__ContactKind;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to General when omitted. */
  purpose?: InputMaybe<provider__ContactPurpose>;
  value: Scalars['String']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderResult = FormError | provider__Provider_Type;

export type QualityAssessment = {
  __typename: 'QualityAssessment';
  id: Scalars['ID']['output'];
  ingestion?: Maybe<ingestion__Ingestion>;
  metrics: Scalars['JSON']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  owner: User;
  performedAt: Scalars['DateTime']['output'];
  resource: fhirext__ResourceVersion;
  score: Scalars['Int']['output'];
  sourceName?: Maybe<Scalars['String']['output']>;
  taskCount: Scalars['Int']['output'];
  uncompletedTaskCount: Scalars['Int']['output'];
};

export type QualityAssessmentFilter = {
  documentId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  executionId?: InputMaybe<Scalars['ID']['input']>;
  maxScore?: InputMaybe<Scalars['Int']['input']>;
  minScore?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Query = {
  __typename: 'Query';
  BaseObject?: Maybe<Array<BaseObject>>;
  Object?: Maybe<Array<Object>>;
  Owned?: Maybe<Array<Owned>>;
  Person?: Maybe<Array<Person>>;
  Personal?: Maybe<Array<Personal>>;
  Slugged?: Maybe<Array<Slugged>>;
  User?: Maybe<Array<User>>;
  /**
   * Internal types placeholder - ensures RpaStatusResult types are generated.
   * This query is not implemented and should not be used.
   * TODO: Remove when doneToStatusResult is refactored to not use these types.
   */
  _internalRpaStatusPlaceholder?: Maybe<RpaStatusResult>;
  /** Get address autocomplete suggestions (max 5 results, no pagination) */
  addressAutocomplete?: Maybe<AddressAutocompleteResponse>;
  /** Get detailed address information for a specific place ID */
  addressDetails?: Maybe<AddressDetails>;
  allRetoolNotifications: Array<notification__RetoolNotification>;
  /**
   * Admin-only: every beneficiary in the restricted instance, newest first.
   * This surface reads PHI and is gated to admins. Temporarily available for testing only.
   */
  beneficiaries: Array<Beneficiary>;
  businessRules: Array<BusinessRule>;
  cache__SerifFairMarketValue?: Maybe<Array<cache__SerifFairMarketValue>>;
  caseFact__CaseFact?: Maybe<Array<caseFact__CaseFact>>;
  caseFact__CaseFactAudit?: Maybe<Array<caseFact__CaseFactAudit>>;
  /** Check if the client version is supported by the API service. */
  checkClientVersion: CheckClientVersionResponse;
  /** Get the current supported binary version and update ID for the client. */
  clientSupportedVersion: ClientSupportedVersionResponse;
  coding__CPT?: Maybe<Array<coding__CPT>>;
  coding__CPTModifier?: Maybe<Array<coding__CPTModifier>>;
  coding__Coding?: Maybe<Array<coding__Coding>>;
  coding__HCPCS?: Maybe<Array<coding__HCPCS>>;
  coding__HCPCSModifier?: Maybe<Array<coding__HCPCSModifier>>;
  consent__Consent?: Maybe<Array<consent__Consent>>;
  consent__HipaaRelease?: Maybe<Array<consent__HipaaRelease>>;
  consent__TemplateRelease?: Maybe<Array<consent__TemplateRelease>>;
  countFlaggedExplanationOfBenefits: Scalars['Int']['output'];
  dataQuality__Assessment?: Maybe<Array<dataQuality__Assessment>>;
  dataQuality__BusinessRule?: Maybe<Array<dataQuality__BusinessRule>>;
  document__Document?: Maybe<Array<document__Document>>;
  document__DocumentSummary?: Maybe<Array<document__DocumentSummary>>;
  document__File?: Maybe<Array<document__File>>;
  document__ParseResult?: Maybe<Array<document__ParseResult>>;
  document__Template?: Maybe<Array<document__Template>>;
  document__TemplateField?: Maybe<Array<document__TemplateField>>;
  eventStore__Event?: Maybe<Array<eventStore__Event>>;
  eventTracking__BaseEvent?: Maybe<Array<eventTracking__BaseEvent>>;
  eventTracking__InsuranceLinkAttempt?: Maybe<Array<eventTracking__InsuranceLinkAttempt>>;
  feedback__GeneralFeedback?: Maybe<Array<feedback__GeneralFeedback>>;
  feedback__IssueEventFeedback?: Maybe<Array<feedback__IssueEventFeedback>>;
  feedback__IssueFeedback?: Maybe<Array<feedback__IssueFeedback>>;
  feedback__Option?: Maybe<Array<feedback__Option>>;
  feedback__StaffFeedback?: Maybe<Array<feedback__StaffFeedback>>;
  feedback__UserFeedback?: Maybe<Array<feedback__UserFeedback>>;
  fhirEdit__CoverageEdit?: Maybe<Array<fhirEdit__CoverageEdit>>;
  fhirEdit__CoverageSnapshot?: Maybe<Array<fhirEdit__CoverageSnapshot>>;
  fhirEdit__ExplanationOfBenefitEdit?: Maybe<Array<fhirEdit__ExplanationOfBenefitEdit>>;
  fhirEdit__ExplanationOfBenefitSnapshot?: Maybe<Array<fhirEdit__ExplanationOfBenefitSnapshot>>;
  fhirEdit__ResourceEdit?: Maybe<Array<fhirEdit__ResourceEdit>>;
  fhirEdit__ResourceSnapshot?: Maybe<Array<fhirEdit__ResourceSnapshot>>;
  fhir__Account?: Maybe<Array<fhir__Account>>;
  fhir__AccountBalance?: Maybe<Array<fhir__AccountBalance>>;
  fhir__AccountGuarantor?: Maybe<Array<fhir__AccountGuarantor>>;
  fhir__Address?: Maybe<Array<fhir__Address>>;
  fhir__Annotation?: Maybe<Array<fhir__Annotation>>;
  fhir__ChargeItem?: Maybe<Array<fhir__ChargeItem>>;
  fhir__ChargeItemPerformer?: Maybe<Array<fhir__ChargeItemPerformer>>;
  fhir__ClinicalNote?: Maybe<Array<fhir__ClinicalNote>>;
  fhir__CodeableConcept?: Maybe<Array<fhir__CodeableConcept>>;
  fhir__CodeableReference?: Maybe<Array<fhir__CodeableReference>>;
  fhir__Coding?: Maybe<Array<fhir__Coding>>;
  fhir__ContactPoint?: Maybe<Array<fhir__ContactPoint>>;
  fhir__Coverage?: Maybe<Array<fhir__Coverage>>;
  fhir__CoverageClass?: Maybe<Array<fhir__CoverageClass>>;
  fhir__Encounter?: Maybe<Array<fhir__Encounter>>;
  fhir__EncounterParticipant?: Maybe<Array<fhir__EncounterParticipant>>;
  fhir__ExplanationOfBenefit?: Maybe<Array<fhir__ExplanationOfBenefit>>;
  fhir__ExplanationOfBenefitCareTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  fhir__ExplanationOfBenefitDiagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  fhir__ExplanationOfBenefitItem?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  fhir__ExplanationOfBenefitItemAdjudication?: Maybe<Array<fhir__ExplanationOfBenefitItemAdjudication>>;
  fhir__ExplanationOfBenefitItemReviewOutcome?: Maybe<Array<fhir__ExplanationOfBenefitItemReviewOutcome>>;
  fhir__ExplanationOfBenefitTotal?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  fhir__FHIRResource?: Maybe<Array<fhir__FHIRResource>>;
  fhir__HumanName?: Maybe<Array<fhir__HumanName>>;
  fhir__Identifier?: Maybe<Array<fhir__Identifier>>;
  fhir__Invoice?: Maybe<Array<fhir__Invoice>>;
  fhir__InvoiceLineItem?: Maybe<Array<fhir__InvoiceLineItem>>;
  fhir__InvoiceParticipant?: Maybe<Array<fhir__InvoiceParticipant>>;
  fhir__Location?: Maybe<Array<fhir__Location>>;
  fhir__MonetaryComponent?: Maybe<Array<fhir__MonetaryComponent>>;
  fhir__Money?: Maybe<Array<fhir__Money>>;
  fhir__Patient?: Maybe<Array<fhir__Patient>>;
  fhir__Practitioner?: Maybe<Array<fhir__Practitioner>>;
  fhir__Quantity?: Maybe<Array<fhir__Quantity>>;
  fhir__Reference?: Maybe<Array<fhir__Reference>>;
  fhirext__Account?: Maybe<Array<fhirext__Account>>;
  fhirext__AccountVersion?: Maybe<Array<fhirext__AccountVersion>>;
  fhirext__Coverage?: Maybe<Array<fhirext__Coverage>>;
  fhirext__CoverageExtension?: Maybe<Array<fhirext__CoverageExtension>>;
  fhirext__CoverageVersion?: Maybe<Array<fhirext__CoverageVersion>>;
  fhirext__Encounter?: Maybe<Array<fhirext__Encounter>>;
  fhirext__EncounterVersion?: Maybe<Array<fhirext__EncounterVersion>>;
  fhirext__ExplanationOfBenefit?: Maybe<Array<fhirext__ExplanationOfBenefit>>;
  fhirext__ExplanationOfBenefitExtension?: Maybe<Array<fhirext__ExplanationOfBenefitExtension>>;
  fhirext__ExplanationOfBenefitTotalsByType?: Maybe<Array<fhirext__ExplanationOfBenefitTotalsByType>>;
  fhirext__ExplanationOfBenefitVersion?: Maybe<Array<fhirext__ExplanationOfBenefitVersion>>;
  fhirext__Finding?: Maybe<Array<fhirext__Finding>>;
  fhirext__FindingReview?: Maybe<Array<fhirext__FindingReview>>;
  fhirext__Invoice?: Maybe<Array<fhirext__Invoice>>;
  fhirext__InvoiceTotalsByType?: Maybe<Array<fhirext__InvoiceTotalsByType>>;
  fhirext__InvoiceVersion?: Maybe<Array<fhirext__InvoiceVersion>>;
  fhirext__Patient?: Maybe<Array<fhirext__Patient>>;
  fhirext__PatientVersion?: Maybe<Array<fhirext__PatientVersion>>;
  fhirext__Practitioner?: Maybe<Array<fhirext__Practitioner>>;
  fhirext__PractitionerVersion?: Maybe<Array<fhirext__PractitionerVersion>>;
  fhirext__ResourceAssociation?: Maybe<Array<fhirext__ResourceAssociation>>;
  fhirext__ResourceIdentifier?: Maybe<Array<fhirext__ResourceIdentifier>>;
  fhirext__ResourceVersion?: Maybe<Array<fhirext__ResourceVersion>>;
  flexpa__Endpoint?: Maybe<Array<flexpa__Endpoint>>;
  flexpa__FlexpaImport?: Maybe<Array<flexpa__FlexpaImport>>;
  flexpa__Link?: Maybe<Array<flexpa__Link>>;
  flexpa__Organization?: Maybe<Array<flexpa__Organization>>;
  /** Get the status of a specific execution attempt */
  getAttemptStatus: AttemptStatus;
  getPaymentProfile?: Maybe<PaymentProfile>;
  getPersonalizedPrompts: GetPersonalizedPromptsResponse;
  getSubscription?: Maybe<BillingSubscription>;
  getSubscriptionProducts: Array<SubscriptionProduct>;
  getTemplateRelease: GetTemplateReleaseResult;
  getUpdatesPrompts: Array<UpdatesPrompt>;
  getWelcomePrompts: Array<WelcomePrompt>;
  ingestion__Distillation?: Maybe<Array<ingestion__Distillation>>;
  ingestion__Extract?: Maybe<Array<ingestion__Extract>>;
  ingestion__Ingestion?: Maybe<Array<ingestion__Ingestion>>;
  ingestion__IngestionStep?: Maybe<Array<ingestion__IngestionStep>>;
  integration__BaseEndpoint?: Maybe<Array<integration__BaseEndpoint>>;
  integration__BaseLink?: Maybe<Array<integration__BaseLink>>;
  integration__Organization?: Maybe<Array<integration__Organization>>;
  issueCount: Scalars['Int']['output'];
  issue__BenefitsContext?: Maybe<Array<issue__BenefitsContext>>;
  issue__BenefitsSummaryGeneratedEvent?: Maybe<Array<issue__BenefitsSummaryGeneratedEvent>>;
  issue__BillDisputeEvent?: Maybe<Array<issue__BillDisputeEvent>>;
  issue__BillPayPostEscalationAction?: Maybe<Array<issue__BillPayPostEscalationAction>>;
  issue__BillPayRequestedEvent?: Maybe<Array<issue__BillPayRequestedEvent>>;
  issue__BillPaySuccessEvent?: Maybe<Array<issue__BillPaySuccessEvent>>;
  issue__BillPaymentRequestedEvent?: Maybe<Array<issue__BillPaymentRequestedEvent>>;
  issue__BillPaymentSuccessEvent?: Maybe<Array<issue__BillPaymentSuccessEvent>>;
  issue__ChatEvent?: Maybe<Array<issue__ChatEvent>>;
  issue__ClosedEvent?: Maybe<Array<issue__ClosedEvent>>;
  issue__ClosurePaymentRequestedEvent?: Maybe<Array<issue__ClosurePaymentRequestedEvent>>;
  issue__CommentEvent?: Maybe<Array<issue__CommentEvent>>;
  issue__ConnectAccountRequestedEvent?: Maybe<Array<issue__ConnectAccountRequestedEvent>>;
  issue__ConnectEhrPostEscalationAction?: Maybe<Array<issue__ConnectEhrPostEscalationAction>>;
  issue__ConnectInsurancePostEscalationAction?: Maybe<Array<issue__ConnectInsurancePostEscalationAction>>;
  issue__ConnectInsuranceRequestedEvent?: Maybe<Array<issue__ConnectInsuranceRequestedEvent>>;
  issue__DocumentAnalysisEvent?: Maybe<Array<issue__DocumentAnalysisEvent>>;
  issue__DocumentClassificationFailedEvent?: Maybe<Array<issue__DocumentClassificationFailedEvent>>;
  issue__DocumentUploadedEvent?: Maybe<Array<issue__DocumentUploadedEvent>>;
  issue__Event?: Maybe<Array<issue__Event>>;
  issue__HAAssignedEvent?: Maybe<Array<issue__HAAssignedEvent>>;
  issue__HipaaReleaseRequestedEvent?: Maybe<Array<issue__HipaaReleaseRequestedEvent>>;
  issue__InternalDocumentUploadedEvent?: Maybe<Array<issue__InternalDocumentUploadedEvent>>;
  issue__Issue?: Maybe<Array<issue__Issue>>;
  issue__IssueDocumentSummary?: Maybe<Array<issue__IssueDocumentSummary>>;
  issue__PaymentAgreementPostEscalationAction?: Maybe<Array<issue__PaymentAgreementPostEscalationAction>>;
  issue__PaymentAgreementRequestedEvent?: Maybe<Array<issue__PaymentAgreementRequestedEvent>>;
  issue__PaymentChargeFailedEvent?: Maybe<Array<issue__PaymentChargeFailedEvent>>;
  issue__PlanSelectionEvent?: Maybe<Array<issue__PlanSelectionEvent>>;
  issue__PostEscalationAction?: Maybe<Array<issue__PostEscalationAction>>;
  issue__PostEscalationActionsEvent?: Maybe<Array<issue__PostEscalationActionsEvent>>;
  issue__ReopenedEvent?: Maybe<Array<issue__ReopenedEvent>>;
  issue__ResolutionPreferences?: Maybe<Array<issue__ResolutionPreferences>>;
  issue__SignTemplatePostEscalationAction?: Maybe<Array<issue__SignTemplatePostEscalationAction>>;
  issue__TemplateReleaseRequestedEvent?: Maybe<Array<issue__TemplateReleaseRequestedEvent>>;
  issue__ToolExecutionEvent?: Maybe<Array<issue__ToolExecutionEvent>>;
  issue__UploadBillPostEscalationAction?: Maybe<Array<issue__UploadBillPostEscalationAction>>;
  issue__UploadEobPostEscalationAction?: Maybe<Array<issue__UploadEobPostEscalationAction>>;
  issue__UploadMemberIdPostEscalationAction?: Maybe<Array<issue__UploadMemberIdPostEscalationAction>>;
  issue__UserMultiSelectionRequestedEvent?: Maybe<Array<issue__UserMultiSelectionRequestedEvent>>;
  issue__UserSelectionRequestedEvent?: Maybe<Array<issue__UserSelectionRequestedEvent>>;
  me?: Maybe<User>;
  modelExecution__LLMExecution?: Maybe<Array<modelExecution__LLMExecution>>;
  modelExecution__VellumLLMExecution?: Maybe<Array<modelExecution__VellumLLMExecution>>;
  notification__RetoolNotification?: Maybe<Array<notification__RetoolNotification>>;
  partner__Partner?: Maybe<Array<partner__Partner>>;
  partner__PartnerGroup?: Maybe<Array<partner__PartnerGroup>>;
  /**
   * Admin-only: every registered partner, newest first, each with its groups.
   * The operator surface for reviewing configured partners.
   */
  partners: Array<Partner>;
  payment__IssuePromoCodeUsage?: Maybe<Array<payment__IssuePromoCodeUsage>>;
  payment__PaymentProfile?: Maybe<Array<payment__PaymentProfile>>;
  payment__PaymentTransaction?: Maybe<Array<payment__PaymentTransaction>>;
  payment__PromoCode?: Maybe<Array<payment__PromoCode>>;
  payment__Subscription?: Maybe<Array<payment__Subscription>>;
  person__Address?: Maybe<Array<person__Address>>;
  planEpicEndpointChanges: PlanEpicEndpointChangesResponse;
  plan__BenefitsSummaryResult?: Maybe<Array<plan__BenefitsSummaryResult>>;
  plan__Plan?: Maybe<Array<plan__Plan>>;
  projection__CaseView?: Maybe<Array<projection__CaseView>>;
  projection__EligibilityCheckAttemptView?: Maybe<Array<projection__EligibilityCheckAttemptView>>;
  projection__RpaConnection?: Maybe<Array<projection__RpaConnection>>;
  projection__RpaEgressIp?: Maybe<Array<projection__RpaEgressIp>>;
  projection__RpaExperimentView?: Maybe<Array<projection__RpaExperimentView>>;
  projection__RpaLinkView?: Maybe<Array<projection__RpaLinkView>>;
  projection__RpaProviderAttempt?: Maybe<Array<projection__RpaProviderAttempt>>;
  projection__RpaSession?: Maybe<Array<projection__RpaSession>>;
  projection__RpaSessionSummary?: Maybe<Array<projection__RpaSessionSummary>>;
  projection__RpaSessionTimeline?: Maybe<Array<projection__RpaSessionTimeline>>;
  projection__RpaTask?: Maybe<Array<projection__RpaTask>>;
  projection__RpaTimelineEntry?: Maybe<Array<projection__RpaTimelineEntry>>;
  projection__UserDataView?: Maybe<Array<projection__UserDataView>>;
  projection__UserEligibilityView?: Maybe<Array<projection__UserEligibilityView>>;
  projection__UserEnrichmentData?: Maybe<Array<projection__UserEnrichmentData>>;
  projection__UserMemory?: Maybe<Array<projection__UserMemory>>;
  provider__ContactPoint?: Maybe<Array<provider__ContactPoint>>;
  provider__NegotiationProfile?: Maybe<Array<provider__NegotiationProfile>>;
  provider__Provider?: Maybe<Array<provider__Provider>>;
  provider__ProviderForm?: Maybe<Array<provider__ProviderForm>>;
  qualityAssessments: Array<QualityAssessment>;
  queryExplanationOfBenefits?: Maybe<Array<fhirext__ExplanationOfBenefitVersion>>;
  queryExplanationOfBenefitsV2?: Maybe<Array<fhirext__ExplanationOfBenefitVersion>>;
  queryFlaggedExplanationOfBenefits: Array<fhirext__ExplanationOfBenefitVersion>;
  queryFlaggedExplanationOfBenefitsForUser: Array<fhirext__ExplanationOfBenefitVersion>;
  queryIssues?: Maybe<Array<issue__Issue>>;
  queryIssuesV2?: Maybe<Array<issue__Issue>>;
  /**
   * One ingestion-v2 EOB by its materialization key, scoped to the current user.
   * Returns null when the key does not resolve to an EOB the user can view.
   */
  queryUserEob?: Maybe<UserHealthRecord>;
  /**
   * All of the current user's ingestion-v2 EOB rows (projection::UserDataView,
   * kind = "claim"). `data` is the canonical v2.EOB JSON, returned verbatim.
   */
  queryUserEobs: Array<UserHealthRecord>;
  /** One ingestion-v2 invoice by its materialization key, scoped to the current user. */
  queryUserInvoice?: Maybe<UserHealthRecord>;
  /**
   * All of the current user's ingestion-v2 invoice rows (projection::UserDataView,
   * kind = "invoice"). `data` is the canonical v2.Invoice JSON, returned verbatim.
   */
  queryUserInvoices: Array<UserHealthRecord>;
  queryUserUploadedDocuments: Array<Maybe<UserUploadedDocumentsResult>>;
  queryWebAgentExecutions: Array<WebAgentExecutionResult>;
  rpaFacts: RpaFacts;
  /** Returns link views with optional lastSessionAt, filtered by time range and/or linkIds. */
  rpaLinkViews: Array<RpaLinkView>;
  rpaScheduleForecast: Array<RpaForecastEntry>;
  /** Returns minimal session dots for viewport rendering, scoped by time + linkIds. */
  rpaSessionDots: Array<RpaSessionDot>;
  /** Returns a single session timeline (loaded on demand when session is selected). */
  rpaSessionTimeline?: Maybe<RpaSessionTimeline>;
  segment__Segment?: Maybe<Array<segment__Segment>>;
  segment__UserSegment?: Maybe<Array<segment__UserSegment>>;
  showWelcomeScreen: Scalars['Boolean']['output'];
  suggestion__SuggestedAction?: Maybe<Array<suggestion__SuggestedAction>>;
  taskManagement__DataQualityFlagTask?: Maybe<Array<taskManagement__DataQualityFlagTask>>;
  taskManagement__DataQualityTask?: Maybe<Array<taskManagement__DataQualityTask>>;
  taskManagement__FollowUpClosurePendingIssueTask?: Maybe<Array<taskManagement__FollowUpClosurePendingIssueTask>>;
  taskManagement__FollowUpUserUnresponsiveIssueTask?: Maybe<Array<taskManagement__FollowUpUserUnresponsiveIssueTask>>;
  taskManagement__GeneralIssueTask?: Maybe<Array<taskManagement__GeneralIssueTask>>;
  taskManagement__IssueResearchTask?: Maybe<Array<taskManagement__IssueResearchTask>>;
  taskManagement__IssueTask?: Maybe<Array<taskManagement__IssueTask>>;
  taskManagement__IssueUserMessagingTask?: Maybe<Array<taskManagement__IssueUserMessagingTask>>;
  taskManagement__PhoneCall?: Maybe<Array<taskManagement__PhoneCall>>;
  taskManagement__PhoneCallIssueTask?: Maybe<Array<taskManagement__PhoneCallIssueTask>>;
  taskManagement__ProcessCustomerBillPaymentIssueTask?: Maybe<Array<taskManagement__ProcessCustomerBillPaymentIssueTask>>;
  taskManagement__ReviewCaseIntakeIssueTask?: Maybe<Array<taskManagement__ReviewCaseIntakeIssueTask>>;
  taskManagement__ReviewEscalatedCaseTask?: Maybe<Array<taskManagement__ReviewEscalatedCaseTask>>;
  taskManagement__ReviewFindingTask?: Maybe<Array<taskManagement__ReviewFindingTask>>;
  taskManagement__ReviewIssueChatTask?: Maybe<Array<taskManagement__ReviewIssueChatTask>>;
  taskManagement__ReviewPaymentAcceptanceIssueTask?: Maybe<Array<taskManagement__ReviewPaymentAcceptanceIssueTask>>;
  taskManagement__ReviewSuggestionTask?: Maybe<Array<taskManagement__ReviewSuggestionTask>>;
  taskManagement__SendFormIssueTask?: Maybe<Array<taskManagement__SendFormIssueTask>>;
  taskManagement__Task?: Maybe<Array<taskManagement__Task>>;
  taskManagement__TaskComment?: Maybe<Array<taskManagement__TaskComment>>;
  templateFieldAttributes: TemplateFieldAttributesResult;
  templateStorageValues: TemplateStorageValuesResult;
  unreadRetoolNotificationCount: Scalars['Int']['output'];
  unreadRetoolNotifications: Array<notification__RetoolNotification>;
  user__Email?: Maybe<Array<user__Email>>;
  user__Profile?: Maybe<Array<user__Profile>>;
  user__SegmentationData?: Maybe<Array<user__SegmentationData>>;
  viewDocument: ViewDocumentResult;
  webAgent__AiConversationLogArtifact?: Maybe<Array<webAgent__AiConversationLogArtifact>>;
  webAgent__AiDiscoveryCrawl?: Maybe<Array<webAgent__AiDiscoveryCrawl>>;
  webAgent__AiDiscoveryCrawlObjective?: Maybe<Array<webAgent__AiDiscoveryCrawlObjective>>;
  webAgent__CrawlDataSummaryArtifact?: Maybe<Array<webAgent__CrawlDataSummaryArtifact>>;
  webAgent__Endpoint?: Maybe<Array<webAgent__Endpoint>>;
  webAgent__EndpointCapability?: Maybe<Array<webAgent__EndpointCapability>>;
  webAgent__EndpointSupportLevelHistory?: Maybe<Array<webAgent__EndpointSupportLevelHistory>>;
  webAgent__InitialPageLoadSpan?: Maybe<Array<webAgent__InitialPageLoadSpan>>;
  webAgent__Link?: Maybe<Array<webAgent__Link>>;
  webAgent__LinkProviderProfile?: Maybe<Array<webAgent__LinkProviderProfile>>;
  webAgent__LinkSecret?: Maybe<Array<webAgent__LinkSecret>>;
  webAgent__ManagedMfaConfiguration?: Maybe<Array<webAgent__ManagedMfaConfiguration>>;
  webAgent__ManagedMfaConfigured?: Maybe<Array<webAgent__ManagedMfaConfigured>>;
  webAgent__ManagedMfaFailed?: Maybe<Array<webAgent__ManagedMfaFailed>>;
  webAgent__ManagedMfaOutcome?: Maybe<Array<webAgent__ManagedMfaOutcome>>;
  webAgent__ManagedMfaRejected?: Maybe<Array<webAgent__ManagedMfaRejected>>;
  webAgent__MfaCodeRequest?: Maybe<Array<webAgent__MfaCodeRequest>>;
  webAgent__MfaConfigurationSummaryArtifact?: Maybe<Array<webAgent__MfaConfigurationSummaryArtifact>>;
  webAgent__MfaEmail?: Maybe<Array<webAgent__MfaEmail>>;
  webAgent__MfaNumber?: Maybe<Array<webAgent__MfaNumber>>;
  webAgent__MfaReceiver?: Maybe<Array<webAgent__MfaReceiver>>;
  webAgent__NavigatorSpecialistInstructions?: Maybe<Array<webAgent__NavigatorSpecialistInstructions>>;
  webAgent__NavigatorSpecialistPageDiscovery?: Maybe<Array<webAgent__NavigatorSpecialistPageDiscovery>>;
  webAgent__PlaywrightHarArtifact?: Maybe<Array<webAgent__PlaywrightHarArtifact>>;
  webAgent__PlaywrightInterceptedResponsesArtifact?: Maybe<Array<webAgent__PlaywrightInterceptedResponsesArtifact>>;
  webAgent__PlaywrightPageSourceArtifact?: Maybe<Array<webAgent__PlaywrightPageSourceArtifact>>;
  webAgent__PlaywrightScreenshotArtifact?: Maybe<Array<webAgent__PlaywrightScreenshotArtifact>>;
  webAgent__PlaywrightTraceArtifact?: Maybe<Array<webAgent__PlaywrightTraceArtifact>>;
  webAgent__ProxyConfig?: Maybe<Array<webAgent__ProxyConfig>>;
  webAgent__RecipeFinishedEvent?: Maybe<Array<webAgent__RecipeFinishedEvent>>;
  webAgent__RecipeStartedEvent?: Maybe<Array<webAgent__RecipeStartedEvent>>;
  webAgent__RequestResponseSpan?: Maybe<Array<webAgent__RequestResponseSpan>>;
  webAgent__RobotFinishedEvent?: Maybe<Array<webAgent__RobotFinishedEvent>>;
  webAgent__RobotStartedEvent?: Maybe<Array<webAgent__RobotStartedEvent>>;
  webAgent__SignInReview?: Maybe<Array<webAgent__SignInReview>>;
  webAgent__SignInRobotResultArtifact?: Maybe<Array<webAgent__SignInRobotResultArtifact>>;
  webAgent__Span?: Maybe<Array<webAgent__Span>>;
  webAgent__UrlOpenedEvent?: Maybe<Array<webAgent__UrlOpenedEvent>>;
  webAgent__UserExitInsuranceLinkFeedback?: Maybe<Array<webAgent__UserExitInsuranceLinkFeedback>>;
  webAgent__WebAgentArtifact?: Maybe<Array<webAgent__WebAgentArtifact>>;
  webAgent__WebAgentExecution?: Maybe<Array<webAgent__WebAgentExecution>>;
  webAgent__WebAgentExecutionArtifact?: Maybe<Array<webAgent__WebAgentExecutionArtifact>>;
  webAgent__WebAgentExecutionEvent?: Maybe<Array<webAgent__WebAgentExecutionEvent>>;
};


export type QueryBaseObjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterBaseObject>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderBaseObject>;
};


export type QueryObjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterObject>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderObject>;
};


export type QueryOwnedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterOwned>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderOwned>;
};


export type QueryPersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type QueryPersonalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPersonal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPersonal>;
};


export type QuerySluggedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterSlugged>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderSlugged>;
};


export type QueryUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type QueryaddressAutocompleteArgs = {
  input: AddressAutocompleteInput;
};


export type QueryaddressDetailsArgs = {
  input: AddressDetailsInput;
};


export type QueryallRetoolNotificationsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerybusinessRulesArgs = {
  filter?: InputMaybe<BusinessRuleFilter>;
};


export type Querycache__SerifFairMarketValueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<cache__FilterSerifFairMarketValue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<cache__OrderSerifFairMarketValue>;
};


export type QuerycaseFact__CaseFactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<caseFact__FilterCaseFact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<caseFact__OrderCaseFact>;
};


export type QuerycaseFact__CaseFactAuditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<caseFact__FilterCaseFactAudit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<caseFact__OrderCaseFactAudit>;
};


export type QuerycheckClientVersionArgs = {
  input: CheckClientVersionInput;
};


export type Querycoding__CPTArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<coding__FilterCPT>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<coding__OrderCPT>;
};


export type Querycoding__CPTModifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<coding__FilterCPTModifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<coding__OrderCPTModifier>;
};


export type Querycoding__CodingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<coding__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<coding__OrderCoding>;
};


export type Querycoding__HCPCSArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<coding__FilterHCPCS>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<coding__OrderHCPCS>;
};


export type Querycoding__HCPCSModifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<coding__FilterHCPCSModifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<coding__OrderHCPCSModifier>;
};


export type Queryconsent__ConsentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterConsent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderConsent>;
};


export type Queryconsent__HipaaReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterHipaaRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderHipaaRelease>;
};


export type Queryconsent__TemplateReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterTemplateRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderTemplateRelease>;
};


export type QuerydataQuality__AssessmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<dataQuality__FilterAssessment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<dataQuality__OrderAssessment>;
};


export type QuerydataQuality__BusinessRuleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<dataQuality__FilterBusinessRule>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<dataQuality__OrderBusinessRule>;
};


export type Querydocument__DocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type Querydocument__DocumentSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocumentSummary>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocumentSummary>;
};


export type Querydocument__FileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterFile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderFile>;
};


export type Querydocument__ParseResultArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterParseResult>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderParseResult>;
};


export type Querydocument__TemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};


export type Querydocument__TemplateFieldArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplateField>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplateField>;
};


export type QueryeventStore__EventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<eventStore__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<eventStore__OrderEvent>;
};


export type QueryeventTracking__BaseEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<eventTracking__FilterBaseEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<eventTracking__OrderBaseEvent>;
};


export type QueryeventTracking__InsuranceLinkAttemptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<eventTracking__FilterInsuranceLinkAttempt>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<eventTracking__OrderInsuranceLinkAttempt>;
};


export type Queryfeedback__GeneralFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterGeneralFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderGeneralFeedback>;
};


export type Queryfeedback__IssueEventFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type Queryfeedback__IssueFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueFeedback>;
};


export type Queryfeedback__OptionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};


export type Queryfeedback__StaffFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterStaffFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderStaffFeedback>;
};


export type Queryfeedback__UserFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterUserFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderUserFeedback>;
};


export type QueryfhirEdit__CoverageEditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterCoverageEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderCoverageEdit>;
};


export type QueryfhirEdit__CoverageSnapshotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterCoverageSnapshot>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderCoverageSnapshot>;
};


export type QueryfhirEdit__ExplanationOfBenefitEditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterExplanationOfBenefitEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderExplanationOfBenefitEdit>;
};


export type QueryfhirEdit__ExplanationOfBenefitSnapshotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterExplanationOfBenefitSnapshot>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderExplanationOfBenefitSnapshot>;
};


export type QueryfhirEdit__ResourceEditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterResourceEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderResourceEdit>;
};


export type QueryfhirEdit__ResourceSnapshotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterResourceSnapshot>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderResourceSnapshot>;
};


export type Queryfhir__AccountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccount>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccount>;
};


export type Queryfhir__AccountBalanceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountBalance>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountBalance>;
};


export type Queryfhir__AccountGuarantorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountGuarantor>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountGuarantor>;
};


export type Queryfhir__AddressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAddress>;
};


export type Queryfhir__AnnotationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAnnotation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAnnotation>;
};


export type Queryfhir__ChargeItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterChargeItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderChargeItem>;
};


export type Queryfhir__ChargeItemPerformerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterChargeItemPerformer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderChargeItemPerformer>;
};


export type Queryfhir__ClinicalNoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterClinicalNote>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderClinicalNote>;
};


export type Queryfhir__CodeableConceptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type Queryfhir__CodeableReferenceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableReference>;
};


export type Queryfhir__CodingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};


export type Queryfhir__ContactPointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderContactPoint>;
};


export type Queryfhir__CoverageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverage>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverage>;
};


export type Queryfhir__CoverageClassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type Queryfhir__EncounterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterEncounter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderEncounter>;
};


export type Queryfhir__EncounterParticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterEncounterParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderEncounterParticipant>;
};


export type Queryfhir__ExplanationOfBenefitArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefit>;
};


export type Queryfhir__ExplanationOfBenefitCareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type Queryfhir__ExplanationOfBenefitDiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type Queryfhir__ExplanationOfBenefitItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type Queryfhir__ExplanationOfBenefitItemAdjudicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItemAdjudication>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItemAdjudication>;
};


export type Queryfhir__ExplanationOfBenefitItemReviewOutcomeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItemReviewOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItemReviewOutcome>;
};


export type Queryfhir__ExplanationOfBenefitTotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type Queryfhir__FHIRResourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterFHIRResource>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderFHIRResource>;
};


export type Queryfhir__HumanNameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type Queryfhir__IdentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type Queryfhir__InvoiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoice>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoice>;
};


export type Queryfhir__InvoiceLineItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceLineItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceLineItem>;
};


export type Queryfhir__InvoiceParticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceParticipant>;
};


export type Queryfhir__LocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterLocation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderLocation>;
};


export type Queryfhir__MonetaryComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMonetaryComponent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMonetaryComponent>;
};


export type Queryfhir__MoneyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type Queryfhir__PatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterPatient>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderPatient>;
};


export type Queryfhir__PractitionerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterPractitioner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderPractitioner>;
};


export type Queryfhir__QuantityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterQuantity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderQuantity>;
};


export type Queryfhir__ReferenceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type Queryfhirext__AccountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterAccount>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderAccount>;
};


export type Queryfhirext__AccountVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterAccountVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderAccountVersion>;
};


export type Queryfhirext__CoverageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterCoverage>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderCoverage>;
};


export type Queryfhirext__CoverageExtensionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterCoverageExtension>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderCoverageExtension>;
};


export type Queryfhirext__CoverageVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterCoverageVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderCoverageVersion>;
};


export type Queryfhirext__EncounterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterEncounter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderEncounter>;
};


export type Queryfhirext__EncounterVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterEncounterVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderEncounterVersion>;
};


export type Queryfhirext__ExplanationOfBenefitArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefit>;
};


export type Queryfhirext__ExplanationOfBenefitExtensionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitExtension>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitExtension>;
};


export type Queryfhirext__ExplanationOfBenefitTotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
};


export type Queryfhirext__ExplanationOfBenefitVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitVersion>;
};


export type Queryfhirext__FindingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type Queryfhirext__FindingReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFindingReview>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFindingReview>;
};


export type Queryfhirext__InvoiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoice>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoice>;
};


export type Queryfhirext__InvoiceTotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceTotalsByType>;
};


export type Queryfhirext__InvoiceVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceVersion>;
};


export type Queryfhirext__PatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterPatient>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderPatient>;
};


export type Queryfhirext__PatientVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterPatientVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderPatientVersion>;
};


export type Queryfhirext__PractitionerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterPractitioner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderPractitioner>;
};


export type Queryfhirext__PractitionerVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterPractitionerVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderPractitionerVersion>;
};


export type Queryfhirext__ResourceAssociationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceAssociation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceAssociation>;
};


export type Queryfhirext__ResourceIdentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceIdentifier>;
};


export type Queryfhirext__ResourceVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type Queryflexpa__EndpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderEndpoint>;
};


export type Queryflexpa__FlexpaImportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterFlexpaImport>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderFlexpaImport>;
};


export type Queryflexpa__LinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderLink>;
};


export type Queryflexpa__OrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderOrganization>;
};


export type QuerygetAttemptStatusArgs = {
  input: GetAttemptStatusInput;
};


export type QuerygetTemplateReleaseArgs = {
  input: GetTemplateReleaseInput;
};


export type Queryingestion__DistillationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterDistillation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderDistillation>;
};


export type Queryingestion__ExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type Queryingestion__IngestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type Queryingestion__IngestionStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestionStep>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestionStep>;
};


export type Queryintegration__BaseEndpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseEndpoint>;
};


export type Queryintegration__BaseLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseLink>;
};


export type Queryintegration__OrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};


export type Queryissue__BenefitsContextArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBenefitsContext>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBenefitsContext>;
};


export type Queryissue__BenefitsSummaryGeneratedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBenefitsSummaryGeneratedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBenefitsSummaryGeneratedEvent>;
};


export type Queryissue__BillDisputeEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillDisputeEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillDisputeEvent>;
};


export type Queryissue__BillPayPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPayPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPayPostEscalationAction>;
};


export type Queryissue__BillPayRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPayRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPayRequestedEvent>;
};


export type Queryissue__BillPaySuccessEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPaySuccessEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPaySuccessEvent>;
};


export type Queryissue__BillPaymentRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPaymentRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPaymentRequestedEvent>;
};


export type Queryissue__BillPaymentSuccessEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPaymentSuccessEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPaymentSuccessEvent>;
};


export type Queryissue__ChatEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterChatEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderChatEvent>;
};


export type Queryissue__ClosedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterClosedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderClosedEvent>;
};


export type Queryissue__ClosurePaymentRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterClosurePaymentRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderClosurePaymentRequestedEvent>;
};


export type Queryissue__CommentEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterCommentEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderCommentEvent>;
};


export type Queryissue__ConnectAccountRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectAccountRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectAccountRequestedEvent>;
};


export type Queryissue__ConnectEhrPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectEhrPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectEhrPostEscalationAction>;
};


export type Queryissue__ConnectInsurancePostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectInsurancePostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectInsurancePostEscalationAction>;
};


export type Queryissue__ConnectInsuranceRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectInsuranceRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectInsuranceRequestedEvent>;
};


export type Queryissue__DocumentAnalysisEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentAnalysisEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentAnalysisEvent>;
};


export type Queryissue__DocumentClassificationFailedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentClassificationFailedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentClassificationFailedEvent>;
};


export type Queryissue__DocumentUploadedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};


export type Queryissue__EventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type Queryissue__HAAssignedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterHAAssignedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderHAAssignedEvent>;
};


export type Queryissue__HipaaReleaseRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterHipaaReleaseRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderHipaaReleaseRequestedEvent>;
};


export type Queryissue__InternalDocumentUploadedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterInternalDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderInternalDocumentUploadedEvent>;
};


export type Queryissue__IssueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type Queryissue__IssueDocumentSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssueDocumentSummary>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssueDocumentSummary>;
};


export type Queryissue__PaymentAgreementPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentAgreementPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentAgreementPostEscalationAction>;
};


export type Queryissue__PaymentAgreementRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentAgreementRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentAgreementRequestedEvent>;
};


export type Queryissue__PaymentChargeFailedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentChargeFailedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentChargeFailedEvent>;
};


export type Queryissue__PlanSelectionEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPlanSelectionEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPlanSelectionEvent>;
};


export type Queryissue__PostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPostEscalationAction>;
};


export type Queryissue__PostEscalationActionsEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPostEscalationActionsEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPostEscalationActionsEvent>;
};


export type Queryissue__ReopenedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterReopenedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderReopenedEvent>;
};


export type Queryissue__ResolutionPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterResolutionPreferences>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderResolutionPreferences>;
};


export type Queryissue__SignTemplatePostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterSignTemplatePostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderSignTemplatePostEscalationAction>;
};


export type Queryissue__TemplateReleaseRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterTemplateReleaseRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderTemplateReleaseRequestedEvent>;
};


export type Queryissue__ToolExecutionEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterToolExecutionEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderToolExecutionEvent>;
};


export type Queryissue__UploadBillPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterUploadBillPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderUploadBillPostEscalationAction>;
};


export type Queryissue__UploadEobPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterUploadEobPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderUploadEobPostEscalationAction>;
};


export type Queryissue__UploadMemberIdPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterUploadMemberIdPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderUploadMemberIdPostEscalationAction>;
};


export type Queryissue__UserMultiSelectionRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterUserMultiSelectionRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderUserMultiSelectionRequestedEvent>;
};


export type Queryissue__UserSelectionRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterUserSelectionRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderUserSelectionRequestedEvent>;
};


export type QuerymodelExecution__LLMExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type QuerymodelExecution__VellumLLMExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterVellumLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderVellumLLMExecution>;
};


export type Querynotification__RetoolNotificationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<notification__FilterRetoolNotification>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<notification__OrderRetoolNotification>;
};


export type Querypartner__PartnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartner>;
};


export type Querypartner__PartnerGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartnerGroup>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartnerGroup>;
};


export type Querypayment__IssuePromoCodeUsageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterIssuePromoCodeUsage>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderIssuePromoCodeUsage>;
};


export type Querypayment__PaymentProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentProfile>;
};


export type Querypayment__PaymentTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


export type Querypayment__PromoCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPromoCode>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPromoCode>;
};


export type Querypayment__SubscriptionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterSubscription>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderSubscription>;
};


export type Queryperson__AddressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<person__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<person__OrderAddress>;
};


export type QueryplanEpicEndpointChangesArgs = {
  input: PlanEpicEndpointChangesInput;
};


export type Queryplan__BenefitsSummaryResultArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterBenefitsSummaryResult>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderBenefitsSummaryResult>;
};


export type Queryplan__PlanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type Queryprojection__CaseViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseView>;
};


export type Queryprojection__EligibilityCheckAttemptViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterEligibilityCheckAttemptView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderEligibilityCheckAttemptView>;
};


export type Queryprojection__RpaConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaConnection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaConnection>;
};


export type Queryprojection__RpaEgressIpArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaEgressIp>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaEgressIp>;
};


export type Queryprojection__RpaExperimentViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaExperimentView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaExperimentView>;
};


export type Queryprojection__RpaLinkViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaLinkView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaLinkView>;
};


export type Queryprojection__RpaProviderAttemptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaProviderAttempt>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaProviderAttempt>;
};


export type Queryprojection__RpaSessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSession>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSession>;
};


export type Queryprojection__RpaSessionSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSessionSummary>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSessionSummary>;
};


export type Queryprojection__RpaSessionTimelineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSessionTimeline>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSessionTimeline>;
};


export type Queryprojection__RpaTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaTask>;
};


export type Queryprojection__RpaTimelineEntryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaTimelineEntry>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaTimelineEntry>;
};


export type Queryprojection__UserDataViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterUserDataView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderUserDataView>;
};


export type Queryprojection__UserEligibilityViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterUserEligibilityView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderUserEligibilityView>;
};


export type Queryprojection__UserEnrichmentDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterUserEnrichmentData>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderUserEnrichmentData>;
};


export type Queryprojection__UserMemoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterUserMemory>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderUserMemory>;
};


export type Queryprovider__ContactPointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderContactPoint>;
};


export type Queryprovider__NegotiationProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterNegotiationProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderNegotiationProfile>;
};


export type Queryprovider__ProviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type Queryprovider__ProviderFormArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProviderForm>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProviderForm>;
};


export type QueryqualityAssessmentsArgs = {
  filter?: InputMaybe<QualityAssessmentFilter>;
};


export type QueryqueryExplanationOfBenefitsArgs = {
  input?: InputMaybe<QueryExplanationOfBenefitsInput>;
};


export type QueryqueryExplanationOfBenefitsV2Args = {
  after?: InputMaybe<Scalars['Int']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  denied?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inNetwork?: InputMaybe<Scalars['Boolean']['input']>;
  outOfNetwork?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryqueryFlaggedExplanationOfBenefitsForUserArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryqueryIssuesArgs = {
  input?: InputMaybe<QueryIssuesInput>;
};


export type QueryqueryIssuesV2Args = {
  after?: InputMaybe<Scalars['Int']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryqueryUserEobArgs = {
  key: Scalars['ID']['input'];
};


export type QueryqueryUserInvoiceArgs = {
  key: Scalars['ID']['input'];
};


export type QueryqueryUserUploadedDocumentsArgs = {
  input: UserUploadedDocumentsInput;
};


export type QueryqueryWebAgentExecutionsArgs = {
  input: QueryWebAgentExecutionsInput;
};


export type QueryrpaFactsArgs = {
  after: Scalars['DateTime']['input'];
  before: Scalars['DateTime']['input'];
  linkIds: Array<Scalars['String']['input']>;
};


export type QueryrpaLinkViewsArgs = {
  input: RpaLinkViewsInput;
};


export type QueryrpaScheduleForecastArgs = {
  input: RpaScheduleForecastInput;
};


export type QueryrpaSessionDotsArgs = {
  input: RpaSessionDotsInput;
};


export type QueryrpaSessionTimelineArgs = {
  input: RpaSessionTimelineInput;
};


export type Querysegment__SegmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderSegment>;
};


export type Querysegment__UserSegmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterUserSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderUserSegment>;
};


export type Querysuggestion__SuggestedActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<suggestion__FilterSuggestedAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<suggestion__OrderSuggestedAction>;
};


export type QuerytaskManagement__DataQualityFlagTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterDataQualityFlagTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderDataQualityFlagTask>;
};


export type QuerytaskManagement__DataQualityTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterDataQualityTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderDataQualityTask>;
};


export type QuerytaskManagement__FollowUpClosurePendingIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterFollowUpClosurePendingIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderFollowUpClosurePendingIssueTask>;
};


export type QuerytaskManagement__FollowUpUserUnresponsiveIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterFollowUpUserUnresponsiveIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderFollowUpUserUnresponsiveIssueTask>;
};


export type QuerytaskManagement__GeneralIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterGeneralIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderGeneralIssueTask>;
};


export type QuerytaskManagement__IssueResearchTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterIssueResearchTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderIssueResearchTask>;
};


export type QuerytaskManagement__IssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderIssueTask>;
};


export type QuerytaskManagement__IssueUserMessagingTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterIssueUserMessagingTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderIssueUserMessagingTask>;
};


export type QuerytaskManagement__PhoneCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterPhoneCall>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderPhoneCall>;
};


export type QuerytaskManagement__PhoneCallIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterPhoneCallIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderPhoneCallIssueTask>;
};


export type QuerytaskManagement__ProcessCustomerBillPaymentIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterProcessCustomerBillPaymentIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderProcessCustomerBillPaymentIssueTask>;
};


export type QuerytaskManagement__ReviewCaseIntakeIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterReviewCaseIntakeIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderReviewCaseIntakeIssueTask>;
};


export type QuerytaskManagement__ReviewEscalatedCaseTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterReviewEscalatedCaseTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderReviewEscalatedCaseTask>;
};


export type QuerytaskManagement__ReviewFindingTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterReviewFindingTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderReviewFindingTask>;
};


export type QuerytaskManagement__ReviewIssueChatTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterReviewIssueChatTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderReviewIssueChatTask>;
};


export type QuerytaskManagement__ReviewPaymentAcceptanceIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterReviewPaymentAcceptanceIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderReviewPaymentAcceptanceIssueTask>;
};


export type QuerytaskManagement__ReviewSuggestionTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterReviewSuggestionTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderReviewSuggestionTask>;
};


export type QuerytaskManagement__SendFormIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterSendFormIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderSendFormIssueTask>;
};


export type QuerytaskManagement__TaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTask>;
};


export type QuerytaskManagement__TaskCommentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type QuerytemplateFieldAttributesArgs = {
  input: TemplateFieldAttributesInput;
};


export type QueryunreadRetoolNotificationsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type Queryuser__EmailArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterEmail>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderEmail>;
};


export type Queryuser__ProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type Queryuser__SegmentationDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterSegmentationData>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderSegmentationData>;
};


export type QueryviewDocumentArgs = {
  input: ViewDocumentInput;
};


export type QuerywebAgent__AiConversationLogArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiConversationLogArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiConversationLogArtifact>;
};


export type QuerywebAgent__AiDiscoveryCrawlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
};


export type QuerywebAgent__AiDiscoveryCrawlObjectiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type QuerywebAgent__CrawlDataSummaryArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterCrawlDataSummaryArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderCrawlDataSummaryArtifact>;
};


export type QuerywebAgent__EndpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};


export type QuerywebAgent__EndpointCapabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpointCapability>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpointCapability>;
};


export type QuerywebAgent__EndpointSupportLevelHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpointSupportLevelHistory>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpointSupportLevelHistory>;
};


export type QuerywebAgent__InitialPageLoadSpanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterInitialPageLoadSpan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderInitialPageLoadSpan>;
};


export type QuerywebAgent__LinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type QuerywebAgent__LinkProviderProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLinkProviderProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLinkProviderProfile>;
};


export type QuerywebAgent__LinkSecretArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLinkSecret>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLinkSecret>;
};


export type QuerywebAgent__ManagedMfaConfigurationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaConfiguration>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaConfiguration>;
};


export type QuerywebAgent__ManagedMfaConfiguredArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaConfigured>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaConfigured>;
};


export type QuerywebAgent__ManagedMfaFailedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaFailed>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaFailed>;
};


export type QuerywebAgent__ManagedMfaOutcomeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaOutcome>;
};


export type QuerywebAgent__ManagedMfaRejectedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaRejected>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaRejected>;
};


export type QuerywebAgent__MfaCodeRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type QuerywebAgent__MfaConfigurationSummaryArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaConfigurationSummaryArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaConfigurationSummaryArtifact>;
};


export type QuerywebAgent__MfaEmailArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaEmail>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaEmail>;
};


export type QuerywebAgent__MfaNumberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaNumber>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaNumber>;
};


export type QuerywebAgent__MfaReceiverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaReceiver>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaReceiver>;
};


export type QuerywebAgent__NavigatorSpecialistInstructionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterNavigatorSpecialistInstructions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderNavigatorSpecialistInstructions>;
};


export type QuerywebAgent__NavigatorSpecialistPageDiscoveryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterNavigatorSpecialistPageDiscovery>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderNavigatorSpecialistPageDiscovery>;
};


export type QuerywebAgent__PlaywrightHarArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterPlaywrightHarArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderPlaywrightHarArtifact>;
};


export type QuerywebAgent__PlaywrightInterceptedResponsesArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterPlaywrightInterceptedResponsesArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderPlaywrightInterceptedResponsesArtifact>;
};


export type QuerywebAgent__PlaywrightPageSourceArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterPlaywrightPageSourceArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderPlaywrightPageSourceArtifact>;
};


export type QuerywebAgent__PlaywrightScreenshotArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterPlaywrightScreenshotArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderPlaywrightScreenshotArtifact>;
};


export type QuerywebAgent__PlaywrightTraceArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterPlaywrightTraceArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderPlaywrightTraceArtifact>;
};


export type QuerywebAgent__ProxyConfigArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterProxyConfig>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderProxyConfig>;
};


export type QuerywebAgent__RecipeFinishedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRecipeFinishedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRecipeFinishedEvent>;
};


export type QuerywebAgent__RecipeStartedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRecipeStartedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRecipeStartedEvent>;
};


export type QuerywebAgent__RequestResponseSpanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRequestResponseSpan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRequestResponseSpan>;
};


export type QuerywebAgent__RobotFinishedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRobotFinishedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRobotFinishedEvent>;
};


export type QuerywebAgent__RobotStartedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRobotStartedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRobotStartedEvent>;
};


export type QuerywebAgent__SignInReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterSignInReview>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderSignInReview>;
};


export type QuerywebAgent__SignInRobotResultArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterSignInRobotResultArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderSignInRobotResultArtifact>;
};


export type QuerywebAgent__SpanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterSpan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderSpan>;
};


export type QuerywebAgent__UrlOpenedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterUrlOpenedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderUrlOpenedEvent>;
};


export type QuerywebAgent__UserExitInsuranceLinkFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterUserExitInsuranceLinkFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderUserExitInsuranceLinkFeedback>;
};


export type QuerywebAgent__WebAgentArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentArtifact>;
};


export type QuerywebAgent__WebAgentExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type QuerywebAgent__WebAgentExecutionArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecutionArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecutionArtifact>;
};


export type QuerywebAgent__WebAgentExecutionEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecutionEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecutionEvent>;
};

export type QueryExplanationOfBenefitsInput = {
  after?: InputMaybe<Scalars['Int']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  denied?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inNetwork?: InputMaybe<Scalars['Boolean']['input']>;
  outOfNetwork?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryIssuesInput = {
  after?: InputMaybe<Scalars['Int']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryWebAgentExecutionsInput = {
  userId: Scalars['ID']['input'];
};

export type RPADebugMode =
  { endpointMode: RPADebugModeEndpoint; linkMode?: never; urlMode?: never; }
  |  { endpointMode?: never; linkMode: RPADebugModeLink; urlMode?: never; }
  |  { endpointMode?: never; linkMode?: never; urlMode: RPADebugModeUrl; };

export type RPADebugModeEndpoint = {
  endpointId: Scalars['ID']['input'];
};

export type RPADebugModeLink = {
  linkId: Scalars['String']['input'];
  rehydrate: Scalars['Boolean']['input'];
};

export type RPADebugModeUrl = {
  url: Scalars['String']['input'];
};

export type RecalculateEligibilityEnrollmentInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  concurrency?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  excludeInternalUsers?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RecommendationFeedbackInput = {
  issueId: Scalars['ID']['input'];
  /**
   * Freeform HA correction. Non-empty after trimming — the resolver rejects
   * whitespace-only input with a GrantedError.
   */
  notes: Scalars['String']['input'];
};

export type RecordIssueEventFeedbackInput = {
  eventId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
  selectedOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RedeemInviteTokenInput = {
  /** The bearer invite token to redeem. */
  inviteToken: Scalars['String']['input'];
  /** User the token is redeemed for. Their source is set to the partner. */
  userId: Scalars['ID']['input'];
};

export type RedisMessage = {
  message: Scalars['String']['input'];
  requestChannel: Scalars['String']['input'];
  responseChannel: Scalars['String']['input'];
};

export type RedisResponse = {
  __typename: 'RedisResponse';
  message: Scalars['String']['output'];
};

export type RefreshAccountUpdatesPrompt = BaseUpdatesPrompt & {
  __typename: 'RefreshAccountUpdatesPrompt';
  count: Scalars['Int']['output'];
  type: UpdatesPromptType;
};

export type RemoveProviderContactPointInput = {
  contactPointId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
};

export type RemoveUserSegmentInput = {
  segmentId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveUserSegmentResult = {
  __typename: 'RemoveUserSegmentResult';
  removedCount: Scalars['Int']['output'];
};

export type ReprocessDocumentInput = {
  documentId: Scalars['ID']['input'];
  reclassify?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReprocessFlexpaImportInput = {
  flexpaImportId: Scalars['ID']['input'];
  reclassify?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReprocessIngestionInput = {
  documentFilter?: InputMaybe<DocumentFilter>;
  id: Scalars['ID']['input'];
  reclassify?: InputMaybe<Scalars['Boolean']['input']>;
  sourceCrawlObjectiveId?: InputMaybe<Scalars['ID']['input']>;
  type: IngestionType;
};

export type ReprocessResourcesInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  resourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  resourceType?: InputMaybe<fhirext__ResourceType>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  steps?: InputMaybe<Array<ResourcePostProcessingStep>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ReprocessWebAgentExecutionInput = {
  documentFilter?: InputMaybe<DocumentFilter>;
  executionId: Scalars['ID']['input'];
  reclassify?: InputMaybe<Scalars['Boolean']['input']>;
  sourceCrawlObjectiveId?: InputMaybe<Scalars['ID']['input']>;
};

export type RequestNewMfaCodeInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  workflowId: Scalars['String']['input'];
};

export type ResendMagicLinkInput = {
  /** If specified, magic links sent by Stytch will redirect to this URI. */
  clientRedirectUri?: InputMaybe<Scalars['String']['input']>;
  /** Challenge token for PKCE flow. */
  codeChallenge?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

export type ResendMagicLinkResult = {
  __typename: 'ResendMagicLinkResult';
  success: Scalars['Boolean']['output'];
};

export type ResolveInviteTokenInput = {
  /** The bearer invite token to resolve. Not consumed by resolution. */
  inviteToken: Scalars['String']['input'];
};

export enum ResourcePostProcessingStep {
  ANALYZE = 'ANALYZE',
  ASSESS = 'ASSESS',
  ENRICH = 'ENRICH'
}

export type ResourceSnapshotResult = {
  __typename: 'ResourceSnapshotResult';
  computedAt: Scalars['DateTime']['output'];
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  snapshotId: Scalars['ID']['output'];
};

export type ReviewFindingInput = {
  findingId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status: fhirext__ReviewStatus;
};

export type RevokeFlexpaLinkInput = {
  flexpaLinkId: Scalars['ID']['input'];
};

export type RpaCommandReceived = {
  __typename: 'RpaCommandReceived';
  workflowId: Scalars['String']['output'];
};

export type RpaCommandResult = RpaCommandReceived | RpaCommunicationError;

export type RpaCommunicationError = {
  __typename: 'RpaCommunicationError';
  cause?: Maybe<Scalars['String']['output']>;
};

export type RpaDayOfWeekRateRow = {
  __typename: 'RpaDayOfWeekRateRow';
  dayOfWeek: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaDistributionRow = {
  __typename: 'RpaDistributionRow';
  p5: Scalars['Float']['output'];
  p50: Scalars['Float']['output'];
  p95: Scalars['Float']['output'];
};

export type RpaDone = {
  __typename: 'RpaDone';
  result?: Maybe<RpaDoneResult>;
};

export type RpaDoneResult = FailedLoginMaxReached | InvalidCredentials | LoginSuccess | ManagedMfaApprovalRequired | MfaRequired | RpaError | SecurityQuestionRequired | SelectMfaMethodResponse;

export type RpaEndpointClassificationRow = {
  __typename: 'RpaEndpointClassificationRow';
  classification: Scalars['String']['output'];
  endpointName: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaEndpointDistributionRow = {
  __typename: 'RpaEndpointDistributionRow';
  endpointName: Scalars['String']['output'];
  p5: Scalars['Float']['output'];
  p50: Scalars['Float']['output'];
  p95: Scalars['Float']['output'];
};

export type RpaEndpointDurationRow = {
  __typename: 'RpaEndpointDurationRow';
  endpointName: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaEndpointLazyDecisionRow = {
  __typename: 'RpaEndpointLazyDecisionRow';
  endpointName: Scalars['String']['output'];
  lazyDecision: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaEndpointMfaMethodsRow = {
  __typename: 'RpaEndpointMfaMethodsRow';
  endpointName: Scalars['String']['output'];
  value: Array<Array<Scalars['String']['output']>>;
};

export type RpaEndpointProviderDurationRow = {
  __typename: 'RpaEndpointProviderDurationRow';
  endpointName: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaEndpointProviderRow = {
  __typename: 'RpaEndpointProviderRow';
  endpointName: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaEndpointRow = {
  __typename: 'RpaEndpointRow';
  endpointName: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaEndpointTimeRow = {
  __typename: 'RpaEndpointTimeRow';
  endpointName: Scalars['String']['output'];
  timeWindow: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaError = {
  __typename: 'RpaError';
  cause: Scalars['String']['output'];
  signInUrl?: Maybe<Scalars['String']['output']>;
};

export type RpaFacts = {
  __typename: 'RpaFacts';
  cohortConnectionLossRate?: Maybe<Array<RpaScalarRow>>;
  cohortDaySuccessRate?: Maybe<Array<RpaDayOfWeekRateRow>>;
  cohortLinkRelinkDaySuccessRate?: Maybe<Array<RpaDayOfWeekRateRow>>;
  cohortLinkRelinkMfaMethods?: Maybe<Array<RpaMfaMethodsRow>>;
  cohortLinkRelinkMfaRate?: Maybe<Array<RpaScalarRow>>;
  cohortLinkRelinkSuccessRate?: Maybe<Array<RpaScalarRow>>;
  cohortLinkRelinkTimeSuccessRate?: Maybe<Array<RpaTimeWindowRateRow>>;
  cohortLinkSessionCount?: Maybe<Array<RpaScalarRow>>;
  cohortMfaInterval?: Maybe<Array<RpaScalarRow>>;
  cohortMfaIntervalDistribution?: Maybe<Array<RpaDistributionRow>>;
  cohortMfaMethods?: Maybe<Array<RpaMfaMethodsRow>>;
  cohortMfaRate?: Maybe<Array<RpaScalarRow>>;
  cohortRelinkSessionCount?: Maybe<Array<RpaScalarRow>>;
  cohortSecurityChallengeRate?: Maybe<Array<RpaScalarRow>>;
  cohortSuccessRate?: Maybe<Array<RpaScalarRow>>;
  cohortSyncSessionCount?: Maybe<Array<RpaScalarRow>>;
  cohortSyncTailgateDaySuccessRate?: Maybe<Array<RpaDayOfWeekRateRow>>;
  cohortSyncTailgateMfaIntervalDistribution?: Maybe<Array<RpaDistributionRow>>;
  cohortSyncTailgateMfaRate?: Maybe<Array<RpaScalarRow>>;
  cohortSyncTailgateSecurityChallengeRate?: Maybe<Array<RpaScalarRow>>;
  cohortSyncTailgateSuccessRate?: Maybe<Array<RpaScalarRow>>;
  cohortSyncTailgateTimeMfaRate?: Maybe<Array<RpaTimeWindowRateRow>>;
  cohortSyncTailgateTimeSuccessRate?: Maybe<Array<RpaTimeWindowRateRow>>;
  cohortTailgateSessionCount?: Maybe<Array<RpaScalarRow>>;
  cohortTimeMfaRate?: Maybe<Array<RpaTimeWindowRateRow>>;
  cohortTimeSuccessRate?: Maybe<Array<RpaTimeWindowRateRow>>;
  lazyDecisionMfaRate?: Maybe<Array<RpaEndpointLazyDecisionRow>>;
  lazyEligibilityRate?: Maybe<Array<RpaEndpointRow>>;
  lazyFallbackClassificationDistribution?: Maybe<Array<RpaEndpointClassificationRow>>;
  lazySkipRate?: Maybe<Array<RpaEndpointRow>>;
  linkDaySessionCount?: Maybe<Array<RpaLinkDayRow>>;
  linkDaySuccessCount?: Maybe<Array<RpaLinkDayRow>>;
  linkMfaCount?: Maybe<Array<RpaLinkRow>>;
  linkMfaInterval?: Maybe<Array<RpaLinkDurationRow>>;
  linkMfaMethods?: Maybe<Array<RpaLinkMfaMethodsRow>>;
  linkRelinkDaySessionCount?: Maybe<Array<RpaRelinkDayRow>>;
  linkRelinkDaySuccessCount?: Maybe<Array<RpaRelinkDayRow>>;
  linkRelinkMfaCount?: Maybe<Array<RpaRelinkRow>>;
  linkRelinkMfaMethods?: Maybe<Array<RpaRelinkMfaMethodsRow>>;
  linkRelinkSessionCount?: Maybe<Array<RpaRelinkRow>>;
  linkRelinkSuccessCount?: Maybe<Array<RpaRelinkRow>>;
  linkRelinkTimeSessionCount?: Maybe<Array<RpaRelinkTimeRow>>;
  linkRelinkTimeSuccessCount?: Maybe<Array<RpaRelinkTimeRow>>;
  linkSecurityChallengeCount?: Maybe<Array<RpaLinkRow>>;
  linkSecurityChallengeSessionCount?: Maybe<Array<RpaLinkRow>>;
  linkSessionCount?: Maybe<Array<RpaLinkRow>>;
  linkSuccessCount?: Maybe<Array<RpaLinkRow>>;
  linkTimeMfaCount?: Maybe<Array<RpaLinkTimeRow>>;
  linkTimeSessionCount?: Maybe<Array<RpaLinkTimeRow>>;
  linkTimeSuccessCount?: Maybe<Array<RpaLinkTimeRow>>;
  portalCredentialRejectionRate?: Maybe<Array<RpaEndpointRow>>;
  portalMfaInterval?: Maybe<Array<RpaEndpointDurationRow>>;
  portalMfaMethods?: Maybe<Array<RpaEndpointMfaMethodsRow>>;
  portalMfaRate?: Maybe<Array<RpaEndpointRow>>;
  portalProviderMfaInterval?: Maybe<Array<RpaEndpointProviderDurationRow>>;
  portalSecurityChallengeRate?: Maybe<Array<RpaEndpointRow>>;
  portalSessionTtlDistribution?: Maybe<Array<RpaEndpointDistributionRow>>;
  portalSuccessRate?: Maybe<Array<RpaEndpointRow>>;
  portalSyncReuseRate?: Maybe<Array<RpaEndpointRow>>;
  portalTimeMfaRate?: Maybe<Array<RpaEndpointTimeRow>>;
  portalTimeSuccessRate?: Maybe<Array<RpaEndpointTimeRow>>;
  providerConnectionLoss?: Maybe<Array<RpaProviderRow>>;
  providerGlobalFailureStreak?: Maybe<Array<RpaProviderRow>>;
  providerGlobalSuccess?: Maybe<Array<RpaProviderRow>>;
  providerPortalFailureStreak?: Maybe<Array<RpaEndpointProviderRow>>;
  providerPortalMfaRate?: Maybe<Array<RpaEndpointProviderRow>>;
  providerPortalSuccess?: Maybe<Array<RpaEndpointProviderRow>>;
  syncTailgateDaySessionCount?: Maybe<Array<RpaLinkDayRow>>;
  syncTailgateDaySuccessCount?: Maybe<Array<RpaLinkDayRow>>;
  syncTailgateMfaCount?: Maybe<Array<RpaLinkRow>>;
  syncTailgateMfaInterval?: Maybe<Array<RpaLinkDurationRow>>;
  syncTailgateMfaIntervalDistribution?: Maybe<Array<RpaLinkDistributionRow>>;
  syncTailgateMfaTimestamps?: Maybe<Array<RpaLinkTimestampsRow>>;
  syncTailgateSecChallengeCount?: Maybe<Array<RpaLinkRow>>;
  syncTailgateSecChallengeSessionCount?: Maybe<Array<RpaLinkRow>>;
  syncTailgateSessionCount?: Maybe<Array<RpaLinkRow>>;
  syncTailgateSuccessCount?: Maybe<Array<RpaLinkRow>>;
  syncTailgateTimeSessionCount?: Maybe<Array<RpaLinkTimeRow>>;
  syncTailgateTimeSuccessCount?: Maybe<Array<RpaLinkTimeRow>>;
};

export type RpaForecastEntry = {
  __typename: 'RpaForecastEntry';
  blockId: Scalars['String']['output'];
  dayOfWeek: Scalars['String']['output'];
  dispatchAt: Scalars['DateTime']['output'];
  linkId: Scalars['String']['output'];
  member: RpaForecastMember;
  provider: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  status: RpaForecastStatus;
  timeOfDay: Scalars['String']['output'];
};

export type RpaForecastMember = {
  __typename: 'RpaForecastMember';
  endpointId: Scalars['String']['output'];
  portalUsername: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export enum RpaForecastStatus {
  Committed = 'Committed',
  Projected = 'Projected'
}

export type RpaLinkDayRow = {
  __typename: 'RpaLinkDayRow';
  dayOfWeek: Scalars['String']['output'];
  linkId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaLinkDistributionRow = {
  __typename: 'RpaLinkDistributionRow';
  linkId: Scalars['String']['output'];
  p5: Scalars['Float']['output'];
  p50: Scalars['Float']['output'];
  p95: Scalars['Float']['output'];
};

export type RpaLinkDurationRow = {
  __typename: 'RpaLinkDurationRow';
  linkId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaLinkMfaMethodsRow = {
  __typename: 'RpaLinkMfaMethodsRow';
  linkId: Scalars['String']['output'];
  value: Array<Array<Scalars['String']['output']>>;
};

export type RpaLinkRow = {
  __typename: 'RpaLinkRow';
  linkId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaLinkTimeRow = {
  __typename: 'RpaLinkTimeRow';
  linkId: Scalars['String']['output'];
  timeWindow: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaLinkTimestampsRow = {
  __typename: 'RpaLinkTimestampsRow';
  linkId: Scalars['String']['output'];
  value: Array<Scalars['DateTime']['output']>;
};

export type RpaLinkView = {
  __typename: 'RpaLinkView';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endpointId: Scalars['String']['output'];
  endpointName: Scalars['String']['output'];
  lastSessionAt?: Maybe<Scalars['DateTime']['output']>;
  linkId: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type RpaLinkViewsInput = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  linkIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RpaMfaMethodsRow = {
  __typename: 'RpaMfaMethodsRow';
  value: Array<Array<Scalars['String']['output']>>;
};

export type RpaOperating = {
  __typename: 'RpaOperating';
  stage: Scalars['String']['output'];
};

export type RpaProviderRow = {
  __typename: 'RpaProviderRow';
  provider: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaRelinkDayRow = {
  __typename: 'RpaRelinkDayRow';
  dayOfWeek: Scalars['String']['output'];
  endpointId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaRelinkMfaMethodsRow = {
  __typename: 'RpaRelinkMfaMethodsRow';
  endpointId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  value: Array<Array<Scalars['String']['output']>>;
};

export type RpaRelinkRow = {
  __typename: 'RpaRelinkRow';
  endpointId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaRelinkTimeRow = {
  __typename: 'RpaRelinkTimeRow';
  endpointId: Scalars['String']['output'];
  timeWindow: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaScalarRow = {
  __typename: 'RpaScalarRow';
  value: Scalars['Float']['output'];
};

export type RpaScheduleForecastInput = {
  after: Scalars['DateTime']['input'];
  before: Scalars['DateTime']['input'];
  experimentId: Scalars['String']['input'];
};

export type RpaSessionDot = {
  __typename: 'RpaSessionDot';
  linkId: Scalars['String']['output'];
  origin: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type RpaSessionDotsInput = {
  after: Scalars['DateTime']['input'];
  before: Scalars['DateTime']['input'];
  linkIds: Array<Scalars['String']['input']>;
};

export type RpaSessionTimeline = {
  __typename: 'RpaSessionTimeline';
  endpointName: Scalars['String']['output'];
  events: Array<RpaTimelineEvent>;
  origin: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
};

export type RpaSessionTimelineInput = {
  sessionId: Scalars['String']['input'];
};

export type RpaStatusResult = RpaDone | RpaOperating;

export type RpaTimeWindowRateRow = {
  __typename: 'RpaTimeWindowRateRow';
  timeWindow: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaTimelineEvent = {
  __typename: 'RpaTimelineEvent';
  event: Scalars['JSON']['output'];
  occurredAt: Scalars['String']['output'];
};

export type RunAllHealthChecksInput = {
  checks: Array<StartHealthCheckInput>;
};

export type SaveNotesInput = {
  notesAsHtml: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SaveNotesResponse = FormError | SaveNotesSuccess;

export type SaveNotesSuccess = {
  __typename: 'SaveNotesSuccess';
  success: Scalars['Boolean']['output'];
};

export type ScheduleDelayedChargeInput = {
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  issueId?: InputMaybe<Scalars['ID']['input']>;
  latencyMinutes: Scalars['Int']['input'];
};

export type ScheduleDelayedChargeResponse = {
  __typename: 'ScheduleDelayedChargeResponse';
  workflowId: Scalars['String']['output'];
};

export type SecurityQuestionRequired = {
  __typename: 'SecurityQuestionRequired';
  securityQuestions: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type SelectMfaMethodInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  selectedDisplay?: InputMaybe<Scalars['String']['input']>;
  selectedMethod?: InputMaybe<MfaMethodType>;
  selectedMethodId: Scalars['Int']['input'];
  workflowId: Scalars['String']['input'];
};

export type SelectMfaMethodResponse = {
  __typename: 'SelectMfaMethodResponse';
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type SelectPlanForEventInput = {
  eventId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
};

export type SendDocumentToUserInput = {
  documentId: Scalars['ID']['input'];
  issueId: Scalars['ID']['input'];
};

export type SendDocumentToUserResult = {
  __typename: 'SendDocumentToUserResult';
  document: document__Document;
};

export type SendDocumentsToUserInput = {
  documentIds: Array<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
};

export type SendDocumentsToUserResult = {
  __typename: 'SendDocumentsToUserResult';
  documents: Array<document__Document>;
};

export type SendMagicLinkInput = {
  /**
   * Anonymous session ID (JWT) from a prior pre-auth session.
   * When provided, the anonymous user record is converted to a full user on login.
   */
  anonymousSessionId?: InputMaybe<Scalars['String']['input']>;
  /** Bot control token for bot protection (e.g. reCAPTCHA, device fingerprinting). */
  botControlToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * If specified, magic links sent by Stytch will redirect to this URI.
   * In particular, this is useful for both local development and for the
   * Expo app - where we want to deeplink back into the app.
   */
  clientRedirectUri?: InputMaybe<Scalars['String']['input']>;
  /** Challenge token for PKCE flow. */
  codeChallenge?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  /**
   * Admin app flag - when true, only allows existing admin users to log in.
   * Does not create new users.
   */
  forAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Source of the registration (e.g., ios, android, web). */
  sourcePlatform?: InputMaybe<Scalars['String']['input']>;
  /** User segmentation data for the web onboarding flow. */
  userSegmentationData?: InputMaybe<UserSegmentationData>;
};

export type SendMagicLinkResponse = {
  __typename: 'SendMagicLinkResponse';
  created: Scalars['Boolean']['output'];
  user: AuthUser;
};

export type SendMagicLinkResult = FormError | SendMagicLinkResponse;

export type SetDefaultEndpointProxyConfigInput = {
  endpointId: Scalars['ID']['input'];
  proxyConfigId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetDefaultLinkProxyConfigInput = {
  linkId: Scalars['ID']['input'];
  proxyConfigId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetEndpointCdpProviderInput = {
  cdpProvider: webAgent__CDPProvider;
  endpointId: Scalars['ID']['input'];
};

export type SetWebAgentEndpointIngestionSupportedInput = {
  endpointId: Scalars['ID']['input'];
  isIngestionSupported: Scalars['Boolean']['input'];
};

export type ShadowLoginInput = {
  email: Scalars['String']['input'];
};

export type SignAndSaveTemplateInput = {
  formFields: Array<FilledField>;
  formOptions: FormOptionsV2;
  patient?: InputMaybe<PersonUpsertInput>;
  signatureDocumentId: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['String']['input']>;
  subscriber?: InputMaybe<PersonUpsertInput>;
  templateEventId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};

export type SignAndSaveTemplateResult = {
  __typename: 'SignAndSaveTemplateResult';
  success: Scalars['Boolean']['output'];
};

export type SignHipaaReleaseInput = {
  dateOfBirth: Scalars['String']['input'];
  name: Scalars['String']['input'];
  signatureDocumentId: Scalars['String']['input'];
};

export type SignHipaaReleaseResult = FormError | consent__HipaaRelease_Type;

export type SignTemplateError = {
  __typename: 'SignTemplateError';
  errorCode: SignTemplateErrorCode;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum SignTemplateErrorCode {
  SIGNING_ERROR = 'SIGNING_ERROR',
  TEMPLATE_NOT_FOUND = 'TEMPLATE_NOT_FOUND',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UPLOAD_ERROR = 'UPLOAD_ERROR'
}

export type SignTemplateInput = {
  formOptions?: InputMaybe<FormOptions>;
  signatureDocumentId: Scalars['String']['input'];
  templateEventId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};

export type SignTemplateResult = SignTemplateError | SignTemplateSuccess;

export type SignTemplateSuccess = {
  __typename: 'SignTemplateSuccess';
  documentId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SimpleMoney = {
  __typename: 'SimpleMoney';
  currency: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Slugged = {
  id: Scalars['ID']['output'];
  slug?: Maybe<Scalars['String']['output']>;
};

export type StaffOpenNewIssueInput = {
  caseType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type StartBackfillInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  cacheBuster?: InputMaybe<Scalars['String']['input']>;
  concurrency?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  dataTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  docsPerWorkflow?: InputMaybe<Scalars['Int']['input']>;
  excludeInternalUsers?: InputMaybe<Scalars['Boolean']['input']>;
  excludeJsonFiles?: InputMaybe<Scalars['Boolean']['input']>;
  maxDocsPerUser?: InputMaybe<Scalars['Int']['input']>;
  skipFhir?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StartBackfillResult = {
  __typename: 'StartBackfillResult';
  runId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

export type StartEligibilityWorkflowResult = {
  __typename: 'StartEligibilityWorkflowResult';
  runId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

/**
 * Input for a bounded event-replay run.
 *
 * Scope rule: at least one of `fromTimestamp` or `aggregateIds` must be set.
 * `aggregateType` alone is not sufficient — every replay must commit to either
 * a time window or a specific set of aggregates. Requests without one of the
 * two are rejected.
 */
export type StartEventReplayInput = {
  /**
   * Specific aggregate IDs to replay (e.g., a list of userIds for UserData).
   * Required unless `fromTimestamp` is provided.
   */
  aggregateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Aggregate type to replay (e.g., "UserData"). Required — replay is always
   * bounded to a specific aggregate family.
   */
  aggregateType: Scalars['String']['input'];
  /**
   * Events per page. Defaults to 100. Each page triggers a `continueAsNew`.
   * Smaller batches reduce burst pressure on the event worker, which matters
   * for ordering when many same-aggregate events are in the stream.
   */
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Resume cursor (eventId). Set when restarting after a failure — the workflow
   * will pick up strictly after this eventId.
   */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Event type tags to include (e.g., ["PersonReceived"]). Filter applied to
   * the event's `data._tag` field. Omit to include all event types for the
   * given aggregate.
   */
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Inclusive lower bound on event timestamp. ISO 8601. Required unless
   * `aggregateIds` is provided.
   */
  fromTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inclusive upper bound on event timestamp. ISO 8601. Omit for no upper bound. */
  toTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StartHealthCheckInput = {
  cdpProvider: webAgent__CDPProvider;
  geoLocation?: InputMaybe<GeoLocation>;
  linkId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type StartLinkBackfillInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  concurrency?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  excludeInternalUsers?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StartLinkCreationInput = {
  endpointId: Scalars['String']['input'];
  issueId?: InputMaybe<Scalars['String']['input']>;
  requestManagedMfa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartLinkCreationResult = {
  __typename: 'StartLinkCreationResult';
  workflowId: Scalars['String']['output'];
};

export type StartLinkRelinkInput = {
  linkId: Scalars['String']['input'];
  requestManagedMfa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartLinkSignInInput = {
  cdpProvider?: InputMaybe<webAgent__CDPProvider>;
  linkId: Scalars['String']['input'];
  proxyConfigId?: InputMaybe<Scalars['String']['input']>;
};

export type StartLinkSignInResponse = {
  __typename: 'StartLinkSignInResponse';
  success: Scalars['Boolean']['output'];
};

export type StartPersonBackfillInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  concurrency?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  excludeInternalUsers?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StartRPADebugInput = {
  browserbaseConfig?: InputMaybe<BrowserbaseConfig>;
  cdpProvider: webAgent__CDPProvider;
  mode: RPADebugMode;
};

export type StartRPADebugResponse = {
  __typename: 'StartRPADebugResponse';
  executionId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type StartRecrawlFromExecutionInput = {
  executionId: Scalars['String']['input'];
};

export type StartRecrawlFromLinkInput = {
  linkId: Scalars['String']['input'];
};

export type StartRecrawlResponse = {
  __typename: 'StartRecrawlResponse';
  /** Whether the recrawl was successfully started */
  success: Scalars['Boolean']['output'];
  /** The workflow ID for tracking the recrawl */
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type StartTailgateInput = {
  linkId: Scalars['String']['input'];
};

export type StartTailgateResult = {
  __typename: 'StartTailgateResult';
  sessionId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

export type StopRPADebugInput = {
  executionId: Scalars['String']['input'];
};

export type StytchImportError = {
  __typename: 'StytchImportError';
  email?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stytchId: Scalars['String']['output'];
};

export type StytchImportResult = {
  __typename: 'StytchImportResult';
  errors?: Maybe<Array<StytchImportError>>;
  importedEmails?: Maybe<Array<Scalars['String']['output']>>;
  knownEmails?: Maybe<Array<Scalars['String']['output']>>;
};

export type SubmitManagedMfaApprovalInput = {
  approved: Scalars['Boolean']['input'];
  workflowId: Scalars['String']['input'];
};

export type SubmitMfaCodeInput = {
  code: Scalars['String']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  workflowId: Scalars['String']['input'];
};

export type SubmitSecurityAnswerInput = {
  answers: Array<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  workflowId: Scalars['String']['input'];
};

export type Subscription = {
  __typename: 'Subscription';
  conversationEvents: ConversationSubscriptionEvent;
};


export type SubscriptionconversationEventsArgs = {
  issueId: Scalars['String']['input'];
};

export type SubscriptionPrice = {
  __typename: 'SubscriptionPrice';
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval: Scalars['String']['output'];
  unitAmount: Scalars['Int']['output'];
};

export type SubscriptionProduct = {
  __typename: 'SubscriptionProduct';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prices: Array<SubscriptionPrice>;
};

export enum SubscriptionStatusGql {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  INCOMPLETE = 'INCOMPLETE',
  INCOMPLETE_EXPIRED = 'INCOMPLETE_EXPIRED',
  PAST_DUE = 'PAST_DUE',
  PAUSED = 'PAUSED',
  TRIALING = 'TRIALING',
  UNPAID = 'UNPAID'
}

export type SummarizeDocumentInput = {
  documentId: Scalars['ID']['input'];
  issueId?: InputMaybe<Scalars['ID']['input']>;
};

export type SystemPreviewMessage = {
  messageId: Scalars['String']['input'];
};

/**
 * Where the task creation originated. Logged on every createIssueTask call so
 * analytics queries can attribute tasks to the surface that produced them
 * (e.g. "tasks created from a CRI recommendation step per HA per day").
 * Optional and not persisted on the Task itself today — see AUT-1015 for the
 * deliberate decision to log-only and defer schema-level provenance.
 */
export enum TaskCreationSource {
  CRI_RECOMMENDATION = 'CRI_RECOMMENDATION',
  MANUAL = 'MANUAL',
  OTHER = 'OTHER'
}

export type TemplateFieldAttributesError = {
  __typename: 'TemplateFieldAttributesError';
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TemplateFieldAttributesInput = {
  templateId: Scalars['String']['input'];
};

export type TemplateFieldAttributesResult = TemplateFieldAttributesError | TemplateFieldAttributesSuccess;

export type TemplateFieldAttributesSuccess = {
  __typename: 'TemplateFieldAttributesSuccess';
  additionalSections: Array<AdditionalSection>;
  fields: Array<FieldAttributes>;
  success: Scalars['Boolean']['output'];
};

export type TemplateStorageValuesResult = {
  __typename: 'TemplateStorageValuesResult';
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  s3PutUrl: Scalars['String']['output'];
};

export enum TemplateType {
  HIPAA_RELEASE = 'HIPAA_RELEASE'
}

export type TrackInsuranceLinkAttemptInput = {
  abandonedReason?: InputMaybe<eventTracking__LinkAttemptAbandonedReason>;
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  baseEndpointId?: InputMaybe<Scalars['String']['input']>;
  baseLinkId?: InputMaybe<Scalars['String']['input']>;
  status: eventTracking__LinkAttemptStatus;
  webAgentExecutionId?: InputMaybe<Scalars['String']['input']>;
};

export type UnreadIssuesUpdatesPrompt = BaseUpdatesPrompt & {
  __typename: 'UnreadIssuesUpdatesPrompt';
  count: Scalars['Int']['output'];
  issueIds: Array<Scalars['String']['output']>;
  type: UpdatesPromptType;
};

export type UpdateBusinessRuleInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimension?: InputMaybe<dataQuality__Dimension>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expression?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  minScore?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCrawlObjectiveReviewInput = {
  categorization: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  objectiveId: Scalars['ID']['input'];
};

export type UpdateCrawlReviewInput = {
  categorization: Scalars['String']['input'];
  crawlId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDefaultError = {
  __typename: 'UpdateDefaultError';
  errors: Array<Scalars['String']['output']>;
  templateId: Scalars['String']['output'];
};

export type UpdateDefaultSuccess = {
  __typename: 'UpdateDefaultSuccess';
  templateId: Scalars['String']['output'];
};

export type UpdateDefaultTemplateInput = {
  templateId: Scalars['String']['input'];
};

export type UpdateDefaultTemplateResult = UpdateDefaultError | UpdateDefaultSuccess;

export type UpdateDocumentNameInput = {
  documentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateDocumentNameResult = {
  __typename: 'UpdateDocumentNameResult';
  document: document__Document;
};

export type UpdateEndpointCapabilityInput = {
  capability: EndpointCapabilityInput;
  endpointId: Scalars['ID']['input'];
};

export type UpdateEndpointSupportLevelInput = {
  endpointId: Scalars['ID']['input'];
  supportLevel: webAgent__EndpointSupportLevel;
};

export type UpdateFileNameInput = {
  fileId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateFileNameResult = {
  __typename: 'UpdateFileNameResult';
  file: document__File;
};

export type UpdateFindingInput = {
  explanation?: InputMaybe<Scalars['String']['input']>;
  findingId: Scalars['ID']['input'];
};

export type UpdateIngestionResolutionStatusInput = {
  ingestionId: Scalars['ID']['input'];
  resolutionStatus: ingestion__ResolutionStatus;
};

export type UpdateInsuranceLinkAttemptInvestigationUrlInput = {
  id: Scalars['ID']['input'];
  investigationUrl: Scalars['String']['input'];
};

export type UpdateInsuranceLinkAttemptInvestigationUrlResult = {
  __typename: 'UpdateInsuranceLinkAttemptInvestigationUrlResult';
  id: Scalars['ID']['output'];
};

export type UpdateIssueCommentEventPinnedInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  commentEventId: Scalars['ID']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateIssueEventInput = {
  actionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  caseIntake?: InputMaybe<Scalars['Boolean']['input']>;
  eventId: Scalars['ID']['input'];
  userVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateIssueInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  caseManagementClosureReason?: InputMaybe<Scalars['String']['input']>;
  caseManagementRelatedIssueCount?: InputMaybe<Scalars['Int']['input']>;
  caseManagementType?: InputMaybe<Scalars['String']['input']>;
  coverageType?: InputMaybe<Scalars['String']['input']>;
  dollarAmountSaved?: InputMaybe<Scalars['Decimal']['input']>;
  estimatedDollarAmountSaved?: InputMaybe<Scalars['Decimal']['input']>;
  followUpDate?: InputMaybe<Scalars['String']['input']>;
  issueId: Scalars['ID']['input'];
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  nextSteps?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalBillDollarAmount?: InputMaybe<Scalars['Decimal']['input']>;
  userLastSeenNow?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for updating a navigator specialist instruction */
export type UpdateNavigatorSpecialistInstructionsInput = {
  id: Scalars['ID']['input'];
  /** The instruction content to update */
  instructions: Scalars['String']['input'];
};

/** Input for updating the isActive flag of a navigator specialist page discovery */
export type UpdateNavigatorSpecialistPageDiscoveryIsActiveInput = {
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
};

/** Input for updating the discovery JSON of a navigator specialist page discovery */
export type UpdateNavigatorSpecialistPageDiscoveryJsonInput = {
  discoveryJson: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdatePaymentAgreementEventInput = {
  eventId: Scalars['ID']['input'];
  userAccepted: Scalars['Boolean']['input'];
};

export type UpdatePaymentProfileInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['String']['input'];
};

export type UpdatePaymentProfileResponse = {
  __typename: 'UpdatePaymentProfileResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdatePersonAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonInput = {
  address?: InputMaybe<PersonAddress>;
  dob?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenNames?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePromoCodeInput = {
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePromoCodeResponse = {
  __typename: 'UpdatePromoCodeResponse';
  promoCode: payment__PromoCode_Type;
};

export type UpdateProviderInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  clearPartOf?: InputMaybe<Scalars['Boolean']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  faPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<provider__ProviderKind>;
  notes?: InputMaybe<Array<Scalars['String']['input']>>;
  npi?: InputMaybe<Scalars['String']['input']>;
  partOfId?: InputMaybe<Scalars['ID']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  systemName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSignInReviewInput = {
  categorization?: InputMaybe<webAgent__SignInAnalysisCategory>;
  executionId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSignInReviewResult = {
  __typename: 'UpdateSignInReviewResult';
  id: Scalars['ID']['output'];
};

export type UpdateSubscriptionPaymentMethodInput = {
  paymentMethodId: Scalars['String']['input'];
};

export type UpdateSubscriptionPaymentMethodResponse = {
  __typename: 'UpdateSubscriptionPaymentMethodResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateTaskCommentInput = {
  comment: Scalars['String']['input'];
  commentId: Scalars['ID']['input'];
};

export type UpdateTaskCommentPinnedInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['ID']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTaskInput = {
  additionalDetailsRequested?: InputMaybe<Scalars['String']['input']>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  formSender?: InputMaybe<Scalars['String']['input']>;
  formType?: InputMaybe<Scalars['String']['input']>;
  hasAllInformation?: InputMaybe<Scalars['Boolean']['input']>;
  minutesSpent?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  researchNotes?: InputMaybe<Scalars['String']['input']>;
  sendingMethod?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<taskManagement__TaskStatus>;
  taskId: Scalars['ID']['input'];
  /** @deprecated Use minutesSpent instead */
  timeSpent?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTemplateItem = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};

export type UpdateTemplatesInput = {
  templates: Array<UpdateTemplateItem>;
};

export type UpdateTemplatesResult = FormError | UpdateTemplatesSuccess;

export type UpdateTemplatesSuccess = {
  __typename: 'UpdateTemplatesSuccess';
  success: Scalars['Boolean']['output'];
};

export type UpdateWebAgentEndpointInput = {
  cdpProvider?: InputMaybe<webAgent__CDPProvider>;
  dashboardUrl?: InputMaybe<Scalars['String']['input']>;
  defaultProxy?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isIngestionSupported?: InputMaybe<Scalars['Boolean']['input']>;
  loginUrl?: InputMaybe<Scalars['String']['input']>;
  managedMfaConfiguration?: InputMaybe<ManagedMfaConfigurationInput>;
  portalGuideUrl?: InputMaybe<Scalars['String']['input']>;
  supportLevel?: InputMaybe<webAgent__EndpointSupportLevel>;
};

export type UpdatesPrompt = BillsToReviewUpdatesPrompt | RefreshAccountUpdatesPrompt | UnreadIssuesUpdatesPrompt;

export enum UpdatesPromptType {
  BILLS_TO_REVIEW = 'BILLS_TO_REVIEW',
  REFRESH_ACCOUNT = 'REFRESH_ACCOUNT',
  UNREAD_ISSUES = 'UNREAD_ISSUES'
}

export type UpsertProviderContactPointInput = {
  contactPointId?: InputMaybe<Scalars['ID']['input']>;
  kind: provider__ContactKind;
  notes?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['ID']['input'];
  /** Defaults to General when omitted. */
  purpose?: InputMaybe<provider__ContactPurpose>;
  value: Scalars['String']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpsertUserSegmentationDataInput = {
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  hasInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  heardAboutUsFrom?: InputMaybe<Scalars['String']['input']>;
  usageScope?: InputMaybe<Scalars['String']['input']>;
  usageScopes?: InputMaybe<Array<Scalars['String']['input']>>;
  useCases?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type User = {
  accounts?: Maybe<Array<fhirext__AccountVersion>>;
  anonymousConvertedAt?: Maybe<Scalars['String']['output']>;
  anonymousSessionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deletionRequestedAt?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<user__Email>>;
  explanationOfBenefits?: Maybe<Array<fhirext__ExplanationOfBenefitVersion>>;
  flexpaLinks?: Maybe<Array<flexpa__Link>>;
  hasSeenHome: Scalars['Boolean']['output'];
  hipaaRelease?: Maybe<consent__HipaaRelease>;
  id: Scalars['ID']['output'];
  invoices?: Maybe<Array<fhirext__InvoiceVersion>>;
  isAdmin: Scalars['Boolean']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  issues?: Maybe<Array<issue__Issue>>;
  lastAuthenticatedAt?: Maybe<Scalars['String']['output']>;
  lastSessionRefreshedAt?: Maybe<Scalars['String']['output']>;
  notesAsHtml?: Maybe<Scalars['String']['output']>;
  persons?: Maybe<Array<Person>>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPerson?: Maybe<Person>;
  profile: user__Profile;
  promoCodeUsages?: Maybe<Array<payment__IssuePromoCodeUsage>>;
  registrationSource?: Maybe<Scalars['String']['output']>;
  segmentationData?: Maybe<user__SegmentationData>;
  source?: Maybe<partner__Partner>;
  stytchId?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<taskManagement__Task>>;
  templateReleases?: Maybe<Array<consent__TemplateRelease>>;
  userExitInsuranceLinkFeedback?: Maybe<Array<webAgent__UserExitInsuranceLinkFeedback>>;
  webAgentLinks?: Maybe<Array<webAgent__Link>>;
};


export type UseraccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterAccountVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderAccountVersion>;
};


export type UseremailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterEmail>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderEmail>;
};


export type UserexplanationOfBenefitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitVersion>;
};


export type UserflexpaLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderLink>;
};


export type UserhipaaReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterHipaaRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderHipaaRelease>;
};


export type UserinvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceVersion>;
};


export type UserissuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type UserpersonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type UserprimaryPersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type UserprofileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type UserpromoCodeUsagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterIssuePromoCodeUsage>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderIssuePromoCodeUsage>;
};


export type UsersegmentationDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterSegmentationData>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderSegmentationData>;
};


export type UsersourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartner>;
};


export type UsertasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTask>;
};


export type UsertemplateReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterTemplateRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderTemplateRelease>;
};


export type UseruserExitInsuranceLinkFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterUserExitInsuranceLinkFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderUserExitInsuranceLinkFeedback>;
};


export type UserwebAgentLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};

export type UserDocumentFile = {
  __typename: 'UserDocumentFile';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserDocumentIngestion = {
  __typename: 'UserDocumentIngestion';
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type UserDocumentIssue = {
  __typename: 'UserDocumentIssue';
  id: Scalars['ID']['output'];
};

export type UserDocumentIssueEvent = {
  __typename: 'UserDocumentIssueEvent';
  id: Scalars['ID']['output'];
  issue: UserDocumentIssue;
};

/**
 * A single ingestion-v2 health record (EOB or invoice) sourced directly from
 * `projection::UserDataView`, with its enrichment overlay stitched in. The
 * `data` blob conforms to `@medbillai/schemas` `v2.EOB` / `v2.Invoice`; clients
 * parse it with those schemas.
 */
export type UserHealthRecord = {
  __typename: 'UserHealthRecord';
  /** The v2.EOB / v2.Invoice blob, verbatim from UserDataView.data. */
  data: Scalars['JSON']['output'];
  /**
   * Stitched UserEnrichmentData overlay (enrichments fields plus title and
   * overallPriceRating), or null when the enrichment pipeline has not produced
   * a row for this record yet.
   */
  enrichment?: Maybe<Scalars['JSON']['output']>;
  /** Materialization key (projection::UserDataView.key), the row identity. */
  key: Scalars['ID']['output'];
  /**
   * Record kind: "claim" for an EOB, "invoice" for an invoice. Matches the
   * underlying UserDataView.kind verbatim.
   */
  kind: Scalars['String']['output'];
  /** When the projection row was last materialized. */
  updatedAt: Scalars['DateTime']['output'];
};

export type UserPreviewMessage = {
  documentId?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UserSegmentAssignment = {
  assignedBy: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  segmentKey: Scalars['String']['input'];
  source: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserSegmentationData = {
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  usageScopes?: InputMaybe<Array<Scalars['String']['input']>>;
  useCases?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserUploadedDocumentsInput = {
  userId: Scalars['ID']['input'];
};

export type UserUploadedDocumentsResult = {
  __typename: 'UserUploadedDocumentsResult';
  createdAt: Scalars['DateTime']['output'];
  dataType: Scalars['String']['output'];
  files: Array<UserDocumentFile>;
  id: Scalars['ID']['output'];
  issueEvent: Array<UserDocumentIssueEvent>;
  latestIngestion?: Maybe<UserDocumentIngestion>;
  name: Scalars['String']['output'];
};

export type User_Type = BaseObject & Object & User & {
  __typename: 'User_Type';
  accounts?: Maybe<Array<fhirext__AccountVersion>>;
  anonymousConvertedAt?: Maybe<Scalars['String']['output']>;
  anonymousSessionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deletionRequestedAt?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<user__Email>>;
  explanationOfBenefits?: Maybe<Array<fhirext__ExplanationOfBenefitVersion>>;
  flexpaLinks?: Maybe<Array<flexpa__Link>>;
  hasSeenHome: Scalars['Boolean']['output'];
  hipaaRelease?: Maybe<consent__HipaaRelease>;
  id: Scalars['ID']['output'];
  invoices?: Maybe<Array<fhirext__InvoiceVersion>>;
  isAdmin: Scalars['Boolean']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  issues?: Maybe<Array<issue__Issue>>;
  lastAuthenticatedAt?: Maybe<Scalars['String']['output']>;
  lastSessionRefreshedAt?: Maybe<Scalars['String']['output']>;
  notesAsHtml?: Maybe<Scalars['String']['output']>;
  persons?: Maybe<Array<Person>>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPerson?: Maybe<Person>;
  profile: user__Profile;
  promoCodeUsages?: Maybe<Array<payment__IssuePromoCodeUsage>>;
  registrationSource?: Maybe<Scalars['String']['output']>;
  segmentationData?: Maybe<user__SegmentationData>;
  source?: Maybe<partner__Partner>;
  stytchId?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<taskManagement__Task>>;
  templateReleases?: Maybe<Array<consent__TemplateRelease>>;
  userExitInsuranceLinkFeedback?: Maybe<Array<webAgent__UserExitInsuranceLinkFeedback>>;
  webAgentLinks?: Maybe<Array<webAgent__Link>>;
};


export type User_TypeaccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterAccountVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderAccountVersion>;
};


export type User_TypeemailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterEmail>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderEmail>;
};


export type User_TypeexplanationOfBenefitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitVersion>;
};


export type User_TypeflexpaLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderLink>;
};


export type User_TypehipaaReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterHipaaRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderHipaaRelease>;
};


export type User_TypeinvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceVersion>;
};


export type User_TypeissuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type User_TypepersonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type User_TypeprimaryPersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type User_TypeprofileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type User_TypepromoCodeUsagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterIssuePromoCodeUsage>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderIssuePromoCodeUsage>;
};


export type User_TypesegmentationDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterSegmentationData>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderSegmentationData>;
};


export type User_TypesourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartner>;
};


export type User_TypetasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTask>;
};


export type User_TypetemplateReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterTemplateRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderTemplateRelease>;
};


export type User_TypeuserExitInsuranceLinkFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterUserExitInsuranceLinkFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderUserExitInsuranceLinkFeedback>;
};


export type User_TypewebAgentLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};

export type ValidateTemplateError = {
  __typename: 'ValidateTemplateError';
  errors: Array<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type ValidateTemplateInput = {
  s3Bucket: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
};

export type ValidateTemplateResult = ValidateTemplateError | ValidateTemplateSuccess;

export type ValidateTemplateSuccess = {
  __typename: 'ValidateTemplateSuccess';
  valid: Scalars['Boolean']['output'];
};

export type ViewDocumentInput = {
  documentId: Scalars['ID']['input'];
};

export type ViewDocumentResult = {
  __typename: 'ViewDocumentResult';
  documentId: Scalars['ID']['output'];
  documentUrl: Scalars['String']['output'];
};

export type WebAgentExecutionResult = {
  __typename: 'WebAgentExecutionResult';
  artifacts: Array<ExecutionResultArtifact>;
  cdpProvider?: Maybe<webAgent__CDPProvider>;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<ExecutionResultDocument>;
  endpoint?: Maybe<EndpointSlug>;
  id: Scalars['ID']['output'];
  lastUserMfaMethods: Array<webAgent__MfaMethod>;
  latestDiscoveryCrawl: Array<LatestDiscoveryCrawl>;
  latestIngestion?: Maybe<LatestIngestion>;
  type?: Maybe<webAgent__WebExecutionType>;
};

export type WelcomePrompt = {
  __typename: 'WelcomePrompt';
  completed: Scalars['Boolean']['output'];
  type: WelcomePromptType;
};

export enum WelcomePromptType {
  CONNECT_INSURANCE = 'CONNECT_INSURANCE',
  OPEN_CASE = 'OPEN_CASE'
}

export type cache__FilterSerifFairMarketValue = {
  and?: InputMaybe<Array<cache__FilterSerifFairMarketValue>>;
  fetchedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<cache__FilterSerifFairMarketValue>;
  or?: InputMaybe<Array<cache__FilterSerifFairMarketValue>>;
  response?: InputMaybe<FilterJSON>;
};

export type cache__OrderSerifFairMarketValue = {
  fetchedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  response?: InputMaybe<Ordering>;
};

/** Cache for Serif Health API fair market value responses */
export type cache__SerifFairMarketValue = {
  fetchedAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  response: Scalars['JSON']['output'];
};

/** Cache for Serif Health API fair market value responses */
export type cache__SerifFairMarketValue_Type = BaseObject & Object & cache__SerifFairMarketValue & {
  __typename: 'cache__SerifFairMarketValue_Type';
  fetchedAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  response: Scalars['JSON']['output'];
};

export type caseFact__CaseFact = {
  entityKey: Scalars['String']['output'];
  factType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  source: caseFact__FactSource;
  sourceId?: Maybe<Scalars['String']['output']>;
  status: caseFact__FactStatus;
  updatedAt: Scalars['String']['output'];
  valueJson: Scalars['JSON']['output'];
};


export type caseFact__CaseFactissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type caseFact__CaseFactAudit = {
  accepted: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  entityKey: Scalars['String']['output'];
  factType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  proposedStatus: caseFact__FactStatus;
  proposedValueJson: Scalars['JSON']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  source: caseFact__FactSource;
  sourceId?: Maybe<Scalars['String']['output']>;
};


export type caseFact__CaseFactAuditissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type caseFact__CaseFactAudit_Type = BaseObject & Object & caseFact__CaseFactAudit & {
  __typename: 'caseFact__CaseFactAudit_Type';
  accepted: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  entityKey: Scalars['String']['output'];
  factType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  proposedStatus: caseFact__FactStatus;
  proposedValueJson: Scalars['JSON']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  source: caseFact__FactSource;
  sourceId?: Maybe<Scalars['String']['output']>;
};


export type caseFact__CaseFactAudit_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type caseFact__CaseFact_Type = BaseObject & Object & caseFact__CaseFact & {
  __typename: 'caseFact__CaseFact_Type';
  entityKey: Scalars['String']['output'];
  factType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  source: caseFact__FactSource;
  sourceId?: Maybe<Scalars['String']['output']>;
  status: caseFact__FactStatus;
  updatedAt: Scalars['String']['output'];
  valueJson: Scalars['JSON']['output'];
};


export type caseFact__CaseFact_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export enum caseFact__FactSource {
  DOCUMENT_OCR = 'DOCUMENT_OCR',
  INSURANCE_LINK = 'INSURANCE_LINK',
  LLM_INFERENCE = 'LLM_INFERENCE',
  MULTI_SELECT = 'MULTI_SELECT',
  STAFF_ENTRY = 'STAFF_ENTRY',
  USER_CHAT = 'USER_CHAT'
}

export enum caseFact__FactStatus {
  CONFIRMED = 'CONFIRMED',
  UNCERTAIN = 'UNCERTAIN',
  UNOBTAINABLE = 'UNOBTAINABLE'
}

export type caseFact__FilterCaseFact = {
  and?: InputMaybe<Array<caseFact__FilterCaseFact>>;
  entityKey?: InputMaybe<FilterString>;
  factType?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<caseFact__FilterCaseFact>;
  or?: InputMaybe<Array<caseFact__FilterCaseFact>>;
  source?: InputMaybe<FiltercaseFact__FactSource>;
  sourceId?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltercaseFact__FactStatus>;
  updatedAt?: InputMaybe<FilterString>;
  valueJson?: InputMaybe<FilterJSON>;
};

export type caseFact__FilterCaseFactAudit = {
  accepted?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<caseFact__FilterCaseFactAudit>>;
  createdAt?: InputMaybe<FilterString>;
  entityKey?: InputMaybe<FilterString>;
  factType?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<caseFact__FilterCaseFactAudit>;
  or?: InputMaybe<Array<caseFact__FilterCaseFactAudit>>;
  proposedStatus?: InputMaybe<FiltercaseFact__FactStatus>;
  proposedValueJson?: InputMaybe<FilterJSON>;
  rejectionReason?: InputMaybe<FilterString>;
  source?: InputMaybe<FiltercaseFact__FactSource>;
  sourceId?: InputMaybe<FilterString>;
};

export type caseFact__OrderCaseFact = {
  entityKey?: InputMaybe<Ordering>;
  factType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  source?: InputMaybe<Ordering>;
  sourceId?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  valueJson?: InputMaybe<Ordering>;
};

export type caseFact__OrderCaseFactAudit = {
  accepted?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  entityKey?: InputMaybe<Ordering>;
  factType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  proposedStatus?: InputMaybe<Ordering>;
  proposedValueJson?: InputMaybe<Ordering>;
  rejectionReason?: InputMaybe<Ordering>;
  source?: InputMaybe<Ordering>;
  sourceId?: InputMaybe<Ordering>;
};

/** Current Procedural Terminology (CPT) codes are used to describe medical, surgical, and diagnostic services. These are maintained by the American Medical Association (AMA). */
export type coding__CPT = {
  code: Scalars['String']['output'];
  conceptId: Scalars['Int']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText?: Maybe<Scalars['String']['output']>;
  mediumText?: Maybe<Scalars['String']['output']>;
  shortText?: Maybe<Scalars['String']['output']>;
  spanishText?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

/** CPT Modifiers are used to provide additional information about a procedure or service. */
export type coding__CPTModifier = {
  code: Scalars['String']['output'];
  conceptId: Scalars['Int']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<Scalars['String']['output']>;
  longText?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

/** CPT Modifiers are used to provide additional information about a procedure or service. */
export type coding__CPTModifier_Type = BaseObject & Object & coding__CPTModifier & coding__Coding & {
  __typename: 'coding__CPTModifier_Type';
  code: Scalars['String']['output'];
  conceptId: Scalars['Int']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<Scalars['String']['output']>;
  longText?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

/** Current Procedural Terminology (CPT) codes are used to describe medical, surgical, and diagnostic services. These are maintained by the American Medical Association (AMA). */
export type coding__CPT_Type = BaseObject & Object & coding__CPT & coding__Coding & {
  __typename: 'coding__CPT_Type';
  code: Scalars['String']['output'];
  conceptId: Scalars['Int']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText?: Maybe<Scalars['String']['output']>;
  mediumText?: Maybe<Scalars['String']['output']>;
  shortText?: Maybe<Scalars['String']['output']>;
  spanishText?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

/** Abstract representation of a code and its description for a given coding taxonomy. Examples include CPT, ICD-10, HCPCS, etc. */
export type coding__Coding = {
  code: Scalars['String']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

export type coding__FilterCPT = {
  and?: InputMaybe<Array<coding__FilterCPT>>;
  code?: InputMaybe<FilterString>;
  conceptId?: InputMaybe<FilterInt>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  longText?: InputMaybe<FilterString>;
  mediumText?: InputMaybe<FilterString>;
  not?: InputMaybe<coding__FilterCPT>;
  or?: InputMaybe<Array<coding__FilterCPT>>;
  shortText?: InputMaybe<FilterString>;
  spanishText?: InputMaybe<FilterString>;
};

export type coding__FilterCPTModifier = {
  and?: InputMaybe<Array<coding__FilterCPTModifier>>;
  code?: InputMaybe<FilterString>;
  conceptId?: InputMaybe<FilterInt>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  level?: InputMaybe<FilterString>;
  longText?: InputMaybe<FilterString>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<coding__FilterCPTModifier>;
  or?: InputMaybe<Array<coding__FilterCPTModifier>>;
};

export type coding__FilterCoding = {
  and?: InputMaybe<Array<coding__FilterCoding>>;
  code?: InputMaybe<FilterString>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  longText?: InputMaybe<FilterString>;
  not?: InputMaybe<coding__FilterCoding>;
  or?: InputMaybe<Array<coding__FilterCoding>>;
};

export type coding__FilterHCPCS = {
  and?: InputMaybe<Array<coding__FilterHCPCS>>;
  code?: InputMaybe<FilterString>;
  coverageCode?: InputMaybe<FilterString>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  longText?: InputMaybe<FilterString>;
  not?: InputMaybe<coding__FilterHCPCS>;
  or?: InputMaybe<Array<coding__FilterHCPCS>>;
};

export type coding__FilterHCPCSModifier = {
  and?: InputMaybe<Array<coding__FilterHCPCSModifier>>;
  code?: InputMaybe<FilterString>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  longText?: InputMaybe<FilterString>;
  not?: InputMaybe<coding__FilterHCPCSModifier>;
  or?: InputMaybe<Array<coding__FilterHCPCSModifier>>;
};

/** Healthcare Common Procedure Coding System (HCPCS) codes are used to identify items, services, and procedures. Level II codes are maintained by CMS. */
export type coding__HCPCS = {
  code: Scalars['String']['output'];
  coverageCode?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

/** HCPCS Modifiers are used to provide additional information about a procedure or service. */
export type coding__HCPCSModifier = {
  code: Scalars['String']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

/** HCPCS Modifiers are used to provide additional information about a procedure or service. */
export type coding__HCPCSModifier_Type = BaseObject & Object & coding__Coding & coding__HCPCSModifier & {
  __typename: 'coding__HCPCSModifier_Type';
  code: Scalars['String']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

/** Healthcare Common Procedure Coding System (HCPCS) codes are used to identify items, services, and procedures. Level II codes are maintained by CMS. */
export type coding__HCPCS_Type = BaseObject & Object & coding__Coding & coding__HCPCS & {
  __typename: 'coding__HCPCS_Type';
  code: Scalars['String']['output'];
  coverageCode?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

export type coding__OrderCPT = {
  code?: InputMaybe<Ordering>;
  conceptId?: InputMaybe<Ordering>;
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  longText?: InputMaybe<Ordering>;
  mediumText?: InputMaybe<Ordering>;
  shortText?: InputMaybe<Ordering>;
  spanishText?: InputMaybe<Ordering>;
};

export type coding__OrderCPTModifier = {
  code?: InputMaybe<Ordering>;
  conceptId?: InputMaybe<Ordering>;
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  level?: InputMaybe<Ordering>;
  longText?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
};

export type coding__OrderCoding = {
  code?: InputMaybe<Ordering>;
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  longText?: InputMaybe<Ordering>;
};

export type coding__OrderHCPCS = {
  code?: InputMaybe<Ordering>;
  coverageCode?: InputMaybe<Ordering>;
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  longText?: InputMaybe<Ordering>;
};

export type coding__OrderHCPCSModifier = {
  code?: InputMaybe<Ordering>;
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  longText?: InputMaybe<Ordering>;
};

export type consent__Consent = {
  archivedAt?: Maybe<Scalars['String']['output']>;
  consentType: consent__ConsentType;
  createdAt: Scalars['String']['output'];
  expirationDate?: Maybe<Scalars['String']['output']>;
  grantedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  user: User;
};


export type consent__ConsentpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type consent__ConsentuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum consent__ConsentType {
  HIPAA_RELEASE = 'HIPAA_RELEASE',
  TEMPLATE_RELEASE = 'TEMPLATE_RELEASE'
}

export type consent__FilterConsent = {
  and?: InputMaybe<Array<consent__FilterConsent>>;
  archivedAt?: InputMaybe<FilterString>;
  consentType?: InputMaybe<Filterconsent__ConsentType>;
  createdAt?: InputMaybe<FilterString>;
  expirationDate?: InputMaybe<FilterString>;
  grantedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<consent__FilterConsent>;
  or?: InputMaybe<Array<consent__FilterConsent>>;
  person?: InputMaybe<NestedFilterPerson>;
  user?: InputMaybe<NestedFilterUser>;
};

export type consent__FilterHipaaRelease = {
  and?: InputMaybe<Array<consent__FilterHipaaRelease>>;
  archivedAt?: InputMaybe<FilterString>;
  consentType?: InputMaybe<Filterconsent__ConsentType>;
  createdAt?: InputMaybe<FilterString>;
  dateOfBirth?: InputMaybe<FilterString>;
  expirationDate?: InputMaybe<FilterString>;
  grantedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<consent__FilterHipaaRelease>;
  or?: InputMaybe<Array<consent__FilterHipaaRelease>>;
  person?: InputMaybe<NestedFilterPerson>;
  signatureDocument?: InputMaybe<document__NestedFilterDocument>;
  user?: InputMaybe<NestedFilterUser>;
};

export type consent__FilterTemplateRelease = {
  and?: InputMaybe<Array<consent__FilterTemplateRelease>>;
  archivedAt?: InputMaybe<FilterString>;
  consentType?: InputMaybe<Filterconsent__ConsentType>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  documentValues?: InputMaybe<FilterJSON>;
  expirationDate?: InputMaybe<FilterString>;
  grantedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<consent__FilterTemplateRelease>;
  or?: InputMaybe<Array<consent__FilterTemplateRelease>>;
  person?: InputMaybe<NestedFilterPerson>;
  template?: InputMaybe<document__NestedFilterTemplate>;
  user?: InputMaybe<NestedFilterUser>;
};

export type consent__HipaaRelease = {
  archivedAt?: Maybe<Scalars['String']['output']>;
  consentType: consent__ConsentType;
  createdAt: Scalars['String']['output'];
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  grantedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person?: Maybe<Person>;
  signatureDocument?: Maybe<document__Document>;
  user: User;
};


export type consent__HipaaReleasepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type consent__HipaaReleasesignatureDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type consent__HipaaReleaseuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type consent__HipaaRelease_Type = BaseObject & Object & Personal & consent__Consent & consent__HipaaRelease & {
  __typename: 'consent__HipaaRelease_Type';
  archivedAt?: Maybe<Scalars['String']['output']>;
  consentType: consent__ConsentType;
  createdAt: Scalars['String']['output'];
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  grantedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person?: Maybe<Person>;
  signatureDocument?: Maybe<document__Document>;
  user: User;
};


export type consent__HipaaRelease_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type consent__HipaaRelease_TypesignatureDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type consent__HipaaRelease_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type consent__NestedFilterHipaaRelease = {
  archivedAt?: InputMaybe<FilterString>;
  consentType?: InputMaybe<Filterconsent__ConsentType>;
  createdAt?: InputMaybe<FilterString>;
  dateOfBirth?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate?: InputMaybe<FilterString>;
  grantedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  person?: InputMaybe<NestedFilterPerson>;
  signatureDocument?: InputMaybe<document__NestedFilterDocument>;
  user?: InputMaybe<NestedFilterUser>;
};

export type consent__NestedFilterTemplateRelease = {
  archivedAt?: InputMaybe<FilterString>;
  consentType?: InputMaybe<Filterconsent__ConsentType>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  documentValues?: InputMaybe<FilterJSON>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate?: InputMaybe<FilterString>;
  grantedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  person?: InputMaybe<NestedFilterPerson>;
  template?: InputMaybe<document__NestedFilterTemplate>;
  user?: InputMaybe<NestedFilterUser>;
};

export type consent__OrderConsent = {
  archivedAt?: InputMaybe<Ordering>;
  consentType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  expirationDate?: InputMaybe<Ordering>;
  grantedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
  user?: InputMaybe<OrderUser>;
};

export type consent__OrderHipaaRelease = {
  archivedAt?: InputMaybe<Ordering>;
  consentType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dateOfBirth?: InputMaybe<Ordering>;
  expirationDate?: InputMaybe<Ordering>;
  grantedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
  signatureDocument?: InputMaybe<document__OrderDocument>;
  user?: InputMaybe<OrderUser>;
};

export type consent__OrderTemplateRelease = {
  archivedAt?: InputMaybe<Ordering>;
  consentType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  documentValues?: InputMaybe<Ordering>;
  expirationDate?: InputMaybe<Ordering>;
  grantedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
  template?: InputMaybe<document__OrderTemplate>;
  user?: InputMaybe<OrderUser>;
};

export type consent__TemplateRelease = {
  archivedAt?: Maybe<Scalars['String']['output']>;
  consentType: consent__ConsentType;
  createdAt: Scalars['String']['output'];
  document: document__Document;
  documentValues?: Maybe<Scalars['JSON']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  grantedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  template: document__Template;
  user: User;
};


export type consent__TemplateReleasedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type consent__TemplateReleasepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type consent__TemplateReleasetemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};


export type consent__TemplateReleaseuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type consent__TemplateRelease_Type = BaseObject & Object & Personal & consent__Consent & consent__TemplateRelease & {
  __typename: 'consent__TemplateRelease_Type';
  archivedAt?: Maybe<Scalars['String']['output']>;
  consentType: consent__ConsentType;
  createdAt: Scalars['String']['output'];
  document: document__Document;
  documentValues?: Maybe<Scalars['JSON']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  grantedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  template: document__Template;
  user: User;
};


export type consent__TemplateRelease_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type consent__TemplateRelease_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type consent__TemplateRelease_TypetemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};


export type consent__TemplateRelease_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** Data quality assessment for FHIR resources */
export type dataQuality__Assessment = {
  id: Scalars['ID']['output'];
  ingestion?: Maybe<ingestion__Ingestion>;
  metrics: Scalars['JSON']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  owner: User;
  performedAt: Scalars['String']['output'];
  resource: fhirext__ResourceVersion;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  score: Scalars['Int']['output'];
  sourceName?: Maybe<Scalars['String']['output']>;
  taskCount: Scalars['Int64']['output'];
  tasks?: Maybe<Array<taskManagement__DataQualityTask>>;
  uncompletedTaskCount: Scalars['Int64']['output'];
};


/** Data quality assessment for FHIR resources */
export type dataQuality__AssessmentingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


/** Data quality assessment for FHIR resources */
export type dataQuality__AssessmentownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Data quality assessment for FHIR resources */
export type dataQuality__AssessmentresourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


/** Data quality assessment for FHIR resources */
export type dataQuality__AssessmenttasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterDataQualityTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderDataQualityTask>;
};

/** Data quality assessment for FHIR resources */
export type dataQuality__Assessment_Type = BaseObject & Object & Owned & dataQuality__Assessment & {
  __typename: 'dataQuality__Assessment_Type';
  id: Scalars['ID']['output'];
  ingestion?: Maybe<ingestion__Ingestion>;
  metrics: Scalars['JSON']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  owner: User;
  performedAt: Scalars['String']['output'];
  resource: fhirext__ResourceVersion;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  score: Scalars['Int']['output'];
  sourceName?: Maybe<Scalars['String']['output']>;
  taskCount: Scalars['Int64']['output'];
  tasks?: Maybe<Array<taskManagement__DataQualityTask>>;
  uncompletedTaskCount: Scalars['Int64']['output'];
};


/** Data quality assessment for FHIR resources */
export type dataQuality__Assessment_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


/** Data quality assessment for FHIR resources */
export type dataQuality__Assessment_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Data quality assessment for FHIR resources */
export type dataQuality__Assessment_TyperesourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


/** Data quality assessment for FHIR resources */
export type dataQuality__Assessment_TypetasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterDataQualityTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderDataQualityTask>;
};

/** Business rules for FHIR validation */
export type dataQuality__BusinessRule = {
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  dimension: dataQuality__Dimension;
  enabled: Scalars['Boolean']['output'];
  expression?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minScore?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  resourceType: fhirext__ResourceType;
};

/** Business rules for FHIR validation */
export type dataQuality__BusinessRule_Type = BaseObject & Object & dataQuality__BusinessRule & {
  __typename: 'dataQuality__BusinessRule_Type';
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  dimension: dataQuality__Dimension;
  enabled: Scalars['Boolean']['output'];
  expression?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minScore?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  resourceType: fhirext__ResourceType;
};

/** Quality dimensions tracked across FHIR resources. */
export enum dataQuality__Dimension {
  ACCURACY = 'ACCURACY',
  COMPLETENESS = 'COMPLETENESS',
  CONSISTENCY = 'CONSISTENCY'
}

export type dataQuality__FilterAssessment = {
  and?: InputMaybe<Array<dataQuality__FilterAssessment>>;
  id?: InputMaybe<FilterID>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  metrics?: InputMaybe<FilterJSON>;
  not?: InputMaybe<dataQuality__FilterAssessment>;
  notes?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<dataQuality__FilterAssessment>>;
  owner?: InputMaybe<NestedFilterUser>;
  performedAt?: InputMaybe<FilterString>;
  resource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  score?: InputMaybe<FilterInt>;
  sourceName?: InputMaybe<FilterString>;
  taskCount?: InputMaybe<FilterInt64>;
  tasks?: InputMaybe<taskManagement__NestedFilterDataQualityTask>;
  uncompletedTaskCount?: InputMaybe<FilterInt64>;
};

export type dataQuality__FilterBusinessRule = {
  and?: InputMaybe<Array<dataQuality__FilterBusinessRule>>;
  category?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dimension?: InputMaybe<FilterdataQuality__Dimension>;
  enabled?: InputMaybe<FilterBoolean>;
  expression?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  minScore?: InputMaybe<FilterInt>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<dataQuality__FilterBusinessRule>;
  or?: InputMaybe<Array<dataQuality__FilterBusinessRule>>;
  priority?: InputMaybe<FilterInt>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
};

export type dataQuality__NestedFilterAssessment = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  metrics?: InputMaybe<FilterJSON>;
  notes?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  performedAt?: InputMaybe<FilterString>;
  resource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  score?: InputMaybe<FilterInt>;
  sourceName?: InputMaybe<FilterString>;
  taskCount?: InputMaybe<FilterInt64>;
  tasks?: InputMaybe<taskManagement__NestedFilterDataQualityTask>;
  uncompletedTaskCount?: InputMaybe<FilterInt64>;
};

export type dataQuality__NestedFilterBusinessRule = {
  category?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dimension?: InputMaybe<FilterdataQuality__Dimension>;
  enabled?: InputMaybe<FilterBoolean>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  expression?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  minScore?: InputMaybe<FilterInt>;
  name?: InputMaybe<FilterString>;
  priority?: InputMaybe<FilterInt>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
};

export type dataQuality__OrderAssessment = {
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  metrics?: InputMaybe<Ordering>;
  notes?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  performedAt?: InputMaybe<Ordering>;
  resource?: InputMaybe<fhirext__OrderResourceVersion>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  score?: InputMaybe<Ordering>;
  sourceName?: InputMaybe<Ordering>;
  taskCount?: InputMaybe<Ordering>;
  uncompletedTaskCount?: InputMaybe<Ordering>;
};

export type dataQuality__OrderBusinessRule = {
  category?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dimension?: InputMaybe<Ordering>;
  enabled?: InputMaybe<Ordering>;
  expression?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  minScore?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
};

/** Enum value used to specify ordering direction. */
export enum directionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type document__Document = {
  createdAt: Scalars['String']['output'];
  dataType?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<document__File>>;
  id: Scalars['ID']['output'];
  ingestions?: Maybe<Array<ingestion__Ingestion>>;
  internalIssueEvent?: Maybe<Array<issue__InternalDocumentUploadedEvent>>;
  issueDocumentSummary?: Maybe<issue__IssueDocumentSummary>;
  issueEvent?: Maybe<Array<issue__DocumentUploadedEvent>>;
  latestIngestion?: Maybe<ingestion__Ingestion>;
  name: Scalars['String']['output'];
  owner: User;
  participant: Participant;
  person?: Maybe<Person>;
  resources?: Maybe<Array<fhirext__ResourceVersion>>;
  source?: Maybe<webAgent__WebAgentExecution>;
  sourceCrawlObjective?: Maybe<webAgent__AiDiscoveryCrawlObjective>;
  sourceFlexpaImport?: Maybe<flexpa__FlexpaImport>;
  summary?: Maybe<document__DocumentSummary>;
  template?: Maybe<document__Template>;
  userVisible: Scalars['Boolean']['output'];
  vellumDocumentId?: Maybe<Scalars['String']['output']>;
};


export type document__DocumentfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterFile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderFile>;
};


export type document__DocumentingestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type document__DocumentinternalIssueEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterInternalDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderInternalDocumentUploadedEvent>;
};


export type document__DocumentissueDocumentSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssueDocumentSummary>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssueDocumentSummary>;
};


export type document__DocumentissueEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};


export type document__DocumentlatestIngestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type document__DocumentownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type document__DocumentpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type document__DocumentresourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type document__DocumentsourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type document__DocumentsourceCrawlObjectiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type document__DocumentsourceFlexpaImportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterFlexpaImport>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderFlexpaImport>;
};


export type document__DocumentsummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocumentSummary>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocumentSummary>;
};


export type document__DocumenttemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};

export type document__DocumentSummary = {
  createdAt?: Maybe<Scalars['String']['output']>;
  document: document__Document;
  id: Scalars['ID']['output'];
  modelId?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type document__DocumentSummarydocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

export type document__DocumentSummary_Type = BaseObject & Object & document__DocumentSummary & {
  __typename: 'document__DocumentSummary_Type';
  createdAt?: Maybe<Scalars['String']['output']>;
  document: document__Document;
  id: Scalars['ID']['output'];
  modelId?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type document__DocumentSummary_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

export type document__Document_Type = BaseObject & Object & Owned & Personal & document__Document & {
  __typename: 'document__Document_Type';
  createdAt: Scalars['String']['output'];
  dataType?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<document__File>>;
  id: Scalars['ID']['output'];
  ingestions?: Maybe<Array<ingestion__Ingestion>>;
  internalIssueEvent?: Maybe<Array<issue__InternalDocumentUploadedEvent>>;
  issueDocumentSummary?: Maybe<issue__IssueDocumentSummary>;
  issueEvent?: Maybe<Array<issue__DocumentUploadedEvent>>;
  latestIngestion?: Maybe<ingestion__Ingestion>;
  name: Scalars['String']['output'];
  owner: User;
  participant: Participant;
  person?: Maybe<Person>;
  resources?: Maybe<Array<fhirext__ResourceVersion>>;
  source?: Maybe<webAgent__WebAgentExecution>;
  sourceCrawlObjective?: Maybe<webAgent__AiDiscoveryCrawlObjective>;
  sourceFlexpaImport?: Maybe<flexpa__FlexpaImport>;
  summary?: Maybe<document__DocumentSummary>;
  template?: Maybe<document__Template>;
  userVisible: Scalars['Boolean']['output'];
  vellumDocumentId?: Maybe<Scalars['String']['output']>;
};


export type document__Document_TypefilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterFile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderFile>;
};


export type document__Document_TypeingestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type document__Document_TypeinternalIssueEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterInternalDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderInternalDocumentUploadedEvent>;
};


export type document__Document_TypeissueDocumentSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssueDocumentSummary>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssueDocumentSummary>;
};


export type document__Document_TypeissueEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};


export type document__Document_TypelatestIngestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type document__Document_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type document__Document_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type document__Document_TyperesourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type document__Document_TypesourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type document__Document_TypesourceCrawlObjectiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type document__Document_TypesourceFlexpaImportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterFlexpaImport>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderFlexpaImport>;
};


export type document__Document_TypesummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocumentSummary>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocumentSummary>;
};


export type document__Document_TypetemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};

export type document__File = {
  contentHash?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  document: document__Document;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  s3Bucket: Scalars['String']['output'];
  s3ETag?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  sizeBytes?: Maybe<Scalars['Int64']['output']>;
  uploaded: Scalars['Boolean']['output'];
  uploadedAt?: Maybe<Scalars['String']['output']>;
};


export type document__FiledocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

export type document__File_Type = BaseObject & Object & document__File & {
  __typename: 'document__File_Type';
  contentHash?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  document: document__Document;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  s3Bucket: Scalars['String']['output'];
  s3ETag?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  sizeBytes?: Maybe<Scalars['Int64']['output']>;
  uploaded: Scalars['Boolean']['output'];
  uploadedAt?: Maybe<Scalars['String']['output']>;
};


export type document__File_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

export type document__FilterDocument = {
  and?: InputMaybe<Array<document__FilterDocument>>;
  createdAt?: InputMaybe<FilterString>;
  dataType?: InputMaybe<FilterString>;
  files?: InputMaybe<document__NestedFilterFile>;
  id?: InputMaybe<FilterID>;
  ingestions?: InputMaybe<ingestion__NestedFilterIngestion>;
  internalIssueEvent?: InputMaybe<issue__NestedFilterInternalDocumentUploadedEvent>;
  issueDocumentSummary?: InputMaybe<issue__NestedFilterIssueDocumentSummary>;
  issueEvent?: InputMaybe<issue__NestedFilterDocumentUploadedEvent>;
  latestIngestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<document__FilterDocument>;
  or?: InputMaybe<Array<document__FilterDocument>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<FilterParticipant>;
  person?: InputMaybe<NestedFilterPerson>;
  resources?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  source?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  sourceCrawlObjective?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  sourceFlexpaImport?: InputMaybe<flexpa__NestedFilterFlexpaImport>;
  summary?: InputMaybe<document__NestedFilterDocumentSummary>;
  template?: InputMaybe<document__NestedFilterTemplate>;
  userVisible?: InputMaybe<FilterBoolean>;
  vellumDocumentId?: InputMaybe<FilterString>;
};

export type document__FilterDocumentSummary = {
  and?: InputMaybe<Array<document__FilterDocumentSummary>>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  id?: InputMaybe<FilterID>;
  modelId?: InputMaybe<FilterString>;
  not?: InputMaybe<document__FilterDocumentSummary>;
  or?: InputMaybe<Array<document__FilterDocumentSummary>>;
  summary?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type document__FilterFile = {
  and?: InputMaybe<Array<document__FilterFile>>;
  contentHash?: InputMaybe<FilterString>;
  contentType?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<document__FilterFile>;
  or?: InputMaybe<Array<document__FilterFile>>;
  s3Bucket?: InputMaybe<FilterString>;
  s3ETag?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
  sizeBytes?: InputMaybe<FilterInt64>;
  uploaded?: InputMaybe<FilterBoolean>;
  uploadedAt?: InputMaybe<FilterString>;
};

export type document__FilterParseResult = {
  and?: InputMaybe<Array<document__FilterParseResult>>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  id?: InputMaybe<FilterID>;
  markdownContent?: InputMaybe<FilterString>;
  model?: InputMaybe<FilterString>;
  not?: InputMaybe<document__FilterParseResult>;
  or?: InputMaybe<Array<document__FilterParseResult>>;
  owner?: InputMaybe<NestedFilterUser>;
  updatedAt?: InputMaybe<FilterString>;
};

export type document__FilterTemplate = {
  and?: InputMaybe<Array<document__FilterTemplate>>;
  archived?: InputMaybe<FilterBoolean>;
  createdAt?: InputMaybe<FilterString>;
  createdBy?: InputMaybe<NestedFilterUser>;
  default?: InputMaybe<FilterBoolean>;
  defaultValidFor?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  fields?: InputMaybe<document__NestedFilterTemplateField>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<document__FilterTemplate>;
  or?: InputMaybe<Array<document__FilterTemplate>>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
  templateType?: InputMaybe<Filterdocument__TemplateType>;
};

export type document__FilterTemplateField = {
  and?: InputMaybe<Array<document__FilterTemplateField>>;
  id?: InputMaybe<FilterID>;
  label?: InputMaybe<FilterString>;
  nameId?: InputMaybe<FilterString>;
  not?: InputMaybe<document__FilterTemplateField>;
  or?: InputMaybe<Array<document__FilterTemplateField>>;
  required?: InputMaybe<FilterBoolean>;
  template?: InputMaybe<document__NestedFilterTemplate>;
};

export type document__NestedFilterDocument = {
  createdAt?: InputMaybe<FilterString>;
  dataType?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<document__NestedFilterFile>;
  id?: InputMaybe<FilterID>;
  ingestions?: InputMaybe<ingestion__NestedFilterIngestion>;
  internalIssueEvent?: InputMaybe<issue__NestedFilterInternalDocumentUploadedEvent>;
  issueDocumentSummary?: InputMaybe<issue__NestedFilterIssueDocumentSummary>;
  issueEvent?: InputMaybe<issue__NestedFilterDocumentUploadedEvent>;
  latestIngestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  name?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<FilterParticipant>;
  person?: InputMaybe<NestedFilterPerson>;
  resources?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  source?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  sourceCrawlObjective?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  sourceFlexpaImport?: InputMaybe<flexpa__NestedFilterFlexpaImport>;
  summary?: InputMaybe<document__NestedFilterDocumentSummary>;
  template?: InputMaybe<document__NestedFilterTemplate>;
  userVisible?: InputMaybe<FilterBoolean>;
  vellumDocumentId?: InputMaybe<FilterString>;
};

export type document__NestedFilterDocumentSummary = {
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  modelId?: InputMaybe<FilterString>;
  summary?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type document__NestedFilterFile = {
  contentHash?: InputMaybe<FilterString>;
  contentType?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  s3Bucket?: InputMaybe<FilterString>;
  s3ETag?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
  sizeBytes?: InputMaybe<FilterInt64>;
  uploaded?: InputMaybe<FilterBoolean>;
  uploadedAt?: InputMaybe<FilterString>;
};

export type document__NestedFilterTemplate = {
  archived?: InputMaybe<FilterBoolean>;
  createdAt?: InputMaybe<FilterString>;
  createdBy?: InputMaybe<NestedFilterUser>;
  default?: InputMaybe<FilterBoolean>;
  defaultValidFor?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<document__NestedFilterTemplateField>;
  id?: InputMaybe<FilterID>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
  templateType?: InputMaybe<Filterdocument__TemplateType>;
};

export type document__NestedFilterTemplateField = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  label?: InputMaybe<FilterString>;
  nameId?: InputMaybe<FilterString>;
  required?: InputMaybe<FilterBoolean>;
  template?: InputMaybe<document__NestedFilterTemplate>;
};

export type document__OrderDocument = {
  createdAt?: InputMaybe<Ordering>;
  dataType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issueDocumentSummary?: InputMaybe<issue__OrderIssueDocumentSummary>;
  latestIngestion?: InputMaybe<ingestion__OrderIngestion>;
  name?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  participant?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
  source?: InputMaybe<webAgent__OrderWebAgentExecution>;
  sourceCrawlObjective?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
  sourceFlexpaImport?: InputMaybe<flexpa__OrderFlexpaImport>;
  summary?: InputMaybe<document__OrderDocumentSummary>;
  template?: InputMaybe<document__OrderTemplate>;
  userVisible?: InputMaybe<Ordering>;
  vellumDocumentId?: InputMaybe<Ordering>;
};

export type document__OrderDocumentSummary = {
  createdAt?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  id?: InputMaybe<Ordering>;
  modelId?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type document__OrderFile = {
  contentHash?: InputMaybe<Ordering>;
  contentType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  s3Bucket?: InputMaybe<Ordering>;
  s3ETag?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
  sizeBytes?: InputMaybe<Ordering>;
  uploaded?: InputMaybe<Ordering>;
  uploadedAt?: InputMaybe<Ordering>;
};

export type document__OrderParseResult = {
  createdAt?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  id?: InputMaybe<Ordering>;
  markdownContent?: InputMaybe<Ordering>;
  model?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  updatedAt?: InputMaybe<Ordering>;
};

export type document__OrderTemplate = {
  archived?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  default?: InputMaybe<Ordering>;
  defaultValidFor?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  displayName?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  organization?: InputMaybe<integration__OrderOrganization>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
  templateType?: InputMaybe<Ordering>;
};

export type document__OrderTemplateField = {
  id?: InputMaybe<Ordering>;
  label?: InputMaybe<Ordering>;
  nameId?: InputMaybe<Ordering>;
  required?: InputMaybe<Ordering>;
  template?: InputMaybe<document__OrderTemplate>;
};

export type document__ParseResult = {
  createdAt?: Maybe<Scalars['String']['output']>;
  document: document__Document;
  id: Scalars['ID']['output'];
  markdownContent: Scalars['String']['output'];
  model: Scalars['String']['output'];
  owner: User;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type document__ParseResultdocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type document__ParseResultownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type document__ParseResult_Type = BaseObject & Object & Owned & document__ParseResult & {
  __typename: 'document__ParseResult_Type';
  createdAt?: Maybe<Scalars['String']['output']>;
  document: document__Document;
  id: Scalars['ID']['output'];
  markdownContent: Scalars['String']['output'];
  model: Scalars['String']['output'];
  owner: User;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type document__ParseResult_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type document__ParseResult_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type document__Template = {
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  default: Scalars['Boolean']['output'];
  defaultValidFor?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  fields?: Maybe<Array<document__TemplateField>>;
  id: Scalars['ID']['output'];
  organization?: Maybe<integration__Organization>;
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  templateType: document__TemplateType;
};


export type document__TemplatecreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type document__TemplatefieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplateField>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplateField>;
};


export type document__TemplateorganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export type document__TemplateField = {
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  nameId: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  template: document__Template;
};


export type document__TemplateFieldtemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};

export type document__TemplateField_Type = BaseObject & Object & document__TemplateField & {
  __typename: 'document__TemplateField_Type';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  nameId: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  template: document__Template;
};


export type document__TemplateField_TypetemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};

export enum document__TemplateType {
  HIPAA_RELEASE = 'HIPAA_RELEASE'
}

export type document__Template_Type = BaseObject & Object & document__Template & {
  __typename: 'document__Template_Type';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  default: Scalars['Boolean']['output'];
  defaultValidFor?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  fields?: Maybe<Array<document__TemplateField>>;
  id: Scalars['ID']['output'];
  organization?: Maybe<integration__Organization>;
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  templateType: document__TemplateType;
};


export type document__Template_TypecreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type document__Template_TypefieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplateField>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplateField>;
};


export type document__Template_TypeorganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export type eventStore__Event = {
  aggregateId: Scalars['String']['output'];
  aggregateType: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  eventId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  sequence: Scalars['Int64']['output'];
  timestamp: Scalars['String']['output'];
  version: Scalars['Int64']['output'];
};

export type eventStore__Event_Type = BaseObject & Object & eventStore__Event & {
  __typename: 'eventStore__Event_Type';
  aggregateId: Scalars['String']['output'];
  aggregateType: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  eventId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  sequence: Scalars['Int64']['output'];
  timestamp: Scalars['String']['output'];
  version: Scalars['Int64']['output'];
};

export type eventStore__FilterEvent = {
  aggregateId?: InputMaybe<FilterString>;
  aggregateType?: InputMaybe<FilterString>;
  and?: InputMaybe<Array<eventStore__FilterEvent>>;
  data?: InputMaybe<FilterJSON>;
  eventId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  metadata?: InputMaybe<FilterJSON>;
  not?: InputMaybe<eventStore__FilterEvent>;
  or?: InputMaybe<Array<eventStore__FilterEvent>>;
  sequence?: InputMaybe<FilterInt64>;
  timestamp?: InputMaybe<FilterString>;
  version?: InputMaybe<FilterInt64>;
};

export type eventStore__OrderEvent = {
  aggregateId?: InputMaybe<Ordering>;
  aggregateType?: InputMaybe<Ordering>;
  data?: InputMaybe<Ordering>;
  eventId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  metadata?: InputMaybe<Ordering>;
  sequence?: InputMaybe<Ordering>;
  timestamp?: InputMaybe<Ordering>;
  version?: InputMaybe<Ordering>;
};

export type eventTracking__BaseEvent = {
  additionalData?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['String']['output'];
  eventType: eventTracking__EventType;
  id: Scalars['ID']['output'];
  owner: User;
};


export type eventTracking__BaseEventownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum eventTracking__EventType {
  INSURANCE_LINK_ATTEMPT = 'INSURANCE_LINK_ATTEMPT'
}

export type eventTracking__FilterBaseEvent = {
  additionalData?: InputMaybe<FilterJSON>;
  and?: InputMaybe<Array<eventTracking__FilterBaseEvent>>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FiltereventTracking__EventType>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<eventTracking__FilterBaseEvent>;
  or?: InputMaybe<Array<eventTracking__FilterBaseEvent>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type eventTracking__FilterInsuranceLinkAttempt = {
  abandonedReason?: InputMaybe<FiltereventTracking__LinkAttemptAbandonedReason>;
  additionalData?: InputMaybe<FilterJSON>;
  and?: InputMaybe<Array<eventTracking__FilterInsuranceLinkAttempt>>;
  baseEndpoint?: InputMaybe<integration__NestedFilterBaseEndpoint>;
  baseLink?: InputMaybe<integration__NestedFilterBaseLink>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FiltereventTracking__EventType>;
  id?: InputMaybe<FilterID>;
  investigationUrl?: InputMaybe<FilterString>;
  not?: InputMaybe<eventTracking__FilterInsuranceLinkAttempt>;
  or?: InputMaybe<Array<eventTracking__FilterInsuranceLinkAttempt>>;
  owner?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<FiltereventTracking__LinkAttemptStatus>;
  webAgentExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
};

export type eventTracking__InsuranceLinkAttempt = {
  abandonedReason?: Maybe<eventTracking__LinkAttemptAbandonedReason>;
  additionalData?: Maybe<Scalars['JSON']['output']>;
  baseEndpoint?: Maybe<integration__BaseEndpoint>;
  baseLink?: Maybe<integration__BaseLink>;
  createdAt: Scalars['String']['output'];
  eventType: eventTracking__EventType;
  id: Scalars['ID']['output'];
  investigationUrl?: Maybe<Scalars['String']['output']>;
  owner: User;
  status: eventTracking__LinkAttemptStatus;
  webAgentExecution?: Maybe<webAgent__WebAgentExecution>;
};


export type eventTracking__InsuranceLinkAttemptbaseEndpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseEndpoint>;
};


export type eventTracking__InsuranceLinkAttemptbaseLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseLink>;
};


export type eventTracking__InsuranceLinkAttemptownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type eventTracking__InsuranceLinkAttemptwebAgentExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type eventTracking__InsuranceLinkAttempt_Type = BaseObject & Object & Owned & eventTracking__BaseEvent & eventTracking__InsuranceLinkAttempt & {
  __typename: 'eventTracking__InsuranceLinkAttempt_Type';
  abandonedReason?: Maybe<eventTracking__LinkAttemptAbandonedReason>;
  additionalData?: Maybe<Scalars['JSON']['output']>;
  baseEndpoint?: Maybe<integration__BaseEndpoint>;
  baseLink?: Maybe<integration__BaseLink>;
  createdAt: Scalars['String']['output'];
  eventType: eventTracking__EventType;
  id: Scalars['ID']['output'];
  investigationUrl?: Maybe<Scalars['String']['output']>;
  owner: User;
  status: eventTracking__LinkAttemptStatus;
  webAgentExecution?: Maybe<webAgent__WebAgentExecution>;
};


export type eventTracking__InsuranceLinkAttempt_TypebaseEndpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseEndpoint>;
};


export type eventTracking__InsuranceLinkAttempt_TypebaseLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseLink>;
};


export type eventTracking__InsuranceLinkAttempt_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type eventTracking__InsuranceLinkAttempt_TypewebAgentExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export enum eventTracking__LinkAttemptAbandonedReason {
  ABANDONED_CREDENTIALS = 'ABANDONED_CREDENTIALS',
  ABANDONED_MFA = 'ABANDONED_MFA',
  ABANDONED_RELINK = 'ABANDONED_RELINK',
  FLEXPA_EMPLOYER_PLAN = 'FLEXPA_EMPLOYER_PLAN',
  INSURANCE_NOT_FOUND = 'INSURANCE_NOT_FOUND'
}

export enum eventTracking__LinkAttemptStatus {
  ABANDONED = 'ABANDONED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export type eventTracking__OrderBaseEvent = {
  additionalData?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type eventTracking__OrderInsuranceLinkAttempt = {
  abandonedReason?: InputMaybe<Ordering>;
  additionalData?: InputMaybe<Ordering>;
  baseEndpoint?: InputMaybe<integration__OrderBaseEndpoint>;
  baseLink?: InputMaybe<integration__OrderBaseLink>;
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  investigationUrl?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  status?: InputMaybe<Ordering>;
  webAgentExecution?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export enum feedback__AreaType {
  GENERAL = 'GENERAL',
  ISSUE = 'ISSUE',
  ISSUE_EVENT = 'ISSUE_EVENT'
}

export type feedback__FilterGeneralFeedback = {
  and?: InputMaybe<Array<feedback__FilterGeneralFeedback>>;
  area?: InputMaybe<Filterfeedback__AreaType>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<feedback__FilterGeneralFeedback>;
  or?: InputMaybe<Array<feedback__FilterGeneralFeedback>>;
  owner?: InputMaybe<NestedFilterUser>;
  rating?: InputMaybe<FilterInt>;
  review?: InputMaybe<FilterString>;
  selectedOptions?: InputMaybe<feedback__NestedFilterOption>;
};

export type feedback__FilterIssueEventFeedback = {
  and?: InputMaybe<Array<feedback__FilterIssueEventFeedback>>;
  area?: InputMaybe<Filterfeedback__AreaType>;
  createdAt?: InputMaybe<FilterString>;
  event?: InputMaybe<issue__NestedFilterEvent>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<feedback__FilterIssueEventFeedback>;
  or?: InputMaybe<Array<feedback__FilterIssueEventFeedback>>;
  owner?: InputMaybe<NestedFilterUser>;
  rating?: InputMaybe<FilterInt>;
  review?: InputMaybe<FilterString>;
  selectedOptions?: InputMaybe<feedback__NestedFilterOption>;
};

export type feedback__FilterIssueFeedback = {
  and?: InputMaybe<Array<feedback__FilterIssueFeedback>>;
  area?: InputMaybe<Filterfeedback__AreaType>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<feedback__FilterIssueFeedback>;
  or?: InputMaybe<Array<feedback__FilterIssueFeedback>>;
  owner?: InputMaybe<NestedFilterUser>;
  rating?: InputMaybe<FilterInt>;
  review?: InputMaybe<FilterString>;
  selectedOptions?: InputMaybe<feedback__NestedFilterOption>;
};

export type feedback__FilterOption = {
  and?: InputMaybe<Array<feedback__FilterOption>>;
  archived?: InputMaybe<FilterBoolean>;
  area?: InputMaybe<Filterfeedback__AreaType>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<feedback__FilterOption>;
  or?: InputMaybe<Array<feedback__FilterOption>>;
  order?: InputMaybe<FilterInt>;
  sentiment?: InputMaybe<Filterfeedback__SentimentType>;
  value?: InputMaybe<FilterString>;
};

export type feedback__FilterStaffFeedback = {
  and?: InputMaybe<Array<feedback__FilterStaffFeedback>>;
  createdAt?: InputMaybe<FilterString>;
  createdBy?: InputMaybe<NestedFilterUser>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<feedback__FilterStaffFeedback>;
  or?: InputMaybe<Array<feedback__FilterStaffFeedback>>;
  review?: InputMaybe<FilterString>;
  sentiment?: InputMaybe<Filterfeedback__SentimentType>;
};

export type feedback__FilterUserFeedback = {
  and?: InputMaybe<Array<feedback__FilterUserFeedback>>;
  area?: InputMaybe<Filterfeedback__AreaType>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<feedback__FilterUserFeedback>;
  or?: InputMaybe<Array<feedback__FilterUserFeedback>>;
  owner?: InputMaybe<NestedFilterUser>;
  rating?: InputMaybe<FilterInt>;
  review?: InputMaybe<FilterString>;
  selectedOptions?: InputMaybe<feedback__NestedFilterOption>;
};

export type feedback__GeneralFeedback = {
  area: feedback__AreaType;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  rating: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<feedback__Option>>;
};


export type feedback__GeneralFeedbackownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__GeneralFeedbackselectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};

export type feedback__GeneralFeedback_Type = BaseObject & Object & Owned & feedback__GeneralFeedback & feedback__UserFeedback & {
  __typename: 'feedback__GeneralFeedback_Type';
  area: feedback__AreaType;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  rating: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<feedback__Option>>;
};


export type feedback__GeneralFeedback_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__GeneralFeedback_TypeselectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};

export type feedback__IssueEventFeedback = {
  area: feedback__AreaType;
  createdAt: Scalars['String']['output'];
  event: issue__Event;
  id: Scalars['ID']['output'];
  owner: User;
  rating: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<feedback__Option>>;
};


export type feedback__IssueEventFeedbackeventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type feedback__IssueEventFeedbackownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__IssueEventFeedbackselectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};

export type feedback__IssueEventFeedback_Type = BaseObject & Object & Owned & feedback__IssueEventFeedback & feedback__UserFeedback & {
  __typename: 'feedback__IssueEventFeedback_Type';
  area: feedback__AreaType;
  createdAt: Scalars['String']['output'];
  event: issue__Event;
  id: Scalars['ID']['output'];
  owner: User;
  rating: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<feedback__Option>>;
};


export type feedback__IssueEventFeedback_TypeeventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type feedback__IssueEventFeedback_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__IssueEventFeedback_TypeselectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};

export type feedback__IssueFeedback = {
  area: feedback__AreaType;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  owner: User;
  rating: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<feedback__Option>>;
};


export type feedback__IssueFeedbackissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type feedback__IssueFeedbackownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__IssueFeedbackselectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};

export type feedback__IssueFeedback_Type = BaseObject & Object & Owned & feedback__IssueFeedback & feedback__UserFeedback & {
  __typename: 'feedback__IssueFeedback_Type';
  area: feedback__AreaType;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  owner: User;
  rating: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<feedback__Option>>;
};


export type feedback__IssueFeedback_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type feedback__IssueFeedback_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__IssueFeedback_TypeselectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};

export type feedback__NestedFilterIssueEventFeedback = {
  area?: InputMaybe<Filterfeedback__AreaType>;
  createdAt?: InputMaybe<FilterString>;
  event?: InputMaybe<issue__NestedFilterEvent>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  rating?: InputMaybe<FilterInt>;
  review?: InputMaybe<FilterString>;
  selectedOptions?: InputMaybe<feedback__NestedFilterOption>;
};

export type feedback__NestedFilterIssueFeedback = {
  area?: InputMaybe<Filterfeedback__AreaType>;
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  owner?: InputMaybe<NestedFilterUser>;
  rating?: InputMaybe<FilterInt>;
  review?: InputMaybe<FilterString>;
  selectedOptions?: InputMaybe<feedback__NestedFilterOption>;
};

export type feedback__NestedFilterOption = {
  archived?: InputMaybe<FilterBoolean>;
  area?: InputMaybe<Filterfeedback__AreaType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  order?: InputMaybe<FilterInt>;
  sentiment?: InputMaybe<Filterfeedback__SentimentType>;
  value?: InputMaybe<FilterString>;
};

export type feedback__Option = {
  archived: Scalars['Boolean']['output'];
  area: feedback__AreaType;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  sentiment: feedback__SentimentType;
  value: Scalars['String']['output'];
};

export type feedback__Option_Type = BaseObject & Object & feedback__Option & {
  __typename: 'feedback__Option_Type';
  archived: Scalars['Boolean']['output'];
  area: feedback__AreaType;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  sentiment: feedback__SentimentType;
  value: Scalars['String']['output'];
};

export type feedback__OrderGeneralFeedback = {
  area?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  rating?: InputMaybe<Ordering>;
  review?: InputMaybe<Ordering>;
};

export type feedback__OrderIssueEventFeedback = {
  area?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  event?: InputMaybe<issue__OrderEvent>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  rating?: InputMaybe<Ordering>;
  review?: InputMaybe<Ordering>;
};

export type feedback__OrderIssueFeedback = {
  area?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  owner?: InputMaybe<OrderUser>;
  rating?: InputMaybe<Ordering>;
  review?: InputMaybe<Ordering>;
};

export type feedback__OrderOption = {
  archived?: InputMaybe<Ordering>;
  area?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  order?: InputMaybe<Ordering>;
  sentiment?: InputMaybe<Ordering>;
  value?: InputMaybe<Ordering>;
};

export type feedback__OrderStaffFeedback = {
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  review?: InputMaybe<Ordering>;
  sentiment?: InputMaybe<Ordering>;
};

export type feedback__OrderUserFeedback = {
  area?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  rating?: InputMaybe<Ordering>;
  review?: InputMaybe<Ordering>;
};

export enum feedback__SentimentType {
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  POSITIVE = 'POSITIVE'
}

export type feedback__StaffFeedback = {
  createdAt: Scalars['String']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  review?: Maybe<Scalars['String']['output']>;
  sentiment: feedback__SentimentType;
};


export type feedback__StaffFeedbackcreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__StaffFeedbackissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type feedback__StaffFeedback_Type = BaseObject & Object & feedback__StaffFeedback & {
  __typename: 'feedback__StaffFeedback_Type';
  createdAt: Scalars['String']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  review?: Maybe<Scalars['String']['output']>;
  sentiment: feedback__SentimentType;
};


export type feedback__StaffFeedback_TypecreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__StaffFeedback_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type feedback__UserFeedback = {
  area: feedback__AreaType;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  rating: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<feedback__Option>>;
};


export type feedback__UserFeedbackownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__UserFeedbackselectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};

export type fhirEdit__CoverageEdit = {
  coverageType?: Maybe<fhir__CoverageType>;
  createdAt: Scalars['String']['output'];
  editor: User;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insuranceName?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  rationale: Scalars['String']['output'];
  relationship?: Maybe<fhirEdit__CoverageRelationship>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  startDate?: Maybe<Scalars['String']['output']>;
  status: fhirEdit__ResourceEditStatus;
  terminationDate?: Maybe<Scalars['String']['output']>;
};


export type fhirEdit__CoverageEditeditorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhirEdit__CoverageEdit_Type = BaseObject & Object & fhirEdit__CoverageEdit & fhirEdit__ResourceEdit & {
  __typename: 'fhirEdit__CoverageEdit_Type';
  coverageType?: Maybe<fhir__CoverageType>;
  createdAt: Scalars['String']['output'];
  editor: User;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insuranceName?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  rationale: Scalars['String']['output'];
  relationship?: Maybe<fhirEdit__CoverageRelationship>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  startDate?: Maybe<Scalars['String']['output']>;
  status: fhirEdit__ResourceEditStatus;
  terminationDate?: Maybe<Scalars['String']['output']>;
};


export type fhirEdit__CoverageEdit_TypeeditorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum fhirEdit__CoverageRelationship {
  CHILD = 'CHILD',
  DEPENDENT = 'DEPENDENT',
  OTHER = 'OTHER',
  SELF = 'SELF',
  SPOUSE = 'SPOUSE'
}

export type fhirEdit__CoverageSnapshot = {
  baseResource?: Maybe<fhirext__ResourceVersion>;
  beneficiary: fhir__Reference;
  class?: Maybe<Array<fhir__CoverageClass>>;
  computedAt: Scalars['String']['output'];
  coverageType?: Maybe<fhir__CoverageType>;
  edit?: Maybe<fhirEdit__ResourceEdit>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  kind: fhir__CoverageKind;
  memberId?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  owner: User;
  period?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  relationship?: Maybe<fhir__CodeableConcept>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  status: fhir__FinancialResourceStatus;
  subscriber?: Maybe<fhir__Reference>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirEdit__CoverageSnapshotbaseResourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirEdit__CoverageSnapshotbeneficiaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__CoverageSnapshotclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type fhirEdit__CoverageSnapshoteditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterResourceEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderResourceEdit>;
};


export type fhirEdit__CoverageSnapshotidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirEdit__CoverageSnapshotownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirEdit__CoverageSnapshotpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirEdit__CoverageSnapshotrelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirEdit__CoverageSnapshotsubscriberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__CoverageSnapshottypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirEdit__CoverageSnapshot_Type = BaseObject & Object & Owned & Personal & fhirEdit__CoverageSnapshot & fhirEdit__ResourceSnapshot & fhir__Coverage & fhir__FHIRResource & fhirext__CoverageExtension & {
  __typename: 'fhirEdit__CoverageSnapshot_Type';
  baseResource?: Maybe<fhirext__ResourceVersion>;
  beneficiary: fhir__Reference;
  class?: Maybe<Array<fhir__CoverageClass>>;
  computedAt: Scalars['String']['output'];
  coverageType?: Maybe<fhir__CoverageType>;
  edit?: Maybe<fhirEdit__ResourceEdit>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  kind: fhir__CoverageKind;
  memberId?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  owner: User;
  period?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  relationship?: Maybe<fhir__CodeableConcept>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  status: fhir__FinancialResourceStatus;
  subscriber?: Maybe<fhir__Reference>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirEdit__CoverageSnapshot_TypebaseResourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirEdit__CoverageSnapshot_TypebeneficiaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__CoverageSnapshot_TypeclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type fhirEdit__CoverageSnapshot_TypeeditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterResourceEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderResourceEdit>;
};


export type fhirEdit__CoverageSnapshot_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirEdit__CoverageSnapshot_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirEdit__CoverageSnapshot_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirEdit__CoverageSnapshot_TyperelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirEdit__CoverageSnapshot_TypesubscriberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__CoverageSnapshot_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export enum fhirEdit__ExplanationOfBenefitDecision {
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  PARTIAL = 'PARTIAL',
  PENDING = 'PENDING'
}

export type fhirEdit__ExplanationOfBenefitEdit = {
  billablePeriodEnd?: Maybe<Scalars['String']['output']>;
  billablePeriodStart?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdDate?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<fhirEdit__ExplanationOfBenefitDecision>;
  editor: User;
  id: Scalars['ID']['output'];
  network?: Maybe<fhirEdit__ExplanationOfBenefitNetwork>;
  rationale: Scalars['String']['output'];
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  status: fhirEdit__ResourceEditStatus;
};


export type fhirEdit__ExplanationOfBenefitEditeditorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhirEdit__ExplanationOfBenefitEdit_Type = BaseObject & Object & fhirEdit__ExplanationOfBenefitEdit & fhirEdit__ResourceEdit & {
  __typename: 'fhirEdit__ExplanationOfBenefitEdit_Type';
  billablePeriodEnd?: Maybe<Scalars['String']['output']>;
  billablePeriodStart?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdDate?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<fhirEdit__ExplanationOfBenefitDecision>;
  editor: User;
  id: Scalars['ID']['output'];
  network?: Maybe<fhirEdit__ExplanationOfBenefitNetwork>;
  rationale: Scalars['String']['output'];
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  status: fhirEdit__ResourceEditStatus;
};


export type fhirEdit__ExplanationOfBenefitEdit_TypeeditorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum fhirEdit__ExplanationOfBenefitNetwork {
  IN_NETWORK = 'IN_NETWORK',
  OTHER = 'OTHER',
  OUT_OF_NETWORK = 'OUT_OF_NETWORK'
}

export type fhirEdit__ExplanationOfBenefitSnapshot = {
  baseResource?: Maybe<fhirext__ResourceVersion>;
  billablePeriod?: Maybe<Scalars['JSON']['output']>;
  careTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  computedAt: Scalars['String']['output'];
  created?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<fhir__CodeableConcept>;
  diagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  edit?: Maybe<fhirEdit__ResourceEdit>;
  facility?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  item?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  network?: Maybe<fhir__CodeableConcept>;
  owner: User;
  patient?: Maybe<fhir__Reference>;
  person?: Maybe<Person>;
  provider?: Maybe<fhir__Reference>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  status: fhir__ExplanationOfBenefitStatus;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  totalsByType?: Maybe<fhirext__ExplanationOfBenefitTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
  use: fhir__ClaimUse;
};


export type fhirEdit__ExplanationOfBenefitSnapshotbaseResourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotcareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotdecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotdiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type fhirEdit__ExplanationOfBenefitSnapshoteditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterResourceEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderResourceEdit>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotfacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotitemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotnetworkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotpatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__ExplanationOfBenefitSnapshottotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type fhirEdit__ExplanationOfBenefitSnapshottotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
};


export type fhirEdit__ExplanationOfBenefitSnapshottypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirEdit__ExplanationOfBenefitSnapshot_Type = BaseObject & Object & Owned & Personal & fhirEdit__ExplanationOfBenefitSnapshot & fhirEdit__ResourceSnapshot & fhir__ExplanationOfBenefit & fhir__FHIRResource & fhirext__ExplanationOfBenefitExtension & {
  __typename: 'fhirEdit__ExplanationOfBenefitSnapshot_Type';
  baseResource?: Maybe<fhirext__ResourceVersion>;
  billablePeriod?: Maybe<Scalars['JSON']['output']>;
  careTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  computedAt: Scalars['String']['output'];
  created?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<fhir__CodeableConcept>;
  diagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  edit?: Maybe<fhirEdit__ResourceEdit>;
  facility?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  item?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  network?: Maybe<fhir__CodeableConcept>;
  owner: User;
  patient?: Maybe<fhir__Reference>;
  person?: Maybe<Person>;
  provider?: Maybe<fhir__Reference>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  status: fhir__ExplanationOfBenefitStatus;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  totalsByType?: Maybe<fhirext__ExplanationOfBenefitTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
  use: fhir__ClaimUse;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypebaseResourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypecareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypedecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypediagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypeeditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterResourceEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderResourceEdit>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypefacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypeitemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypenetworkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypepatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypeproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypetotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypetotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirEdit__FilterCoverageEdit = {
  and?: InputMaybe<Array<fhirEdit__FilterCoverageEdit>>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  createdAt?: InputMaybe<FilterString>;
  editor?: InputMaybe<NestedFilterUser>;
  groupId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  insuranceName?: InputMaybe<FilterString>;
  memberId?: InputMaybe<FilterString>;
  not?: InputMaybe<fhirEdit__FilterCoverageEdit>;
  or?: InputMaybe<Array<fhirEdit__FilterCoverageEdit>>;
  planName?: InputMaybe<FilterString>;
  rationale?: InputMaybe<FilterString>;
  relationship?: InputMaybe<FilterfhirEdit__CoverageRelationship>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  startDate?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterfhirEdit__ResourceEditStatus>;
  terminationDate?: InputMaybe<FilterString>;
};

export type fhirEdit__FilterCoverageSnapshot = {
  and?: InputMaybe<Array<fhirEdit__FilterCoverageSnapshot>>;
  baseResource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  beneficiary?: InputMaybe<fhir__NestedFilterReference>;
  class?: InputMaybe<fhir__NestedFilterCoverageClass>;
  computedAt?: InputMaybe<FilterString>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  edit?: InputMaybe<fhirEdit__NestedFilterResourceEdit>;
  groupId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  isActive?: InputMaybe<FilterBoolean>;
  kind?: InputMaybe<Filterfhir__CoverageKind>;
  memberId?: InputMaybe<FilterString>;
  network?: InputMaybe<FilterString>;
  not?: InputMaybe<fhirEdit__FilterCoverageSnapshot>;
  or?: InputMaybe<Array<fhirEdit__FilterCoverageSnapshot>>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  relationship?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  status?: InputMaybe<Filterfhir__FinancialResourceStatus>;
  subscriber?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirEdit__FilterExplanationOfBenefitEdit = {
  and?: InputMaybe<Array<fhirEdit__FilterExplanationOfBenefitEdit>>;
  billablePeriodEnd?: InputMaybe<FilterString>;
  billablePeriodStart?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  createdDate?: InputMaybe<FilterString>;
  decision?: InputMaybe<FilterfhirEdit__ExplanationOfBenefitDecision>;
  editor?: InputMaybe<NestedFilterUser>;
  id?: InputMaybe<FilterID>;
  network?: InputMaybe<FilterfhirEdit__ExplanationOfBenefitNetwork>;
  not?: InputMaybe<fhirEdit__FilterExplanationOfBenefitEdit>;
  or?: InputMaybe<Array<fhirEdit__FilterExplanationOfBenefitEdit>>;
  rationale?: InputMaybe<FilterString>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterfhirEdit__ResourceEditStatus>;
};

export type fhirEdit__FilterExplanationOfBenefitSnapshot = {
  and?: InputMaybe<Array<fhirEdit__FilterExplanationOfBenefitSnapshot>>;
  baseResource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  careTeam?: InputMaybe<fhir__NestedFilterExplanationOfBenefitCareTeam>;
  computedAt?: InputMaybe<FilterString>;
  created?: InputMaybe<FilterString>;
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  diagnosis?: InputMaybe<fhir__NestedFilterExplanationOfBenefitDiagnosis>;
  edit?: InputMaybe<fhirEdit__NestedFilterResourceEdit>;
  facility?: InputMaybe<fhir__NestedFilterReference>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  item?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItem>;
  network?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  not?: InputMaybe<fhirEdit__FilterExplanationOfBenefitSnapshot>;
  or?: InputMaybe<Array<fhirEdit__FilterExplanationOfBenefitSnapshot>>;
  owner?: InputMaybe<NestedFilterUser>;
  patient?: InputMaybe<fhir__NestedFilterReference>;
  person?: InputMaybe<NestedFilterPerson>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterfhir__ExplanationOfBenefitStatus>;
  summary?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  total?: InputMaybe<fhir__NestedFilterExplanationOfBenefitTotal>;
  totalsByType?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<Filterfhir__ClaimUse>;
};

export type fhirEdit__FilterResourceEdit = {
  and?: InputMaybe<Array<fhirEdit__FilterResourceEdit>>;
  createdAt?: InputMaybe<FilterString>;
  editor?: InputMaybe<NestedFilterUser>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhirEdit__FilterResourceEdit>;
  or?: InputMaybe<Array<fhirEdit__FilterResourceEdit>>;
  rationale?: InputMaybe<FilterString>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  status?: InputMaybe<FilterfhirEdit__ResourceEditStatus>;
};

export type fhirEdit__FilterResourceSnapshot = {
  and?: InputMaybe<Array<fhirEdit__FilterResourceSnapshot>>;
  baseResource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  computedAt?: InputMaybe<FilterString>;
  edit?: InputMaybe<fhirEdit__NestedFilterResourceEdit>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhirEdit__FilterResourceSnapshot>;
  or?: InputMaybe<Array<fhirEdit__FilterResourceSnapshot>>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
};

export type fhirEdit__NestedFilterResourceEdit = {
  createdAt?: InputMaybe<FilterString>;
  editor?: InputMaybe<NestedFilterUser>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  rationale?: InputMaybe<FilterString>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  status?: InputMaybe<FilterfhirEdit__ResourceEditStatus>;
};

export type fhirEdit__OrderCoverageEdit = {
  coverageType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  editor?: InputMaybe<OrderUser>;
  groupId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  insuranceName?: InputMaybe<Ordering>;
  memberId?: InputMaybe<Ordering>;
  planName?: InputMaybe<Ordering>;
  rationale?: InputMaybe<Ordering>;
  relationship?: InputMaybe<Ordering>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  startDate?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  terminationDate?: InputMaybe<Ordering>;
};

export type fhirEdit__OrderCoverageSnapshot = {
  baseResource?: InputMaybe<fhirext__OrderResourceVersion>;
  beneficiary?: InputMaybe<fhir__OrderReference>;
  computedAt?: InputMaybe<Ordering>;
  coverageType?: InputMaybe<Ordering>;
  edit?: InputMaybe<fhirEdit__OrderResourceEdit>;
  groupId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  memberId?: InputMaybe<Ordering>;
  network?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  relationship?: InputMaybe<fhir__OrderCodeableConcept>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  subscriber?: InputMaybe<fhir__OrderReference>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirEdit__OrderExplanationOfBenefitEdit = {
  billablePeriodEnd?: InputMaybe<Ordering>;
  billablePeriodStart?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  createdDate?: InputMaybe<Ordering>;
  decision?: InputMaybe<Ordering>;
  editor?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  network?: InputMaybe<Ordering>;
  rationale?: InputMaybe<Ordering>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceDate?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
};

export type fhirEdit__OrderExplanationOfBenefitSnapshot = {
  baseResource?: InputMaybe<fhirext__OrderResourceVersion>;
  computedAt?: InputMaybe<Ordering>;
  created?: InputMaybe<Ordering>;
  decision?: InputMaybe<fhir__OrderCodeableConcept>;
  edit?: InputMaybe<fhirEdit__OrderResourceEdit>;
  facility?: InputMaybe<fhir__OrderReference>;
  id?: InputMaybe<Ordering>;
  network?: InputMaybe<fhir__OrderCodeableConcept>;
  owner?: InputMaybe<OrderUser>;
  patient?: InputMaybe<fhir__OrderReference>;
  person?: InputMaybe<OrderPerson>;
  provider?: InputMaybe<fhir__OrderReference>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceDate?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  totalsByType?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
  use?: InputMaybe<Ordering>;
};

export type fhirEdit__OrderResourceEdit = {
  createdAt?: InputMaybe<Ordering>;
  editor?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  rationale?: InputMaybe<Ordering>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
};

export type fhirEdit__OrderResourceSnapshot = {
  baseResource?: InputMaybe<fhirext__OrderResourceVersion>;
  computedAt?: InputMaybe<Ordering>;
  edit?: InputMaybe<fhirEdit__OrderResourceEdit>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
};

export type fhirEdit__ResourceEdit = {
  createdAt: Scalars['String']['output'];
  editor: User;
  id: Scalars['ID']['output'];
  rationale: Scalars['String']['output'];
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  status: fhirEdit__ResourceEditStatus;
};


export type fhirEdit__ResourceEditeditorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum fhirEdit__ResourceEditStatus {
  ACTIVE = 'ACTIVE',
  SUPERSEDED = 'SUPERSEDED'
}

export type fhirEdit__ResourceSnapshot = {
  baseResource?: Maybe<fhirext__ResourceVersion>;
  computedAt: Scalars['String']['output'];
  edit?: Maybe<fhirEdit__ResourceEdit>;
  id: Scalars['ID']['output'];
  owner: User;
  person?: Maybe<Person>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
};


export type fhirEdit__ResourceSnapshotbaseResourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirEdit__ResourceSnapshoteditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterResourceEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderResourceEdit>;
};


export type fhirEdit__ResourceSnapshotownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirEdit__ResourceSnapshotpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};

export type fhir__Account = {
  balance?: Maybe<fhir__AccountBalance>;
  billingStatus?: Maybe<fhir__CodeableConcept>;
  calculatedAt?: Maybe<Scalars['String']['output']>;
  coverage?: Maybe<Array<fhir__Reference>>;
  currency?: Maybe<fhir__CodeableConcept>;
  description?: Maybe<Scalars['String']['output']>;
  guarantor?: Maybe<Array<fhir__AccountGuarantor>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  name?: Maybe<Scalars['String']['output']>;
  owner: User;
  servicePeriod?: Maybe<Scalars['JSON']['output']>;
  status: fhir__AccountStatus;
  subject?: Maybe<Array<fhir__Reference>>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhir__AccountbalanceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountBalance>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountBalance>;
};


export type fhir__AccountbillingStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__AccountcoverageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__AccountcurrencyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__AccountguarantorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountGuarantor>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountGuarantor>;
};


export type fhir__AccountidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__AccountownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__AccountsubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__AccounttypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__AccountBalance = {
  aggregate?: Maybe<fhir__CodeableConcept>;
  amount?: Maybe<fhir__Money>;
  estimate?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  term?: Maybe<fhir__CodeableConcept>;
};


export type fhir__AccountBalanceaggregateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__AccountBalanceamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__AccountBalanceownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__AccountBalancetermArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__AccountBalance_Type = BaseObject & Object & Owned & fhir__AccountBalance & {
  __typename: 'fhir__AccountBalance_Type';
  aggregate?: Maybe<fhir__CodeableConcept>;
  amount?: Maybe<fhir__Money>;
  estimate?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  term?: Maybe<fhir__CodeableConcept>;
};


export type fhir__AccountBalance_TypeaggregateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__AccountBalance_TypeamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__AccountBalance_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__AccountBalance_TypetermArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__AccountGuarantor = {
  id: Scalars['ID']['output'];
  onHold?: Maybe<Scalars['Boolean']['output']>;
  owner: User;
  party: fhir__Reference;
  period?: Maybe<Scalars['JSON']['output']>;
};


export type fhir__AccountGuarantorownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__AccountGuarantorpartyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__AccountGuarantor_Type = BaseObject & Object & Owned & fhir__AccountGuarantor & {
  __typename: 'fhir__AccountGuarantor_Type';
  id: Scalars['ID']['output'];
  onHold?: Maybe<Scalars['Boolean']['output']>;
  owner: User;
  party: fhir__Reference;
  period?: Maybe<Scalars['JSON']['output']>;
};


export type fhir__AccountGuarantor_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__AccountGuarantor_TypepartyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export enum fhir__AccountStatus {
  ACTIVE = 'ACTIVE',
  ENTERED_IN_ERROR = 'ENTERED_IN_ERROR',
  INACTIVE = 'INACTIVE',
  ON_HOLD = 'ON_HOLD',
  UNKNOWN = 'UNKNOWN'
}

export type fhir__Address = {
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type fhir__Address_Type = BaseObject & Object & fhir__Address & {
  __typename: 'fhir__Address_Type';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type fhir__Annotation = {
  authorReference?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};


export type fhir__AnnotationauthorReferenceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__Annotation_Type = BaseObject & Object & fhir__Annotation & {
  __typename: 'fhir__Annotation_Type';
  authorReference?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};


export type fhir__Annotation_TypeauthorReferenceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__ChargeItem = {
  code?: Maybe<fhir__CodeableConcept>;
  enteredDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Array<fhir__Annotation>>;
  occurrenceDateTime?: Maybe<Scalars['String']['output']>;
  occurrencePeriod?: Maybe<Scalars['JSON']['output']>;
  owner: User;
  performer?: Maybe<Array<fhir__ChargeItemPerformer>>;
  quantity?: Maybe<fhir__Quantity>;
  reason?: Maybe<Array<fhir__CodeableConcept>>;
  service?: Maybe<Array<fhir__CodeableReference>>;
  status: fhir__ChargeItemStatus;
  subject?: Maybe<fhir__Reference>;
};


export type fhir__ChargeItemcodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ChargeItemnoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAnnotation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAnnotation>;
};


export type fhir__ChargeItemownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ChargeItemperformerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterChargeItemPerformer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderChargeItemPerformer>;
};


export type fhir__ChargeItemquantityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterQuantity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderQuantity>;
};


export type fhir__ChargeItemreasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ChargeItemserviceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableReference>;
};


export type fhir__ChargeItemsubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__ChargeItemPerformer = {
  actor?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  operation?: Maybe<fhir__CodeableConcept>;
};


export type fhir__ChargeItemPerformeractorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__ChargeItemPerformeroperationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__ChargeItemPerformer_Type = BaseObject & Object & fhir__ChargeItemPerformer & {
  __typename: 'fhir__ChargeItemPerformer_Type';
  actor?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  operation?: Maybe<fhir__CodeableConcept>;
};


export type fhir__ChargeItemPerformer_TypeactorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__ChargeItemPerformer_TypeoperationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export enum fhir__ChargeItemStatus {
  ABORTED = 'ABORTED',
  BILLABLE = 'BILLABLE',
  BILLED = 'BILLED',
  ENTERED_IN_ERROR = 'ENTERED_IN_ERROR',
  NOT_BILLABLE = 'NOT_BILLABLE',
  PLANNED = 'PLANNED',
  UNKNOWN = 'UNKNOWN'
}

export type fhir__ChargeItem_Type = BaseObject & Object & Owned & fhir__ChargeItem & {
  __typename: 'fhir__ChargeItem_Type';
  code?: Maybe<fhir__CodeableConcept>;
  enteredDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Array<fhir__Annotation>>;
  occurrenceDateTime?: Maybe<Scalars['String']['output']>;
  occurrencePeriod?: Maybe<Scalars['JSON']['output']>;
  owner: User;
  performer?: Maybe<Array<fhir__ChargeItemPerformer>>;
  quantity?: Maybe<fhir__Quantity>;
  reason?: Maybe<Array<fhir__CodeableConcept>>;
  service?: Maybe<Array<fhir__CodeableReference>>;
  status: fhir__ChargeItemStatus;
  subject?: Maybe<fhir__Reference>;
};


export type fhir__ChargeItem_TypecodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ChargeItem_TypenoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAnnotation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAnnotation>;
};


export type fhir__ChargeItem_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ChargeItem_TypeperformerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterChargeItemPerformer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderChargeItemPerformer>;
};


export type fhir__ChargeItem_TypequantityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterQuantity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderQuantity>;
};


export type fhir__ChargeItem_TypereasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ChargeItem_TypeserviceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableReference>;
};


export type fhir__ChargeItem_TypesubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export enum fhir__ClaimUse {
  CLAIM = 'CLAIM',
  PREAUTHORIZATION = 'PREAUTHORIZATION',
  PREDETERMINATION = 'PREDETERMINATION'
}

export type fhir__ClinicalNote = {
  author?: Maybe<fhir__Reference>;
  category?: Maybe<fhir__CodeableConcept>;
  dateTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  text: Scalars['String']['output'];
};


export type fhir__ClinicalNoteauthorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__ClinicalNotecategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ClinicalNoteownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__ClinicalNote_Type = BaseObject & Object & Owned & fhir__ClinicalNote & {
  __typename: 'fhir__ClinicalNote_Type';
  author?: Maybe<fhir__Reference>;
  category?: Maybe<fhir__CodeableConcept>;
  dateTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  text: Scalars['String']['output'];
};


export type fhir__ClinicalNote_TypeauthorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__ClinicalNote_TypecategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ClinicalNote_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__CodeableConcept = {
  coding?: Maybe<Array<fhir__Coding>>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};


export type fhir__CodeableConceptcodingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};

export type fhir__CodeableConcept_Type = BaseObject & Object & fhir__CodeableConcept & {
  __typename: 'fhir__CodeableConcept_Type';
  coding?: Maybe<Array<fhir__Coding>>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};


export type fhir__CodeableConcept_TypecodingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};

export type fhir__CodeableReference = {
  concept?: Maybe<fhir__CodeableConcept>;
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reference?: Maybe<fhir__Reference>;
};


export type fhir__CodeableReferenceconceptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__CodeableReferencereferenceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__CodeableReference_Type = BaseObject & Object & fhir__CodeableReference & {
  __typename: 'fhir__CodeableReference_Type';
  concept?: Maybe<fhir__CodeableConcept>;
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reference?: Maybe<fhir__Reference>;
};


export type fhir__CodeableReference_TypeconceptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__CodeableReference_TypereferenceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__Coding = {
  code?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  system?: Maybe<Scalars['String']['output']>;
};

export type fhir__Coding_Type = BaseObject & Object & fhir__Coding & {
  __typename: 'fhir__Coding_Type';
  code?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  system?: Maybe<Scalars['String']['output']>;
};

export type fhir__ContactPoint = {
  id: Scalars['ID']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  use?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type fhir__ContactPoint_Type = BaseObject & Object & fhir__ContactPoint & {
  __typename: 'fhir__ContactPoint_Type';
  id: Scalars['ID']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  use?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type fhir__Coverage = {
  beneficiary: fhir__Reference;
  class?: Maybe<Array<fhir__CoverageClass>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  kind: fhir__CoverageKind;
  network?: Maybe<Scalars['String']['output']>;
  owner: User;
  period?: Maybe<Scalars['JSON']['output']>;
  relationship?: Maybe<fhir__CodeableConcept>;
  status: fhir__FinancialResourceStatus;
  subscriber?: Maybe<fhir__Reference>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhir__CoveragebeneficiaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__CoverageclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type fhir__CoverageidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__CoverageownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__CoveragerelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__CoveragesubscriberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__CoveragetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__CoverageClass = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: fhir__CodeableConcept;
  value: fhir__Identifier;
};


export type fhir__CoverageClasstypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__CoverageClassvalueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};

export type fhir__CoverageClass_Type = BaseObject & Object & fhir__CoverageClass & {
  __typename: 'fhir__CoverageClass_Type';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: fhir__CodeableConcept;
  value: fhir__Identifier;
};


export type fhir__CoverageClass_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__CoverageClass_TypevalueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};

export enum fhir__CoverageKind {
  INSURANCE = 'INSURANCE',
  OTHER = 'OTHER',
  SELF_PAY = 'SELF_PAY'
}

/** Type of coverage: MEDICAL, DENTAL, VISION, PHARMACY, OTHER. */
export enum fhir__CoverageType {
  DENTAL = 'DENTAL',
  MEDICAL = 'MEDICAL',
  OTHER = 'OTHER',
  PHARMACY = 'PHARMACY',
  VISION = 'VISION'
}

export type fhir__Encounter = {
  actualPeriod?: Maybe<Scalars['JSON']['output']>;
  class?: Maybe<Array<fhir__Coding>>;
  clinicalNote?: Maybe<Array<fhir__ClinicalNote>>;
  diagnosis?: Maybe<Array<fhir__CodeableConcept>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  location?: Maybe<Array<fhir__Location>>;
  owner: User;
  participant?: Maybe<Array<fhir__EncounterParticipant>>;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<fhir__Reference>;
  type?: Maybe<Array<fhir__Coding>>;
};


export type fhir__EncounterclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};


export type fhir__EncounterclinicalNoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterClinicalNote>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderClinicalNote>;
};


export type fhir__EncounterdiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__EncounteridentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__EncounterlocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterLocation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderLocation>;
};


export type fhir__EncounterownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__EncounterparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterEncounterParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderEncounterParticipant>;
};


export type fhir__EncountersubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__EncountertypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};

export type fhir__EncounterParticipant = {
  id: Scalars['ID']['output'];
  identifier?: Maybe<fhir__Identifier>;
  owner: User;
  text: Scalars['String']['output'];
};


export type fhir__EncounterParticipantidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__EncounterParticipantownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__EncounterParticipant_Type = BaseObject & Object & Owned & fhir__EncounterParticipant & {
  __typename: 'fhir__EncounterParticipant_Type';
  id: Scalars['ID']['output'];
  identifier?: Maybe<fhir__Identifier>;
  owner: User;
  text: Scalars['String']['output'];
};


export type fhir__EncounterParticipant_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__EncounterParticipant_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__ExplanationOfBenefit = {
  billablePeriod?: Maybe<Scalars['JSON']['output']>;
  careTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  created?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<fhir__CodeableConcept>;
  diagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  facility?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  item?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  owner: User;
  patient?: Maybe<fhir__Reference>;
  provider?: Maybe<fhir__Reference>;
  status: fhir__ExplanationOfBenefitStatus;
  total?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  type?: Maybe<fhir__CodeableConcept>;
  use: fhir__ClaimUse;
};


export type fhir__ExplanationOfBenefitcareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type fhir__ExplanationOfBenefitdecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitdiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type fhir__ExplanationOfBenefitfacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__ExplanationOfBenefitidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__ExplanationOfBenefititemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type fhir__ExplanationOfBenefitownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitpatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__ExplanationOfBenefitproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__ExplanationOfBenefittotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type fhir__ExplanationOfBenefittypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__ExplanationOfBenefitCareTeam = {
  id: Scalars['ID']['output'];
  owner: User;
  provider?: Maybe<fhir__Reference>;
};


export type fhir__ExplanationOfBenefitCareTeamownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitCareTeamproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__ExplanationOfBenefitCareTeam_Type = BaseObject & Object & Owned & fhir__ExplanationOfBenefitCareTeam & {
  __typename: 'fhir__ExplanationOfBenefitCareTeam_Type';
  id: Scalars['ID']['output'];
  owner: User;
  provider?: Maybe<fhir__Reference>;
};


export type fhir__ExplanationOfBenefitCareTeam_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitCareTeam_TypeproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__ExplanationOfBenefitDiagnosis = {
  diagnosisCodeableConcept?: Maybe<fhir__CodeableConcept>;
  id: Scalars['ID']['output'];
  owner: User;
  sequence: Scalars['Int64']['output'];
};


export type fhir__ExplanationOfBenefitDiagnosisdiagnosisCodeableConceptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitDiagnosisownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__ExplanationOfBenefitDiagnosis_Type = BaseObject & Object & Owned & fhir__ExplanationOfBenefitDiagnosis & {
  __typename: 'fhir__ExplanationOfBenefitDiagnosis_Type';
  diagnosisCodeableConcept?: Maybe<fhir__CodeableConcept>;
  id: Scalars['ID']['output'];
  owner: User;
  sequence: Scalars['Int64']['output'];
};


export type fhir__ExplanationOfBenefitDiagnosis_TypediagnosisCodeableConceptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitDiagnosis_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__ExplanationOfBenefitItem = {
  adjudication?: Maybe<Array<fhir__ExplanationOfBenefitItemAdjudication>>;
  diagnosisSequence?: Maybe<Array<Scalars['Int64']['output']>>;
  id: Scalars['ID']['output'];
  net?: Maybe<fhir__Money>;
  owner: User;
  productOrService?: Maybe<fhir__CodeableConcept>;
  quantity?: Maybe<fhir__Quantity>;
  reviewOutcome?: Maybe<fhir__ExplanationOfBenefitItemReviewOutcome>;
  sequence: Scalars['Int64']['output'];
  unitPrice?: Maybe<fhir__Money>;
};


export type fhir__ExplanationOfBenefitItemadjudicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItemAdjudication>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItemAdjudication>;
};


export type fhir__ExplanationOfBenefitItemnetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__ExplanationOfBenefitItemownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitItemproductOrServiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemquantityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterQuantity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderQuantity>;
};


export type fhir__ExplanationOfBenefitItemreviewOutcomeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItemReviewOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItemReviewOutcome>;
};


export type fhir__ExplanationOfBenefitItemunitPriceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};

export type fhir__ExplanationOfBenefitItemAdjudication = {
  amount?: Maybe<fhir__Money>;
  category: fhir__CodeableConcept;
  id: Scalars['ID']['output'];
  owner: User;
  quantity?: Maybe<fhir__Quantity>;
  reason?: Maybe<fhir__CodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemAdjudicationamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__ExplanationOfBenefitItemAdjudicationcategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemAdjudicationownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitItemAdjudicationquantityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterQuantity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderQuantity>;
};


export type fhir__ExplanationOfBenefitItemAdjudicationreasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__ExplanationOfBenefitItemAdjudication_Type = BaseObject & Object & Owned & fhir__ExplanationOfBenefitItemAdjudication & {
  __typename: 'fhir__ExplanationOfBenefitItemAdjudication_Type';
  amount?: Maybe<fhir__Money>;
  category: fhir__CodeableConcept;
  id: Scalars['ID']['output'];
  owner: User;
  quantity?: Maybe<fhir__Quantity>;
  reason?: Maybe<fhir__CodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemAdjudication_TypeamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__ExplanationOfBenefitItemAdjudication_TypecategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemAdjudication_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitItemAdjudication_TypequantityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterQuantity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderQuantity>;
};


export type fhir__ExplanationOfBenefitItemAdjudication_TypereasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__ExplanationOfBenefitItemReviewOutcome = {
  decision?: Maybe<fhir__CodeableConcept>;
  id: Scalars['ID']['output'];
  owner: User;
  reason?: Maybe<fhir__CodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemReviewOutcomedecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemReviewOutcomeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitItemReviewOutcomereasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__ExplanationOfBenefitItemReviewOutcome_Type = BaseObject & Object & Owned & fhir__ExplanationOfBenefitItemReviewOutcome & {
  __typename: 'fhir__ExplanationOfBenefitItemReviewOutcome_Type';
  decision?: Maybe<fhir__CodeableConcept>;
  id: Scalars['ID']['output'];
  owner: User;
  reason?: Maybe<fhir__CodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemReviewOutcome_TypedecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemReviewOutcome_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitItemReviewOutcome_TypereasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__ExplanationOfBenefitItem_Type = BaseObject & Object & Owned & fhir__ExplanationOfBenefitItem & {
  __typename: 'fhir__ExplanationOfBenefitItem_Type';
  adjudication?: Maybe<Array<fhir__ExplanationOfBenefitItemAdjudication>>;
  diagnosisSequence?: Maybe<Array<Scalars['Int64']['output']>>;
  id: Scalars['ID']['output'];
  net?: Maybe<fhir__Money>;
  owner: User;
  productOrService?: Maybe<fhir__CodeableConcept>;
  quantity?: Maybe<fhir__Quantity>;
  reviewOutcome?: Maybe<fhir__ExplanationOfBenefitItemReviewOutcome>;
  sequence: Scalars['Int64']['output'];
  unitPrice?: Maybe<fhir__Money>;
};


export type fhir__ExplanationOfBenefitItem_TypeadjudicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItemAdjudication>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItemAdjudication>;
};


export type fhir__ExplanationOfBenefitItem_TypenetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__ExplanationOfBenefitItem_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitItem_TypeproductOrServiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitItem_TypequantityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterQuantity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderQuantity>;
};


export type fhir__ExplanationOfBenefitItem_TypereviewOutcomeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItemReviewOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItemReviewOutcome>;
};


export type fhir__ExplanationOfBenefitItem_TypeunitPriceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};

export enum fhir__ExplanationOfBenefitStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  DRAFT = 'DRAFT',
  ENTERED_IN_ERROR = 'ENTERED_IN_ERROR'
}

export type fhir__ExplanationOfBenefitTotal = {
  amount: fhir__Money;
  category: fhir__CodeableConcept;
  id: Scalars['ID']['output'];
  owner: User;
};


export type fhir__ExplanationOfBenefitTotalamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__ExplanationOfBenefitTotalcategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitTotalownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__ExplanationOfBenefitTotal_Type = BaseObject & Object & Owned & fhir__ExplanationOfBenefitTotal & {
  __typename: 'fhir__ExplanationOfBenefitTotal_Type';
  amount: fhir__Money;
  category: fhir__CodeableConcept;
  id: Scalars['ID']['output'];
  owner: User;
};


export type fhir__ExplanationOfBenefitTotal_TypeamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__ExplanationOfBenefitTotal_TypecategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitTotal_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__FHIRResource = {
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  owner: User;
};


export type fhir__FHIRResourceidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__FHIRResourceownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__FilterAccount = {
  and?: InputMaybe<Array<fhir__FilterAccount>>;
  balance?: InputMaybe<fhir__NestedFilterAccountBalance>;
  billingStatus?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  calculatedAt?: InputMaybe<FilterString>;
  coverage?: InputMaybe<fhir__NestedFilterReference>;
  currency?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  description?: InputMaybe<FilterString>;
  guarantor?: InputMaybe<fhir__NestedFilterAccountGuarantor>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<fhir__FilterAccount>;
  or?: InputMaybe<Array<fhir__FilterAccount>>;
  owner?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<Filterfhir__AccountStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterAccountBalance = {
  aggregate?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  and?: InputMaybe<Array<fhir__FilterAccountBalance>>;
  estimate?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterAccountBalance>;
  or?: InputMaybe<Array<fhir__FilterAccountBalance>>;
  owner?: InputMaybe<NestedFilterUser>;
  term?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterAccountGuarantor = {
  and?: InputMaybe<Array<fhir__FilterAccountGuarantor>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterAccountGuarantor>;
  onHold?: InputMaybe<FilterBoolean>;
  or?: InputMaybe<Array<fhir__FilterAccountGuarantor>>;
  owner?: InputMaybe<NestedFilterUser>;
  party?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__FilterAddress = {
  and?: InputMaybe<Array<fhir__FilterAddress>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterAddress>;
  or?: InputMaybe<Array<fhir__FilterAddress>>;
  text?: InputMaybe<FilterString>;
};

export type fhir__FilterAnnotation = {
  and?: InputMaybe<Array<fhir__FilterAnnotation>>;
  authorReference?: InputMaybe<fhir__NestedFilterReference>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterAnnotation>;
  or?: InputMaybe<Array<fhir__FilterAnnotation>>;
  text?: InputMaybe<FilterString>;
  time?: InputMaybe<FilterString>;
};

export type fhir__FilterChargeItem = {
  and?: InputMaybe<Array<fhir__FilterChargeItem>>;
  code?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  enteredDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterChargeItem>;
  note?: InputMaybe<fhir__NestedFilterAnnotation>;
  occurrenceDateTime?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<fhir__FilterChargeItem>>;
  owner?: InputMaybe<NestedFilterUser>;
  performer?: InputMaybe<fhir__NestedFilterChargeItemPerformer>;
  quantity?: InputMaybe<fhir__NestedFilterQuantity>;
  reason?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  service?: InputMaybe<fhir__NestedFilterCodeableReference>;
  status?: InputMaybe<Filterfhir__ChargeItemStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__FilterChargeItemPerformer = {
  actor?: InputMaybe<fhir__NestedFilterReference>;
  and?: InputMaybe<Array<fhir__FilterChargeItemPerformer>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterChargeItemPerformer>;
  operation?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  or?: InputMaybe<Array<fhir__FilterChargeItemPerformer>>;
};

export type fhir__FilterClinicalNote = {
  and?: InputMaybe<Array<fhir__FilterClinicalNote>>;
  author?: InputMaybe<fhir__NestedFilterReference>;
  category?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  dateTime?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterClinicalNote>;
  or?: InputMaybe<Array<fhir__FilterClinicalNote>>;
  owner?: InputMaybe<NestedFilterUser>;
  text?: InputMaybe<FilterString>;
};

export type fhir__FilterCodeableConcept = {
  and?: InputMaybe<Array<fhir__FilterCodeableConcept>>;
  coding?: InputMaybe<fhir__NestedFilterCoding>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterCodeableConcept>;
  or?: InputMaybe<Array<fhir__FilterCodeableConcept>>;
  text?: InputMaybe<FilterString>;
};

export type fhir__FilterCodeableReference = {
  and?: InputMaybe<Array<fhir__FilterCodeableReference>>;
  concept?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterCodeableReference>;
  or?: InputMaybe<Array<fhir__FilterCodeableReference>>;
  reference?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__FilterCoding = {
  and?: InputMaybe<Array<fhir__FilterCoding>>;
  code?: InputMaybe<FilterString>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterCoding>;
  or?: InputMaybe<Array<fhir__FilterCoding>>;
  system?: InputMaybe<FilterString>;
};

export type fhir__FilterContactPoint = {
  and?: InputMaybe<Array<fhir__FilterContactPoint>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterContactPoint>;
  or?: InputMaybe<Array<fhir__FilterContactPoint>>;
  rank?: InputMaybe<FilterInt>;
  system?: InputMaybe<FilterString>;
  use?: InputMaybe<FilterString>;
  value?: InputMaybe<FilterString>;
};

export type fhir__FilterCoverage = {
  and?: InputMaybe<Array<fhir__FilterCoverage>>;
  beneficiary?: InputMaybe<fhir__NestedFilterReference>;
  class?: InputMaybe<fhir__NestedFilterCoverageClass>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  kind?: InputMaybe<Filterfhir__CoverageKind>;
  network?: InputMaybe<FilterString>;
  not?: InputMaybe<fhir__FilterCoverage>;
  or?: InputMaybe<Array<fhir__FilterCoverage>>;
  owner?: InputMaybe<NestedFilterUser>;
  relationship?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  status?: InputMaybe<Filterfhir__FinancialResourceStatus>;
  subscriber?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterCoverageClass = {
  and?: InputMaybe<Array<fhir__FilterCoverageClass>>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<fhir__FilterCoverageClass>;
  or?: InputMaybe<Array<fhir__FilterCoverageClass>>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  value?: InputMaybe<fhir__NestedFilterIdentifier>;
};

export type fhir__FilterEncounter = {
  and?: InputMaybe<Array<fhir__FilterEncounter>>;
  class?: InputMaybe<fhir__NestedFilterCoding>;
  clinicalNote?: InputMaybe<fhir__NestedFilterClinicalNote>;
  diagnosis?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  location?: InputMaybe<fhir__NestedFilterLocation>;
  not?: InputMaybe<fhir__FilterEncounter>;
  or?: InputMaybe<Array<fhir__FilterEncounter>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<fhir__NestedFilterEncounterParticipant>;
  serviceProvider?: InputMaybe<FilterString>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCoding>;
};

export type fhir__FilterEncounterParticipant = {
  and?: InputMaybe<Array<fhir__FilterEncounterParticipant>>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  not?: InputMaybe<fhir__FilterEncounterParticipant>;
  or?: InputMaybe<Array<fhir__FilterEncounterParticipant>>;
  owner?: InputMaybe<NestedFilterUser>;
  text?: InputMaybe<FilterString>;
};

export type fhir__FilterExplanationOfBenefit = {
  and?: InputMaybe<Array<fhir__FilterExplanationOfBenefit>>;
  careTeam?: InputMaybe<fhir__NestedFilterExplanationOfBenefitCareTeam>;
  created?: InputMaybe<FilterString>;
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  diagnosis?: InputMaybe<fhir__NestedFilterExplanationOfBenefitDiagnosis>;
  facility?: InputMaybe<fhir__NestedFilterReference>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  item?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItem>;
  not?: InputMaybe<fhir__FilterExplanationOfBenefit>;
  or?: InputMaybe<Array<fhir__FilterExplanationOfBenefit>>;
  owner?: InputMaybe<NestedFilterUser>;
  patient?: InputMaybe<fhir__NestedFilterReference>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
  status?: InputMaybe<Filterfhir__ExplanationOfBenefitStatus>;
  total?: InputMaybe<fhir__NestedFilterExplanationOfBenefitTotal>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<Filterfhir__ClaimUse>;
};

export type fhir__FilterExplanationOfBenefitCareTeam = {
  and?: InputMaybe<Array<fhir__FilterExplanationOfBenefitCareTeam>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  or?: InputMaybe<Array<fhir__FilterExplanationOfBenefitCareTeam>>;
  owner?: InputMaybe<NestedFilterUser>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__FilterExplanationOfBenefitDiagnosis = {
  and?: InputMaybe<Array<fhir__FilterExplanationOfBenefitDiagnosis>>;
  diagnosisCodeableConcept?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  or?: InputMaybe<Array<fhir__FilterExplanationOfBenefitDiagnosis>>;
  owner?: InputMaybe<NestedFilterUser>;
  sequence?: InputMaybe<FilterInt64>;
};

export type fhir__FilterExplanationOfBenefitItem = {
  adjudication?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItemAdjudication>;
  and?: InputMaybe<Array<fhir__FilterExplanationOfBenefitItem>>;
  id?: InputMaybe<FilterID>;
  net?: InputMaybe<fhir__NestedFilterMoney>;
  not?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  or?: InputMaybe<Array<fhir__FilterExplanationOfBenefitItem>>;
  owner?: InputMaybe<NestedFilterUser>;
  productOrService?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  quantity?: InputMaybe<fhir__NestedFilterQuantity>;
  reviewOutcome?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItemReviewOutcome>;
  sequence?: InputMaybe<FilterInt64>;
  unitPrice?: InputMaybe<fhir__NestedFilterMoney>;
};

export type fhir__FilterExplanationOfBenefitItemAdjudication = {
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  and?: InputMaybe<Array<fhir__FilterExplanationOfBenefitItemAdjudication>>;
  category?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterExplanationOfBenefitItemAdjudication>;
  or?: InputMaybe<Array<fhir__FilterExplanationOfBenefitItemAdjudication>>;
  owner?: InputMaybe<NestedFilterUser>;
  quantity?: InputMaybe<fhir__NestedFilterQuantity>;
  reason?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterExplanationOfBenefitItemReviewOutcome = {
  and?: InputMaybe<Array<fhir__FilterExplanationOfBenefitItemReviewOutcome>>;
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterExplanationOfBenefitItemReviewOutcome>;
  or?: InputMaybe<Array<fhir__FilterExplanationOfBenefitItemReviewOutcome>>;
  owner?: InputMaybe<NestedFilterUser>;
  reason?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterExplanationOfBenefitTotal = {
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  and?: InputMaybe<Array<fhir__FilterExplanationOfBenefitTotal>>;
  category?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  or?: InputMaybe<Array<fhir__FilterExplanationOfBenefitTotal>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type fhir__FilterFHIRResource = {
  and?: InputMaybe<Array<fhir__FilterFHIRResource>>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  not?: InputMaybe<fhir__FilterFHIRResource>;
  or?: InputMaybe<Array<fhir__FilterFHIRResource>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type fhir__FilterHumanName = {
  and?: InputMaybe<Array<fhir__FilterHumanName>>;
  family?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterHumanName>;
  or?: InputMaybe<Array<fhir__FilterHumanName>>;
  text?: InputMaybe<FilterString>;
};

export type fhir__FilterIdentifier = {
  and?: InputMaybe<Array<fhir__FilterIdentifier>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterIdentifier>;
  or?: InputMaybe<Array<fhir__FilterIdentifier>>;
  system?: InputMaybe<FilterString>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<FilterString>;
  value?: InputMaybe<FilterString>;
};

export type fhir__FilterInvoice = {
  account?: InputMaybe<fhir__NestedFilterReference>;
  and?: InputMaybe<Array<fhir__FilterInvoice>>;
  creation?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  issuer?: InputMaybe<fhir__NestedFilterReference>;
  lineItem?: InputMaybe<fhir__NestedFilterInvoiceLineItem>;
  not?: InputMaybe<fhir__FilterInvoice>;
  note?: InputMaybe<fhir__NestedFilterAnnotation>;
  or?: InputMaybe<Array<fhir__FilterInvoice>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<fhir__NestedFilterInvoiceParticipant>;
  paymentTerms?: InputMaybe<FilterString>;
  recipient?: InputMaybe<fhir__NestedFilterReference>;
  status?: InputMaybe<Filterfhir__InvoiceStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  totalGross?: InputMaybe<fhir__NestedFilterMoney>;
  totalNet?: InputMaybe<fhir__NestedFilterMoney>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterInvoiceLineItem = {
  and?: InputMaybe<Array<fhir__FilterInvoiceLineItem>>;
  chargeItem?: InputMaybe<fhir__NestedFilterChargeItem>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterInvoiceLineItem>;
  or?: InputMaybe<Array<fhir__FilterInvoiceLineItem>>;
  owner?: InputMaybe<NestedFilterUser>;
  priceComponent?: InputMaybe<fhir__NestedFilterMonetaryComponent>;
  sequence?: InputMaybe<FilterInt64>;
};

export type fhir__FilterInvoiceParticipant = {
  actor?: InputMaybe<fhir__NestedFilterReference>;
  and?: InputMaybe<Array<fhir__FilterInvoiceParticipant>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterInvoiceParticipant>;
  or?: InputMaybe<Array<fhir__FilterInvoiceParticipant>>;
  owner?: InputMaybe<NestedFilterUser>;
  role?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterLocation = {
  address?: InputMaybe<fhir__NestedFilterAddress>;
  and?: InputMaybe<Array<fhir__FilterLocation>>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<fhir__FilterLocation>;
  or?: InputMaybe<Array<fhir__FilterLocation>>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterMonetaryComponent = {
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  and?: InputMaybe<Array<fhir__FilterMonetaryComponent>>;
  code?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  factor?: InputMaybe<FilterDecimal>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterMonetaryComponent>;
  or?: InputMaybe<Array<fhir__FilterMonetaryComponent>>;
  type?: InputMaybe<Filterfhir__PriceComponentType>;
};

export type fhir__FilterMoney = {
  and?: InputMaybe<Array<fhir__FilterMoney>>;
  currency?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterMoney>;
  or?: InputMaybe<Array<fhir__FilterMoney>>;
  value?: InputMaybe<FilterDecimal>;
};

export type fhir__FilterPatient = {
  and?: InputMaybe<Array<fhir__FilterPatient>>;
  birthDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  name?: InputMaybe<fhir__NestedFilterHumanName>;
  not?: InputMaybe<fhir__FilterPatient>;
  or?: InputMaybe<Array<fhir__FilterPatient>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type fhir__FilterPractitioner = {
  and?: InputMaybe<Array<fhir__FilterPractitioner>>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  name?: InputMaybe<fhir__NestedFilterHumanName>;
  not?: InputMaybe<fhir__FilterPractitioner>;
  or?: InputMaybe<Array<fhir__FilterPractitioner>>;
  owner?: InputMaybe<NestedFilterUser>;
  telecom?: InputMaybe<fhir__NestedFilterContactPoint>;
};

export type fhir__FilterQuantity = {
  and?: InputMaybe<Array<fhir__FilterQuantity>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterQuantity>;
  or?: InputMaybe<Array<fhir__FilterQuantity>>;
  value?: InputMaybe<FilterDecimal>;
};

export type fhir__FilterReference = {
  and?: InputMaybe<Array<fhir__FilterReference>>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  not?: InputMaybe<fhir__FilterReference>;
  or?: InputMaybe<Array<fhir__FilterReference>>;
  resource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
};

export enum fhir__FinancialResourceStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  DRAFT = 'DRAFT',
  ENTERED_IN_ERROR = 'ENTERED_IN_ERROR'
}

export type fhir__HumanName = {
  family?: Maybe<Scalars['String']['output']>;
  given?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type fhir__HumanName_Type = BaseObject & Object & fhir__HumanName & {
  __typename: 'fhir__HumanName_Type';
  family?: Maybe<Scalars['String']['output']>;
  given?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type fhir__Identifier = {
  id: Scalars['ID']['output'];
  system?: Maybe<Scalars['String']['output']>;
  type?: Maybe<fhir__CodeableConcept>;
  use?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};


export type fhir__IdentifiertypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__Identifier_Type = BaseObject & Object & fhir__Identifier & {
  __typename: 'fhir__Identifier_Type';
  id: Scalars['ID']['output'];
  system?: Maybe<Scalars['String']['output']>;
  type?: Maybe<fhir__CodeableConcept>;
  use?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};


export type fhir__Identifier_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__Invoice = {
  account?: Maybe<fhir__Reference>;
  creation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  issuer?: Maybe<fhir__Reference>;
  lineItem?: Maybe<Array<fhir__InvoiceLineItem>>;
  note?: Maybe<Array<fhir__Annotation>>;
  owner: User;
  participant?: Maybe<Array<fhir__InvoiceParticipant>>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  periodPeriod?: Maybe<Scalars['JSON']['output']>;
  recipient?: Maybe<fhir__Reference>;
  status: fhir__InvoiceStatus;
  subject?: Maybe<fhir__Reference>;
  totalGross?: Maybe<fhir__Money>;
  totalNet?: Maybe<fhir__Money>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhir__InvoiceaccountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__InvoiceidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__InvoiceissuerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__InvoicelineItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceLineItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceLineItem>;
};


export type fhir__InvoicenoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAnnotation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAnnotation>;
};


export type fhir__InvoiceownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__InvoiceparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceParticipant>;
};


export type fhir__InvoicerecipientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__InvoicesubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__InvoicetotalGrossArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__InvoicetotalNetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__InvoicetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__InvoiceLineItem = {
  chargeItem?: Maybe<fhir__ChargeItem>;
  id: Scalars['ID']['output'];
  owner: User;
  priceComponent?: Maybe<Array<fhir__MonetaryComponent>>;
  sequence: Scalars['Int64']['output'];
  servicedPeriod?: Maybe<Scalars['JSON']['output']>;
};


export type fhir__InvoiceLineItemchargeItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterChargeItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderChargeItem>;
};


export type fhir__InvoiceLineItemownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__InvoiceLineItempriceComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMonetaryComponent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMonetaryComponent>;
};

export type fhir__InvoiceLineItem_Type = BaseObject & Object & Owned & fhir__InvoiceLineItem & {
  __typename: 'fhir__InvoiceLineItem_Type';
  chargeItem?: Maybe<fhir__ChargeItem>;
  id: Scalars['ID']['output'];
  owner: User;
  priceComponent?: Maybe<Array<fhir__MonetaryComponent>>;
  sequence: Scalars['Int64']['output'];
  servicedPeriod?: Maybe<Scalars['JSON']['output']>;
};


export type fhir__InvoiceLineItem_TypechargeItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterChargeItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderChargeItem>;
};


export type fhir__InvoiceLineItem_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__InvoiceLineItem_TypepriceComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMonetaryComponent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMonetaryComponent>;
};

export type fhir__InvoiceParticipant = {
  actor?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  owner: User;
  role?: Maybe<fhir__CodeableConcept>;
};


export type fhir__InvoiceParticipantactorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__InvoiceParticipantownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__InvoiceParticipantroleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__InvoiceParticipant_Type = BaseObject & Object & Owned & fhir__InvoiceParticipant & {
  __typename: 'fhir__InvoiceParticipant_Type';
  actor?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  owner: User;
  role?: Maybe<fhir__CodeableConcept>;
};


export type fhir__InvoiceParticipant_TypeactorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__InvoiceParticipant_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__InvoiceParticipant_TyperoleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export enum fhir__InvoiceStatus {
  BALANCED = 'BALANCED',
  CANCELLED = 'CANCELLED',
  DRAFT = 'DRAFT',
  ENTERED_IN_ERROR = 'ENTERED_IN_ERROR',
  ISSUED = 'ISSUED'
}

export type fhir__Location = {
  address?: Maybe<fhir__Address>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhir__LocationaddressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAddress>;
};


export type fhir__LocationtypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__Location_Type = BaseObject & Object & fhir__Location & {
  __typename: 'fhir__Location_Type';
  address?: Maybe<fhir__Address>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhir__Location_TypeaddressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAddress>;
};


export type fhir__Location_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__MonetaryComponent = {
  amount?: Maybe<fhir__Money>;
  code?: Maybe<fhir__CodeableConcept>;
  factor?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  type?: Maybe<fhir__PriceComponentType>;
};


export type fhir__MonetaryComponentamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__MonetaryComponentcodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__MonetaryComponent_Type = BaseObject & Object & fhir__MonetaryComponent & {
  __typename: 'fhir__MonetaryComponent_Type';
  amount?: Maybe<fhir__Money>;
  code?: Maybe<fhir__CodeableConcept>;
  factor?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  type?: Maybe<fhir__PriceComponentType>;
};


export type fhir__MonetaryComponent_TypeamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__MonetaryComponent_TypecodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__Money = {
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type fhir__Money_Type = BaseObject & Object & fhir__Money & {
  __typename: 'fhir__Money_Type';
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type fhir__NestedFilterAccountBalance = {
  aggregate?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  estimate?: InputMaybe<FilterBoolean>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  term?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__NestedFilterAccountGuarantor = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  onHold?: InputMaybe<FilterBoolean>;
  owner?: InputMaybe<NestedFilterUser>;
  party?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__NestedFilterAddress = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  text?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterAnnotation = {
  authorReference?: InputMaybe<fhir__NestedFilterReference>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  text?: InputMaybe<FilterString>;
  time?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterChargeItem = {
  code?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  enteredDate?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  note?: InputMaybe<fhir__NestedFilterAnnotation>;
  occurrenceDateTime?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  performer?: InputMaybe<fhir__NestedFilterChargeItemPerformer>;
  quantity?: InputMaybe<fhir__NestedFilterQuantity>;
  reason?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  service?: InputMaybe<fhir__NestedFilterCodeableReference>;
  status?: InputMaybe<Filterfhir__ChargeItemStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__NestedFilterChargeItemPerformer = {
  actor?: InputMaybe<fhir__NestedFilterReference>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  operation?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__NestedFilterClinicalNote = {
  author?: InputMaybe<fhir__NestedFilterReference>;
  category?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  dateTime?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  text?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterCodeableConcept = {
  coding?: InputMaybe<fhir__NestedFilterCoding>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  text?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterCodeableReference = {
  concept?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  display?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  reference?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__NestedFilterCoding = {
  code?: InputMaybe<FilterString>;
  display?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  system?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterContactPoint = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  rank?: InputMaybe<FilterInt>;
  system?: InputMaybe<FilterString>;
  use?: InputMaybe<FilterString>;
  value?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterCoverageClass = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  value?: InputMaybe<fhir__NestedFilterIdentifier>;
};

export type fhir__NestedFilterEncounterParticipant = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  owner?: InputMaybe<NestedFilterUser>;
  text?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterExplanationOfBenefitCareTeam = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__NestedFilterExplanationOfBenefitDiagnosis = {
  diagnosisCodeableConcept?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  sequence?: InputMaybe<FilterInt64>;
};

export type fhir__NestedFilterExplanationOfBenefitItem = {
  adjudication?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItemAdjudication>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  net?: InputMaybe<fhir__NestedFilterMoney>;
  owner?: InputMaybe<NestedFilterUser>;
  productOrService?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  quantity?: InputMaybe<fhir__NestedFilterQuantity>;
  reviewOutcome?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItemReviewOutcome>;
  sequence?: InputMaybe<FilterInt64>;
  unitPrice?: InputMaybe<fhir__NestedFilterMoney>;
};

export type fhir__NestedFilterExplanationOfBenefitItemAdjudication = {
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  category?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  quantity?: InputMaybe<fhir__NestedFilterQuantity>;
  reason?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__NestedFilterExplanationOfBenefitItemReviewOutcome = {
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  reason?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__NestedFilterExplanationOfBenefitTotal = {
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  category?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type fhir__NestedFilterHumanName = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  family?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  text?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterIdentifier = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  system?: InputMaybe<FilterString>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<FilterString>;
  value?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterInvoiceLineItem = {
  chargeItem?: InputMaybe<fhir__NestedFilterChargeItem>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  priceComponent?: InputMaybe<fhir__NestedFilterMonetaryComponent>;
  sequence?: InputMaybe<FilterInt64>;
};

export type fhir__NestedFilterInvoiceParticipant = {
  actor?: InputMaybe<fhir__NestedFilterReference>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  role?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__NestedFilterLocation = {
  address?: InputMaybe<fhir__NestedFilterAddress>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__NestedFilterMonetaryComponent = {
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  code?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  factor?: InputMaybe<FilterDecimal>;
  id?: InputMaybe<FilterID>;
  type?: InputMaybe<Filterfhir__PriceComponentType>;
};

export type fhir__NestedFilterMoney = {
  currency?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  value?: InputMaybe<FilterDecimal>;
};

export type fhir__NestedFilterQuantity = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  value?: InputMaybe<FilterDecimal>;
};

export type fhir__NestedFilterReference = {
  display?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  resource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
};

export type fhir__OrderAccount = {
  balance?: InputMaybe<fhir__OrderAccountBalance>;
  billingStatus?: InputMaybe<fhir__OrderCodeableConcept>;
  calculatedAt?: InputMaybe<Ordering>;
  currency?: InputMaybe<fhir__OrderCodeableConcept>;
  description?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  status?: InputMaybe<Ordering>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderAccountBalance = {
  aggregate?: InputMaybe<fhir__OrderCodeableConcept>;
  amount?: InputMaybe<fhir__OrderMoney>;
  estimate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  term?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderAccountGuarantor = {
  id?: InputMaybe<Ordering>;
  onHold?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  party?: InputMaybe<fhir__OrderReference>;
};

export type fhir__OrderAddress = {
  id?: InputMaybe<Ordering>;
  text?: InputMaybe<Ordering>;
};

export type fhir__OrderAnnotation = {
  authorReference?: InputMaybe<fhir__OrderReference>;
  id?: InputMaybe<Ordering>;
  text?: InputMaybe<Ordering>;
  time?: InputMaybe<Ordering>;
};

export type fhir__OrderChargeItem = {
  code?: InputMaybe<fhir__OrderCodeableConcept>;
  enteredDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  occurrenceDateTime?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  quantity?: InputMaybe<fhir__OrderQuantity>;
  status?: InputMaybe<Ordering>;
  subject?: InputMaybe<fhir__OrderReference>;
};

export type fhir__OrderChargeItemPerformer = {
  actor?: InputMaybe<fhir__OrderReference>;
  id?: InputMaybe<Ordering>;
  operation?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderClinicalNote = {
  author?: InputMaybe<fhir__OrderReference>;
  category?: InputMaybe<fhir__OrderCodeableConcept>;
  dateTime?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  text?: InputMaybe<Ordering>;
};

export type fhir__OrderCodeableConcept = {
  id?: InputMaybe<Ordering>;
  text?: InputMaybe<Ordering>;
};

export type fhir__OrderCodeableReference = {
  concept?: InputMaybe<fhir__OrderCodeableConcept>;
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  reference?: InputMaybe<fhir__OrderReference>;
};

export type fhir__OrderCoding = {
  code?: InputMaybe<Ordering>;
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  system?: InputMaybe<Ordering>;
};

export type fhir__OrderContactPoint = {
  id?: InputMaybe<Ordering>;
  rank?: InputMaybe<Ordering>;
  system?: InputMaybe<Ordering>;
  use?: InputMaybe<Ordering>;
  value?: InputMaybe<Ordering>;
};

export type fhir__OrderCoverage = {
  beneficiary?: InputMaybe<fhir__OrderReference>;
  id?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  network?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  relationship?: InputMaybe<fhir__OrderCodeableConcept>;
  status?: InputMaybe<Ordering>;
  subscriber?: InputMaybe<fhir__OrderReference>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderCoverageClass = {
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
  value?: InputMaybe<fhir__OrderIdentifier>;
};

export type fhir__OrderEncounter = {
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  serviceProvider?: InputMaybe<Ordering>;
  subject?: InputMaybe<fhir__OrderReference>;
};

export type fhir__OrderEncounterParticipant = {
  id?: InputMaybe<Ordering>;
  identifier?: InputMaybe<fhir__OrderIdentifier>;
  owner?: InputMaybe<OrderUser>;
  text?: InputMaybe<Ordering>;
};

export type fhir__OrderExplanationOfBenefit = {
  created?: InputMaybe<Ordering>;
  decision?: InputMaybe<fhir__OrderCodeableConcept>;
  facility?: InputMaybe<fhir__OrderReference>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  patient?: InputMaybe<fhir__OrderReference>;
  provider?: InputMaybe<fhir__OrderReference>;
  status?: InputMaybe<Ordering>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
  use?: InputMaybe<Ordering>;
};

export type fhir__OrderExplanationOfBenefitCareTeam = {
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  provider?: InputMaybe<fhir__OrderReference>;
};

export type fhir__OrderExplanationOfBenefitDiagnosis = {
  diagnosisCodeableConcept?: InputMaybe<fhir__OrderCodeableConcept>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  sequence?: InputMaybe<Ordering>;
};

export type fhir__OrderExplanationOfBenefitItem = {
  id?: InputMaybe<Ordering>;
  net?: InputMaybe<fhir__OrderMoney>;
  owner?: InputMaybe<OrderUser>;
  productOrService?: InputMaybe<fhir__OrderCodeableConcept>;
  quantity?: InputMaybe<fhir__OrderQuantity>;
  reviewOutcome?: InputMaybe<fhir__OrderExplanationOfBenefitItemReviewOutcome>;
  sequence?: InputMaybe<Ordering>;
  unitPrice?: InputMaybe<fhir__OrderMoney>;
};

export type fhir__OrderExplanationOfBenefitItemAdjudication = {
  amount?: InputMaybe<fhir__OrderMoney>;
  category?: InputMaybe<fhir__OrderCodeableConcept>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  quantity?: InputMaybe<fhir__OrderQuantity>;
  reason?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderExplanationOfBenefitItemReviewOutcome = {
  decision?: InputMaybe<fhir__OrderCodeableConcept>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  reason?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderExplanationOfBenefitTotal = {
  amount?: InputMaybe<fhir__OrderMoney>;
  category?: InputMaybe<fhir__OrderCodeableConcept>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type fhir__OrderFHIRResource = {
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type fhir__OrderHumanName = {
  family?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  text?: InputMaybe<Ordering>;
};

export type fhir__OrderIdentifier = {
  id?: InputMaybe<Ordering>;
  system?: InputMaybe<Ordering>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
  use?: InputMaybe<Ordering>;
  value?: InputMaybe<Ordering>;
};

export type fhir__OrderInvoice = {
  account?: InputMaybe<fhir__OrderReference>;
  creation?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issuer?: InputMaybe<fhir__OrderReference>;
  owner?: InputMaybe<OrderUser>;
  paymentTerms?: InputMaybe<Ordering>;
  recipient?: InputMaybe<fhir__OrderReference>;
  status?: InputMaybe<Ordering>;
  subject?: InputMaybe<fhir__OrderReference>;
  totalGross?: InputMaybe<fhir__OrderMoney>;
  totalNet?: InputMaybe<fhir__OrderMoney>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderInvoiceLineItem = {
  chargeItem?: InputMaybe<fhir__OrderChargeItem>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  sequence?: InputMaybe<Ordering>;
};

export type fhir__OrderInvoiceParticipant = {
  actor?: InputMaybe<fhir__OrderReference>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  role?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderLocation = {
  address?: InputMaybe<fhir__OrderAddress>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderMonetaryComponent = {
  amount?: InputMaybe<fhir__OrderMoney>;
  code?: InputMaybe<fhir__OrderCodeableConcept>;
  factor?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
};

export type fhir__OrderMoney = {
  currency?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  value?: InputMaybe<Ordering>;
};

export type fhir__OrderPatient = {
  birthDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type fhir__OrderPractitioner = {
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type fhir__OrderQuantity = {
  id?: InputMaybe<Ordering>;
  value?: InputMaybe<Ordering>;
};

export type fhir__OrderReference = {
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  identifier?: InputMaybe<fhir__OrderIdentifier>;
  resource?: InputMaybe<fhirext__OrderResourceVersion>;
};

export type fhir__Patient = {
  birthDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
};


export type fhir__PatientidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__PatientnameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhir__PatientownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__Practitioner = {
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
  telecom?: Maybe<Array<fhir__ContactPoint>>;
};


export type fhir__PractitioneridentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__PractitionernameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhir__PractitionerownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__PractitionertelecomArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderContactPoint>;
};

export enum fhir__PriceComponentType {
  BASE = 'BASE',
  DEDUCTION = 'DEDUCTION',
  DISCOUNT = 'DISCOUNT',
  INFORMATIONAL = 'INFORMATIONAL',
  SURCHARGE = 'SURCHARGE',
  TAX = 'TAX'
}

export type fhir__Quantity = {
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type fhir__Quantity_Type = BaseObject & Object & fhir__Quantity & {
  __typename: 'fhir__Quantity_Type';
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type fhir__Reference = {
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<fhir__Identifier>;
  resource?: Maybe<fhirext__ResourceVersion>;
};


export type fhir__ReferenceidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__ReferenceresourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};

export type fhir__Reference_Type = BaseObject & Object & fhir__Reference & {
  __typename: 'fhir__Reference_Type';
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<fhir__Identifier>;
  resource?: Maybe<fhirext__ResourceVersion>;
};


export type fhir__Reference_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__Reference_TyperesourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};

export type fhirext__Account = {
  __typename: 'fhirext__Account';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  balance?: Maybe<fhir__AccountBalance>;
  billingStatus?: Maybe<fhir__CodeableConcept>;
  calculatedAt?: Maybe<Scalars['String']['output']>;
  coverage?: Maybe<Array<fhir__Reference>>;
  createdAt: Scalars['String']['output'];
  currency?: Maybe<fhir__CodeableConcept>;
  currentAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<fhirext__Finding>>;
  guarantor?: Maybe<Array<fhir__AccountGuarantor>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Scalars['String']['output']>;
  owner: User;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  servicePeriod?: Maybe<Scalars['JSON']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__AccountStatus;
  subject?: Maybe<Array<fhir__Reference>>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__AccountassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__AccountbalanceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountBalance>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountBalance>;
};


export type fhirext__AccountbillingStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__AccountcoverageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__AccountcurrencyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__AccountfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__AccountguarantorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountGuarantor>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountGuarantor>;
};


export type fhirext__AccountidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__AccountingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__AccountlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__AccountrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__AccountsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__AccountsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountsubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__AccounttypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__AccountVersion = {
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  balance?: Maybe<fhir__AccountBalance>;
  billingStatus?: Maybe<fhir__CodeableConcept>;
  calculatedAt?: Maybe<Scalars['String']['output']>;
  coverage?: Maybe<Array<fhir__Reference>>;
  createdAt: Scalars['String']['output'];
  currency?: Maybe<fhir__CodeableConcept>;
  currentAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<fhirext__Finding>>;
  guarantor?: Maybe<Array<fhir__AccountGuarantor>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Scalars['String']['output']>;
  owner: User;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  servicePeriod?: Maybe<Scalars['JSON']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__AccountStatus;
  subject?: Maybe<Array<fhir__Reference>>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__AccountVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__AccountVersionbalanceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountBalance>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountBalance>;
};


export type fhirext__AccountVersionbillingStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__AccountVersioncoverageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__AccountVersioncurrencyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__AccountVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__AccountVersionguarantorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountGuarantor>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountGuarantor>;
};


export type fhirext__AccountVersionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__AccountVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__AccountVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__AccountVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__AccountVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__AccountVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountVersionsubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__AccountVersiontypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__AccountVersion_Type = BaseObject & Object & Owned & fhir__Account & fhir__FHIRResource & fhirext__AccountVersion & fhirext__ResourceVersion & {
  __typename: 'fhirext__AccountVersion_Type';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  balance?: Maybe<fhir__AccountBalance>;
  billingStatus?: Maybe<fhir__CodeableConcept>;
  calculatedAt?: Maybe<Scalars['String']['output']>;
  coverage?: Maybe<Array<fhir__Reference>>;
  createdAt: Scalars['String']['output'];
  currency?: Maybe<fhir__CodeableConcept>;
  currentAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<fhirext__Finding>>;
  guarantor?: Maybe<Array<fhir__AccountGuarantor>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Scalars['String']['output']>;
  owner: User;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  servicePeriod?: Maybe<Scalars['JSON']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__AccountStatus;
  subject?: Maybe<Array<fhir__Reference>>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__AccountVersion_TypeassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__AccountVersion_TypebalanceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountBalance>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountBalance>;
};


export type fhirext__AccountVersion_TypebillingStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__AccountVersion_TypecoverageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__AccountVersion_TypecurrencyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__AccountVersion_TypefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__AccountVersion_TypeguarantorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountGuarantor>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountGuarantor>;
};


export type fhirext__AccountVersion_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__AccountVersion_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__AccountVersion_TypelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountVersion_TypelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountVersion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__AccountVersion_TyperelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__AccountVersion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__AccountVersion_TypesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountVersion_TypesubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__AccountVersion_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__Coverage = {
  __typename: 'fhirext__Coverage';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  beneficiary: fhir__Reference;
  class?: Maybe<Array<fhir__CoverageClass>>;
  coverageType?: Maybe<fhir__CoverageType>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  kind: fhir__CoverageKind;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  memberId?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  owner: User;
  period?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  relationship?: Maybe<fhir__CodeableConcept>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__FinancialResourceStatus;
  subscriber?: Maybe<fhir__Reference>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__CoverageassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__CoveragebeneficiaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoverageclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type fhirext__CoveragefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__CoverageidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__CoverageingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__CoveragelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoveragelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoverageownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__CoveragepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__CoveragerelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__CoveragerelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__CoveragesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__CoveragesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoveragesubscriberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoveragetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__CoverageExtension = {
  beneficiary: fhir__Reference;
  class?: Maybe<Array<fhir__CoverageClass>>;
  coverageType?: Maybe<fhir__CoverageType>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  kind: fhir__CoverageKind;
  memberId?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  owner: User;
  period?: Maybe<Scalars['JSON']['output']>;
  relationship?: Maybe<fhir__CodeableConcept>;
  status: fhir__FinancialResourceStatus;
  subscriber?: Maybe<fhir__Reference>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__CoverageExtensionbeneficiaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoverageExtensionclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type fhirext__CoverageExtensionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__CoverageExtensionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__CoverageExtensionrelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__CoverageExtensionsubscriberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoverageExtensiontypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__CoverageVersion = {
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  beneficiary: fhir__Reference;
  class?: Maybe<Array<fhir__CoverageClass>>;
  coverageType?: Maybe<fhir__CoverageType>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  kind: fhir__CoverageKind;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  memberId?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  owner: User;
  period?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  relationship?: Maybe<fhir__CodeableConcept>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__FinancialResourceStatus;
  subscriber?: Maybe<fhir__Reference>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__CoverageVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__CoverageVersionbeneficiaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoverageVersionclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type fhirext__CoverageVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__CoverageVersionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__CoverageVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__CoverageVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoverageVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoverageVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__CoverageVersionpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__CoverageVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__CoverageVersionrelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__CoverageVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__CoverageVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoverageVersionsubscriberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoverageVersiontypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__CoverageVersion_Type = BaseObject & Object & Owned & Personal & fhir__Coverage & fhir__FHIRResource & fhirext__CoverageExtension & fhirext__CoverageVersion & fhirext__ResourceVersion & {
  __typename: 'fhirext__CoverageVersion_Type';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  beneficiary: fhir__Reference;
  class?: Maybe<Array<fhir__CoverageClass>>;
  coverageType?: Maybe<fhir__CoverageType>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  kind: fhir__CoverageKind;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  memberId?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  owner: User;
  period?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  relationship?: Maybe<fhir__CodeableConcept>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__FinancialResourceStatus;
  subscriber?: Maybe<fhir__Reference>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__CoverageVersion_TypeassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__CoverageVersion_TypebeneficiaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoverageVersion_TypeclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type fhirext__CoverageVersion_TypefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__CoverageVersion_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__CoverageVersion_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__CoverageVersion_TypelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoverageVersion_TypelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoverageVersion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__CoverageVersion_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__CoverageVersion_TyperelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__CoverageVersion_TyperelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__CoverageVersion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__CoverageVersion_TypesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoverageVersion_TypesubscriberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoverageVersion_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__Encounter = {
  __typename: 'fhirext__Encounter';
  actualPeriod?: Maybe<Scalars['JSON']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  class?: Maybe<Array<fhir__Coding>>;
  clinicalNote?: Maybe<Array<fhir__ClinicalNote>>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  diagnosis?: Maybe<Array<fhir__CodeableConcept>>;
  encounterDate: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  location?: Maybe<Array<fhir__Location>>;
  owner: User;
  participant?: Maybe<Array<fhir__EncounterParticipant>>;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  subject?: Maybe<fhir__Reference>;
  type?: Maybe<Array<fhir__Coding>>;
};


export type fhirext__EncounterassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__EncounterclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};


export type fhirext__EncounterclinicalNoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterClinicalNote>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderClinicalNote>;
};


export type fhirext__EncounterdiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__EncounterfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__EncounteridentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__EncounteringestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__EncounterlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterlocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterLocation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderLocation>;
};


export type fhirext__EncounterownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__EncounterparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterEncounterParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderEncounterParticipant>;
};


export type fhirext__EncounterpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__EncounterrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__EncountersourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__EncountersourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncountersubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__EncountertypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};

export type fhirext__EncounterVersion = {
  actualPeriod?: Maybe<Scalars['JSON']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  class?: Maybe<Array<fhir__Coding>>;
  clinicalNote?: Maybe<Array<fhir__ClinicalNote>>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  diagnosis?: Maybe<Array<fhir__CodeableConcept>>;
  encounterDate: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  location?: Maybe<Array<fhir__Location>>;
  owner: User;
  participant?: Maybe<Array<fhir__EncounterParticipant>>;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  subject?: Maybe<fhir__Reference>;
  type?: Maybe<Array<fhir__Coding>>;
};


export type fhirext__EncounterVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__EncounterVersionclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};


export type fhirext__EncounterVersionclinicalNoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterClinicalNote>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderClinicalNote>;
};


export type fhirext__EncounterVersiondiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__EncounterVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__EncounterVersionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__EncounterVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__EncounterVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterVersionlocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterLocation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderLocation>;
};


export type fhirext__EncounterVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__EncounterVersionparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterEncounterParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderEncounterParticipant>;
};


export type fhirext__EncounterVersionpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__EncounterVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__EncounterVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__EncounterVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterVersionsubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__EncounterVersiontypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};

export type fhirext__EncounterVersion_Type = BaseObject & Object & Owned & Personal & fhir__Encounter & fhir__FHIRResource & fhirext__EncounterVersion & fhirext__ResourceVersion & {
  __typename: 'fhirext__EncounterVersion_Type';
  actualPeriod?: Maybe<Scalars['JSON']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  class?: Maybe<Array<fhir__Coding>>;
  clinicalNote?: Maybe<Array<fhir__ClinicalNote>>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  diagnosis?: Maybe<Array<fhir__CodeableConcept>>;
  encounterDate: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  location?: Maybe<Array<fhir__Location>>;
  owner: User;
  participant?: Maybe<Array<fhir__EncounterParticipant>>;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  subject?: Maybe<fhir__Reference>;
  type?: Maybe<Array<fhir__Coding>>;
};


export type fhirext__EncounterVersion_TypeassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__EncounterVersion_TypeclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};


export type fhirext__EncounterVersion_TypeclinicalNoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterClinicalNote>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderClinicalNote>;
};


export type fhirext__EncounterVersion_TypediagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__EncounterVersion_TypefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__EncounterVersion_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__EncounterVersion_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__EncounterVersion_TypelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterVersion_TypelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterVersion_TypelocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterLocation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderLocation>;
};


export type fhirext__EncounterVersion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__EncounterVersion_TypeparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterEncounterParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderEncounterParticipant>;
};


export type fhirext__EncounterVersion_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__EncounterVersion_TyperelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__EncounterVersion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__EncounterVersion_TypesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterVersion_TypesubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__EncounterVersion_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};

export type fhirext__ExplanationOfBenefit = {
  __typename: 'fhirext__ExplanationOfBenefit';
  amountOwed?: Maybe<Scalars['Decimal']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  billablePeriod?: Maybe<Scalars['JSON']['output']>;
  careTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  created?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  decision?: Maybe<fhir__CodeableConcept>;
  diagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  facility?: Maybe<fhir__Reference>;
  findings?: Maybe<Array<fhirext__Finding>>;
  hasUserVisibleFindings: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  network?: Maybe<fhir__CodeableConcept>;
  owner: User;
  patient?: Maybe<fhir__Reference>;
  person?: Maybe<Person>;
  provider?: Maybe<fhir__Reference>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__ExplanationOfBenefitStatus;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  totalsByType?: Maybe<fhirext__ExplanationOfBenefitTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
  use: fhir__ClaimUse;
};


export type fhirext__ExplanationOfBenefitassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__ExplanationOfBenefitcareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type fhirext__ExplanationOfBenefitdecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitdiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type fhirext__ExplanationOfBenefitfacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__ExplanationOfBenefitidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__ExplanationOfBenefitingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__ExplanationOfBenefititemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type fhirext__ExplanationOfBenefitlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitnetworkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ExplanationOfBenefitpatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__ExplanationOfBenefitproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ExplanationOfBenefitsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ExplanationOfBenefitsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefittotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type fhirext__ExplanationOfBenefittotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
};


export type fhirext__ExplanationOfBenefittypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__ExplanationOfBenefitExtension = {
  billablePeriod?: Maybe<Scalars['JSON']['output']>;
  careTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  created?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<fhir__CodeableConcept>;
  diagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  facility?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  item?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  network?: Maybe<fhir__CodeableConcept>;
  owner: User;
  patient?: Maybe<fhir__Reference>;
  provider?: Maybe<fhir__Reference>;
  serviceDate?: Maybe<Scalars['String']['output']>;
  status: fhir__ExplanationOfBenefitStatus;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  totalsByType?: Maybe<fhirext__ExplanationOfBenefitTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
  use: fhir__ClaimUse;
};


export type fhirext__ExplanationOfBenefitExtensioncareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type fhirext__ExplanationOfBenefitExtensiondecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitExtensiondiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type fhirext__ExplanationOfBenefitExtensionfacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitExtensionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__ExplanationOfBenefitExtensionitemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type fhirext__ExplanationOfBenefitExtensionnetworkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitExtensionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ExplanationOfBenefitExtensionpatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitExtensionproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitExtensiontotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type fhirext__ExplanationOfBenefitExtensiontotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
};


export type fhirext__ExplanationOfBenefitExtensiontypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__ExplanationOfBenefitTotalsByType = {
  benefit?: Maybe<fhir__Money>;
  coinsurance?: Maybe<fhir__Money>;
  copay?: Maybe<fhir__Money>;
  deductible?: Maybe<fhir__Money>;
  discount?: Maybe<fhir__Money>;
  drugCost?: Maybe<fhir__Money>;
  eligible?: Maybe<fhir__Money>;
  id: Scalars['ID']['output'];
  memberLiability?: Maybe<fhir__Money>;
  nonCovered?: Maybe<fhir__Money>;
  owner: User;
  paidByPatient?: Maybe<fhir__Money>;
  paidByPatientCash?: Maybe<fhir__Money>;
  paidByPatientOther?: Maybe<fhir__Money>;
  paidToPatient?: Maybe<fhir__Money>;
  paidToProvider?: Maybe<fhir__Money>;
  priorPayerPaid?: Maybe<fhir__Money>;
  submitted?: Maybe<fhir__Money>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypebenefitArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypecoinsuranceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypecopayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypedeductibleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypediscountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypedrugCostArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypeeligibleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypememberLiabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypenonCoveredArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypepaidByPatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypepaidByPatientCashArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypepaidByPatientOtherArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypepaidToPatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypepaidToProviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypepriorPayerPaidArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypesubmittedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};

export type fhirext__ExplanationOfBenefitTotalsByType_Type = BaseObject & Object & Owned & fhirext__ExplanationOfBenefitTotalsByType & {
  __typename: 'fhirext__ExplanationOfBenefitTotalsByType_Type';
  benefit?: Maybe<fhir__Money>;
  coinsurance?: Maybe<fhir__Money>;
  copay?: Maybe<fhir__Money>;
  deductible?: Maybe<fhir__Money>;
  discount?: Maybe<fhir__Money>;
  drugCost?: Maybe<fhir__Money>;
  eligible?: Maybe<fhir__Money>;
  id: Scalars['ID']['output'];
  memberLiability?: Maybe<fhir__Money>;
  nonCovered?: Maybe<fhir__Money>;
  owner: User;
  paidByPatient?: Maybe<fhir__Money>;
  paidByPatientCash?: Maybe<fhir__Money>;
  paidByPatientOther?: Maybe<fhir__Money>;
  paidToPatient?: Maybe<fhir__Money>;
  paidToProvider?: Maybe<fhir__Money>;
  priorPayerPaid?: Maybe<fhir__Money>;
  submitted?: Maybe<fhir__Money>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypebenefitArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypecoinsuranceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypecopayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypedeductibleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypediscountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypedrugCostArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypeeligibleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypememberLiabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypenonCoveredArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypepaidByPatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypepaidByPatientCashArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypepaidByPatientOtherArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypepaidToPatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypepaidToProviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypepriorPayerPaidArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypesubmittedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};

export type fhirext__ExplanationOfBenefitVersion = {
  amountOwed?: Maybe<Scalars['Decimal']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  billablePeriod?: Maybe<Scalars['JSON']['output']>;
  careTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  created?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  decision?: Maybe<fhir__CodeableConcept>;
  diagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  facility?: Maybe<fhir__Reference>;
  fairMarketValue?: Maybe<Array<FairMarketValueResponse>>;
  findings?: Maybe<Array<fhirext__Finding>>;
  hasUserVisibleFindings: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  network?: Maybe<fhir__CodeableConcept>;
  owner: User;
  patient?: Maybe<fhir__Reference>;
  person?: Maybe<Person>;
  provider?: Maybe<fhir__Reference>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__ExplanationOfBenefitStatus;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  totalsByType?: Maybe<fhirext__ExplanationOfBenefitTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
  use: fhir__ClaimUse;
};


export type fhirext__ExplanationOfBenefitVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__ExplanationOfBenefitVersioncareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type fhirext__ExplanationOfBenefitVersiondecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitVersiondiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type fhirext__ExplanationOfBenefitVersionfacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__ExplanationOfBenefitVersionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__ExplanationOfBenefitVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__ExplanationOfBenefitVersionitemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type fhirext__ExplanationOfBenefitVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitVersionnetworkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ExplanationOfBenefitVersionpatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitVersionpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__ExplanationOfBenefitVersionproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ExplanationOfBenefitVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ExplanationOfBenefitVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitVersiontotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type fhirext__ExplanationOfBenefitVersiontotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
};


export type fhirext__ExplanationOfBenefitVersiontypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__ExplanationOfBenefitVersion_Type = BaseObject & Object & Owned & Personal & fhir__ExplanationOfBenefit & fhir__FHIRResource & fhirext__ExplanationOfBenefitExtension & fhirext__ExplanationOfBenefitVersion & fhirext__ResourceVersion & {
  __typename: 'fhirext__ExplanationOfBenefitVersion_Type';
  amountOwed?: Maybe<Scalars['Decimal']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  billablePeriod?: Maybe<Scalars['JSON']['output']>;
  careTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  created?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  decision?: Maybe<fhir__CodeableConcept>;
  diagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  facility?: Maybe<fhir__Reference>;
  fairMarketValue?: Maybe<Array<FairMarketValueResponse>>;
  findings?: Maybe<Array<fhirext__Finding>>;
  hasUserVisibleFindings: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  network?: Maybe<fhir__CodeableConcept>;
  owner: User;
  patient?: Maybe<fhir__Reference>;
  person?: Maybe<Person>;
  provider?: Maybe<fhir__Reference>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__ExplanationOfBenefitStatus;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  totalsByType?: Maybe<fhirext__ExplanationOfBenefitTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
  use: fhir__ClaimUse;
};


export type fhirext__ExplanationOfBenefitVersion_TypeassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__ExplanationOfBenefitVersion_TypecareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type fhirext__ExplanationOfBenefitVersion_TypedecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitVersion_TypediagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type fhirext__ExplanationOfBenefitVersion_TypefacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitVersion_TypefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__ExplanationOfBenefitVersion_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__ExplanationOfBenefitVersion_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__ExplanationOfBenefitVersion_TypeitemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type fhirext__ExplanationOfBenefitVersion_TypelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitVersion_TypelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitVersion_TypenetworkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitVersion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ExplanationOfBenefitVersion_TypepatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitVersion_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__ExplanationOfBenefitVersion_TypeproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitVersion_TyperelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ExplanationOfBenefitVersion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ExplanationOfBenefitVersion_TypesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitVersion_TypetotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type fhirext__ExplanationOfBenefitVersion_TypetotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
};


export type fhirext__ExplanationOfBenefitVersion_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__FilterAccount = {
  and?: InputMaybe<Array<fhirext__FilterAccount>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  balance?: InputMaybe<fhir__NestedFilterAccountBalance>;
  billingStatus?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  calculatedAt?: InputMaybe<FilterString>;
  coverage?: InputMaybe<fhir__NestedFilterReference>;
  createdAt?: InputMaybe<FilterString>;
  currency?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  currentAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  guarantor?: InputMaybe<fhir__NestedFilterAccountGuarantor>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<fhirext__FilterAccount>;
  or?: InputMaybe<Array<fhirext__FilterAccount>>;
  owner?: InputMaybe<NestedFilterUser>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__AccountStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__FilterAccountVersion = {
  and?: InputMaybe<Array<fhirext__FilterAccountVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  balance?: InputMaybe<fhir__NestedFilterAccountBalance>;
  billingStatus?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  calculatedAt?: InputMaybe<FilterString>;
  coverage?: InputMaybe<fhir__NestedFilterReference>;
  createdAt?: InputMaybe<FilterString>;
  currency?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  currentAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  guarantor?: InputMaybe<fhir__NestedFilterAccountGuarantor>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<fhirext__FilterAccountVersion>;
  or?: InputMaybe<Array<fhirext__FilterAccountVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__AccountStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__FilterCoverage = {
  and?: InputMaybe<Array<fhirext__FilterCoverage>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  beneficiary?: InputMaybe<fhir__NestedFilterReference>;
  class?: InputMaybe<fhir__NestedFilterCoverageClass>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  groupId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isActive?: InputMaybe<FilterBoolean>;
  isLatest?: InputMaybe<FilterBoolean>;
  kind?: InputMaybe<Filterfhir__CoverageKind>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  memberId?: InputMaybe<FilterString>;
  network?: InputMaybe<FilterString>;
  not?: InputMaybe<fhirext__FilterCoverage>;
  or?: InputMaybe<Array<fhirext__FilterCoverage>>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  relationship?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__FinancialResourceStatus>;
  subscriber?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__FilterCoverageExtension = {
  and?: InputMaybe<Array<fhirext__FilterCoverageExtension>>;
  beneficiary?: InputMaybe<fhir__NestedFilterReference>;
  class?: InputMaybe<fhir__NestedFilterCoverageClass>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  groupId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  isActive?: InputMaybe<FilterBoolean>;
  kind?: InputMaybe<Filterfhir__CoverageKind>;
  memberId?: InputMaybe<FilterString>;
  network?: InputMaybe<FilterString>;
  not?: InputMaybe<fhirext__FilterCoverageExtension>;
  or?: InputMaybe<Array<fhirext__FilterCoverageExtension>>;
  owner?: InputMaybe<NestedFilterUser>;
  relationship?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  status?: InputMaybe<Filterfhir__FinancialResourceStatus>;
  subscriber?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__FilterCoverageVersion = {
  and?: InputMaybe<Array<fhirext__FilterCoverageVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  beneficiary?: InputMaybe<fhir__NestedFilterReference>;
  class?: InputMaybe<fhir__NestedFilterCoverageClass>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  groupId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isActive?: InputMaybe<FilterBoolean>;
  isLatest?: InputMaybe<FilterBoolean>;
  kind?: InputMaybe<Filterfhir__CoverageKind>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  memberId?: InputMaybe<FilterString>;
  network?: InputMaybe<FilterString>;
  not?: InputMaybe<fhirext__FilterCoverageVersion>;
  or?: InputMaybe<Array<fhirext__FilterCoverageVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  relationship?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__FinancialResourceStatus>;
  subscriber?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__FilterEncounter = {
  and?: InputMaybe<Array<fhirext__FilterEncounter>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  class?: InputMaybe<fhir__NestedFilterCoding>;
  clinicalNote?: InputMaybe<fhir__NestedFilterClinicalNote>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  diagnosis?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  encounterDate?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  location?: InputMaybe<fhir__NestedFilterLocation>;
  not?: InputMaybe<fhirext__FilterEncounter>;
  or?: InputMaybe<Array<fhirext__FilterEncounter>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<fhir__NestedFilterEncounterParticipant>;
  person?: InputMaybe<NestedFilterPerson>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceProvider?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCoding>;
};

export type fhirext__FilterEncounterVersion = {
  and?: InputMaybe<Array<fhirext__FilterEncounterVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  class?: InputMaybe<fhir__NestedFilterCoding>;
  clinicalNote?: InputMaybe<fhir__NestedFilterClinicalNote>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  diagnosis?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  encounterDate?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  location?: InputMaybe<fhir__NestedFilterLocation>;
  not?: InputMaybe<fhirext__FilterEncounterVersion>;
  or?: InputMaybe<Array<fhirext__FilterEncounterVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<fhir__NestedFilterEncounterParticipant>;
  person?: InputMaybe<NestedFilterPerson>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceProvider?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCoding>;
};

export type fhirext__FilterExplanationOfBenefit = {
  amountOwed?: InputMaybe<FilterDecimal>;
  and?: InputMaybe<Array<fhirext__FilterExplanationOfBenefit>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  careTeam?: InputMaybe<fhir__NestedFilterExplanationOfBenefitCareTeam>;
  created?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  diagnosis?: InputMaybe<fhir__NestedFilterExplanationOfBenefitDiagnosis>;
  facility?: InputMaybe<fhir__NestedFilterReference>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  hasUserVisibleFindings?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  item?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItem>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  network?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  not?: InputMaybe<fhirext__FilterExplanationOfBenefit>;
  or?: InputMaybe<Array<fhirext__FilterExplanationOfBenefit>>;
  owner?: InputMaybe<NestedFilterUser>;
  patient?: InputMaybe<fhir__NestedFilterReference>;
  person?: InputMaybe<NestedFilterPerson>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__ExplanationOfBenefitStatus>;
  summary?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  total?: InputMaybe<fhir__NestedFilterExplanationOfBenefitTotal>;
  totalsByType?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<Filterfhir__ClaimUse>;
};

export type fhirext__FilterExplanationOfBenefitExtension = {
  and?: InputMaybe<Array<fhirext__FilterExplanationOfBenefitExtension>>;
  careTeam?: InputMaybe<fhir__NestedFilterExplanationOfBenefitCareTeam>;
  created?: InputMaybe<FilterString>;
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  diagnosis?: InputMaybe<fhir__NestedFilterExplanationOfBenefitDiagnosis>;
  facility?: InputMaybe<fhir__NestedFilterReference>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  item?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItem>;
  network?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  not?: InputMaybe<fhirext__FilterExplanationOfBenefitExtension>;
  or?: InputMaybe<Array<fhirext__FilterExplanationOfBenefitExtension>>;
  owner?: InputMaybe<NestedFilterUser>;
  patient?: InputMaybe<fhir__NestedFilterReference>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
  serviceDate?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterfhir__ExplanationOfBenefitStatus>;
  summary?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  total?: InputMaybe<fhir__NestedFilterExplanationOfBenefitTotal>;
  totalsByType?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<Filterfhir__ClaimUse>;
};

export type fhirext__FilterExplanationOfBenefitTotalsByType = {
  and?: InputMaybe<Array<fhirext__FilterExplanationOfBenefitTotalsByType>>;
  benefit?: InputMaybe<fhir__NestedFilterMoney>;
  coinsurance?: InputMaybe<fhir__NestedFilterMoney>;
  copay?: InputMaybe<fhir__NestedFilterMoney>;
  deductible?: InputMaybe<fhir__NestedFilterMoney>;
  discount?: InputMaybe<fhir__NestedFilterMoney>;
  drugCost?: InputMaybe<fhir__NestedFilterMoney>;
  eligible?: InputMaybe<fhir__NestedFilterMoney>;
  id?: InputMaybe<FilterID>;
  memberLiability?: InputMaybe<fhir__NestedFilterMoney>;
  nonCovered?: InputMaybe<fhir__NestedFilterMoney>;
  not?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  or?: InputMaybe<Array<fhirext__FilterExplanationOfBenefitTotalsByType>>;
  owner?: InputMaybe<NestedFilterUser>;
  paidByPatient?: InputMaybe<fhir__NestedFilterMoney>;
  paidByPatientCash?: InputMaybe<fhir__NestedFilterMoney>;
  paidByPatientOther?: InputMaybe<fhir__NestedFilterMoney>;
  paidToPatient?: InputMaybe<fhir__NestedFilterMoney>;
  paidToProvider?: InputMaybe<fhir__NestedFilterMoney>;
  priorPayerPaid?: InputMaybe<fhir__NestedFilterMoney>;
  submitted?: InputMaybe<fhir__NestedFilterMoney>;
};

export type fhirext__FilterExplanationOfBenefitVersion = {
  amountOwed?: InputMaybe<FilterDecimal>;
  and?: InputMaybe<Array<fhirext__FilterExplanationOfBenefitVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  careTeam?: InputMaybe<fhir__NestedFilterExplanationOfBenefitCareTeam>;
  created?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  diagnosis?: InputMaybe<fhir__NestedFilterExplanationOfBenefitDiagnosis>;
  facility?: InputMaybe<fhir__NestedFilterReference>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  hasUserVisibleFindings?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  item?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItem>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  network?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  not?: InputMaybe<fhirext__FilterExplanationOfBenefitVersion>;
  or?: InputMaybe<Array<fhirext__FilterExplanationOfBenefitVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  patient?: InputMaybe<fhir__NestedFilterReference>;
  person?: InputMaybe<NestedFilterPerson>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__ExplanationOfBenefitStatus>;
  summary?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  total?: InputMaybe<fhir__NestedFilterExplanationOfBenefitTotal>;
  totalsByType?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<Filterfhir__ClaimUse>;
};

export type fhirext__FilterFinding = {
  and?: InputMaybe<Array<fhirext__FilterFinding>>;
  confidence?: InputMaybe<FilterDecimal>;
  createdAt?: InputMaybe<FilterString>;
  details?: InputMaybe<FilterJSON>;
  explanation?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  lastReviewStatus?: InputMaybe<Filterfhirext__ReviewStatus>;
  not?: InputMaybe<fhirext__FilterFinding>;
  note?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<fhirext__FilterFinding>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<FilterParticipant>;
  resource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  reviews?: InputMaybe<fhirext__NestedFilterFindingReview>;
  type?: InputMaybe<Filterfhirext__FindingType>;
  userDismissed?: InputMaybe<FilterBoolean>;
  userNotified?: InputMaybe<FilterBoolean>;
};

export type fhirext__FilterFindingReview = {
  and?: InputMaybe<Array<fhirext__FilterFindingReview>>;
  createdAt?: InputMaybe<FilterString>;
  finding?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhirext__FilterFindingReview>;
  note?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<fhirext__FilterFindingReview>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<FilterParticipant>;
  reviewer?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<Filterfhirext__ReviewStatus>;
};

export type fhirext__FilterInvoice = {
  account?: InputMaybe<fhir__NestedFilterReference>;
  amountOwed?: InputMaybe<FilterDecimal>;
  and?: InputMaybe<Array<fhirext__FilterInvoice>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  createdAt?: InputMaybe<FilterString>;
  creation?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  issuer?: InputMaybe<fhir__NestedFilterReference>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  lineItem?: InputMaybe<fhir__NestedFilterInvoiceLineItem>;
  not?: InputMaybe<fhirext__FilterInvoice>;
  note?: InputMaybe<fhir__NestedFilterAnnotation>;
  or?: InputMaybe<Array<fhirext__FilterInvoice>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<fhir__NestedFilterInvoiceParticipant>;
  paymentTerms?: InputMaybe<FilterString>;
  person?: InputMaybe<NestedFilterPerson>;
  recipient?: InputMaybe<fhir__NestedFilterReference>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__InvoiceStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  title?: InputMaybe<FilterString>;
  totalGross?: InputMaybe<fhir__NestedFilterMoney>;
  totalNet?: InputMaybe<fhir__NestedFilterMoney>;
  totalsByType?: InputMaybe<fhirext__NestedFilterInvoiceTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__FilterInvoiceTotalsByType = {
  and?: InputMaybe<Array<fhirext__FilterInvoiceTotalsByType>>;
  base?: InputMaybe<fhir__NestedFilterMoney>;
  deduction?: InputMaybe<fhir__NestedFilterMoney>;
  discount?: InputMaybe<fhir__NestedFilterMoney>;
  gross?: InputMaybe<fhir__NestedFilterMoney>;
  id?: InputMaybe<FilterID>;
  informational?: InputMaybe<fhir__NestedFilterMoney>;
  net?: InputMaybe<fhir__NestedFilterMoney>;
  not?: InputMaybe<fhirext__FilterInvoiceTotalsByType>;
  or?: InputMaybe<Array<fhirext__FilterInvoiceTotalsByType>>;
  owner?: InputMaybe<NestedFilterUser>;
  surcharge?: InputMaybe<fhir__NestedFilterMoney>;
  tax?: InputMaybe<fhir__NestedFilterMoney>;
};

export type fhirext__FilterInvoiceVersion = {
  account?: InputMaybe<fhir__NestedFilterReference>;
  amountOwed?: InputMaybe<FilterDecimal>;
  and?: InputMaybe<Array<fhirext__FilterInvoiceVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  createdAt?: InputMaybe<FilterString>;
  creation?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  issuer?: InputMaybe<fhir__NestedFilterReference>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  lineItem?: InputMaybe<fhir__NestedFilterInvoiceLineItem>;
  not?: InputMaybe<fhirext__FilterInvoiceVersion>;
  note?: InputMaybe<fhir__NestedFilterAnnotation>;
  or?: InputMaybe<Array<fhirext__FilterInvoiceVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<fhir__NestedFilterInvoiceParticipant>;
  paymentTerms?: InputMaybe<FilterString>;
  person?: InputMaybe<NestedFilterPerson>;
  recipient?: InputMaybe<fhir__NestedFilterReference>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__InvoiceStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  title?: InputMaybe<FilterString>;
  totalGross?: InputMaybe<fhir__NestedFilterMoney>;
  totalNet?: InputMaybe<fhir__NestedFilterMoney>;
  totalsByType?: InputMaybe<fhirext__NestedFilterInvoiceTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__FilterPatient = {
  and?: InputMaybe<Array<fhirext__FilterPatient>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  birthDate?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  name?: InputMaybe<fhir__NestedFilterHumanName>;
  not?: InputMaybe<fhirext__FilterPatient>;
  or?: InputMaybe<Array<fhirext__FilterPatient>>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
};

export type fhirext__FilterPatientVersion = {
  and?: InputMaybe<Array<fhirext__FilterPatientVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  birthDate?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  name?: InputMaybe<fhir__NestedFilterHumanName>;
  not?: InputMaybe<fhirext__FilterPatientVersion>;
  or?: InputMaybe<Array<fhirext__FilterPatientVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
};

export type fhirext__FilterPractitioner = {
  and?: InputMaybe<Array<fhirext__FilterPractitioner>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  name?: InputMaybe<fhir__NestedFilterHumanName>;
  not?: InputMaybe<fhirext__FilterPractitioner>;
  or?: InputMaybe<Array<fhirext__FilterPractitioner>>;
  owner?: InputMaybe<NestedFilterUser>;
  primaryEmail?: InputMaybe<FilterString>;
  primaryPhoneNumber?: InputMaybe<FilterString>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  telecom?: InputMaybe<fhir__NestedFilterContactPoint>;
};

export type fhirext__FilterPractitionerVersion = {
  and?: InputMaybe<Array<fhirext__FilterPractitionerVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  name?: InputMaybe<fhir__NestedFilterHumanName>;
  not?: InputMaybe<fhirext__FilterPractitionerVersion>;
  or?: InputMaybe<Array<fhirext__FilterPractitionerVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  primaryEmail?: InputMaybe<FilterString>;
  primaryPhoneNumber?: InputMaybe<FilterString>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  telecom?: InputMaybe<fhir__NestedFilterContactPoint>;
};

export type fhirext__FilterResourceAssociation = {
  and?: InputMaybe<Array<fhirext__FilterResourceAssociation>>;
  confidence?: InputMaybe<FilterDecimal>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhirext__FilterResourceAssociation>;
  or?: InputMaybe<Array<fhirext__FilterResourceAssociation>>;
  owner?: InputMaybe<NestedFilterUser>;
  source?: InputMaybe<FilterID>;
  sourceType?: InputMaybe<Filterfhirext__ResourceType>;
  target?: InputMaybe<FilterID>;
  targetType?: InputMaybe<Filterfhirext__ResourceType>;
  type?: InputMaybe<FilterString>;
};

export type fhirext__FilterResourceIdentifier = {
  and?: InputMaybe<Array<fhirext__FilterResourceIdentifier>>;
  hash?: InputMaybe<FilterString>;
  hashInput?: InputMaybe<FilterJSON>;
  hashVersion?: InputMaybe<FilterInt>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhirext__FilterResourceIdentifier>;
  or?: InputMaybe<Array<fhirext__FilterResourceIdentifier>>;
  owner?: InputMaybe<NestedFilterUser>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceOrganization?: InputMaybe<integration__NestedFilterOrganization>;
};

export type fhirext__FilterResourceVersion = {
  and?: InputMaybe<Array<fhirext__FilterResourceVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  not?: InputMaybe<fhirext__FilterResourceVersion>;
  or?: InputMaybe<Array<fhirext__FilterResourceVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
};

export type fhirext__Finding = {
  confidence?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['String']['output'];
  details?: Maybe<Scalars['JSON']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastReviewStatus?: Maybe<fhirext__ReviewStatus>;
  note?: Maybe<Scalars['String']['output']>;
  owner: User;
  participant: Participant;
  resource: fhirext__ResourceVersion;
  reviews?: Maybe<Array<fhirext__FindingReview>>;
  type: fhirext__FindingType;
  userDismissed: Scalars['Boolean']['output'];
  userNotified: Scalars['Boolean']['output'];
};


export type fhirext__FindingownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__FindingresourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__FindingreviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFindingReview>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFindingReview>;
};

export type fhirext__FindingReview = {
  createdAt: Scalars['String']['output'];
  finding: fhirext__Finding;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  owner: User;
  participant: Participant;
  reviewer?: Maybe<User>;
  status: fhirext__ReviewStatus;
};


export type fhirext__FindingReviewfindingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__FindingReviewownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__FindingReviewreviewerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhirext__FindingReview_Type = BaseObject & Object & Owned & fhirext__FindingReview & {
  __typename: 'fhirext__FindingReview_Type';
  createdAt: Scalars['String']['output'];
  finding: fhirext__Finding;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  owner: User;
  participant: Participant;
  reviewer?: Maybe<User>;
  status: fhirext__ReviewStatus;
};


export type fhirext__FindingReview_TypefindingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__FindingReview_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__FindingReview_TypereviewerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum fhirext__FindingType {
  CATEGORY_TOTALS_MISMATCH = 'CATEGORY_TOTALS_MISMATCH',
  DENIAL = 'DENIAL',
  EOB_HIGH_TOTAL_VALUE = 'EOB_HIGH_TOTAL_VALUE',
  EOB_TOTALS_INVALID = 'EOB_TOTALS_INVALID',
  EOB_TOTAL_MISMATCH = 'EOB_TOTAL_MISMATCH',
  HIGH_TOTAL = 'HIGH_TOTAL',
  LINE_ITEM_TOTALS_MISMATCH = 'LINE_ITEM_TOTALS_MISMATCH',
  OUT_OF_NETWORK = 'OUT_OF_NETWORK'
}

export type fhirext__Finding_Type = BaseObject & Object & Owned & fhirext__Finding & {
  __typename: 'fhirext__Finding_Type';
  confidence?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['String']['output'];
  details?: Maybe<Scalars['JSON']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastReviewStatus?: Maybe<fhirext__ReviewStatus>;
  note?: Maybe<Scalars['String']['output']>;
  owner: User;
  participant: Participant;
  resource: fhirext__ResourceVersion;
  reviews?: Maybe<Array<fhirext__FindingReview>>;
  type: fhirext__FindingType;
  userDismissed: Scalars['Boolean']['output'];
  userNotified: Scalars['Boolean']['output'];
};


export type fhirext__Finding_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__Finding_TyperesourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__Finding_TypereviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFindingReview>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFindingReview>;
};

export type fhirext__Invoice = {
  __typename: 'fhirext__Invoice';
  account?: Maybe<fhir__Reference>;
  amountOwed?: Maybe<Scalars['Decimal']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  createdAt: Scalars['String']['output'];
  creation?: Maybe<Scalars['String']['output']>;
  currentAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  issuer?: Maybe<fhir__Reference>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  lineItem?: Maybe<Array<fhir__InvoiceLineItem>>;
  note?: Maybe<Array<fhir__Annotation>>;
  owner: User;
  participant?: Maybe<Array<fhir__InvoiceParticipant>>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  periodPeriod?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  recipient?: Maybe<fhir__Reference>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__InvoiceStatus;
  subject?: Maybe<fhir__Reference>;
  title?: Maybe<Scalars['String']['output']>;
  totalGross?: Maybe<fhir__Money>;
  totalNet?: Maybe<fhir__Money>;
  totalsByType?: Maybe<fhirext__InvoiceTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__InvoiceaccountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__InvoicefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__InvoiceidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__InvoiceingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__InvoiceissuerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoicelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoicelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoicelineItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceLineItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceLineItem>;
};


export type fhirext__InvoicenoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAnnotation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAnnotation>;
};


export type fhirext__InvoiceownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__InvoiceparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceParticipant>;
};


export type fhirext__InvoicepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__InvoicerecipientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoicerelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__InvoicesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__InvoicesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoicesubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoicetotalGrossArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoicetotalNetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoicetotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceTotalsByType>;
};


export type fhirext__InvoicetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__InvoiceTotalsByType = {
  base?: Maybe<fhir__Money>;
  deduction?: Maybe<fhir__Money>;
  discount?: Maybe<fhir__Money>;
  gross?: Maybe<fhir__Money>;
  id: Scalars['ID']['output'];
  informational?: Maybe<fhir__Money>;
  net?: Maybe<fhir__Money>;
  owner: User;
  surcharge?: Maybe<fhir__Money>;
  tax?: Maybe<fhir__Money>;
};


export type fhirext__InvoiceTotalsByTypebaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByTypedeductionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByTypediscountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByTypegrossArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByTypeinformationalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByTypenetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByTypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__InvoiceTotalsByTypesurchargeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByTypetaxArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};

export type fhirext__InvoiceTotalsByType_Type = BaseObject & Object & Owned & fhirext__InvoiceTotalsByType & {
  __typename: 'fhirext__InvoiceTotalsByType_Type';
  base?: Maybe<fhir__Money>;
  deduction?: Maybe<fhir__Money>;
  discount?: Maybe<fhir__Money>;
  gross?: Maybe<fhir__Money>;
  id: Scalars['ID']['output'];
  informational?: Maybe<fhir__Money>;
  net?: Maybe<fhir__Money>;
  owner: User;
  surcharge?: Maybe<fhir__Money>;
  tax?: Maybe<fhir__Money>;
};


export type fhirext__InvoiceTotalsByType_TypebaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByType_TypedeductionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByType_TypediscountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByType_TypegrossArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByType_TypeinformationalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByType_TypenetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByType_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__InvoiceTotalsByType_TypesurchargeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByType_TypetaxArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};

export type fhirext__InvoiceVersion = {
  account?: Maybe<fhir__Reference>;
  amountOwed?: Maybe<Scalars['Decimal']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  createdAt: Scalars['String']['output'];
  creation?: Maybe<Scalars['String']['output']>;
  currentAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  issuer?: Maybe<fhir__Reference>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  lineItem?: Maybe<Array<fhir__InvoiceLineItem>>;
  note?: Maybe<Array<fhir__Annotation>>;
  owner: User;
  participant?: Maybe<Array<fhir__InvoiceParticipant>>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  periodPeriod?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  recipient?: Maybe<fhir__Reference>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__InvoiceStatus;
  subject?: Maybe<fhir__Reference>;
  title?: Maybe<Scalars['String']['output']>;
  totalGross?: Maybe<fhir__Money>;
  totalNet?: Maybe<fhir__Money>;
  totalsByType?: Maybe<fhirext__InvoiceTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__InvoiceVersionaccountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__InvoiceVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__InvoiceVersionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__InvoiceVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__InvoiceVersionissuerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoiceVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoiceVersionlineItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceLineItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceLineItem>;
};


export type fhirext__InvoiceVersionnoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAnnotation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAnnotation>;
};


export type fhirext__InvoiceVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__InvoiceVersionparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceParticipant>;
};


export type fhirext__InvoiceVersionpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__InvoiceVersionrecipientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__InvoiceVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__InvoiceVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoiceVersionsubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersiontotalGrossArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceVersiontotalNetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceVersiontotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceTotalsByType>;
};


export type fhirext__InvoiceVersiontypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__InvoiceVersion_Type = BaseObject & Object & Owned & Personal & fhir__FHIRResource & fhir__Invoice & fhirext__InvoiceVersion & fhirext__ResourceVersion & {
  __typename: 'fhirext__InvoiceVersion_Type';
  account?: Maybe<fhir__Reference>;
  amountOwed?: Maybe<Scalars['Decimal']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  createdAt: Scalars['String']['output'];
  creation?: Maybe<Scalars['String']['output']>;
  currentAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  issuer?: Maybe<fhir__Reference>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  lineItem?: Maybe<Array<fhir__InvoiceLineItem>>;
  note?: Maybe<Array<fhir__Annotation>>;
  owner: User;
  participant?: Maybe<Array<fhir__InvoiceParticipant>>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  periodPeriod?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  recipient?: Maybe<fhir__Reference>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__InvoiceStatus;
  subject?: Maybe<fhir__Reference>;
  title?: Maybe<Scalars['String']['output']>;
  totalGross?: Maybe<fhir__Money>;
  totalNet?: Maybe<fhir__Money>;
  totalsByType?: Maybe<fhirext__InvoiceTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__InvoiceVersion_TypeaccountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersion_TypeassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__InvoiceVersion_TypefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__InvoiceVersion_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__InvoiceVersion_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__InvoiceVersion_TypeissuerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersion_TypelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoiceVersion_TypelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoiceVersion_TypelineItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceLineItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceLineItem>;
};


export type fhirext__InvoiceVersion_TypenoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAnnotation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAnnotation>;
};


export type fhirext__InvoiceVersion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__InvoiceVersion_TypeparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceParticipant>;
};


export type fhirext__InvoiceVersion_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__InvoiceVersion_TyperecipientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersion_TyperelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__InvoiceVersion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__InvoiceVersion_TypesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoiceVersion_TypesubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersion_TypetotalGrossArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceVersion_TypetotalNetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceVersion_TypetotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceTotalsByType>;
};


export type fhirext__InvoiceVersion_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__NestedFilterAccountVersion = {
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  balance?: InputMaybe<fhir__NestedFilterAccountBalance>;
  billingStatus?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  calculatedAt?: InputMaybe<FilterString>;
  coverage?: InputMaybe<fhir__NestedFilterReference>;
  createdAt?: InputMaybe<FilterString>;
  currency?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  currentAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  guarantor?: InputMaybe<fhir__NestedFilterAccountGuarantor>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  name?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__AccountStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__NestedFilterCoverageVersion = {
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  beneficiary?: InputMaybe<fhir__NestedFilterReference>;
  class?: InputMaybe<fhir__NestedFilterCoverageClass>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  groupId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isActive?: InputMaybe<FilterBoolean>;
  isLatest?: InputMaybe<FilterBoolean>;
  kind?: InputMaybe<Filterfhir__CoverageKind>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  memberId?: InputMaybe<FilterString>;
  network?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  relationship?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__FinancialResourceStatus>;
  subscriber?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__NestedFilterExplanationOfBenefitTotalsByType = {
  benefit?: InputMaybe<fhir__NestedFilterMoney>;
  coinsurance?: InputMaybe<fhir__NestedFilterMoney>;
  copay?: InputMaybe<fhir__NestedFilterMoney>;
  deductible?: InputMaybe<fhir__NestedFilterMoney>;
  discount?: InputMaybe<fhir__NestedFilterMoney>;
  drugCost?: InputMaybe<fhir__NestedFilterMoney>;
  eligible?: InputMaybe<fhir__NestedFilterMoney>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  memberLiability?: InputMaybe<fhir__NestedFilterMoney>;
  nonCovered?: InputMaybe<fhir__NestedFilterMoney>;
  owner?: InputMaybe<NestedFilterUser>;
  paidByPatient?: InputMaybe<fhir__NestedFilterMoney>;
  paidByPatientCash?: InputMaybe<fhir__NestedFilterMoney>;
  paidByPatientOther?: InputMaybe<fhir__NestedFilterMoney>;
  paidToPatient?: InputMaybe<fhir__NestedFilterMoney>;
  paidToProvider?: InputMaybe<fhir__NestedFilterMoney>;
  priorPayerPaid?: InputMaybe<fhir__NestedFilterMoney>;
  submitted?: InputMaybe<fhir__NestedFilterMoney>;
};

export type fhirext__NestedFilterExplanationOfBenefitVersion = {
  amountOwed?: InputMaybe<FilterDecimal>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  careTeam?: InputMaybe<fhir__NestedFilterExplanationOfBenefitCareTeam>;
  created?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  diagnosis?: InputMaybe<fhir__NestedFilterExplanationOfBenefitDiagnosis>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  facility?: InputMaybe<fhir__NestedFilterReference>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  hasUserVisibleFindings?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  item?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItem>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  network?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  owner?: InputMaybe<NestedFilterUser>;
  patient?: InputMaybe<fhir__NestedFilterReference>;
  person?: InputMaybe<NestedFilterPerson>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__ExplanationOfBenefitStatus>;
  summary?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  total?: InputMaybe<fhir__NestedFilterExplanationOfBenefitTotal>;
  totalsByType?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<Filterfhir__ClaimUse>;
};

export type fhirext__NestedFilterFinding = {
  confidence?: InputMaybe<FilterDecimal>;
  createdAt?: InputMaybe<FilterString>;
  details?: InputMaybe<FilterJSON>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  explanation?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  lastReviewStatus?: InputMaybe<Filterfhirext__ReviewStatus>;
  note?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<FilterParticipant>;
  resource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  reviews?: InputMaybe<fhirext__NestedFilterFindingReview>;
  type?: InputMaybe<Filterfhirext__FindingType>;
  userDismissed?: InputMaybe<FilterBoolean>;
  userNotified?: InputMaybe<FilterBoolean>;
};

export type fhirext__NestedFilterFindingReview = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  finding?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  note?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<FilterParticipant>;
  reviewer?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<Filterfhirext__ReviewStatus>;
};

export type fhirext__NestedFilterInvoiceTotalsByType = {
  base?: InputMaybe<fhir__NestedFilterMoney>;
  deduction?: InputMaybe<fhir__NestedFilterMoney>;
  discount?: InputMaybe<fhir__NestedFilterMoney>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gross?: InputMaybe<fhir__NestedFilterMoney>;
  id?: InputMaybe<FilterID>;
  informational?: InputMaybe<fhir__NestedFilterMoney>;
  net?: InputMaybe<fhir__NestedFilterMoney>;
  owner?: InputMaybe<NestedFilterUser>;
  surcharge?: InputMaybe<fhir__NestedFilterMoney>;
  tax?: InputMaybe<fhir__NestedFilterMoney>;
};

export type fhirext__NestedFilterInvoiceVersion = {
  account?: InputMaybe<fhir__NestedFilterReference>;
  amountOwed?: InputMaybe<FilterDecimal>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  createdAt?: InputMaybe<FilterString>;
  creation?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  issuer?: InputMaybe<fhir__NestedFilterReference>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  lineItem?: InputMaybe<fhir__NestedFilterInvoiceLineItem>;
  note?: InputMaybe<fhir__NestedFilterAnnotation>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<fhir__NestedFilterInvoiceParticipant>;
  paymentTerms?: InputMaybe<FilterString>;
  person?: InputMaybe<NestedFilterPerson>;
  recipient?: InputMaybe<fhir__NestedFilterReference>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__InvoiceStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  title?: InputMaybe<FilterString>;
  totalGross?: InputMaybe<fhir__NestedFilterMoney>;
  totalNet?: InputMaybe<fhir__NestedFilterMoney>;
  totalsByType?: InputMaybe<fhirext__NestedFilterInvoiceTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__NestedFilterResourceVersion = {
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  owner?: InputMaybe<NestedFilterUser>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
};

export type fhirext__OrderAccount = {
  balance?: InputMaybe<fhir__OrderAccountBalance>;
  billingStatus?: InputMaybe<fhir__OrderCodeableConcept>;
  calculatedAt?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currency?: InputMaybe<fhir__OrderCodeableConcept>;
  currentAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  name?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__OrderAccountVersion = {
  balance?: InputMaybe<fhir__OrderAccountBalance>;
  billingStatus?: InputMaybe<fhir__OrderCodeableConcept>;
  calculatedAt?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currency?: InputMaybe<fhir__OrderCodeableConcept>;
  currentAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  name?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__OrderCoverage = {
  beneficiary?: InputMaybe<fhir__OrderReference>;
  coverageType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  groupId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isActive?: InputMaybe<Ordering>;
  isLatest?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  memberId?: InputMaybe<Ordering>;
  network?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  relationship?: InputMaybe<fhir__OrderCodeableConcept>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  subscriber?: InputMaybe<fhir__OrderReference>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__OrderCoverageExtension = {
  beneficiary?: InputMaybe<fhir__OrderReference>;
  coverageType?: InputMaybe<Ordering>;
  groupId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  memberId?: InputMaybe<Ordering>;
  network?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  relationship?: InputMaybe<fhir__OrderCodeableConcept>;
  status?: InputMaybe<Ordering>;
  subscriber?: InputMaybe<fhir__OrderReference>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__OrderCoverageVersion = {
  beneficiary?: InputMaybe<fhir__OrderReference>;
  coverageType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  groupId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isActive?: InputMaybe<Ordering>;
  isLatest?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  memberId?: InputMaybe<Ordering>;
  network?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  relationship?: InputMaybe<fhir__OrderCodeableConcept>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  subscriber?: InputMaybe<fhir__OrderReference>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__OrderEncounter = {
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  encounterDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceProvider?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  subject?: InputMaybe<fhir__OrderReference>;
};

export type fhirext__OrderEncounterVersion = {
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  encounterDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceProvider?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  subject?: InputMaybe<fhir__OrderReference>;
};

export type fhirext__OrderExplanationOfBenefit = {
  amountOwed?: InputMaybe<Ordering>;
  created?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  decision?: InputMaybe<fhir__OrderCodeableConcept>;
  facility?: InputMaybe<fhir__OrderReference>;
  hasUserVisibleFindings?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  network?: InputMaybe<fhir__OrderCodeableConcept>;
  owner?: InputMaybe<OrderUser>;
  patient?: InputMaybe<fhir__OrderReference>;
  person?: InputMaybe<OrderPerson>;
  provider?: InputMaybe<fhir__OrderReference>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceDate?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  totalsByType?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
  use?: InputMaybe<Ordering>;
};

export type fhirext__OrderExplanationOfBenefitExtension = {
  created?: InputMaybe<Ordering>;
  decision?: InputMaybe<fhir__OrderCodeableConcept>;
  facility?: InputMaybe<fhir__OrderReference>;
  id?: InputMaybe<Ordering>;
  network?: InputMaybe<fhir__OrderCodeableConcept>;
  owner?: InputMaybe<OrderUser>;
  patient?: InputMaybe<fhir__OrderReference>;
  provider?: InputMaybe<fhir__OrderReference>;
  serviceDate?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  totalsByType?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
  use?: InputMaybe<Ordering>;
};

export type fhirext__OrderExplanationOfBenefitTotalsByType = {
  benefit?: InputMaybe<fhir__OrderMoney>;
  coinsurance?: InputMaybe<fhir__OrderMoney>;
  copay?: InputMaybe<fhir__OrderMoney>;
  deductible?: InputMaybe<fhir__OrderMoney>;
  discount?: InputMaybe<fhir__OrderMoney>;
  drugCost?: InputMaybe<fhir__OrderMoney>;
  eligible?: InputMaybe<fhir__OrderMoney>;
  id?: InputMaybe<Ordering>;
  memberLiability?: InputMaybe<fhir__OrderMoney>;
  nonCovered?: InputMaybe<fhir__OrderMoney>;
  owner?: InputMaybe<OrderUser>;
  paidByPatient?: InputMaybe<fhir__OrderMoney>;
  paidByPatientCash?: InputMaybe<fhir__OrderMoney>;
  paidByPatientOther?: InputMaybe<fhir__OrderMoney>;
  paidToPatient?: InputMaybe<fhir__OrderMoney>;
  paidToProvider?: InputMaybe<fhir__OrderMoney>;
  priorPayerPaid?: InputMaybe<fhir__OrderMoney>;
  submitted?: InputMaybe<fhir__OrderMoney>;
};

export type fhirext__OrderExplanationOfBenefitVersion = {
  amountOwed?: InputMaybe<Ordering>;
  created?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  decision?: InputMaybe<fhir__OrderCodeableConcept>;
  facility?: InputMaybe<fhir__OrderReference>;
  hasUserVisibleFindings?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  network?: InputMaybe<fhir__OrderCodeableConcept>;
  owner?: InputMaybe<OrderUser>;
  patient?: InputMaybe<fhir__OrderReference>;
  person?: InputMaybe<OrderPerson>;
  provider?: InputMaybe<fhir__OrderReference>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceDate?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  totalsByType?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
  use?: InputMaybe<Ordering>;
};

export type fhirext__OrderFinding = {
  confidence?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  details?: InputMaybe<Ordering>;
  explanation?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  lastReviewStatus?: InputMaybe<Ordering>;
  note?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  participant?: InputMaybe<Ordering>;
  resource?: InputMaybe<fhirext__OrderResourceVersion>;
  type?: InputMaybe<Ordering>;
  userDismissed?: InputMaybe<Ordering>;
  userNotified?: InputMaybe<Ordering>;
};

export type fhirext__OrderFindingReview = {
  createdAt?: InputMaybe<Ordering>;
  finding?: InputMaybe<fhirext__OrderFinding>;
  id?: InputMaybe<Ordering>;
  note?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  participant?: InputMaybe<Ordering>;
  reviewer?: InputMaybe<OrderUser>;
  status?: InputMaybe<Ordering>;
};

export type fhirext__OrderInvoice = {
  account?: InputMaybe<fhir__OrderReference>;
  amountOwed?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  creation?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  issuer?: InputMaybe<fhir__OrderReference>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  paymentTerms?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
  recipient?: InputMaybe<fhir__OrderReference>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceDate?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  subject?: InputMaybe<fhir__OrderReference>;
  title?: InputMaybe<Ordering>;
  totalGross?: InputMaybe<fhir__OrderMoney>;
  totalNet?: InputMaybe<fhir__OrderMoney>;
  totalsByType?: InputMaybe<fhirext__OrderInvoiceTotalsByType>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__OrderInvoiceTotalsByType = {
  base?: InputMaybe<fhir__OrderMoney>;
  deduction?: InputMaybe<fhir__OrderMoney>;
  discount?: InputMaybe<fhir__OrderMoney>;
  gross?: InputMaybe<fhir__OrderMoney>;
  id?: InputMaybe<Ordering>;
  informational?: InputMaybe<fhir__OrderMoney>;
  net?: InputMaybe<fhir__OrderMoney>;
  owner?: InputMaybe<OrderUser>;
  surcharge?: InputMaybe<fhir__OrderMoney>;
  tax?: InputMaybe<fhir__OrderMoney>;
};

export type fhirext__OrderInvoiceVersion = {
  account?: InputMaybe<fhir__OrderReference>;
  amountOwed?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  creation?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  issuer?: InputMaybe<fhir__OrderReference>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  paymentTerms?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
  recipient?: InputMaybe<fhir__OrderReference>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceDate?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  subject?: InputMaybe<fhir__OrderReference>;
  title?: InputMaybe<Ordering>;
  totalGross?: InputMaybe<fhir__OrderMoney>;
  totalNet?: InputMaybe<fhir__OrderMoney>;
  totalsByType?: InputMaybe<fhirext__OrderInvoiceTotalsByType>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__OrderPatient = {
  birthDate?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
};

export type fhirext__OrderPatientVersion = {
  birthDate?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
};

export type fhirext__OrderPractitioner = {
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  primaryEmail?: InputMaybe<Ordering>;
  primaryPhoneNumber?: InputMaybe<Ordering>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
};

export type fhirext__OrderPractitionerVersion = {
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  primaryEmail?: InputMaybe<Ordering>;
  primaryPhoneNumber?: InputMaybe<Ordering>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
};

export type fhirext__OrderResourceAssociation = {
  confidence?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  source?: InputMaybe<Ordering>;
  sourceType?: InputMaybe<Ordering>;
  target?: InputMaybe<Ordering>;
  targetType?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
};

export type fhirext__OrderResourceIdentifier = {
  hash?: InputMaybe<Ordering>;
  hashInput?: InputMaybe<Ordering>;
  hashVersion?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceOrganization?: InputMaybe<integration__OrderOrganization>;
};

export type fhirext__OrderResourceVersion = {
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
};

export type fhirext__Patient = {
  __typename: 'fhirext__Patient';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  birthDate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
};


export type fhirext__PatientassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__PatientfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__PatientidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__PatientingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__PatientlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PatientlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PatientnameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhirext__PatientownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__PatientpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__PatientrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PatientsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PatientsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};

export type fhirext__PatientVersion = {
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  birthDate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
};


export type fhirext__PatientVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__PatientVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__PatientVersionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__PatientVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__PatientVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PatientVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PatientVersionnameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhirext__PatientVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__PatientVersionpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__PatientVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PatientVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PatientVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};

export type fhirext__PatientVersion_Type = BaseObject & Object & Owned & Personal & fhir__FHIRResource & fhir__Patient & fhirext__PatientVersion & fhirext__ResourceVersion & {
  __typename: 'fhirext__PatientVersion_Type';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  birthDate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
};


export type fhirext__PatientVersion_TypeassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__PatientVersion_TypefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__PatientVersion_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__PatientVersion_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__PatientVersion_TypelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PatientVersion_TypelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PatientVersion_TypenameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhirext__PatientVersion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__PatientVersion_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__PatientVersion_TyperelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PatientVersion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PatientVersion_TypesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};

export type fhirext__Practitioner = {
  __typename: 'fhirext__Practitioner';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  telecom?: Maybe<Array<fhir__ContactPoint>>;
};


export type fhirext__PractitionerassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__PractitionerfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__PractitioneridentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__PractitioneringestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__PractitionerlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionerlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionernameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhirext__PractitionerownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__PractitionerrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PractitionersourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PractitionersourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionertelecomArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderContactPoint>;
};

export type fhirext__PractitionerVersion = {
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  telecom?: Maybe<Array<fhir__ContactPoint>>;
};


export type fhirext__PractitionerVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__PractitionerVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__PractitionerVersionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__PractitionerVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__PractitionerVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionerVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionerVersionnameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhirext__PractitionerVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__PractitionerVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PractitionerVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PractitionerVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionerVersiontelecomArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderContactPoint>;
};

export type fhirext__PractitionerVersion_Type = BaseObject & Object & Owned & fhir__FHIRResource & fhir__Practitioner & fhirext__PractitionerVersion & fhirext__ResourceVersion & {
  __typename: 'fhirext__PractitionerVersion_Type';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  telecom?: Maybe<Array<fhir__ContactPoint>>;
};


export type fhirext__PractitionerVersion_TypeassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__PractitionerVersion_TypefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__PractitionerVersion_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__PractitionerVersion_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__PractitionerVersion_TypelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionerVersion_TypelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionerVersion_TypenameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhirext__PractitionerVersion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__PractitionerVersion_TyperelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PractitionerVersion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PractitionerVersion_TypesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionerVersion_TypetelecomArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderContactPoint>;
};

export type fhirext__ResourceAssociation = {
  confidence?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['String']['output'];
  evidences?: Maybe<Array<Scalars['JSON']['output']>>;
  id: Scalars['ID']['output'];
  owner: User;
  source: Scalars['ID']['output'];
  sourceType: fhirext__ResourceType;
  target: Scalars['ID']['output'];
  targetType: fhirext__ResourceType;
  type: Scalars['String']['output'];
};


export type fhirext__ResourceAssociationownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhirext__ResourceAssociation_Type = BaseObject & Object & Owned & fhirext__ResourceAssociation & {
  __typename: 'fhirext__ResourceAssociation_Type';
  confidence?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['String']['output'];
  evidences?: Maybe<Array<Scalars['JSON']['output']>>;
  id: Scalars['ID']['output'];
  owner: User;
  source: Scalars['ID']['output'];
  sourceType: fhirext__ResourceType;
  target: Scalars['ID']['output'];
  targetType: fhirext__ResourceType;
  type: Scalars['String']['output'];
};


export type fhirext__ResourceAssociation_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhirext__ResourceIdentifier = {
  hash: Scalars['String']['output'];
  hashInput: Scalars['JSON']['output'];
  hashVersion: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceOrganization?: Maybe<integration__Organization>;
};


export type fhirext__ResourceIdentifierownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ResourceIdentifiersourceOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export type fhirext__ResourceIdentifier_Type = BaseObject & Object & Owned & fhirext__ResourceIdentifier & {
  __typename: 'fhirext__ResourceIdentifier_Type';
  hash: Scalars['String']['output'];
  hashInput: Scalars['JSON']['output'];
  hashVersion: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceOrganization?: Maybe<integration__Organization>;
};


export type fhirext__ResourceIdentifier_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ResourceIdentifier_TypesourceOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export enum fhirext__ResourceType {
  ACCOUNT = 'ACCOUNT',
  COVERAGE = 'COVERAGE',
  ENCOUNTER = 'ENCOUNTER',
  EXPLANATION_OF_BENEFIT = 'EXPLANATION_OF_BENEFIT',
  INVOICE = 'INVOICE',
  PATIENT = 'PATIENT',
  PRACTITIONER = 'PRACTITIONER'
}

export type fhirext__ResourceVersion = {
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  owner: User;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
};


export type fhirext__ResourceVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__ResourceVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__ResourceVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__ResourceVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ResourceVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ResourceVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ResourceVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ResourceVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ResourceVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};

export enum fhirext__ReviewStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED'
}

export type flexpa__Endpoint = {
  displayName?: Maybe<Scalars['String']['output']>;
  externalIds: Array<Scalars['JSON']['output']>;
  flexpaId: Scalars['String']['output'];
  flexpaOrganization?: Maybe<flexpa__Organization>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  label?: Maybe<Array<Scalars['String']['output']>>;
  metadata: Array<Scalars['JSON']['output']>;
  mode: flexpa__EndpointMode;
  name: Scalars['String']['output'];
  organization?: Maybe<integration__Organization>;
  refreshable: Scalars['Boolean']['output'];
  resources?: Maybe<Array<Scalars['String']['output']>>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type flexpa__EndpointflexpaOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderOrganization>;
};


export type flexpa__EndpointorganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export enum flexpa__EndpointMode {
  LIVE = 'LIVE',
  TEST = 'TEST'
}

export type flexpa__Endpoint_Type = BaseObject & Object & flexpa__Endpoint & integration__BaseEndpoint & {
  __typename: 'flexpa__Endpoint_Type';
  displayName?: Maybe<Scalars['String']['output']>;
  externalIds: Array<Scalars['JSON']['output']>;
  flexpaId: Scalars['String']['output'];
  flexpaOrganization?: Maybe<flexpa__Organization>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  label?: Maybe<Array<Scalars['String']['output']>>;
  metadata: Array<Scalars['JSON']['output']>;
  mode: flexpa__EndpointMode;
  name: Scalars['String']['output'];
  organization?: Maybe<integration__Organization>;
  refreshable: Scalars['Boolean']['output'];
  resources?: Maybe<Array<Scalars['String']['output']>>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type flexpa__Endpoint_TypeflexpaOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderOrganization>;
};


export type flexpa__Endpoint_TypeorganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export type flexpa__FilterEndpoint = {
  and?: InputMaybe<Array<flexpa__FilterEndpoint>>;
  displayName?: InputMaybe<FilterString>;
  flexpaId?: InputMaybe<FilterString>;
  flexpaOrganization?: InputMaybe<flexpa__NestedFilterOrganization>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  mode?: InputMaybe<Filterflexpa__EndpointMode>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<flexpa__FilterEndpoint>;
  or?: InputMaybe<Array<flexpa__FilterEndpoint>>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  refreshable?: InputMaybe<FilterBoolean>;
  slug?: InputMaybe<FilterString>;
};

export type flexpa__FilterFlexpaImport = {
  and?: InputMaybe<Array<flexpa__FilterFlexpaImport>>;
  bundleDocument?: InputMaybe<document__NestedFilterDocument>;
  endedAt?: InputMaybe<FilterString>;
  flexpaLink?: InputMaybe<flexpa__NestedFilterLink>;
  id?: InputMaybe<FilterID>;
  ingestions?: InputMaybe<ingestion__NestedFilterIngestion>;
  not?: InputMaybe<flexpa__FilterFlexpaImport>;
  or?: InputMaybe<Array<flexpa__FilterFlexpaImport>>;
  owner?: InputMaybe<NestedFilterUser>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterflexpa__FlexpaImportStatus>;
  workflowId?: InputMaybe<FilterString>;
};

export type flexpa__FilterLink = {
  accessToken?: InputMaybe<FilterString>;
  active?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<flexpa__FilterLink>>;
  createdAt?: InputMaybe<FilterString>;
  deactivatedAt?: InputMaybe<FilterString>;
  deactivatedReason?: InputMaybe<Filterflexpa__LinkDeactivatedReason>;
  endpoint?: InputMaybe<flexpa__NestedFilterEndpoint>;
  id?: InputMaybe<FilterID>;
  imports?: InputMaybe<flexpa__NestedFilterFlexpaImport>;
  lastRefreshedAt?: InputMaybe<FilterString>;
  lastSyncedAt?: InputMaybe<FilterString>;
  not?: InputMaybe<flexpa__FilterLink>;
  or?: InputMaybe<Array<flexpa__FilterLink>>;
  owner?: InputMaybe<NestedFilterUser>;
  patientDOB?: InputMaybe<FilterString>;
  patientId?: InputMaybe<FilterString>;
  patientName?: InputMaybe<FilterString>;
  refreshError?: InputMaybe<FilterString>;
  refreshExpiresAt?: InputMaybe<FilterString>;
  refreshToken?: InputMaybe<FilterString>;
  tokenExpiresAt?: InputMaybe<FilterString>;
};

export type flexpa__FilterOrganization = {
  and?: InputMaybe<Array<flexpa__FilterOrganization>>;
  flexpaId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<flexpa__FilterOrganization>;
  note?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<flexpa__FilterOrganization>>;
  orgType?: InputMaybe<Filterflexpa__OrganizationType>;
};

export type flexpa__FlexpaImport = {
  bundleDocument?: Maybe<document__Document>;
  endedAt?: Maybe<Scalars['String']['output']>;
  flexpaLink: flexpa__Link;
  id: Scalars['ID']['output'];
  ingestions?: Maybe<Array<ingestion__Ingestion>>;
  owner: User;
  startedAt: Scalars['String']['output'];
  status: flexpa__FlexpaImportStatus;
  workflowId: Scalars['String']['output'];
};


export type flexpa__FlexpaImportbundleDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type flexpa__FlexpaImportflexpaLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderLink>;
};


export type flexpa__FlexpaImportingestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type flexpa__FlexpaImportownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum flexpa__FlexpaImportStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type flexpa__FlexpaImport_Type = BaseObject & Object & Owned & flexpa__FlexpaImport & {
  __typename: 'flexpa__FlexpaImport_Type';
  bundleDocument?: Maybe<document__Document>;
  endedAt?: Maybe<Scalars['String']['output']>;
  flexpaLink: flexpa__Link;
  id: Scalars['ID']['output'];
  ingestions?: Maybe<Array<ingestion__Ingestion>>;
  owner: User;
  startedAt: Scalars['String']['output'];
  status: flexpa__FlexpaImportStatus;
  workflowId: Scalars['String']['output'];
};


export type flexpa__FlexpaImport_TypebundleDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type flexpa__FlexpaImport_TypeflexpaLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderLink>;
};


export type flexpa__FlexpaImport_TypeingestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type flexpa__FlexpaImport_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type flexpa__Link = {
  accessToken: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  deactivatedReason?: Maybe<flexpa__LinkDeactivatedReason>;
  endpoint: flexpa__Endpoint;
  id: Scalars['ID']['output'];
  imports?: Maybe<Array<flexpa__FlexpaImport>>;
  lastRefreshedAt?: Maybe<Scalars['String']['output']>;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  owner: User;
  patientDOB?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  refreshError?: Maybe<Scalars['String']['output']>;
  refreshExpiresAt?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  tokenExpiresAt: Scalars['String']['output'];
};


export type flexpa__LinkendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderEndpoint>;
};


export type flexpa__LinkimportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterFlexpaImport>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderFlexpaImport>;
};


export type flexpa__LinkownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum flexpa__LinkDeactivatedReason {
  EXPIRED = 'EXPIRED',
  REFRESH_ERROR = 'REFRESH_ERROR',
  REVOKED = 'REVOKED'
}

export type flexpa__Link_Type = BaseObject & Object & Owned & flexpa__Link & integration__BaseLink & {
  __typename: 'flexpa__Link_Type';
  accessToken: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  deactivatedReason?: Maybe<flexpa__LinkDeactivatedReason>;
  endpoint: flexpa__Endpoint;
  id: Scalars['ID']['output'];
  imports?: Maybe<Array<flexpa__FlexpaImport>>;
  lastRefreshedAt?: Maybe<Scalars['String']['output']>;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  owner: User;
  patientDOB?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  refreshError?: Maybe<Scalars['String']['output']>;
  refreshExpiresAt?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  tokenExpiresAt: Scalars['String']['output'];
};


export type flexpa__Link_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderEndpoint>;
};


export type flexpa__Link_TypeimportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterFlexpaImport>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderFlexpaImport>;
};


export type flexpa__Link_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type flexpa__NestedFilterEndpoint = {
  displayName?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  flexpaId?: InputMaybe<FilterString>;
  flexpaOrganization?: InputMaybe<flexpa__NestedFilterOrganization>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  mode?: InputMaybe<Filterflexpa__EndpointMode>;
  name?: InputMaybe<FilterString>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  refreshable?: InputMaybe<FilterBoolean>;
  slug?: InputMaybe<FilterString>;
};

export type flexpa__NestedFilterFlexpaImport = {
  bundleDocument?: InputMaybe<document__NestedFilterDocument>;
  endedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  flexpaLink?: InputMaybe<flexpa__NestedFilterLink>;
  id?: InputMaybe<FilterID>;
  ingestions?: InputMaybe<ingestion__NestedFilterIngestion>;
  owner?: InputMaybe<NestedFilterUser>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterflexpa__FlexpaImportStatus>;
  workflowId?: InputMaybe<FilterString>;
};

export type flexpa__NestedFilterLink = {
  accessToken?: InputMaybe<FilterString>;
  active?: InputMaybe<FilterBoolean>;
  createdAt?: InputMaybe<FilterString>;
  deactivatedAt?: InputMaybe<FilterString>;
  deactivatedReason?: InputMaybe<Filterflexpa__LinkDeactivatedReason>;
  endpoint?: InputMaybe<flexpa__NestedFilterEndpoint>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  imports?: InputMaybe<flexpa__NestedFilterFlexpaImport>;
  lastRefreshedAt?: InputMaybe<FilterString>;
  lastSyncedAt?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  patientDOB?: InputMaybe<FilterString>;
  patientId?: InputMaybe<FilterString>;
  patientName?: InputMaybe<FilterString>;
  refreshError?: InputMaybe<FilterString>;
  refreshExpiresAt?: InputMaybe<FilterString>;
  refreshToken?: InputMaybe<FilterString>;
  tokenExpiresAt?: InputMaybe<FilterString>;
};

export type flexpa__NestedFilterOrganization = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  flexpaId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  name?: InputMaybe<FilterString>;
  note?: InputMaybe<FilterString>;
  orgType?: InputMaybe<Filterflexpa__OrganizationType>;
};

export type flexpa__OrderEndpoint = {
  displayName?: InputMaybe<Ordering>;
  flexpaId?: InputMaybe<Ordering>;
  flexpaOrganization?: InputMaybe<flexpa__OrderOrganization>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  mode?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  organization?: InputMaybe<integration__OrderOrganization>;
  refreshable?: InputMaybe<Ordering>;
  slug?: InputMaybe<Ordering>;
};

export type flexpa__OrderFlexpaImport = {
  bundleDocument?: InputMaybe<document__OrderDocument>;
  endedAt?: InputMaybe<Ordering>;
  flexpaLink?: InputMaybe<flexpa__OrderLink>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  workflowId?: InputMaybe<Ordering>;
};

export type flexpa__OrderLink = {
  accessToken?: InputMaybe<Ordering>;
  active?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  deactivatedAt?: InputMaybe<Ordering>;
  deactivatedReason?: InputMaybe<Ordering>;
  endpoint?: InputMaybe<flexpa__OrderEndpoint>;
  id?: InputMaybe<Ordering>;
  lastRefreshedAt?: InputMaybe<Ordering>;
  lastSyncedAt?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  patientDOB?: InputMaybe<Ordering>;
  patientId?: InputMaybe<Ordering>;
  patientName?: InputMaybe<Ordering>;
  refreshError?: InputMaybe<Ordering>;
  refreshExpiresAt?: InputMaybe<Ordering>;
  refreshToken?: InputMaybe<Ordering>;
  tokenExpiresAt?: InputMaybe<Ordering>;
};

export type flexpa__OrderOrganization = {
  flexpaId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  note?: InputMaybe<Ordering>;
  orgType?: InputMaybe<Ordering>;
};

export type flexpa__Organization = {
  flexpaId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  orgType?: Maybe<flexpa__OrganizationType>;
};

export enum flexpa__OrganizationType {
  PAYER = 'PAYER',
  PROVIDER = 'PROVIDER',
  VENDOR = 'VENDOR'
}

export type flexpa__Organization_Type = BaseObject & Object & flexpa__Organization & {
  __typename: 'flexpa__Organization_Type';
  flexpaId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  orgType?: Maybe<flexpa__OrganizationType>;
};

export enum geolocation__State {
  AK = 'AK',
  AL = 'AL',
  AR = 'AR',
  AZ = 'AZ',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DE = 'DE',
  FL = 'FL',
  GA = 'GA',
  HI = 'HI',
  IA = 'IA',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  MA = 'MA',
  MD = 'MD',
  ME = 'ME',
  MI = 'MI',
  MN = 'MN',
  MO = 'MO',
  MS = 'MS',
  MT = 'MT',
  NC = 'NC',
  ND = 'ND',
  NE = 'NE',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NV = 'NV',
  NY = 'NY',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VA = 'VA',
  VT = 'VT',
  WA = 'WA',
  WI = 'WI',
  WV = 'WV',
  WY = 'WY'
}

export type ingestion__Distillation = {
  determinedIngestable: Scalars['Boolean']['output'];
  endedAt?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  owner: User;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceWebAgentExecution?: Maybe<webAgent__WebAgentExecution>;
  startedAt: Scalars['String']['output'];
  status: ingestion__DistillationStatus;
  summary?: Maybe<Scalars['JSON']['output']>;
  temporalWorkflowId: Scalars['String']['output'];
};


export type ingestion__DistillationownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__DistillationsourceWebAgentExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export enum ingestion__DistillationStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type ingestion__Distillation_Type = BaseObject & Object & Owned & ingestion__Distillation & {
  __typename: 'ingestion__Distillation_Type';
  determinedIngestable: Scalars['Boolean']['output'];
  endedAt?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  owner: User;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceWebAgentExecution?: Maybe<webAgent__WebAgentExecution>;
  startedAt: Scalars['String']['output'];
  status: ingestion__DistillationStatus;
  summary?: Maybe<Scalars['JSON']['output']>;
  temporalWorkflowId: Scalars['String']['output'];
};


export type ingestion__Distillation_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__Distillation_TypesourceWebAgentExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type ingestion__Extract = {
  contentDate?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  dataType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingestion?: Maybe<ingestion__Ingestion>;
  meta?: Maybe<Scalars['JSON']['output']>;
  multiple: Scalars['Boolean']['output'];
  owner: User;
  source: document__Document;
  success: Scalars['Boolean']['output'];
  type: ingestion__ExtractionType;
};


export type ingestion__ExtractingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type ingestion__ExtractownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__ExtractsourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

export type ingestion__Extract_Type = BaseObject & Object & Owned & ingestion__Extract & {
  __typename: 'ingestion__Extract_Type';
  contentDate?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  dataType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingestion?: Maybe<ingestion__Ingestion>;
  meta?: Maybe<Scalars['JSON']['output']>;
  multiple: Scalars['Boolean']['output'];
  owner: User;
  source: document__Document;
  success: Scalars['Boolean']['output'];
  type: ingestion__ExtractionType;
};


export type ingestion__Extract_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type ingestion__Extract_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__Extract_TypesourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

export enum ingestion__ExtractionType {
  JSON = 'JSON',
  LLM_FHIR = 'LLM_FHIR'
}

export type ingestion__FilterDistillation = {
  and?: InputMaybe<Array<ingestion__FilterDistillation>>;
  determinedIngestable?: InputMaybe<FilterBoolean>;
  endedAt?: InputMaybe<FilterString>;
  error?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<ingestion__FilterDistillation>;
  or?: InputMaybe<Array<ingestion__FilterDistillation>>;
  owner?: InputMaybe<NestedFilterUser>;
  sourceName?: InputMaybe<FilterString>;
  sourceWebAgentExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filteringestion__DistillationStatus>;
  summary?: InputMaybe<FilterJSON>;
  temporalWorkflowId?: InputMaybe<FilterString>;
};

export type ingestion__FilterExtract = {
  and?: InputMaybe<Array<ingestion__FilterExtract>>;
  contentDate?: InputMaybe<FilterString>;
  data?: InputMaybe<FilterJSON>;
  dataType?: InputMaybe<FilterString>;
  error?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  meta?: InputMaybe<FilterJSON>;
  multiple?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<ingestion__FilterExtract>;
  or?: InputMaybe<Array<ingestion__FilterExtract>>;
  owner?: InputMaybe<NestedFilterUser>;
  source?: InputMaybe<document__NestedFilterDocument>;
  success?: InputMaybe<FilterBoolean>;
  type?: InputMaybe<Filteringestion__ExtractionType>;
};

export type ingestion__FilterIngestion = {
  and?: InputMaybe<Array<ingestion__FilterIngestion>>;
  endedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  initiatedBy?: InputMaybe<NestedFilterUser>;
  initiatorRole?: InputMaybe<FilterParticipant>;
  meta?: InputMaybe<FilterJSON>;
  not?: InputMaybe<ingestion__FilterIngestion>;
  or?: InputMaybe<Array<ingestion__FilterIngestion>>;
  owner?: InputMaybe<NestedFilterUser>;
  resolutionStatus?: InputMaybe<Filteringestion__ResolutionStatus>;
  resources?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  sourceCrawlObjective?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceFlexpaImport?: InputMaybe<flexpa__NestedFilterFlexpaImport>;
  sourceWebAgentExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filteringestion__IngestionStatus>;
  steps?: InputMaybe<ingestion__NestedFilterIngestionStep>;
  strategy?: InputMaybe<Filteringestion__IngestionStrategy>;
  workflowId?: InputMaybe<FilterString>;
};

export type ingestion__FilterIngestionStep = {
  and?: InputMaybe<Array<ingestion__FilterIngestionStep>>;
  error?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  not?: InputMaybe<ingestion__FilterIngestionStep>;
  or?: InputMaybe<Array<ingestion__FilterIngestionStep>>;
  owner?: InputMaybe<NestedFilterUser>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filteringestion__IngestionStatus>;
  type?: InputMaybe<Filteringestion__IngestionStepType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type ingestion__Ingestion = {
  endedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiatedBy?: Maybe<User>;
  initiatorRole?: Maybe<Participant>;
  meta?: Maybe<Scalars['JSON']['output']>;
  owner: User;
  resolutionStatus: ingestion__ResolutionStatus;
  resources?: Maybe<Array<fhirext__ResourceVersion>>;
  sourceCrawlObjective?: Maybe<webAgent__AiDiscoveryCrawlObjective>;
  sourceDocument?: Maybe<document__Document>;
  sourceFlexpaImport?: Maybe<flexpa__FlexpaImport>;
  sourceWebAgentExecution?: Maybe<webAgent__WebAgentExecution>;
  startedAt: Scalars['String']['output'];
  status: ingestion__IngestionStatus;
  steps?: Maybe<Array<ingestion__IngestionStep>>;
  strategy: ingestion__IngestionStrategy;
  workflowId: Scalars['String']['output'];
};


export type ingestion__IngestioninitiatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__IngestionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__IngestionresourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type ingestion__IngestionsourceCrawlObjectiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type ingestion__IngestionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type ingestion__IngestionsourceFlexpaImportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterFlexpaImport>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderFlexpaImport>;
};


export type ingestion__IngestionsourceWebAgentExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type ingestion__IngestionstepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestionStep>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestionStep>;
};

export enum ingestion__IngestionStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PARTIAL = 'PARTIAL'
}

export type ingestion__IngestionStep = {
  error?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  ingestion: ingestion__Ingestion;
  owner: User;
  startedAt: Scalars['String']['output'];
  status?: Maybe<ingestion__IngestionStatus>;
  type: ingestion__IngestionStepType;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type ingestion__IngestionStepingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type ingestion__IngestionStepownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum ingestion__IngestionStepType {
  ANALYZED = 'ANALYZED',
  ASSOCIATED = 'ASSOCIATED',
  BENEFITS_SUMMARIZED = 'BENEFITS_SUMMARIZED',
  CLASSIFIED = 'CLASSIFIED',
  DATA_QUALITY_ASSESSED = 'DATA_QUALITY_ASSESSED',
  ENRICHED = 'ENRICHED',
  EXTRACTED = 'EXTRACTED',
  INDEXED = 'INDEXED',
  PLANS_CREATED = 'PLANS_CREATED',
  PREPROCESSED = 'PREPROCESSED',
  RECONCILED = 'RECONCILED',
  TRANSFORMED = 'TRANSFORMED',
  UPLOADED = 'UPLOADED'
}

export type ingestion__IngestionStep_Type = BaseObject & Object & Owned & ingestion__IngestionStep & {
  __typename: 'ingestion__IngestionStep_Type';
  error?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  ingestion: ingestion__Ingestion;
  owner: User;
  startedAt: Scalars['String']['output'];
  status?: Maybe<ingestion__IngestionStatus>;
  type: ingestion__IngestionStepType;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type ingestion__IngestionStep_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type ingestion__IngestionStep_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum ingestion__IngestionStrategy {
  CLASSIC = 'CLASSIC',
  INDEX_ONLY = 'INDEX_ONLY',
  UNIVERSAL = 'UNIVERSAL'
}

export type ingestion__Ingestion_Type = BaseObject & Object & Owned & ingestion__Ingestion & {
  __typename: 'ingestion__Ingestion_Type';
  endedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiatedBy?: Maybe<User>;
  initiatorRole?: Maybe<Participant>;
  meta?: Maybe<Scalars['JSON']['output']>;
  owner: User;
  resolutionStatus: ingestion__ResolutionStatus;
  resources?: Maybe<Array<fhirext__ResourceVersion>>;
  sourceCrawlObjective?: Maybe<webAgent__AiDiscoveryCrawlObjective>;
  sourceDocument?: Maybe<document__Document>;
  sourceFlexpaImport?: Maybe<flexpa__FlexpaImport>;
  sourceWebAgentExecution?: Maybe<webAgent__WebAgentExecution>;
  startedAt: Scalars['String']['output'];
  status: ingestion__IngestionStatus;
  steps?: Maybe<Array<ingestion__IngestionStep>>;
  strategy: ingestion__IngestionStrategy;
  workflowId: Scalars['String']['output'];
};


export type ingestion__Ingestion_TypeinitiatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__Ingestion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__Ingestion_TyperesourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type ingestion__Ingestion_TypesourceCrawlObjectiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type ingestion__Ingestion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type ingestion__Ingestion_TypesourceFlexpaImportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterFlexpaImport>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderFlexpaImport>;
};


export type ingestion__Ingestion_TypesourceWebAgentExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type ingestion__Ingestion_TypestepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestionStep>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestionStep>;
};

export type ingestion__NestedFilterExtract = {
  contentDate?: InputMaybe<FilterString>;
  data?: InputMaybe<FilterJSON>;
  dataType?: InputMaybe<FilterString>;
  error?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  meta?: InputMaybe<FilterJSON>;
  multiple?: InputMaybe<FilterBoolean>;
  owner?: InputMaybe<NestedFilterUser>;
  source?: InputMaybe<document__NestedFilterDocument>;
  success?: InputMaybe<FilterBoolean>;
  type?: InputMaybe<Filteringestion__ExtractionType>;
};

export type ingestion__NestedFilterIngestion = {
  endedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  initiatedBy?: InputMaybe<NestedFilterUser>;
  initiatorRole?: InputMaybe<FilterParticipant>;
  meta?: InputMaybe<FilterJSON>;
  owner?: InputMaybe<NestedFilterUser>;
  resolutionStatus?: InputMaybe<Filteringestion__ResolutionStatus>;
  resources?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  sourceCrawlObjective?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceFlexpaImport?: InputMaybe<flexpa__NestedFilterFlexpaImport>;
  sourceWebAgentExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filteringestion__IngestionStatus>;
  steps?: InputMaybe<ingestion__NestedFilterIngestionStep>;
  strategy?: InputMaybe<Filteringestion__IngestionStrategy>;
  workflowId?: InputMaybe<FilterString>;
};

export type ingestion__NestedFilterIngestionStep = {
  error?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  owner?: InputMaybe<NestedFilterUser>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filteringestion__IngestionStatus>;
  type?: InputMaybe<Filteringestion__IngestionStepType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type ingestion__OrderDistillation = {
  determinedIngestable?: InputMaybe<Ordering>;
  endedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  sourceName?: InputMaybe<Ordering>;
  sourceWebAgentExecution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  temporalWorkflowId?: InputMaybe<Ordering>;
};

export type ingestion__OrderExtract = {
  contentDate?: InputMaybe<Ordering>;
  data?: InputMaybe<Ordering>;
  dataType?: InputMaybe<Ordering>;
  error?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  meta?: InputMaybe<Ordering>;
  multiple?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  source?: InputMaybe<document__OrderDocument>;
  success?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
};

export type ingestion__OrderIngestion = {
  endedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  initiatedBy?: InputMaybe<OrderUser>;
  initiatorRole?: InputMaybe<Ordering>;
  meta?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  resolutionStatus?: InputMaybe<Ordering>;
  sourceCrawlObjective?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  sourceFlexpaImport?: InputMaybe<flexpa__OrderFlexpaImport>;
  sourceWebAgentExecution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  strategy?: InputMaybe<Ordering>;
  workflowId?: InputMaybe<Ordering>;
};

export type ingestion__OrderIngestionStep = {
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  owner?: InputMaybe<OrderUser>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export enum ingestion__ResolutionStatus {
  NOT_RESOLVABLE = 'NOT_RESOLVABLE',
  RESOLVED = 'RESOLVED',
  UNKNOWN = 'UNKNOWN'
}

export type integration__BaseEndpoint = {
  displayName?: Maybe<Scalars['String']['output']>;
  externalIds: Array<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  metadata: Array<Scalars['JSON']['output']>;
  organization?: Maybe<integration__Organization>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type integration__BaseEndpointorganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export type integration__BaseLink = {
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
};


export type integration__BaseLinkownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type integration__FilterBaseEndpoint = {
  and?: InputMaybe<Array<integration__FilterBaseEndpoint>>;
  displayName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<integration__FilterBaseEndpoint>;
  or?: InputMaybe<Array<integration__FilterBaseEndpoint>>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  slug?: InputMaybe<FilterString>;
};

export type integration__FilterBaseLink = {
  active?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<integration__FilterBaseLink>>;
  createdAt?: InputMaybe<FilterString>;
  deactivatedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<integration__FilterBaseLink>;
  or?: InputMaybe<Array<integration__FilterBaseLink>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type integration__FilterOrganization = {
  and?: InputMaybe<Array<integration__FilterOrganization>>;
  displayName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<integration__FilterOrganization>;
  or?: InputMaybe<Array<integration__FilterOrganization>>;
  partOf?: InputMaybe<integration__NestedFilterOrganization>;
  slug?: InputMaybe<FilterString>;
};

export type integration__NestedFilterBaseEndpoint = {
  displayName?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  slug?: InputMaybe<FilterString>;
};

export type integration__NestedFilterBaseLink = {
  active?: InputMaybe<FilterBoolean>;
  createdAt?: InputMaybe<FilterString>;
  deactivatedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type integration__NestedFilterOrganization = {
  displayName?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  partOf?: InputMaybe<integration__NestedFilterOrganization>;
  slug?: InputMaybe<FilterString>;
};

export type integration__OrderBaseEndpoint = {
  displayName?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  organization?: InputMaybe<integration__OrderOrganization>;
  slug?: InputMaybe<Ordering>;
};

export type integration__OrderBaseLink = {
  active?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  deactivatedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type integration__OrderOrganization = {
  displayName?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  partOf?: InputMaybe<integration__OrderOrganization>;
  slug?: InputMaybe<Ordering>;
};

export type integration__Organization = {
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  partOf?: Maybe<integration__Organization>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type integration__OrganizationpartOfArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export type integration__Organization_Type = BaseObject & Object & Slugged & integration__Organization & {
  __typename: 'integration__Organization_Type';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  partOf?: Maybe<integration__Organization>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type integration__Organization_TypepartOfArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

/** Alternative payment strategies the user can opt into when their discount threshold is high. */
export enum issue__AlternativePaymentOption {
  INCOME_BASED_ADJUSTMENT = 'INCOME_BASED_ADJUSTMENT',
  MONTHLY_PAYMENT_PLAN = 'MONTHLY_PAYMENT_PLAN',
  WAIT_AND_SAVE = 'WAIT_AND_SAVE'
}

export type issue__BenefitsContext = {
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  selectedAt?: Maybe<Scalars['String']['output']>;
  selectedPlan?: Maybe<plan__Plan>;
};


export type issue__BenefitsContextissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BenefitsContextselectedPlanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};

export type issue__BenefitsContext_Type = BaseObject & Object & issue__BenefitsContext & {
  __typename: 'issue__BenefitsContext_Type';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  selectedAt?: Maybe<Scalars['String']['output']>;
  selectedPlan?: Maybe<plan__Plan>;
};


export type issue__BenefitsContext_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BenefitsContext_TypeselectedPlanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};

export type issue__BenefitsSummaryGeneratedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  plan: plan__Plan;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BenefitsSummaryGeneratedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BenefitsSummaryGeneratedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BenefitsSummaryGeneratedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BenefitsSummaryGeneratedEventplanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type issue__BenefitsSummaryGeneratedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BenefitsSummaryGeneratedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BenefitsSummaryGeneratedEvent_Type = BaseObject & Object & issue__BenefitsSummaryGeneratedEvent & issue__Event & {
  __typename: 'issue__BenefitsSummaryGeneratedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  plan: plan__Plan;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BenefitsSummaryGeneratedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BenefitsSummaryGeneratedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BenefitsSummaryGeneratedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BenefitsSummaryGeneratedEvent_TypeplanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type issue__BenefitsSummaryGeneratedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BenefitsSummaryGeneratedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BillDisputeEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eob?: Maybe<Array<fhirext__ExplanationOfBenefitVersion>>;
  eobId?: Maybe<Scalars['ID']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  healthRecordKey?: Maybe<Scalars['String']['output']>;
  healthRecordKind?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Array<fhirext__InvoiceVersion>>;
  invoiceId?: Maybe<Scalars['ID']['output']>;
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BillDisputeEventeobArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitVersion>;
};


export type issue__BillDisputeEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BillDisputeEventinvoiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceVersion>;
};


export type issue__BillDisputeEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillDisputeEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BillDisputeEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BillDisputeEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BillDisputeEvent_Type = BaseObject & Object & issue__BillDisputeEvent & issue__Event & {
  __typename: 'issue__BillDisputeEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eob?: Maybe<Array<fhirext__ExplanationOfBenefitVersion>>;
  eobId?: Maybe<Scalars['ID']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  healthRecordKey?: Maybe<Scalars['String']['output']>;
  healthRecordKind?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Array<fhirext__InvoiceVersion>>;
  invoiceId?: Maybe<Scalars['ID']['output']>;
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BillDisputeEvent_TypeeobArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitVersion>;
};


export type issue__BillDisputeEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BillDisputeEvent_TypeinvoiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceVersion>;
};


export type issue__BillDisputeEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillDisputeEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BillDisputeEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BillDisputeEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BillPayPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__BillPayRequestedEvent;
};


export type issue__BillPayPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillPayPostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPayRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPayRequestedEvent>;
};

export type issue__BillPayPostEscalationAction_Type = BaseObject & Object & issue__BillPayPostEscalationAction & issue__PostEscalationAction & {
  __typename: 'issue__BillPayPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__BillPayRequestedEvent;
};


export type issue__BillPayPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillPayPostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPayRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPayRequestedEvent>;
};

/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent = {
  acceptedAt?: Maybe<Scalars['String']['output']>;
  actionRequired: Scalars['Boolean']['output'];
  availableAlternativePaymentOptions: Array<issue__AlternativePaymentOption>;
  availableMinimumDiscountOptions: Array<Scalars['Int']['output']>;
  availableSuccessFeeOptions: Array<Scalars['Int']['output']>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  declinedAt?: Maybe<Scalars['String']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  preAuthTransaction?: Maybe<payment__PaymentTransaction>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEventpreAuthTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent_Type = BaseObject & Object & issue__BillPayRequestedEvent & issue__Event & {
  __typename: 'issue__BillPayRequestedEvent_Type';
  acceptedAt?: Maybe<Scalars['String']['output']>;
  actionRequired: Scalars['Boolean']['output'];
  availableAlternativePaymentOptions: Array<issue__AlternativePaymentOption>;
  availableMinimumDiscountOptions: Array<Scalars['Int']['output']>;
  availableSuccessFeeOptions: Array<Scalars['Int']['output']>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  declinedAt?: Maybe<Scalars['String']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  preAuthTransaction?: Maybe<payment__PaymentTransaction>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent_TypepreAuthTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chargeTransaction: payment__PaymentTransaction;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  negotiatedBillAmount: Scalars['Decimal']['output'];
  originalBillAmount: Scalars['Decimal']['output'];
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  successFeeAmount: Scalars['Decimal']['output'];
  successFeePercent: Scalars['Int']['output'];
  totalCharged: Scalars['Decimal']['output'];
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEventchargeTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent_Type = BaseObject & Object & issue__BillPaySuccessEvent & issue__Event & {
  __typename: 'issue__BillPaySuccessEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chargeTransaction: payment__PaymentTransaction;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  negotiatedBillAmount: Scalars['Decimal']['output'];
  originalBillAmount: Scalars['Decimal']['output'];
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  successFeeAmount: Scalars['Decimal']['output'];
  successFeePercent: Scalars['Int']['output'];
  totalCharged: Scalars['Decimal']['output'];
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent_TypechargeTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BillPaymentRequestedEvent = {
  acceptedAt?: Maybe<Scalars['String']['output']>;
  actionRequired: Scalars['Boolean']['output'];
  billAmount?: Maybe<Scalars['Decimal']['output']>;
  billPaid: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BillPaymentRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BillPaymentRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillPaymentRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BillPaymentRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BillPaymentRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BillPaymentRequestedEvent_Type = BaseObject & Object & issue__BillPaymentRequestedEvent & issue__Event & {
  __typename: 'issue__BillPaymentRequestedEvent_Type';
  acceptedAt?: Maybe<Scalars['String']['output']>;
  actionRequired: Scalars['Boolean']['output'];
  billAmount?: Maybe<Scalars['Decimal']['output']>;
  billPaid: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BillPaymentRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BillPaymentRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillPaymentRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BillPaymentRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BillPaymentRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BillPaymentSuccessEvent = {
  actionRequired: Scalars['Boolean']['output'];
  billAmount: Scalars['Decimal']['output'];
  billPaymentRequest: issue__BillPaymentRequestedEvent;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  stripePaymentIntentId: Scalars['String']['output'];
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BillPaymentSuccessEventbillPaymentRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPaymentRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPaymentRequestedEvent>;
};


export type issue__BillPaymentSuccessEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BillPaymentSuccessEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillPaymentSuccessEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BillPaymentSuccessEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BillPaymentSuccessEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BillPaymentSuccessEvent_Type = BaseObject & Object & issue__BillPaymentSuccessEvent & issue__Event & {
  __typename: 'issue__BillPaymentSuccessEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  billAmount: Scalars['Decimal']['output'];
  billPaymentRequest: issue__BillPaymentRequestedEvent;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  stripePaymentIntentId: Scalars['String']['output'];
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BillPaymentSuccessEvent_TypebillPaymentRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPaymentRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPaymentRequestedEvent>;
};


export type issue__BillPaymentSuccessEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BillPaymentSuccessEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillPaymentSuccessEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BillPaymentSuccessEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BillPaymentSuccessEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ChatEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chatBody: Scalars['String']['output'];
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ChatEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ChatEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ChatEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ChatEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ChatEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ChatEvent_Type = BaseObject & Object & issue__ChatEvent & issue__Event & {
  __typename: 'issue__ChatEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chatBody: Scalars['String']['output'];
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ChatEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ChatEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ChatEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ChatEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ChatEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ClosedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  feedback?: Maybe<feedback__IssueFeedback>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ClosedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ClosedEventfeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueFeedback>;
};


export type issue__ClosedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ClosedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ClosedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ClosedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ClosedEvent_Type = BaseObject & Object & issue__ClosedEvent & issue__Event & {
  __typename: 'issue__ClosedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  feedback?: Maybe<feedback__IssueFeedback>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ClosedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ClosedEvent_TypefeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueFeedback>;
};


export type issue__ClosedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ClosedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ClosedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ClosedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ClosurePaymentRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chargeDate?: Maybe<Scalars['String']['output']>;
  chargeDelayDays?: Maybe<Scalars['Int']['output']>;
  dollarAmountSaved?: Maybe<Scalars['Decimal']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  successFee?: Maybe<Scalars['Decimal']['output']>;
  totalBillDollarAmount?: Maybe<Scalars['Decimal']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ClosurePaymentRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ClosurePaymentRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ClosurePaymentRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ClosurePaymentRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ClosurePaymentRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ClosurePaymentRequestedEvent_Type = BaseObject & Object & issue__ClosurePaymentRequestedEvent & issue__Event & {
  __typename: 'issue__ClosurePaymentRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chargeDate?: Maybe<Scalars['String']['output']>;
  chargeDelayDays?: Maybe<Scalars['Int']['output']>;
  dollarAmountSaved?: Maybe<Scalars['Decimal']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  successFee?: Maybe<Scalars['Decimal']['output']>;
  totalBillDollarAmount?: Maybe<Scalars['Decimal']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ClosurePaymentRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ClosurePaymentRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ClosurePaymentRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ClosurePaymentRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ClosurePaymentRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__CommentEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  comment: Scalars['String']['output'];
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  pinned: Scalars['Boolean']['output'];
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__CommentEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__CommentEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__CommentEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__CommentEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__CommentEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__CommentEvent_Type = BaseObject & Object & issue__CommentEvent & issue__Event & {
  __typename: 'issue__CommentEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  comment: Scalars['String']['output'];
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  pinned: Scalars['Boolean']['output'];
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__CommentEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__CommentEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__CommentEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__CommentEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__CommentEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ConnectAccountRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  buttonText: Scalars['String']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chatBody?: Maybe<Scalars['String']['output']>;
  endpointType: webAgent__EndpointType;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  showSkipButton?: Maybe<Scalars['Boolean']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ConnectAccountRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ConnectAccountRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectAccountRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ConnectAccountRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ConnectAccountRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ConnectAccountRequestedEvent_Type = BaseObject & Object & issue__ConnectAccountRequestedEvent & issue__Event & {
  __typename: 'issue__ConnectAccountRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  buttonText: Scalars['String']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chatBody?: Maybe<Scalars['String']['output']>;
  endpointType: webAgent__EndpointType;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  showSkipButton?: Maybe<Scalars['Boolean']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ConnectAccountRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ConnectAccountRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectAccountRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ConnectAccountRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ConnectAccountRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ConnectEhrPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__ConnectAccountRequestedEvent;
};


export type issue__ConnectEhrPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectEhrPostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectAccountRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectAccountRequestedEvent>;
};

export type issue__ConnectEhrPostEscalationAction_Type = BaseObject & Object & issue__ConnectEhrPostEscalationAction & issue__PostEscalationAction & {
  __typename: 'issue__ConnectEhrPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__ConnectAccountRequestedEvent;
};


export type issue__ConnectEhrPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectEhrPostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectAccountRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectAccountRequestedEvent>;
};

export type issue__ConnectInsurancePostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__ConnectAccountRequestedEvent;
};


export type issue__ConnectInsurancePostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectInsurancePostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectAccountRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectAccountRequestedEvent>;
};

export type issue__ConnectInsurancePostEscalationAction_Type = BaseObject & Object & issue__ConnectInsurancePostEscalationAction & issue__PostEscalationAction & {
  __typename: 'issue__ConnectInsurancePostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__ConnectAccountRequestedEvent;
};


export type issue__ConnectInsurancePostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectInsurancePostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectAccountRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectAccountRequestedEvent>;
};

export type issue__ConnectInsuranceRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  insuranceLinkMessage?: Maybe<Scalars['String']['output']>;
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ConnectInsuranceRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ConnectInsuranceRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectInsuranceRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ConnectInsuranceRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ConnectInsuranceRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ConnectInsuranceRequestedEvent_Type = BaseObject & Object & issue__ConnectInsuranceRequestedEvent & issue__Event & {
  __typename: 'issue__ConnectInsuranceRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  insuranceLinkMessage?: Maybe<Scalars['String']['output']>;
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ConnectInsuranceRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ConnectInsuranceRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectInsuranceRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ConnectInsuranceRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ConnectInsuranceRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__DocumentAnalysisEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  document: document__Document;
  errorIsRetriable?: Maybe<Scalars['Boolean']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  status: issue__DocumentAnalysisStatus;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__DocumentAnalysisEventdocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__DocumentAnalysisEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__DocumentAnalysisEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__DocumentAnalysisEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__DocumentAnalysisEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__DocumentAnalysisEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__DocumentAnalysisEvent_Type = BaseObject & Object & issue__DocumentAnalysisEvent & issue__Event & {
  __typename: 'issue__DocumentAnalysisEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  document: document__Document;
  errorIsRetriable?: Maybe<Scalars['Boolean']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  status: issue__DocumentAnalysisStatus;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__DocumentAnalysisEvent_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__DocumentAnalysisEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__DocumentAnalysisEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__DocumentAnalysisEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__DocumentAnalysisEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__DocumentAnalysisEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export enum issue__DocumentAnalysisStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_ANALYZABLE = 'NOT_ANALYZABLE',
  PENDING = 'PENDING'
}

export type issue__DocumentClassificationFailedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  document: document__Document;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__DocumentClassificationFailedEventdocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__DocumentClassificationFailedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__DocumentClassificationFailedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__DocumentClassificationFailedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__DocumentClassificationFailedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__DocumentClassificationFailedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__DocumentClassificationFailedEvent_Type = BaseObject & Object & issue__DocumentClassificationFailedEvent & issue__Event & {
  __typename: 'issue__DocumentClassificationFailedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  document: document__Document;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__DocumentClassificationFailedEvent_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__DocumentClassificationFailedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__DocumentClassificationFailedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__DocumentClassificationFailedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__DocumentClassificationFailedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__DocumentClassificationFailedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__DocumentUploadedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  document: document__Document;
  documentLabel?: Maybe<Scalars['String']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__DocumentUploadedEventdocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__DocumentUploadedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__DocumentUploadedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__DocumentUploadedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__DocumentUploadedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__DocumentUploadedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__DocumentUploadedEvent_Type = BaseObject & Object & issue__DocumentUploadedEvent & issue__Event & {
  __typename: 'issue__DocumentUploadedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  document: document__Document;
  documentLabel?: Maybe<Scalars['String']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  uploadFailed?: Maybe<Scalars['Boolean']['output']>;
  uploading?: Maybe<Scalars['Boolean']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__DocumentUploadedEvent_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__DocumentUploadedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__DocumentUploadedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__DocumentUploadedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__DocumentUploadedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__DocumentUploadedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__Event = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__EventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__EventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__EventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__EventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__EventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export enum issue__EventType {
  BENEFITS_SUMMARY_GENERATED = 'BENEFITS_SUMMARY_GENERATED',
  BILL_DISPUTE = 'BILL_DISPUTE',
  BILL_PAYMENT_REQUESTED = 'BILL_PAYMENT_REQUESTED',
  BILL_PAYMENT_SUCCESS = 'BILL_PAYMENT_SUCCESS',
  BILL_PAY_REQUESTED = 'BILL_PAY_REQUESTED',
  BILL_PAY_SUCCESS = 'BILL_PAY_SUCCESS',
  CHAT = 'CHAT',
  CLOSED = 'CLOSED',
  CLOSURE_PAYMENT_REQUESTED = 'CLOSURE_PAYMENT_REQUESTED',
  COMMENT = 'COMMENT',
  CONNECT_ACCOUNT_REQUESTED = 'CONNECT_ACCOUNT_REQUESTED',
  CONNECT_INSURANCE_REQUESTED = 'CONNECT_INSURANCE_REQUESTED',
  DOCUMENT_ANALYSIS = 'DOCUMENT_ANALYSIS',
  DOCUMENT_ANALYSIS_COMPLETE = 'DOCUMENT_ANALYSIS_COMPLETE',
  DOCUMENT_ANALYSIS_SELECT_VISIT = 'DOCUMENT_ANALYSIS_SELECT_VISIT',
  DOCUMENT_ANALYSIS_STARTED = 'DOCUMENT_ANALYSIS_STARTED',
  DOCUMENT_CLASSIFICATION_FAILED = 'DOCUMENT_CLASSIFICATION_FAILED',
  DOCUMENT_UPLOADED = 'DOCUMENT_UPLOADED',
  HA_ASSIGNED = 'HA_ASSIGNED',
  HIPAA_RELEASE_REQUESTED = 'HIPAA_RELEASE_REQUESTED',
  INTERNAL_DOCUMENT_UPLOADED = 'INTERNAL_DOCUMENT_UPLOADED',
  PAYMENT_AGREEMENT_REQUESTED = 'PAYMENT_AGREEMENT_REQUESTED',
  PAYMENT_CHARGE_FAILED = 'PAYMENT_CHARGE_FAILED',
  PLAN_SELECTION = 'PLAN_SELECTION',
  POST_ESCALATION_ACTIONS = 'POST_ESCALATION_ACTIONS',
  REOPENED = 'REOPENED',
  TEMPLATE_RELEASE_REQUESTED = 'TEMPLATE_RELEASE_REQUESTED',
  TOOL_EXECUTION = 'TOOL_EXECUTION',
  USER_MULTI_SELECTION_REQUESTED = 'USER_MULTI_SELECTION_REQUESTED',
  USER_SELECTION_REQUESTED = 'USER_SELECTION_REQUESTED'
}

export type issue__FilterBenefitsContext = {
  and?: InputMaybe<Array<issue__FilterBenefitsContext>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<issue__FilterBenefitsContext>;
  or?: InputMaybe<Array<issue__FilterBenefitsContext>>;
  selectedAt?: InputMaybe<FilterString>;
  selectedPlan?: InputMaybe<plan__NestedFilterPlan>;
};

export type issue__FilterBenefitsSummaryGeneratedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterBenefitsSummaryGeneratedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterBenefitsSummaryGeneratedEvent>;
  or?: InputMaybe<Array<issue__FilterBenefitsSummaryGeneratedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  plan?: InputMaybe<plan__NestedFilterPlan>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterBillDisputeEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterBillDisputeEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eob?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitVersion>;
  eobId?: InputMaybe<FilterID>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  healthRecordKey?: InputMaybe<FilterString>;
  healthRecordKind?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  invoice?: InputMaybe<fhirext__NestedFilterInvoiceVersion>;
  invoiceId?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterBillDisputeEvent>;
  or?: InputMaybe<Array<issue__FilterBillDisputeEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterBillPayPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterBillPayPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterBillPayRequestedEvent>;
  not?: InputMaybe<issue__FilterBillPayPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterBillPayPostEscalationAction>>;
};

export type issue__FilterBillPayRequestedEvent = {
  acceptedAt?: InputMaybe<FilterString>;
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterBillPayRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  declinedAt?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterBillPayRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterBillPayRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  preAuthTransaction?: InputMaybe<payment__NestedFilterPaymentTransaction>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterBillPaySuccessEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterBillPaySuccessEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  chargeTransaction?: InputMaybe<payment__NestedFilterPaymentTransaction>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  negotiatedBillAmount?: InputMaybe<FilterDecimal>;
  not?: InputMaybe<issue__FilterBillPaySuccessEvent>;
  or?: InputMaybe<Array<issue__FilterBillPaySuccessEvent>>;
  originalBillAmount?: InputMaybe<FilterDecimal>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  successFeeAmount?: InputMaybe<FilterDecimal>;
  successFeePercent?: InputMaybe<FilterInt>;
  totalCharged?: InputMaybe<FilterDecimal>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterBillPaymentRequestedEvent = {
  acceptedAt?: InputMaybe<FilterString>;
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterBillPaymentRequestedEvent>>;
  billAmount?: InputMaybe<FilterDecimal>;
  billPaid?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterBillPaymentRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterBillPaymentRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterBillPaymentSuccessEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterBillPaymentSuccessEvent>>;
  billAmount?: InputMaybe<FilterDecimal>;
  billPaymentRequest?: InputMaybe<issue__NestedFilterBillPaymentRequestedEvent>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterBillPaymentSuccessEvent>;
  or?: InputMaybe<Array<issue__FilterBillPaymentSuccessEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  stripePaymentIntentId?: InputMaybe<FilterString>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterChatEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterChatEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  chatBody?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterChatEvent>;
  or?: InputMaybe<Array<issue__FilterChatEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterClosedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterClosedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  feedback?: InputMaybe<feedback__NestedFilterIssueFeedback>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterClosedEvent>;
  or?: InputMaybe<Array<issue__FilterClosedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterClosurePaymentRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterClosurePaymentRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  chargeDate?: InputMaybe<FilterString>;
  chargeDelayDays?: InputMaybe<FilterInt>;
  dollarAmountSaved?: InputMaybe<FilterDecimal>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterClosurePaymentRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterClosurePaymentRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  successFee?: InputMaybe<FilterDecimal>;
  totalBillDollarAmount?: InputMaybe<FilterDecimal>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterCommentEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterCommentEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  comment?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterCommentEvent>;
  or?: InputMaybe<Array<issue__FilterCommentEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  pinned?: InputMaybe<FilterBoolean>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterConnectAccountRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterConnectAccountRequestedEvent>>;
  buttonText?: InputMaybe<FilterString>;
  caseIntake?: InputMaybe<FilterBoolean>;
  chatBody?: InputMaybe<FilterString>;
  endpointType?: InputMaybe<FilterwebAgent__EndpointType>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterConnectAccountRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterConnectAccountRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  showSkipButton?: InputMaybe<FilterBoolean>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterConnectEhrPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterConnectEhrPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterConnectAccountRequestedEvent>;
  not?: InputMaybe<issue__FilterConnectEhrPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterConnectEhrPostEscalationAction>>;
};

export type issue__FilterConnectInsurancePostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterConnectInsurancePostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterConnectAccountRequestedEvent>;
  not?: InputMaybe<issue__FilterConnectInsurancePostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterConnectInsurancePostEscalationAction>>;
};

export type issue__FilterConnectInsuranceRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterConnectInsuranceRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  insuranceLinkMessage?: InputMaybe<FilterString>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterConnectInsuranceRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterConnectInsuranceRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterDocumentAnalysisEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterDocumentAnalysisEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  document?: InputMaybe<document__NestedFilterDocument>;
  errorIsRetriable?: InputMaybe<FilterBoolean>;
  errorMessage?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterDocumentAnalysisEvent>;
  or?: InputMaybe<Array<issue__FilterDocumentAnalysisEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  status?: InputMaybe<Filterissue__DocumentAnalysisStatus>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterDocumentClassificationFailedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterDocumentClassificationFailedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  document?: InputMaybe<document__NestedFilterDocument>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterDocumentClassificationFailedEvent>;
  or?: InputMaybe<Array<issue__FilterDocumentClassificationFailedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterDocumentUploadedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterDocumentUploadedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  document?: InputMaybe<document__NestedFilterDocument>;
  documentLabel?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  or?: InputMaybe<Array<issue__FilterDocumentUploadedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterEvent>;
  or?: InputMaybe<Array<issue__FilterEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterHAAssignedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterHAAssignedEvent>>;
  assigneeAverageCaseRating?: InputMaybe<FilterFloat>;
  assigneeProfile?: InputMaybe<user__NestedFilterProfile>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterHAAssignedEvent>;
  or?: InputMaybe<Array<issue__FilterHAAssignedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterHipaaReleaseRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterHipaaReleaseRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  hipaaRelease?: InputMaybe<consent__NestedFilterHipaaRelease>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterHipaaReleaseRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterHipaaReleaseRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterInternalDocumentUploadedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterInternalDocumentUploadedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  internalDocument?: InputMaybe<document__NestedFilterDocument>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterInternalDocumentUploadedEvent>;
  or?: InputMaybe<Array<issue__FilterInternalDocumentUploadedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterIssue = {
  actions?: InputMaybe<issue__NestedFilterEvent>;
  additionalDetails?: InputMaybe<FilterString>;
  and?: InputMaybe<Array<issue__FilterIssue>>;
  assignee?: InputMaybe<NestedFilterUser>;
  benefitsContext?: InputMaybe<issue__NestedFilterBenefitsContext>;
  benefitsCoverage?: InputMaybe<FilterString>;
  benefitsPrice?: InputMaybe<FilterString>;
  benefitsQuestionType?: InputMaybe<FilterString>;
  billDisputeType?: InputMaybe<FilterString>;
  caseManagementClosureReason?: InputMaybe<FilterString>;
  caseManagementRelatedIssueCount?: InputMaybe<FilterInt>;
  caseManagementType?: InputMaybe<FilterString>;
  caseRecommendation?: InputMaybe<FilterJSON>;
  caseRecommendationGeneratedAt?: InputMaybe<FilterString>;
  caseRef?: InputMaybe<FilterString>;
  caseSeq?: InputMaybe<FilterInt64>;
  caseType?: InputMaybe<FilterString>;
  closedAt?: InputMaybe<FilterString>;
  coverageType?: InputMaybe<FilterString>;
  documents?: InputMaybe<document__NestedFilterDocument>;
  dollarAmountSaved?: InputMaybe<FilterDecimal>;
  engineState?: InputMaybe<FilterString>;
  eobId?: InputMaybe<FilterString>;
  estimatedDollarAmountSaved?: InputMaybe<FilterDecimal>;
  events?: InputMaybe<issue__NestedFilterEvent>;
  firstUnseenEvent?: InputMaybe<issue__NestedFilterEvent>;
  followUpDate?: InputMaybe<FilterString>;
  hasActions?: InputMaybe<FilterBoolean>;
  hasStaffParticipant?: InputMaybe<FilterBoolean>;
  healthRecordKey?: InputMaybe<FilterString>;
  healthRecordKind?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isEscalated?: InputMaybe<FilterBoolean>;
  issueType?: InputMaybe<FilterString>;
  lastEvent?: InputMaybe<issue__NestedFilterEvent>;
  lastNonUserEvent?: InputMaybe<issue__NestedFilterEvent>;
  lastSeenAt?: InputMaybe<FilterString>;
  nextSteps?: InputMaybe<FilterString>;
  not?: InputMaybe<issue__FilterIssue>;
  openedAt?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<issue__FilterIssue>>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  promoCodeUsages?: InputMaybe<payment__NestedFilterIssuePromoCodeUsage>;
  resolutionPreferences?: InputMaybe<issue__NestedFilterResolutionPreferences>;
  tasks?: InputMaybe<taskManagement__NestedFilterIssueTask>;
  title?: InputMaybe<FilterString>;
  totalBillDollarAmount?: InputMaybe<FilterDecimal>;
  userVisibleEvents?: InputMaybe<issue__NestedFilterEvent>;
};

export type issue__FilterIssueDocumentSummary = {
  analysisResult?: InputMaybe<FilterJSON>;
  and?: InputMaybe<Array<issue__FilterIssueDocumentSummary>>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  modelId?: InputMaybe<FilterString>;
  not?: InputMaybe<issue__FilterIssueDocumentSummary>;
  or?: InputMaybe<Array<issue__FilterIssueDocumentSummary>>;
  schemaVersion?: InputMaybe<FilterInt>;
  summary?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type issue__FilterPaymentAgreementPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterPaymentAgreementPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterPaymentAgreementRequestedEvent>;
  not?: InputMaybe<issue__FilterPaymentAgreementPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterPaymentAgreementPostEscalationAction>>;
};

export type issue__FilterPaymentAgreementRequestedEvent = {
  acceptedAt?: InputMaybe<FilterString>;
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterPaymentAgreementRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterPaymentAgreementRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterPaymentAgreementRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userAccepted?: InputMaybe<FilterBoolean>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterPaymentChargeFailedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterPaymentChargeFailedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterPaymentChargeFailedEvent>;
  or?: InputMaybe<Array<issue__FilterPaymentChargeFailedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  paymentTransaction?: InputMaybe<payment__NestedFilterPaymentTransaction>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterPlanSelectionEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterPlanSelectionEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  isResolved?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterPlanSelectionEvent>;
  options?: InputMaybe<plan__NestedFilterPlan>;
  or?: InputMaybe<Array<issue__FilterPlanSelectionEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  selectedPlan?: InputMaybe<plan__NestedFilterPlan>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<issue__FilterPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterPostEscalationAction>>;
};

export type issue__FilterPostEscalationActionsEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  actions?: InputMaybe<issue__NestedFilterPostEscalationAction>;
  and?: InputMaybe<Array<issue__FilterPostEscalationActionsEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterPostEscalationActionsEvent>;
  or?: InputMaybe<Array<issue__FilterPostEscalationActionsEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterReopenedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterReopenedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterReopenedEvent>;
  or?: InputMaybe<Array<issue__FilterReopenedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterResolutionPreferences = {
  and?: InputMaybe<Array<issue__FilterResolutionPreferences>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minimumDiscountPercent?: InputMaybe<FilterInt>;
  not?: InputMaybe<issue__FilterResolutionPreferences>;
  or?: InputMaybe<Array<issue__FilterResolutionPreferences>>;
  owner?: InputMaybe<NestedFilterUser>;
  savingsPreference?: InputMaybe<Filterissue__SavingsPreference>;
  successFeePercent?: InputMaybe<FilterInt>;
  updatedAt?: InputMaybe<FilterString>;
};

export type issue__FilterSignTemplatePostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterSignTemplatePostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterTemplateReleaseRequestedEvent>;
  not?: InputMaybe<issue__FilterSignTemplatePostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterSignTemplatePostEscalationAction>>;
};

export type issue__FilterTemplateReleaseRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterTemplateReleaseRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterTemplateReleaseRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterTemplateReleaseRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  release?: InputMaybe<consent__NestedFilterTemplateRelease>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  template?: InputMaybe<document__NestedFilterTemplate>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterToolExecutionEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterToolExecutionEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterToolExecutionEvent>;
  or?: InputMaybe<Array<issue__FilterToolExecutionEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  toolInput?: InputMaybe<FilterJSON>;
  toolName?: InputMaybe<FilterString>;
  toolOutput?: InputMaybe<FilterString>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterUploadBillPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterUploadBillPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterDocumentUploadedEvent>;
  not?: InputMaybe<issue__FilterUploadBillPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterUploadBillPostEscalationAction>>;
};

export type issue__FilterUploadEobPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterUploadEobPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterDocumentUploadedEvent>;
  not?: InputMaybe<issue__FilterUploadEobPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterUploadEobPostEscalationAction>>;
};

export type issue__FilterUploadMemberIdPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterUploadMemberIdPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterDocumentUploadedEvent>;
  not?: InputMaybe<issue__FilterUploadMemberIdPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterUploadMemberIdPostEscalationAction>>;
};

export type issue__FilterUserMultiSelectionRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterUserMultiSelectionRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  message?: InputMaybe<FilterString>;
  not?: InputMaybe<issue__FilterUserMultiSelectionRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterUserMultiSelectionRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterUserSelectionRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterUserSelectionRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  message?: InputMaybe<FilterString>;
  not?: InputMaybe<issue__FilterUserSelectionRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterUserSelectionRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__HAAssignedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  assigneeAverageCaseRating?: Maybe<Scalars['Float']['output']>;
  assigneeProfile: user__Profile;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__HAAssignedEventassigneeProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type issue__HAAssignedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__HAAssignedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__HAAssignedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__HAAssignedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__HAAssignedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__HAAssignedEvent_Type = BaseObject & Object & issue__Event & issue__HAAssignedEvent & {
  __typename: 'issue__HAAssignedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  assigneeAverageCaseRating?: Maybe<Scalars['Float']['output']>;
  assigneeProfile: user__Profile;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__HAAssignedEvent_TypeassigneeProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type issue__HAAssignedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__HAAssignedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__HAAssignedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__HAAssignedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__HAAssignedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__HipaaReleaseRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  hipaaRelease: consent__HipaaRelease;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__HipaaReleaseRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__HipaaReleaseRequestedEventhipaaReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterHipaaRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderHipaaRelease>;
};


export type issue__HipaaReleaseRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__HipaaReleaseRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__HipaaReleaseRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__HipaaReleaseRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__HipaaReleaseRequestedEvent_Type = BaseObject & Object & issue__Event & issue__HipaaReleaseRequestedEvent & {
  __typename: 'issue__HipaaReleaseRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  hipaaRelease: consent__HipaaRelease;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__HipaaReleaseRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__HipaaReleaseRequestedEvent_TypehipaaReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterHipaaRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderHipaaRelease>;
};


export type issue__HipaaReleaseRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__HipaaReleaseRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__HipaaReleaseRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__HipaaReleaseRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__InternalDocumentUploadedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  internalDocument: document__Document;
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__InternalDocumentUploadedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__InternalDocumentUploadedEventinternalDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__InternalDocumentUploadedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__InternalDocumentUploadedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__InternalDocumentUploadedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__InternalDocumentUploadedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__InternalDocumentUploadedEvent_Type = BaseObject & Object & issue__Event & issue__InternalDocumentUploadedEvent & {
  __typename: 'issue__InternalDocumentUploadedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  internalDocument: document__Document;
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__InternalDocumentUploadedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__InternalDocumentUploadedEvent_TypeinternalDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__InternalDocumentUploadedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__InternalDocumentUploadedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__InternalDocumentUploadedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__InternalDocumentUploadedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__Issue = {
  actions?: Maybe<Array<issue__Event>>;
  additionalDetails?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<User>;
  benefitsContext?: Maybe<issue__BenefitsContext>;
  benefitsCoverage?: Maybe<Scalars['String']['output']>;
  benefitsInclude?: Maybe<Array<Scalars['String']['output']>>;
  benefitsPrice?: Maybe<Scalars['String']['output']>;
  benefitsQuestionType?: Maybe<Scalars['String']['output']>;
  billDisputeType?: Maybe<Scalars['String']['output']>;
  caseManagementClosureReason?: Maybe<Scalars['String']['output']>;
  caseManagementRelatedIssueCount?: Maybe<Scalars['Int']['output']>;
  caseManagementType?: Maybe<Scalars['String']['output']>;
  caseRecommendation?: Maybe<Scalars['JSON']['output']>;
  caseRecommendationGeneratedAt?: Maybe<Scalars['String']['output']>;
  caseRef: Scalars['String']['output'];
  caseSeq: Scalars['Int64']['output'];
  caseType?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['String']['output']>;
  completedPostEscalationActions: Array<issue__PostEscalationActionType>;
  coverageType?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<document__Document>>;
  dollarAmountSaved?: Maybe<Scalars['Decimal']['output']>;
  engineState: Scalars['String']['output'];
  eobId?: Maybe<Scalars['String']['output']>;
  estimatedDollarAmountSaved?: Maybe<Scalars['Decimal']['output']>;
  events?: Maybe<Array<issue__Event>>;
  firstUnseenEvent?: Maybe<issue__Event>;
  followUpDate?: Maybe<Scalars['String']['output']>;
  hasActions: Scalars['Boolean']['output'];
  hasStaffParticipant: Scalars['Boolean']['output'];
  healthRecordKey?: Maybe<Scalars['String']['output']>;
  healthRecordKind?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEscalated: Scalars['Boolean']['output'];
  issueType?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  lastEvent?: Maybe<issue__Event>;
  lastNonUserEvent?: Maybe<issue__Event>;
  lastSeenAt?: Maybe<Scalars['String']['output']>;
  nextSteps?: Maybe<Scalars['String']['output']>;
  openedAt: Scalars['String']['output'];
  owner: User;
  person?: Maybe<Person>;
  promoCodeUsages?: Maybe<Array<payment__IssuePromoCodeUsage>>;
  /**
   * The latest HA recommendation for this issue, or null if no
   * recommendation is stored. `null` does NOT distinguish "never run" from
   * "generation attempted and failed" — the generator stamps the Gel
   * scalar `caseRecommendationGeneratedAt` only on first attempt so the UI
   * can render an "unavailable" state without clobbering the timestamp on
   * retried/regenerated runs that fail. Query `caseRecommendationGeneratedAt`
   * alongside `recommendation` to disambiguate:
   *   - caseRecommendationGeneratedAt null + recommendation null → never generated
   *   - caseRecommendationGeneratedAt set  + recommendation null → attempted and failed
   *   - caseRecommendationGeneratedAt set  + recommendation set  → available
   */
  recommendation?: Maybe<CaseRecommendation>;
  resolutionPreferences?: Maybe<issue__ResolutionPreferences>;
  tasks?: Maybe<Array<taskManagement__IssueTask>>;
  title?: Maybe<Scalars['String']['output']>;
  totalBillDollarAmount?: Maybe<Scalars['Decimal']['output']>;
  userVisibleEvents?: Maybe<Array<issue__Event>>;
};


export type issue__IssueactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__IssueassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__IssuebenefitsContextArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBenefitsContext>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBenefitsContext>;
};


export type issue__IssuedocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__IssueeventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__IssuefirstUnseenEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__IssuelastEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__IssuelastNonUserEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__IssueownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__IssuepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type issue__IssuepromoCodeUsagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterIssuePromoCodeUsage>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderIssuePromoCodeUsage>;
};


export type issue__IssueresolutionPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterResolutionPreferences>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderResolutionPreferences>;
};


export type issue__IssuetasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderIssueTask>;
};


export type issue__IssueuserVisibleEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};

export type issue__IssueDocumentSummary = {
  analysisResult: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  document: document__Document;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  modelId?: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type issue__IssueDocumentSummarydocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__IssueDocumentSummaryissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type issue__IssueDocumentSummary_Type = BaseObject & Object & document__DocumentSummary & issue__IssueDocumentSummary & {
  __typename: 'issue__IssueDocumentSummary_Type';
  analysisResult: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  document: document__Document;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  modelId?: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type issue__IssueDocumentSummary_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__IssueDocumentSummary_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type issue__Issue_Type = BaseObject & Object & Owned & Personal & issue__Issue & {
  __typename: 'issue__Issue_Type';
  actions?: Maybe<Array<issue__Event>>;
  additionalDetails?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<User>;
  benefitsContext?: Maybe<issue__BenefitsContext>;
  benefitsCoverage?: Maybe<Scalars['String']['output']>;
  benefitsInclude?: Maybe<Array<Scalars['String']['output']>>;
  benefitsPrice?: Maybe<Scalars['String']['output']>;
  benefitsQuestionType?: Maybe<Scalars['String']['output']>;
  billDisputeType?: Maybe<Scalars['String']['output']>;
  caseManagementClosureReason?: Maybe<Scalars['String']['output']>;
  caseManagementRelatedIssueCount?: Maybe<Scalars['Int']['output']>;
  caseManagementType?: Maybe<Scalars['String']['output']>;
  caseRecommendation?: Maybe<Scalars['JSON']['output']>;
  caseRecommendationGeneratedAt?: Maybe<Scalars['String']['output']>;
  caseRef: Scalars['String']['output'];
  caseSeq: Scalars['Int64']['output'];
  caseType?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['String']['output']>;
  completedPostEscalationActions: Array<issue__PostEscalationActionType>;
  coverageType?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<document__Document>>;
  dollarAmountSaved?: Maybe<Scalars['Decimal']['output']>;
  engineState: Scalars['String']['output'];
  eobId?: Maybe<Scalars['String']['output']>;
  estimatedDollarAmountSaved?: Maybe<Scalars['Decimal']['output']>;
  events?: Maybe<Array<issue__Event>>;
  firstUnseenEvent?: Maybe<issue__Event>;
  followUpDate?: Maybe<Scalars['String']['output']>;
  hasActions: Scalars['Boolean']['output'];
  hasStaffParticipant: Scalars['Boolean']['output'];
  healthRecordKey?: Maybe<Scalars['String']['output']>;
  healthRecordKind?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEscalated: Scalars['Boolean']['output'];
  issueType?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  lastEvent?: Maybe<issue__Event>;
  lastNonUserEvent?: Maybe<issue__Event>;
  lastSeenAt?: Maybe<Scalars['String']['output']>;
  nextSteps?: Maybe<Scalars['String']['output']>;
  openedAt: Scalars['String']['output'];
  owner: User;
  person?: Maybe<Person>;
  promoCodeUsages?: Maybe<Array<payment__IssuePromoCodeUsage>>;
  /**
   * See the docstring on `issue__Issue.recommendation` — `null` plus a
   * non-null `caseRecommendationGeneratedAt` means generation was attempted
   * and failed; query both fields together.
   */
  recommendation?: Maybe<CaseRecommendation>;
  resolutionPreferences?: Maybe<issue__ResolutionPreferences>;
  tasks?: Maybe<Array<taskManagement__IssueTask>>;
  title?: Maybe<Scalars['String']['output']>;
  totalBillDollarAmount?: Maybe<Scalars['Decimal']['output']>;
  userVisibleEvents?: Maybe<Array<issue__Event>>;
};


export type issue__Issue_TypeactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__Issue_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__Issue_TypebenefitsContextArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBenefitsContext>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBenefitsContext>;
};


export type issue__Issue_TypedocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__Issue_TypeeventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__Issue_TypefirstUnseenEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__Issue_TypelastEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__Issue_TypelastNonUserEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__Issue_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__Issue_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type issue__Issue_TypepromoCodeUsagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterIssuePromoCodeUsage>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderIssuePromoCodeUsage>;
};


export type issue__Issue_TyperesolutionPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterResolutionPreferences>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderResolutionPreferences>;
};


export type issue__Issue_TypetasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderIssueTask>;
};


export type issue__Issue_TypeuserVisibleEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};

export type issue__NestedFilterBenefitsContext = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  selectedAt?: InputMaybe<FilterString>;
  selectedPlan?: InputMaybe<plan__NestedFilterPlan>;
};

export type issue__NestedFilterBenefitsSummaryGeneratedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  plan?: InputMaybe<plan__NestedFilterPlan>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterBillPayRequestedEvent = {
  acceptedAt?: InputMaybe<FilterString>;
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  declinedAt?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  preAuthTransaction?: InputMaybe<payment__NestedFilterPaymentTransaction>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterBillPaymentRequestedEvent = {
  acceptedAt?: InputMaybe<FilterString>;
  actionRequired?: InputMaybe<FilterBoolean>;
  billAmount?: InputMaybe<FilterDecimal>;
  billPaid?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterConnectAccountRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  buttonText?: InputMaybe<FilterString>;
  caseIntake?: InputMaybe<FilterBoolean>;
  chatBody?: InputMaybe<FilterString>;
  endpointType?: InputMaybe<FilterwebAgent__EndpointType>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  showSkipButton?: InputMaybe<FilterBoolean>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterDocumentUploadedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  document?: InputMaybe<document__NestedFilterDocument>;
  documentLabel?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterInternalDocumentUploadedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  internalDocument?: InputMaybe<document__NestedFilterDocument>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterIssue = {
  actions?: InputMaybe<issue__NestedFilterEvent>;
  additionalDetails?: InputMaybe<FilterString>;
  assignee?: InputMaybe<NestedFilterUser>;
  benefitsContext?: InputMaybe<issue__NestedFilterBenefitsContext>;
  benefitsCoverage?: InputMaybe<FilterString>;
  benefitsPrice?: InputMaybe<FilterString>;
  benefitsQuestionType?: InputMaybe<FilterString>;
  billDisputeType?: InputMaybe<FilterString>;
  caseManagementClosureReason?: InputMaybe<FilterString>;
  caseManagementRelatedIssueCount?: InputMaybe<FilterInt>;
  caseManagementType?: InputMaybe<FilterString>;
  caseRecommendation?: InputMaybe<FilterJSON>;
  caseRecommendationGeneratedAt?: InputMaybe<FilterString>;
  caseRef?: InputMaybe<FilterString>;
  caseSeq?: InputMaybe<FilterInt64>;
  caseType?: InputMaybe<FilterString>;
  closedAt?: InputMaybe<FilterString>;
  coverageType?: InputMaybe<FilterString>;
  documents?: InputMaybe<document__NestedFilterDocument>;
  dollarAmountSaved?: InputMaybe<FilterDecimal>;
  engineState?: InputMaybe<FilterString>;
  eobId?: InputMaybe<FilterString>;
  estimatedDollarAmountSaved?: InputMaybe<FilterDecimal>;
  events?: InputMaybe<issue__NestedFilterEvent>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstUnseenEvent?: InputMaybe<issue__NestedFilterEvent>;
  followUpDate?: InputMaybe<FilterString>;
  hasActions?: InputMaybe<FilterBoolean>;
  hasStaffParticipant?: InputMaybe<FilterBoolean>;
  healthRecordKey?: InputMaybe<FilterString>;
  healthRecordKind?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isEscalated?: InputMaybe<FilterBoolean>;
  issueType?: InputMaybe<FilterString>;
  lastEvent?: InputMaybe<issue__NestedFilterEvent>;
  lastNonUserEvent?: InputMaybe<issue__NestedFilterEvent>;
  lastSeenAt?: InputMaybe<FilterString>;
  nextSteps?: InputMaybe<FilterString>;
  openedAt?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  promoCodeUsages?: InputMaybe<payment__NestedFilterIssuePromoCodeUsage>;
  resolutionPreferences?: InputMaybe<issue__NestedFilterResolutionPreferences>;
  tasks?: InputMaybe<taskManagement__NestedFilterIssueTask>;
  title?: InputMaybe<FilterString>;
  totalBillDollarAmount?: InputMaybe<FilterDecimal>;
  userVisibleEvents?: InputMaybe<issue__NestedFilterEvent>;
};

export type issue__NestedFilterIssueDocumentSummary = {
  analysisResult?: InputMaybe<FilterJSON>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  modelId?: InputMaybe<FilterString>;
  schemaVersion?: InputMaybe<FilterInt>;
  summary?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type issue__NestedFilterPaymentAgreementRequestedEvent = {
  acceptedAt?: InputMaybe<FilterString>;
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userAccepted?: InputMaybe<FilterBoolean>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterPostEscalationAction = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
};

export type issue__NestedFilterResolutionPreferences = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minimumDiscountPercent?: InputMaybe<FilterInt>;
  owner?: InputMaybe<NestedFilterUser>;
  savingsPreference?: InputMaybe<Filterissue__SavingsPreference>;
  successFeePercent?: InputMaybe<FilterInt>;
  updatedAt?: InputMaybe<FilterString>;
};

export type issue__NestedFilterTemplateReleaseRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  release?: InputMaybe<consent__NestedFilterTemplateRelease>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  template?: InputMaybe<document__NestedFilterTemplate>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__OrderBenefitsContext = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  selectedAt?: InputMaybe<Ordering>;
  selectedPlan?: InputMaybe<plan__OrderPlan>;
};

export type issue__OrderBenefitsSummaryGeneratedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  plan?: InputMaybe<plan__OrderPlan>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderBillDisputeEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eobId?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  healthRecordKey?: InputMaybe<Ordering>;
  healthRecordKind?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  invoiceId?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderBillPayPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderBillPayRequestedEvent>;
};

export type issue__OrderBillPayRequestedEvent = {
  acceptedAt?: InputMaybe<Ordering>;
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  declinedAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  preAuthTransaction?: InputMaybe<payment__OrderPaymentTransaction>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderBillPaySuccessEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  chargeTransaction?: InputMaybe<payment__OrderPaymentTransaction>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  negotiatedBillAmount?: InputMaybe<Ordering>;
  originalBillAmount?: InputMaybe<Ordering>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  successFeeAmount?: InputMaybe<Ordering>;
  successFeePercent?: InputMaybe<Ordering>;
  totalCharged?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderBillPaymentRequestedEvent = {
  acceptedAt?: InputMaybe<Ordering>;
  actionRequired?: InputMaybe<Ordering>;
  billAmount?: InputMaybe<Ordering>;
  billPaid?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderBillPaymentSuccessEvent = {
  actionRequired?: InputMaybe<Ordering>;
  billAmount?: InputMaybe<Ordering>;
  billPaymentRequest?: InputMaybe<issue__OrderBillPaymentRequestedEvent>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  stripePaymentIntentId?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderChatEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  chatBody?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderClosedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  feedback?: InputMaybe<feedback__OrderIssueFeedback>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderClosurePaymentRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  chargeDate?: InputMaybe<Ordering>;
  chargeDelayDays?: InputMaybe<Ordering>;
  dollarAmountSaved?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  successFee?: InputMaybe<Ordering>;
  totalBillDollarAmount?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderCommentEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  comment?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  pinned?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderConnectAccountRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  buttonText?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  chatBody?: InputMaybe<Ordering>;
  endpointType?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  showSkipButton?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderConnectEhrPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderConnectAccountRequestedEvent>;
};

export type issue__OrderConnectInsurancePostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderConnectAccountRequestedEvent>;
};

export type issue__OrderConnectInsuranceRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  insuranceLinkMessage?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderDocumentAnalysisEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  errorIsRetriable?: InputMaybe<Ordering>;
  errorMessage?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  status?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderDocumentClassificationFailedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderDocumentUploadedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  documentLabel?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderHAAssignedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  assigneeAverageCaseRating?: InputMaybe<Ordering>;
  assigneeProfile?: InputMaybe<user__OrderProfile>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderHipaaReleaseRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  hipaaRelease?: InputMaybe<consent__OrderHipaaRelease>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderInternalDocumentUploadedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  internalDocument?: InputMaybe<document__OrderDocument>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderIssue = {
  additionalDetails?: InputMaybe<Ordering>;
  assignee?: InputMaybe<OrderUser>;
  benefitsContext?: InputMaybe<issue__OrderBenefitsContext>;
  benefitsCoverage?: InputMaybe<Ordering>;
  benefitsPrice?: InputMaybe<Ordering>;
  benefitsQuestionType?: InputMaybe<Ordering>;
  billDisputeType?: InputMaybe<Ordering>;
  caseManagementClosureReason?: InputMaybe<Ordering>;
  caseManagementRelatedIssueCount?: InputMaybe<Ordering>;
  caseManagementType?: InputMaybe<Ordering>;
  caseRecommendation?: InputMaybe<Ordering>;
  caseRecommendationGeneratedAt?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  caseSeq?: InputMaybe<Ordering>;
  caseType?: InputMaybe<Ordering>;
  closedAt?: InputMaybe<Ordering>;
  coverageType?: InputMaybe<Ordering>;
  dollarAmountSaved?: InputMaybe<Ordering>;
  engineState?: InputMaybe<Ordering>;
  eobId?: InputMaybe<Ordering>;
  estimatedDollarAmountSaved?: InputMaybe<Ordering>;
  firstUnseenEvent?: InputMaybe<issue__OrderEvent>;
  followUpDate?: InputMaybe<Ordering>;
  hasActions?: InputMaybe<Ordering>;
  hasStaffParticipant?: InputMaybe<Ordering>;
  healthRecordKey?: InputMaybe<Ordering>;
  healthRecordKind?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isEscalated?: InputMaybe<Ordering>;
  issueType?: InputMaybe<Ordering>;
  lastEvent?: InputMaybe<issue__OrderEvent>;
  lastNonUserEvent?: InputMaybe<issue__OrderEvent>;
  lastSeenAt?: InputMaybe<Ordering>;
  nextSteps?: InputMaybe<Ordering>;
  openedAt?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  resolutionPreferences?: InputMaybe<issue__OrderResolutionPreferences>;
  title?: InputMaybe<Ordering>;
  totalBillDollarAmount?: InputMaybe<Ordering>;
};

export type issue__OrderIssueDocumentSummary = {
  analysisResult?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  modelId?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type issue__OrderPaymentAgreementPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderPaymentAgreementRequestedEvent>;
};

export type issue__OrderPaymentAgreementRequestedEvent = {
  acceptedAt?: InputMaybe<Ordering>;
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userAccepted?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderPaymentChargeFailedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  paymentTransaction?: InputMaybe<payment__OrderPaymentTransaction>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderPlanSelectionEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isResolved?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  selectedPlan?: InputMaybe<plan__OrderPlan>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
};

export type issue__OrderPostEscalationActionsEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderReopenedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderResolutionPreferences = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minimumDiscountPercent?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  savingsPreference?: InputMaybe<Ordering>;
  successFeePercent?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type issue__OrderSignTemplatePostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderTemplateReleaseRequestedEvent>;
};

export type issue__OrderTemplateReleaseRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  release?: InputMaybe<consent__OrderTemplateRelease>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  template?: InputMaybe<document__OrderTemplate>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderToolExecutionEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  toolInput?: InputMaybe<Ordering>;
  toolName?: InputMaybe<Ordering>;
  toolOutput?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderUploadBillPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__OrderUploadEobPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__OrderUploadMemberIdPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__OrderUserMultiSelectionRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  message?: InputMaybe<Ordering>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderUserSelectionRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  message?: InputMaybe<Ordering>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__PaymentAgreementPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__PaymentAgreementRequestedEvent;
};


export type issue__PaymentAgreementPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentAgreementPostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentAgreementRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentAgreementRequestedEvent>;
};

export type issue__PaymentAgreementPostEscalationAction_Type = BaseObject & Object & issue__PaymentAgreementPostEscalationAction & issue__PostEscalationAction & {
  __typename: 'issue__PaymentAgreementPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__PaymentAgreementRequestedEvent;
};


export type issue__PaymentAgreementPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentAgreementPostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentAgreementRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentAgreementRequestedEvent>;
};

export type issue__PaymentAgreementRequestedEvent = {
  acceptedAt?: Maybe<Scalars['String']['output']>;
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userAccepted?: Maybe<Scalars['Boolean']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PaymentAgreementRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PaymentAgreementRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentAgreementRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PaymentAgreementRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PaymentAgreementRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PaymentAgreementRequestedEvent_Type = BaseObject & Object & issue__Event & issue__PaymentAgreementRequestedEvent & {
  __typename: 'issue__PaymentAgreementRequestedEvent_Type';
  acceptedAt?: Maybe<Scalars['String']['output']>;
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userAccepted?: Maybe<Scalars['Boolean']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PaymentAgreementRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PaymentAgreementRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentAgreementRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PaymentAgreementRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PaymentAgreementRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PaymentChargeFailedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  paymentTransaction: payment__PaymentTransaction;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PaymentChargeFailedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PaymentChargeFailedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentChargeFailedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PaymentChargeFailedEventpaymentTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


export type issue__PaymentChargeFailedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PaymentChargeFailedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PaymentChargeFailedEvent_Type = BaseObject & Object & issue__Event & issue__PaymentChargeFailedEvent & {
  __typename: 'issue__PaymentChargeFailedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  paymentTransaction: payment__PaymentTransaction;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PaymentChargeFailedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PaymentChargeFailedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentChargeFailedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PaymentChargeFailedEvent_TypepaymentTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


export type issue__PaymentChargeFailedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PaymentChargeFailedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PlanSelectionEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  isResolved: Scalars['Boolean']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  options?: Maybe<Array<plan__Plan>>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  selectedPlan?: Maybe<plan__Plan>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PlanSelectionEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PlanSelectionEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PlanSelectionEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PlanSelectionEventoptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type issue__PlanSelectionEventselectedPlanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type issue__PlanSelectionEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PlanSelectionEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PlanSelectionEvent_Type = BaseObject & Object & issue__Event & issue__PlanSelectionEvent & {
  __typename: 'issue__PlanSelectionEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  isResolved: Scalars['Boolean']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  options?: Maybe<Array<plan__Plan>>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  selectedPlan?: Maybe<plan__Plan>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PlanSelectionEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PlanSelectionEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PlanSelectionEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PlanSelectionEvent_TypeoptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type issue__PlanSelectionEvent_TypeselectedPlanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type issue__PlanSelectionEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PlanSelectionEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
};


export type issue__PostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export enum issue__PostEscalationActionType {
  ACCEPT_BILL_PAY = 'ACCEPT_BILL_PAY',
  ACCEPT_PAYMENT_AGREEMENT = 'ACCEPT_PAYMENT_AGREEMENT',
  CONNECT_EHR = 'CONNECT_EHR',
  CONNECT_INSURANCE = 'CONNECT_INSURANCE',
  SIGN_TEMPLATE = 'SIGN_TEMPLATE',
  UPLOAD_BILL = 'UPLOAD_BILL',
  UPLOAD_EOB = 'UPLOAD_EOB',
  UPLOAD_MEMBER_ID = 'UPLOAD_MEMBER_ID'
}

export type issue__PostEscalationActionsEvent = {
  actionRequired: Scalars['Boolean']['output'];
  actions?: Maybe<Array<issue__PostEscalationAction>>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PostEscalationActionsEventactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPostEscalationAction>;
};


export type issue__PostEscalationActionsEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PostEscalationActionsEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PostEscalationActionsEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PostEscalationActionsEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PostEscalationActionsEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PostEscalationActionsEvent_Type = BaseObject & Object & issue__Event & issue__PostEscalationActionsEvent & {
  __typename: 'issue__PostEscalationActionsEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  actions?: Maybe<Array<issue__PostEscalationAction>>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PostEscalationActionsEvent_TypeactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPostEscalationAction>;
};


export type issue__PostEscalationActionsEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PostEscalationActionsEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PostEscalationActionsEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PostEscalationActionsEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PostEscalationActionsEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ReopenedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ReopenedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ReopenedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ReopenedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ReopenedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ReopenedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ReopenedEvent_Type = BaseObject & Object & issue__Event & issue__ReopenedEvent & {
  __typename: 'issue__ReopenedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ReopenedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ReopenedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ReopenedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ReopenedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ReopenedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** User's bill pay preferences — stored when they accept a BillPayRequestedEvent. */
export type issue__ResolutionPreferences = {
  alternativePaymentOptions: Array<issue__AlternativePaymentOption>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minimumDiscountPercent: Scalars['Int']['output'];
  owner: User;
  savingsPreference: issue__SavingsPreference;
  successFeePercent: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};


/** User's bill pay preferences — stored when they accept a BillPayRequestedEvent. */
export type issue__ResolutionPreferencesissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** User's bill pay preferences — stored when they accept a BillPayRequestedEvent. */
export type issue__ResolutionPreferencesownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** User's bill pay preferences — stored when they accept a BillPayRequestedEvent. */
export type issue__ResolutionPreferences_Type = BaseObject & Object & Owned & issue__ResolutionPreferences & {
  __typename: 'issue__ResolutionPreferences_Type';
  alternativePaymentOptions: Array<issue__AlternativePaymentOption>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minimumDiscountPercent: Scalars['Int']['output'];
  owner: User;
  savingsPreference: issue__SavingsPreference;
  successFeePercent: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};


/** User's bill pay preferences — stored when they accept a BillPayRequestedEvent. */
export type issue__ResolutionPreferences_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** User's bill pay preferences — stored when they accept a BillPayRequestedEvent. */
export type issue__ResolutionPreferences_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** User's savings preference: ANY accepts any discount, MINIMUM requires a threshold. */
export enum issue__SavingsPreference {
  ANY = 'ANY',
  MINIMUM = 'MINIMUM'
}

export type issue__SignTemplatePostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__TemplateReleaseRequestedEvent;
};


export type issue__SignTemplatePostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__SignTemplatePostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterTemplateReleaseRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderTemplateReleaseRequestedEvent>;
};

export type issue__SignTemplatePostEscalationAction_Type = BaseObject & Object & issue__PostEscalationAction & issue__SignTemplatePostEscalationAction & {
  __typename: 'issue__SignTemplatePostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__TemplateReleaseRequestedEvent;
};


export type issue__SignTemplatePostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__SignTemplatePostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterTemplateReleaseRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderTemplateReleaseRequestedEvent>;
};

export type issue__TemplateReleaseRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  release?: Maybe<consent__TemplateRelease>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  template: document__Template;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__TemplateReleaseRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__TemplateReleaseRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__TemplateReleaseRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__TemplateReleaseRequestedEventreleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterTemplateRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderTemplateRelease>;
};


export type issue__TemplateReleaseRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__TemplateReleaseRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type issue__TemplateReleaseRequestedEventtemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};

export type issue__TemplateReleaseRequestedEvent_Type = BaseObject & Object & issue__Event & issue__TemplateReleaseRequestedEvent & {
  __typename: 'issue__TemplateReleaseRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  release?: Maybe<consent__TemplateRelease>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  template: document__Template;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__TemplateReleaseRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__TemplateReleaseRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__TemplateReleaseRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__TemplateReleaseRequestedEvent_TypereleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterTemplateRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderTemplateRelease>;
};


export type issue__TemplateReleaseRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__TemplateReleaseRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type issue__TemplateReleaseRequestedEvent_TypetemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};

export type issue__ToolExecutionEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  toolInput: Scalars['JSON']['output'];
  toolName: Scalars['String']['output'];
  toolOutput: Scalars['String']['output'];
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ToolExecutionEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ToolExecutionEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ToolExecutionEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ToolExecutionEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ToolExecutionEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ToolExecutionEvent_Type = BaseObject & Object & issue__Event & issue__ToolExecutionEvent & {
  __typename: 'issue__ToolExecutionEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  toolInput: Scalars['JSON']['output'];
  toolName: Scalars['String']['output'];
  toolOutput: Scalars['String']['output'];
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ToolExecutionEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ToolExecutionEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ToolExecutionEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ToolExecutionEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ToolExecutionEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__UploadBillPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent?: Maybe<issue__DocumentUploadedEvent>;
};


export type issue__UploadBillPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UploadBillPostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__UploadBillPostEscalationAction_Type = BaseObject & Object & issue__PostEscalationAction & issue__UploadBillPostEscalationAction & {
  __typename: 'issue__UploadBillPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent?: Maybe<issue__DocumentUploadedEvent>;
};


export type issue__UploadBillPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UploadBillPostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__UploadEobPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent?: Maybe<issue__DocumentUploadedEvent>;
};


export type issue__UploadEobPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UploadEobPostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__UploadEobPostEscalationAction_Type = BaseObject & Object & issue__PostEscalationAction & issue__UploadEobPostEscalationAction & {
  __typename: 'issue__UploadEobPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent?: Maybe<issue__DocumentUploadedEvent>;
};


export type issue__UploadEobPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UploadEobPostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__UploadMemberIdPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent?: Maybe<issue__DocumentUploadedEvent>;
};


export type issue__UploadMemberIdPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UploadMemberIdPostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__UploadMemberIdPostEscalationAction_Type = BaseObject & Object & issue__PostEscalationAction & issue__UploadMemberIdPostEscalationAction & {
  __typename: 'issue__UploadMemberIdPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent?: Maybe<issue__DocumentUploadedEvent>;
};


export type issue__UploadMemberIdPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UploadMemberIdPostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__UserMultiSelectionRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  message?: Maybe<Scalars['String']['output']>;
  options: Array<Scalars['String']['output']>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__UserMultiSelectionRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__UserMultiSelectionRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UserMultiSelectionRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__UserMultiSelectionRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__UserMultiSelectionRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__UserMultiSelectionRequestedEvent_Type = BaseObject & Object & issue__Event & issue__UserMultiSelectionRequestedEvent & {
  __typename: 'issue__UserMultiSelectionRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  message?: Maybe<Scalars['String']['output']>;
  options: Array<Scalars['String']['output']>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__UserMultiSelectionRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__UserMultiSelectionRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UserMultiSelectionRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__UserMultiSelectionRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__UserMultiSelectionRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__UserSelectionRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  message?: Maybe<Scalars['String']['output']>;
  options: Array<Scalars['String']['output']>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__UserSelectionRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__UserSelectionRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UserSelectionRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__UserSelectionRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__UserSelectionRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__UserSelectionRequestedEvent_Type = BaseObject & Object & issue__Event & issue__UserSelectionRequestedEvent & {
  __typename: 'issue__UserSelectionRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  message?: Maybe<Scalars['String']['output']>;
  options: Array<Scalars['String']['output']>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__UserSelectionRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__UserSelectionRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UserSelectionRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__UserSelectionRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__UserSelectionRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type modelExecution__FilterLLMExecution = {
  and?: InputMaybe<Array<modelExecution__FilterLLMExecution>>;
  createdAt?: InputMaybe<FilterString>;
  executionId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  llmProvider?: InputMaybe<FiltermodelExecution__LLMProvider>;
  not?: InputMaybe<modelExecution__FilterLLMExecution>;
  or?: InputMaybe<Array<modelExecution__FilterLLMExecution>>;
};

export type modelExecution__FilterVellumLLMExecution = {
  and?: InputMaybe<Array<modelExecution__FilterVellumLLMExecution>>;
  createdAt?: InputMaybe<FilterString>;
  executionId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  llmProvider?: InputMaybe<FiltermodelExecution__LLMProvider>;
  not?: InputMaybe<modelExecution__FilterVellumLLMExecution>;
  or?: InputMaybe<Array<modelExecution__FilterVellumLLMExecution>>;
};

export type modelExecution__LLMExecution = {
  createdAt: Scalars['String']['output'];
  executionId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  llmProvider: modelExecution__LLMProvider;
};

export enum modelExecution__LLMProvider {
  VELLUM = 'VELLUM'
}

export type modelExecution__NestedFilterLLMExecution = {
  createdAt?: InputMaybe<FilterString>;
  executionId?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  llmProvider?: InputMaybe<FiltermodelExecution__LLMProvider>;
};

export type modelExecution__OrderLLMExecution = {
  createdAt?: InputMaybe<Ordering>;
  executionId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  llmProvider?: InputMaybe<Ordering>;
};

export type modelExecution__OrderVellumLLMExecution = {
  createdAt?: InputMaybe<Ordering>;
  executionId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  llmProvider?: InputMaybe<Ordering>;
};

export type modelExecution__VellumLLMExecution = {
  createdAt: Scalars['String']['output'];
  executionId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  llmProvider: modelExecution__LLMProvider;
};

export type modelExecution__VellumLLMExecution_Type = BaseObject & Object & modelExecution__LLMExecution & modelExecution__VellumLLMExecution & {
  __typename: 'modelExecution__VellumLLMExecution_Type';
  createdAt: Scalars['String']['output'];
  executionId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  llmProvider: modelExecution__LLMProvider;
};

export type notification__FilterRetoolNotification = {
  and?: InputMaybe<Array<notification__FilterRetoolNotification>>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<notification__FilterRetoolNotification>;
  or?: InputMaybe<Array<notification__FilterRetoolNotification>>;
  owner?: InputMaybe<NestedFilterUser>;
  readAt?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type notification__OrderRetoolNotification = {
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  owner?: InputMaybe<OrderUser>;
  readAt?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type notification__RetoolNotification = {
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue?: Maybe<issue__Issue>;
  owner: User;
  readAt?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type notification__RetoolNotificationissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type notification__RetoolNotificationownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type notification__RetoolNotification_Type = BaseObject & Object & Owned & notification__RetoolNotification & {
  __typename: 'notification__RetoolNotification_Type';
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue?: Maybe<issue__Issue>;
  owner: User;
  readAt?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type notification__RetoolNotification_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type notification__RetoolNotification_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** Enum value used to specify how nulls are ordered. */
export enum nullsOrderingEnum {
  BIGGEST = 'BIGGEST',
  SMALLEST = 'SMALLEST'
}

export type partner__FilterPartner = {
  and?: InputMaybe<Array<partner__FilterPartner>>;
  createdAt?: InputMaybe<FilterString>;
  groups?: InputMaybe<partner__NestedFilterPartnerGroup>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<partner__FilterPartner>;
  or?: InputMaybe<Array<partner__FilterPartner>>;
  slug?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type partner__FilterPartnerGroup = {
  and?: InputMaybe<Array<partner__FilterPartnerGroup>>;
  createdAt?: InputMaybe<FilterString>;
  externalId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<partner__FilterPartnerGroup>;
  or?: InputMaybe<Array<partner__FilterPartnerGroup>>;
  partner?: InputMaybe<partner__NestedFilterPartner>;
  updatedAt?: InputMaybe<FilterString>;
};

export type partner__NestedFilterPartner = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<partner__NestedFilterPartnerGroup>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  name?: InputMaybe<FilterString>;
  slug?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type partner__NestedFilterPartnerGroup = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  partner?: InputMaybe<partner__NestedFilterPartner>;
  updatedAt?: InputMaybe<FilterString>;
};

export type partner__OrderPartner = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  slug?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type partner__OrderPartnerGroup = {
  createdAt?: InputMaybe<Ordering>;
  externalId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  partner?: InputMaybe<partner__OrderPartner>;
  updatedAt?: InputMaybe<Ordering>;
};

export type partner__Partner = {
  createdAt: Scalars['String']['output'];
  groups?: Maybe<Array<partner__PartnerGroup>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};


export type partner__PartnergroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartnerGroup>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartnerGroup>;
};

export type partner__PartnerGroup = {
  createdAt: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  partner: partner__Partner;
  updatedAt: Scalars['String']['output'];
};


export type partner__PartnerGrouppartnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartner>;
};

export type partner__PartnerGroup_Type = BaseObject & Object & partner__PartnerGroup & {
  __typename: 'partner__PartnerGroup_Type';
  createdAt: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  partner: partner__Partner;
  updatedAt: Scalars['String']['output'];
};


export type partner__PartnerGroup_TypepartnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartner>;
};

export type partner__Partner_Type = BaseObject & Object & Slugged & partner__Partner & {
  __typename: 'partner__Partner_Type';
  createdAt: Scalars['String']['output'];
  groups?: Maybe<Array<partner__PartnerGroup>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};


export type partner__Partner_TypegroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartnerGroup>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartnerGroup>;
};

export type payment__FilterIssuePromoCodeUsage = {
  and?: InputMaybe<Array<payment__FilterIssuePromoCodeUsage>>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<payment__FilterIssuePromoCodeUsage>;
  or?: InputMaybe<Array<payment__FilterIssuePromoCodeUsage>>;
  owner?: InputMaybe<NestedFilterUser>;
  promoCode?: InputMaybe<payment__NestedFilterPromoCode>;
  usedAt?: InputMaybe<FilterString>;
};

export type payment__FilterPaymentProfile = {
  and?: InputMaybe<Array<payment__FilterPaymentProfile>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<payment__FilterPaymentProfile>;
  or?: InputMaybe<Array<payment__FilterPaymentProfile>>;
  owner?: InputMaybe<NestedFilterUser>;
  stripeCustomerId?: InputMaybe<FilterString>;
  stripePaymentMethodId?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type payment__FilterPaymentTransaction = {
  amount?: InputMaybe<FilterDecimal>;
  and?: InputMaybe<Array<payment__FilterPaymentTransaction>>;
  createdAt?: InputMaybe<FilterString>;
  currency?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<payment__FilterPaymentTransaction>;
  or?: InputMaybe<Array<payment__FilterPaymentTransaction>>;
  owner?: InputMaybe<NestedFilterUser>;
  paymentProfile?: InputMaybe<payment__NestedFilterPaymentProfile>;
  status?: InputMaybe<Filterpayment__PaymentStatus>;
  stripeInvoiceId?: InputMaybe<FilterString>;
  stripePaymentIntentId?: InputMaybe<FilterString>;
  stripeReceiptUrl?: InputMaybe<FilterString>;
  transactionType?: InputMaybe<Filterpayment__PaymentTransactionType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type payment__FilterPromoCode = {
  and?: InputMaybe<Array<payment__FilterPromoCode>>;
  code?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<payment__FilterPromoCode>;
  or?: InputMaybe<Array<payment__FilterPromoCode>>;
  updatedAt?: InputMaybe<FilterString>;
};

export type payment__FilterSubscription = {
  and?: InputMaybe<Array<payment__FilterSubscription>>;
  cancelAtPeriodEnd?: InputMaybe<FilterBoolean>;
  canceledAt?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  currentPeriodEnd?: InputMaybe<FilterString>;
  currentPeriodStart?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<payment__FilterSubscription>;
  or?: InputMaybe<Array<payment__FilterSubscription>>;
  owner?: InputMaybe<NestedFilterUser>;
  paymentProfile?: InputMaybe<payment__NestedFilterPaymentProfile>;
  status?: InputMaybe<Filterpayment__SubscriptionStatus>;
  stripePriceId?: InputMaybe<FilterString>;
  stripeSubscriptionId?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type payment__IssuePromoCodeUsage = {
  id: Scalars['ID']['output'];
  issue?: Maybe<issue__Issue>;
  owner: User;
  promoCode: payment__PromoCode;
  usedAt?: Maybe<Scalars['String']['output']>;
};


export type payment__IssuePromoCodeUsageissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type payment__IssuePromoCodeUsageownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type payment__IssuePromoCodeUsagepromoCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPromoCode>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPromoCode>;
};

export type payment__IssuePromoCodeUsage_Type = BaseObject & Object & Owned & payment__IssuePromoCodeUsage & {
  __typename: 'payment__IssuePromoCodeUsage_Type';
  id: Scalars['ID']['output'];
  issue?: Maybe<issue__Issue>;
  owner: User;
  promoCode: payment__PromoCode;
  usedAt?: Maybe<Scalars['String']['output']>;
};


export type payment__IssuePromoCodeUsage_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type payment__IssuePromoCodeUsage_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type payment__IssuePromoCodeUsage_TypepromoCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPromoCode>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPromoCode>;
};

export type payment__NestedFilterIssuePromoCodeUsage = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  owner?: InputMaybe<NestedFilterUser>;
  promoCode?: InputMaybe<payment__NestedFilterPromoCode>;
  usedAt?: InputMaybe<FilterString>;
};

export type payment__NestedFilterPaymentProfile = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  stripeCustomerId?: InputMaybe<FilterString>;
  stripePaymentMethodId?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type payment__NestedFilterPaymentTransaction = {
  amount?: InputMaybe<FilterDecimal>;
  createdAt?: InputMaybe<FilterString>;
  currency?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  owner?: InputMaybe<NestedFilterUser>;
  paymentProfile?: InputMaybe<payment__NestedFilterPaymentProfile>;
  status?: InputMaybe<Filterpayment__PaymentStatus>;
  stripeInvoiceId?: InputMaybe<FilterString>;
  stripePaymentIntentId?: InputMaybe<FilterString>;
  stripeReceiptUrl?: InputMaybe<FilterString>;
  transactionType?: InputMaybe<Filterpayment__PaymentTransactionType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type payment__NestedFilterPromoCode = {
  code?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  updatedAt?: InputMaybe<FilterString>;
};

export type payment__OrderIssuePromoCodeUsage = {
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  owner?: InputMaybe<OrderUser>;
  promoCode?: InputMaybe<payment__OrderPromoCode>;
  usedAt?: InputMaybe<Ordering>;
};

export type payment__OrderPaymentProfile = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  stripeCustomerId?: InputMaybe<Ordering>;
  stripePaymentMethodId?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type payment__OrderPaymentTransaction = {
  amount?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currency?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  owner?: InputMaybe<OrderUser>;
  paymentProfile?: InputMaybe<payment__OrderPaymentProfile>;
  status?: InputMaybe<Ordering>;
  stripeInvoiceId?: InputMaybe<Ordering>;
  stripePaymentIntentId?: InputMaybe<Ordering>;
  stripeReceiptUrl?: InputMaybe<Ordering>;
  transactionType?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type payment__OrderPromoCode = {
  code?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type payment__OrderSubscription = {
  cancelAtPeriodEnd?: InputMaybe<Ordering>;
  canceledAt?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currentPeriodEnd?: InputMaybe<Ordering>;
  currentPeriodStart?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  paymentProfile?: InputMaybe<payment__OrderPaymentProfile>;
  status?: InputMaybe<Ordering>;
  stripePriceId?: InputMaybe<Ordering>;
  stripeSubscriptionId?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type payment__PaymentProfile = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  stripeCustomerId: Scalars['String']['output'];
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};


export type payment__PaymentProfileownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type payment__PaymentProfile_Type = BaseObject & Object & Owned & payment__PaymentProfile & {
  __typename: 'payment__PaymentProfile_Type';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  stripeCustomerId: Scalars['String']['output'];
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};


export type payment__PaymentProfile_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** Status of a payment transaction, matching Stripe PaymentIntent statuses. */
export enum payment__PaymentStatus {
  CANCELED = 'CANCELED',
  PROCESSING = 'PROCESSING',
  REQUIRES_ACTION = 'REQUIRES_ACTION',
  REQUIRES_CAPTURE = 'REQUIRES_CAPTURE',
  REQUIRES_CONFIRMATION = 'REQUIRES_CONFIRMATION',
  REQUIRES_PAYMENT_METHOD = 'REQUIRES_PAYMENT_METHOD',
  SUCCEEDED = 'SUCCEEDED'
}

export type payment__PaymentTransaction = {
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue?: Maybe<issue__Issue>;
  owner: User;
  paymentProfile: payment__PaymentProfile;
  status: payment__PaymentStatus;
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  stripeReceiptUrl?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<payment__PaymentTransactionType>;
  updatedAt: Scalars['String']['output'];
};


export type payment__PaymentTransactionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type payment__PaymentTransactionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type payment__PaymentTransactionpaymentProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentProfile>;
};

/** Type of payment transaction. */
export enum payment__PaymentTransactionType {
  CAPTURE = 'CAPTURE',
  CHARGE = 'CHARGE',
  PRE_AUTHORIZATION = 'PRE_AUTHORIZATION'
}

export type payment__PaymentTransaction_Type = BaseObject & Object & Owned & payment__PaymentTransaction & {
  __typename: 'payment__PaymentTransaction_Type';
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue?: Maybe<issue__Issue>;
  owner: User;
  paymentProfile: payment__PaymentProfile;
  status: payment__PaymentStatus;
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  stripeReceiptUrl?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<payment__PaymentTransactionType>;
  updatedAt: Scalars['String']['output'];
};


export type payment__PaymentTransaction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type payment__PaymentTransaction_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type payment__PaymentTransaction_TypepaymentProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentProfile>;
};

export type payment__PromoCode = {
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
};

export type payment__PromoCode_Type = BaseObject & Object & payment__PromoCode & {
  __typename: 'payment__PromoCode_Type';
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
};

export type payment__Subscription = {
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentPeriodEnd?: Maybe<Scalars['String']['output']>;
  currentPeriodStart?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  paymentProfile: payment__PaymentProfile;
  status: payment__SubscriptionStatus;
  stripePriceId: Scalars['String']['output'];
  stripeSubscriptionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};


export type payment__SubscriptionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type payment__SubscriptionpaymentProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentProfile>;
};

/** Status of a Stripe subscription. */
export enum payment__SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  INCOMPLETE = 'INCOMPLETE',
  INCOMPLETE_EXPIRED = 'INCOMPLETE_EXPIRED',
  PAST_DUE = 'PAST_DUE',
  PAUSED = 'PAUSED',
  TRIALING = 'TRIALING',
  UNPAID = 'UNPAID'
}

export type payment__Subscription_Type = BaseObject & Object & Owned & payment__Subscription & {
  __typename: 'payment__Subscription_Type';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentPeriodEnd?: Maybe<Scalars['String']['output']>;
  currentPeriodStart?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  paymentProfile: payment__PaymentProfile;
  status: payment__SubscriptionStatus;
  stripePriceId: Scalars['String']['output'];
  stripeSubscriptionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};


export type payment__Subscription_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type payment__Subscription_TypepaymentProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentProfile>;
};

export type person__Address = {
  city: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  primary: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};


export type person__AddresspersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};

export type person__Address_Type = BaseObject & Object & Personal & person__Address & {
  __typename: 'person__Address_Type';
  city: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  primary: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};


export type person__Address_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};

export type person__FilterAddress = {
  and?: InputMaybe<Array<person__FilterAddress>>;
  city?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<person__FilterAddress>;
  or?: InputMaybe<Array<person__FilterAddress>>;
  person?: InputMaybe<NestedFilterPerson>;
  primary?: InputMaybe<FilterBoolean>;
  state?: InputMaybe<FilterString>;
  street?: InputMaybe<FilterString>;
  street2?: InputMaybe<FilterString>;
  zip?: InputMaybe<FilterString>;
};

export type person__NestedFilterAddress = {
  city?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  person?: InputMaybe<NestedFilterPerson>;
  primary?: InputMaybe<FilterBoolean>;
  state?: InputMaybe<FilterString>;
  street?: InputMaybe<FilterString>;
  street2?: InputMaybe<FilterString>;
  zip?: InputMaybe<FilterString>;
};

export type person__OrderAddress = {
  city?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
  primary?: InputMaybe<Ordering>;
  state?: InputMaybe<Ordering>;
  street?: InputMaybe<Ordering>;
  street2?: InputMaybe<Ordering>;
  zip?: InputMaybe<Ordering>;
};

export type plan__BenefitsSummaryResult = {
  createdAt: Scalars['String']['output'];
  event?: Maybe<issue__BenefitsSummaryGeneratedEvent>;
  id: Scalars['ID']['output'];
  owner: User;
  plan: plan__Plan;
  schemaVersion: Scalars['Int']['output'];
  summary: Scalars['JSON']['output'];
  updatedAt: Scalars['String']['output'];
};


export type plan__BenefitsSummaryResulteventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBenefitsSummaryGeneratedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBenefitsSummaryGeneratedEvent>;
};


export type plan__BenefitsSummaryResultownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type plan__BenefitsSummaryResultplanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};

export type plan__BenefitsSummaryResult_Type = BaseObject & Object & Owned & plan__BenefitsSummaryResult & {
  __typename: 'plan__BenefitsSummaryResult_Type';
  createdAt: Scalars['String']['output'];
  event?: Maybe<issue__BenefitsSummaryGeneratedEvent>;
  id: Scalars['ID']['output'];
  owner: User;
  plan: plan__Plan;
  schemaVersion: Scalars['Int']['output'];
  summary: Scalars['JSON']['output'];
  updatedAt: Scalars['String']['output'];
};


export type plan__BenefitsSummaryResult_TypeeventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBenefitsSummaryGeneratedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBenefitsSummaryGeneratedEvent>;
};


export type plan__BenefitsSummaryResult_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type plan__BenefitsSummaryResult_TypeplanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};

export type plan__FilterBenefitsSummaryResult = {
  and?: InputMaybe<Array<plan__FilterBenefitsSummaryResult>>;
  createdAt?: InputMaybe<FilterString>;
  event?: InputMaybe<issue__NestedFilterBenefitsSummaryGeneratedEvent>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<plan__FilterBenefitsSummaryResult>;
  or?: InputMaybe<Array<plan__FilterBenefitsSummaryResult>>;
  owner?: InputMaybe<NestedFilterUser>;
  plan?: InputMaybe<plan__NestedFilterPlan>;
  schemaVersion?: InputMaybe<FilterInt>;
  summary?: InputMaybe<FilterJSON>;
  updatedAt?: InputMaybe<FilterString>;
};

export type plan__FilterPlan = {
  activeCoverages?: InputMaybe<fhirext__NestedFilterCoverageVersion>;
  and?: InputMaybe<Array<plan__FilterPlan>>;
  benefitsSummaryResults?: InputMaybe<plan__NestedFilterBenefitsSummaryResult>;
  coc?: InputMaybe<document__NestedFilterDocument>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  not?: InputMaybe<plan__FilterPlan>;
  or?: InputMaybe<Array<plan__FilterPlan>>;
  owner?: InputMaybe<NestedFilterUser>;
  planLabel?: InputMaybe<FilterString>;
  planType?: InputMaybe<Filterplan__PlanType>;
  sbc?: InputMaybe<document__NestedFilterDocument>;
  sob?: InputMaybe<document__NestedFilterDocument>;
  spd?: InputMaybe<document__NestedFilterDocument>;
  status?: InputMaybe<Filterplan__PlanStatus>;
};

export type plan__NestedFilterBenefitsSummaryResult = {
  createdAt?: InputMaybe<FilterString>;
  event?: InputMaybe<issue__NestedFilterBenefitsSummaryGeneratedEvent>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  plan?: InputMaybe<plan__NestedFilterPlan>;
  schemaVersion?: InputMaybe<FilterInt>;
  summary?: InputMaybe<FilterJSON>;
  updatedAt?: InputMaybe<FilterString>;
};

export type plan__NestedFilterPlan = {
  activeCoverages?: InputMaybe<fhirext__NestedFilterCoverageVersion>;
  benefitsSummaryResults?: InputMaybe<plan__NestedFilterBenefitsSummaryResult>;
  coc?: InputMaybe<document__NestedFilterDocument>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  owner?: InputMaybe<NestedFilterUser>;
  planLabel?: InputMaybe<FilterString>;
  planType?: InputMaybe<Filterplan__PlanType>;
  sbc?: InputMaybe<document__NestedFilterDocument>;
  sob?: InputMaybe<document__NestedFilterDocument>;
  spd?: InputMaybe<document__NestedFilterDocument>;
  status?: InputMaybe<Filterplan__PlanStatus>;
};

export type plan__OrderBenefitsSummaryResult = {
  createdAt?: InputMaybe<Ordering>;
  event?: InputMaybe<issue__OrderBenefitsSummaryGeneratedEvent>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  plan?: InputMaybe<plan__OrderPlan>;
  schemaVersion?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type plan__OrderPlan = {
  coc?: InputMaybe<document__OrderDocument>;
  coverageType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  link?: InputMaybe<webAgent__OrderLink>;
  owner?: InputMaybe<OrderUser>;
  planLabel?: InputMaybe<Ordering>;
  planType?: InputMaybe<Ordering>;
  sbc?: InputMaybe<document__OrderDocument>;
  sob?: InputMaybe<document__OrderDocument>;
  spd?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
};

export type plan__Plan = {
  activeCoverages?: Maybe<Array<fhirext__CoverageVersion>>;
  benefitsSummaryResults?: Maybe<Array<plan__BenefitsSummaryResult>>;
  coc?: Maybe<document__Document>;
  coveragePeriod?: Maybe<Scalars['JSON']['output']>;
  coverageType?: Maybe<fhir__CoverageType>;
  createdAt: Scalars['String']['output'];
  document?: Maybe<document__Document>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<webAgent__Link>;
  owner: User;
  planLabel?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<plan__PlanType>;
  sbc?: Maybe<document__Document>;
  sob?: Maybe<document__Document>;
  spd?: Maybe<document__Document>;
  status?: Maybe<plan__PlanStatus>;
};


export type plan__PlanactiveCoveragesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterCoverageVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderCoverageVersion>;
};


export type plan__PlanbenefitsSummaryResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterBenefitsSummaryResult>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderBenefitsSummaryResult>;
};


export type plan__PlancocArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__PlandocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__PlanlinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type plan__PlanownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type plan__PlansbcArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__PlansobArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__PlanspdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

/** Status of the plan: ACTIVE, CANCELLED, PENDING. */
export enum plan__PlanStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING'
}

/** Type of health insurance plan. */
export enum plan__PlanType {
  Catastrophic = 'Catastrophic',
  DEPO = 'DEPO',
  DHMO = 'DHMO',
  DISP = 'DISP',
  DPOS = 'DPOS',
  DPPO = 'DPPO',
  EHB = 'EHB',
  EPO = 'EPO',
  FFS = 'FFS',
  HDHP = 'HDHP',
  HMO = 'HMO',
  Indemnity = 'Indemnity',
  MAPD = 'MAPD',
  MA_PD = 'MA_PD',
  MTM = 'MTM',
  OTC = 'OTC',
  PBM = 'PBM',
  PDP = 'PDP',
  POS = 'POS',
  PPO = 'PPO',
  Rx = 'Rx',
  VFFS = 'VFFS',
  VHMO = 'VHMO',
  VPOS = 'VPOS',
  VPPO = 'VPPO',
  VSP = 'VSP'
}

export type plan__Plan_Type = BaseObject & Object & Owned & plan__Plan & {
  __typename: 'plan__Plan_Type';
  activeCoverages?: Maybe<Array<fhirext__CoverageVersion>>;
  benefitsSummaryResults?: Maybe<Array<plan__BenefitsSummaryResult>>;
  coc?: Maybe<document__Document>;
  coveragePeriod?: Maybe<Scalars['JSON']['output']>;
  coverageType?: Maybe<fhir__CoverageType>;
  createdAt: Scalars['String']['output'];
  document?: Maybe<document__Document>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<webAgent__Link>;
  owner: User;
  planLabel?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<plan__PlanType>;
  sbc?: Maybe<document__Document>;
  sob?: Maybe<document__Document>;
  spd?: Maybe<document__Document>;
  status?: Maybe<plan__PlanStatus>;
};


export type plan__Plan_TypeactiveCoveragesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterCoverageVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderCoverageVersion>;
};


export type plan__Plan_TypebenefitsSummaryResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterBenefitsSummaryResult>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderBenefitsSummaryResult>;
};


export type plan__Plan_TypecocArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__Plan_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__Plan_TypelinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type plan__Plan_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type plan__Plan_TypesbcArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__Plan_TypesobArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__Plan_TypespdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

export enum projection__CaseLifecycle {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN'
}

export type projection__CaseView = {
  caseType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  documentCount: Scalars['Int64']['output'];
  facts?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  info?: Maybe<Scalars['JSON']['output']>;
  isEscalated: Scalars['Boolean']['output'];
  issue: issue__Issue;
  lifecycle: projection__CaseLifecycle;
  milestones?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};


export type projection__CaseViewissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type projection__CaseView_Type = BaseObject & Object & projection__CaseView & {
  __typename: 'projection__CaseView_Type';
  caseType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  documentCount: Scalars['Int64']['output'];
  facts?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  info?: Maybe<Scalars['JSON']['output']>;
  isEscalated: Scalars['Boolean']['output'];
  issue: issue__Issue;
  lifecycle: projection__CaseLifecycle;
  milestones?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};


export type projection__CaseView_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export enum projection__CdpProvider {
  BRIGHTDATA = 'BRIGHTDATA',
  BROWSERBASE = 'BROWSERBASE',
  BROWSERLESS = 'BROWSERLESS',
  LOCAL = 'LOCAL',
  STEEL = 'STEEL'
}

export type projection__EligibilityCheckAttemptView = {
  attemptedAt: Scalars['String']['output'];
  dispatchReason?: Maybe<projection__EligibilityCheckDispatchReason>;
  dispatched: Scalars['Boolean']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  errorSubCode?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  materializationKey: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  membershipSource?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
  npiSource?: Maybe<Scalars['String']['output']>;
  outcome: projection__EligibilityCheckOutcome;
  payerId?: Maybe<Scalars['String']['output']>;
  payerName: Scalars['String']['output'];
  payerSource?: Maybe<Scalars['String']['output']>;
  subscriberDobSource?: Maybe<Scalars['String']['output']>;
  subscriberFirstNameSource?: Maybe<Scalars['String']['output']>;
  subscriberLastNameSource?: Maybe<Scalars['String']['output']>;
  user: User;
  vendorResponseId?: Maybe<Scalars['String']['output']>;
};


export type projection__EligibilityCheckAttemptViewuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__EligibilityCheckAttemptView_Type = BaseObject & Object & projection__EligibilityCheckAttemptView & {
  __typename: 'projection__EligibilityCheckAttemptView_Type';
  attemptedAt: Scalars['String']['output'];
  dispatchReason?: Maybe<projection__EligibilityCheckDispatchReason>;
  dispatched: Scalars['Boolean']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  errorSubCode?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  materializationKey: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  membershipSource?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
  npiSource?: Maybe<Scalars['String']['output']>;
  outcome: projection__EligibilityCheckOutcome;
  payerId?: Maybe<Scalars['String']['output']>;
  payerName: Scalars['String']['output'];
  payerSource?: Maybe<Scalars['String']['output']>;
  subscriberDobSource?: Maybe<Scalars['String']['output']>;
  subscriberFirstNameSource?: Maybe<Scalars['String']['output']>;
  subscriberLastNameSource?: Maybe<Scalars['String']['output']>;
  user: User;
  vendorResponseId?: Maybe<Scalars['String']['output']>;
};


export type projection__EligibilityCheckAttemptView_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum projection__EligibilityCheckDispatchReason {
  BASELINE = 'BASELINE',
  CHANGED = 'CHANGED',
  DRY_RUN = 'DRY_RUN',
  EMPTY_SNAPSHOT = 'EMPTY_SNAPSHOT',
  FORCED = 'FORCED',
  UNCHANGED = 'UNCHANGED'
}

export enum projection__EligibilityCheckOutcome {
  CHECKED = 'CHECKED',
  FAILED = 'FAILED',
  SKIPPED = 'SKIPPED'
}

export enum projection__EnrichmentConfidence {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export enum projection__EnrichmentPriceRating {
  GOOD_VALUE = 'GOOD_VALUE',
  HIGH = 'HIGH',
  LOW = 'LOW',
  TYPICAL = 'TYPICAL',
  UNKNOWN = 'UNKNOWN'
}

export type projection__FilterCaseView = {
  and?: InputMaybe<Array<projection__FilterCaseView>>;
  caseType?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  documentCount?: InputMaybe<FilterInt64>;
  facts?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  info?: InputMaybe<FilterJSON>;
  isEscalated?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  lifecycle?: InputMaybe<Filterprojection__CaseLifecycle>;
  milestones?: InputMaybe<FilterJSON>;
  not?: InputMaybe<projection__FilterCaseView>;
  or?: InputMaybe<Array<projection__FilterCaseView>>;
  updatedAt?: InputMaybe<FilterString>;
  userId?: InputMaybe<FilterString>;
};

export type projection__FilterEligibilityCheckAttemptView = {
  and?: InputMaybe<Array<projection__FilterEligibilityCheckAttemptView>>;
  attemptedAt?: InputMaybe<FilterString>;
  dispatchReason?: InputMaybe<Filterprojection__EligibilityCheckDispatchReason>;
  dispatched?: InputMaybe<FilterBoolean>;
  errorCode?: InputMaybe<FilterString>;
  errorSubCode?: InputMaybe<FilterString>;
  eventId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  materializationKey?: InputMaybe<FilterString>;
  memberId?: InputMaybe<FilterString>;
  membershipSource?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterEligibilityCheckAttemptView>;
  npi?: InputMaybe<FilterString>;
  npiSource?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<projection__FilterEligibilityCheckAttemptView>>;
  outcome?: InputMaybe<Filterprojection__EligibilityCheckOutcome>;
  payerId?: InputMaybe<FilterString>;
  payerName?: InputMaybe<FilterString>;
  payerSource?: InputMaybe<FilterString>;
  subscriberDobSource?: InputMaybe<FilterString>;
  subscriberFirstNameSource?: InputMaybe<FilterString>;
  subscriberLastNameSource?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
  vendorResponseId?: InputMaybe<FilterString>;
};

export type projection__FilterRpaConnection = {
  and?: InputMaybe<Array<projection__FilterRpaConnection>>;
  connectionId?: InputMaybe<FilterString>;
  connectionStatus?: InputMaybe<Filterprojection__RpaConnectionStatus>;
  id?: InputMaybe<FilterID>;
  inspectUrl?: InputMaybe<FilterString>;
  lostReason?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterRpaConnection>;
  or?: InputMaybe<Array<projection__FilterRpaConnection>>;
  session?: InputMaybe<projection__NestedFilterRpaSession>;
  startedAt?: InputMaybe<FilterString>;
  tasks?: InputMaybe<projection__NestedFilterRpaTask>;
};

export type projection__FilterRpaEgressIp = {
  and?: InputMaybe<Array<projection__FilterRpaEgressIp>>;
  connectionId?: InputMaybe<FilterString>;
  data?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterRpaEgressIp>;
  or?: InputMaybe<Array<projection__FilterRpaEgressIp>>;
  schemaVersion?: InputMaybe<FilterInt64>;
  sessionId?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type projection__FilterRpaExperimentView = {
  and?: InputMaybe<Array<projection__FilterRpaExperimentView>>;
  data?: InputMaybe<FilterJSON>;
  experimentId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterRpaExperimentView>;
  or?: InputMaybe<Array<projection__FilterRpaExperimentView>>;
  schemaVersion?: InputMaybe<FilterInt64>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterString>;
  stoppedAt?: InputMaybe<FilterString>;
};

export type projection__FilterRpaLinkView = {
  and?: InputMaybe<Array<projection__FilterRpaLinkView>>;
  data?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  linkId?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterRpaLinkView>;
  or?: InputMaybe<Array<projection__FilterRpaLinkView>>;
  schemaVersion?: InputMaybe<FilterInt64>;
};

export type projection__FilterRpaProviderAttempt = {
  and?: InputMaybe<Array<projection__FilterRpaProviderAttempt>>;
  errorMessage?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterRpaProviderAttempt>;
  occurredAt?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<projection__FilterRpaProviderAttempt>>;
  provider?: InputMaybe<Filterprojection__CdpProvider>;
  session?: InputMaybe<projection__NestedFilterRpaSession>;
  success?: InputMaybe<FilterBoolean>;
};

export type projection__FilterRpaSession = {
  and?: InputMaybe<Array<projection__FilterRpaSession>>;
  cancelledAt?: InputMaybe<FilterString>;
  cdpProviderSessionId?: InputMaybe<FilterString>;
  connections?: InputMaybe<projection__NestedFilterRpaConnection>;
  endpointId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  linkId?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterRpaSession>;
  or?: InputMaybe<Array<projection__FilterRpaSession>>;
  provider?: InputMaybe<Filterprojection__CdpProvider>;
  providerAttempts?: InputMaybe<projection__NestedFilterRpaProviderAttempt>;
  proxyStrategy?: InputMaybe<Filterprojection__ProxyStrategy>;
  sessionId?: InputMaybe<FilterString>;
  sessionStatus?: InputMaybe<Filterprojection__RpaSessionStatus>;
  startedAt?: InputMaybe<FilterString>;
  stealthStrategy?: InputMaybe<Filterprojection__StealthStrategy>;
  timeline?: InputMaybe<projection__NestedFilterRpaTimelineEntry>;
  userId?: InputMaybe<FilterString>;
};

export type projection__FilterRpaSessionSummary = {
  and?: InputMaybe<Array<projection__FilterRpaSessionSummary>>;
  data?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  linkId?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterRpaSessionSummary>;
  or?: InputMaybe<Array<projection__FilterRpaSessionSummary>>;
  schemaVersion?: InputMaybe<FilterInt64>;
  sessionId?: InputMaybe<FilterString>;
  startedAt?: InputMaybe<FilterString>;
};

export type projection__FilterRpaSessionTimeline = {
  and?: InputMaybe<Array<projection__FilterRpaSessionTimeline>>;
  data?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterRpaSessionTimeline>;
  or?: InputMaybe<Array<projection__FilterRpaSessionTimeline>>;
  schemaVersion?: InputMaybe<FilterInt64>;
  sessionId?: InputMaybe<FilterString>;
};

export type projection__FilterRpaTask = {
  and?: InputMaybe<Array<projection__FilterRpaTask>>;
  classifyActionTaken?: InputMaybe<FilterBoolean>;
  classifyClassification?: InputMaybe<FilterString>;
  connection?: InputMaybe<projection__NestedFilterRpaConnection>;
  failureReason?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  kind?: InputMaybe<Filterprojection__RpaTaskKind>;
  not?: InputMaybe<projection__FilterRpaTask>;
  or?: InputMaybe<Array<projection__FilterRpaTask>>;
  signInPhase?: InputMaybe<FilterString>;
  signInPhaseDetail?: InputMaybe<FilterJSON>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterprojection__RpaTaskStatus>;
  taskId?: InputMaybe<FilterString>;
};

export type projection__FilterRpaTimelineEntry = {
  and?: InputMaybe<Array<projection__FilterRpaTimelineEntry>>;
  eventDetail?: InputMaybe<FilterJSON>;
  eventTag?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterRpaTimelineEntry>;
  occurredAt?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<projection__FilterRpaTimelineEntry>>;
  session?: InputMaybe<projection__NestedFilterRpaSession>;
};

export type projection__FilterUserDataView = {
  and?: InputMaybe<Array<projection__FilterUserDataView>>;
  createdAt?: InputMaybe<FilterString>;
  data?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  key?: InputMaybe<FilterString>;
  kind?: InputMaybe<FilterString>;
  metadata?: InputMaybe<FilterJSON>;
  not?: InputMaybe<projection__FilterUserDataView>;
  or?: InputMaybe<Array<projection__FilterUserDataView>>;
  schemaVersion?: InputMaybe<FilterInt64>;
  updatedAt?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type projection__FilterUserEligibilityView = {
  and?: InputMaybe<Array<projection__FilterUserEligibilityView>>;
  createdAt?: InputMaybe<FilterString>;
  enrolledAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  lastCheckDispatchReason?: InputMaybe<Filterprojection__EligibilityCheckDispatchReason>;
  lastCheckOutcome?: InputMaybe<Filterprojection__EligibilityCheckOutcome>;
  lastCheckVendorResponseId?: InputMaybe<FilterString>;
  lastCheckedAt?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterUserEligibilityView>;
  or?: InputMaybe<Array<projection__FilterUserEligibilityView>>;
  updatedAt?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type projection__FilterUserEnrichmentData = {
  and?: InputMaybe<Array<projection__FilterUserEnrichmentData>>;
  confidence?: InputMaybe<Filterprojection__EnrichmentConfidence>;
  createdAt?: InputMaybe<FilterString>;
  enrichments?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  key?: InputMaybe<FilterString>;
  kind?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterUserEnrichmentData>;
  or?: InputMaybe<Array<projection__FilterUserEnrichmentData>>;
  overallPriceRating?: InputMaybe<Filterprojection__EnrichmentPriceRating>;
  schemaVersion?: InputMaybe<FilterInt64>;
  title?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type projection__FilterUserMemory = {
  and?: InputMaybe<Array<projection__FilterUserMemory>>;
  createdAt?: InputMaybe<FilterString>;
  entries?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterUserMemory>;
  or?: InputMaybe<Array<projection__FilterUserMemory>>;
  updatedAt?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type projection__NestedFilterRpaConnection = {
  connectionId?: InputMaybe<FilterString>;
  connectionStatus?: InputMaybe<Filterprojection__RpaConnectionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  inspectUrl?: InputMaybe<FilterString>;
  lostReason?: InputMaybe<FilterString>;
  session?: InputMaybe<projection__NestedFilterRpaSession>;
  startedAt?: InputMaybe<FilterString>;
  tasks?: InputMaybe<projection__NestedFilterRpaTask>;
};

export type projection__NestedFilterRpaProviderAttempt = {
  errorMessage?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  occurredAt?: InputMaybe<FilterString>;
  provider?: InputMaybe<Filterprojection__CdpProvider>;
  session?: InputMaybe<projection__NestedFilterRpaSession>;
  success?: InputMaybe<FilterBoolean>;
};

export type projection__NestedFilterRpaSession = {
  cancelledAt?: InputMaybe<FilterString>;
  cdpProviderSessionId?: InputMaybe<FilterString>;
  connections?: InputMaybe<projection__NestedFilterRpaConnection>;
  endpointId?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  linkId?: InputMaybe<FilterString>;
  provider?: InputMaybe<Filterprojection__CdpProvider>;
  providerAttempts?: InputMaybe<projection__NestedFilterRpaProviderAttempt>;
  proxyStrategy?: InputMaybe<Filterprojection__ProxyStrategy>;
  sessionId?: InputMaybe<FilterString>;
  sessionStatus?: InputMaybe<Filterprojection__RpaSessionStatus>;
  startedAt?: InputMaybe<FilterString>;
  stealthStrategy?: InputMaybe<Filterprojection__StealthStrategy>;
  timeline?: InputMaybe<projection__NestedFilterRpaTimelineEntry>;
  userId?: InputMaybe<FilterString>;
};

export type projection__NestedFilterRpaTask = {
  classifyActionTaken?: InputMaybe<FilterBoolean>;
  classifyClassification?: InputMaybe<FilterString>;
  connection?: InputMaybe<projection__NestedFilterRpaConnection>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  failureReason?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  kind?: InputMaybe<Filterprojection__RpaTaskKind>;
  signInPhase?: InputMaybe<FilterString>;
  signInPhaseDetail?: InputMaybe<FilterJSON>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterprojection__RpaTaskStatus>;
  taskId?: InputMaybe<FilterString>;
};

export type projection__NestedFilterRpaTimelineEntry = {
  eventDetail?: InputMaybe<FilterJSON>;
  eventTag?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  occurredAt?: InputMaybe<FilterString>;
  session?: InputMaybe<projection__NestedFilterRpaSession>;
};

export type projection__OrderCaseView = {
  caseType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  documentCount?: InputMaybe<Ordering>;
  facts?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  info?: InputMaybe<Ordering>;
  isEscalated?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  lifecycle?: InputMaybe<Ordering>;
  milestones?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  userId?: InputMaybe<Ordering>;
};

export type projection__OrderEligibilityCheckAttemptView = {
  attemptedAt?: InputMaybe<Ordering>;
  dispatchReason?: InputMaybe<Ordering>;
  dispatched?: InputMaybe<Ordering>;
  errorCode?: InputMaybe<Ordering>;
  errorSubCode?: InputMaybe<Ordering>;
  eventId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  materializationKey?: InputMaybe<Ordering>;
  memberId?: InputMaybe<Ordering>;
  membershipSource?: InputMaybe<Ordering>;
  npi?: InputMaybe<Ordering>;
  npiSource?: InputMaybe<Ordering>;
  outcome?: InputMaybe<Ordering>;
  payerId?: InputMaybe<Ordering>;
  payerName?: InputMaybe<Ordering>;
  payerSource?: InputMaybe<Ordering>;
  subscriberDobSource?: InputMaybe<Ordering>;
  subscriberFirstNameSource?: InputMaybe<Ordering>;
  subscriberLastNameSource?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
  vendorResponseId?: InputMaybe<Ordering>;
};

export type projection__OrderRpaConnection = {
  connectionId?: InputMaybe<Ordering>;
  connectionStatus?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  inspectUrl?: InputMaybe<Ordering>;
  lostReason?: InputMaybe<Ordering>;
  session?: InputMaybe<projection__OrderRpaSession>;
  startedAt?: InputMaybe<Ordering>;
};

export type projection__OrderRpaEgressIp = {
  connectionId?: InputMaybe<Ordering>;
  data?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  sessionId?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type projection__OrderRpaExperimentView = {
  data?: InputMaybe<Ordering>;
  experimentId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  stoppedAt?: InputMaybe<Ordering>;
};

export type projection__OrderRpaLinkView = {
  data?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  linkId?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
};

export type projection__OrderRpaProviderAttempt = {
  errorMessage?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  occurredAt?: InputMaybe<Ordering>;
  provider?: InputMaybe<Ordering>;
  session?: InputMaybe<projection__OrderRpaSession>;
  success?: InputMaybe<Ordering>;
};

export type projection__OrderRpaSession = {
  cancelledAt?: InputMaybe<Ordering>;
  cdpProviderSessionId?: InputMaybe<Ordering>;
  endpointId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  linkId?: InputMaybe<Ordering>;
  provider?: InputMaybe<Ordering>;
  proxyStrategy?: InputMaybe<Ordering>;
  sessionId?: InputMaybe<Ordering>;
  sessionStatus?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
  stealthStrategy?: InputMaybe<Ordering>;
  userId?: InputMaybe<Ordering>;
};

export type projection__OrderRpaSessionSummary = {
  data?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  linkId?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  sessionId?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
};

export type projection__OrderRpaSessionTimeline = {
  data?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  sessionId?: InputMaybe<Ordering>;
};

export type projection__OrderRpaTask = {
  classifyActionTaken?: InputMaybe<Ordering>;
  classifyClassification?: InputMaybe<Ordering>;
  connection?: InputMaybe<projection__OrderRpaConnection>;
  failureReason?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  signInPhase?: InputMaybe<Ordering>;
  signInPhaseDetail?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  taskId?: InputMaybe<Ordering>;
};

export type projection__OrderRpaTimelineEntry = {
  eventDetail?: InputMaybe<Ordering>;
  eventTag?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  occurredAt?: InputMaybe<Ordering>;
  session?: InputMaybe<projection__OrderRpaSession>;
};

export type projection__OrderUserDataView = {
  createdAt?: InputMaybe<Ordering>;
  data?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  key?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  metadata?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type projection__OrderUserEligibilityView = {
  createdAt?: InputMaybe<Ordering>;
  enrolledAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  lastCheckDispatchReason?: InputMaybe<Ordering>;
  lastCheckOutcome?: InputMaybe<Ordering>;
  lastCheckVendorResponseId?: InputMaybe<Ordering>;
  lastCheckedAt?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type projection__OrderUserEnrichmentData = {
  confidence?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  enrichments?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  key?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  overallPriceRating?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type projection__OrderUserMemory = {
  createdAt?: InputMaybe<Ordering>;
  entries?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export enum projection__ProxyStrategy {
  DEFAULT = 'DEFAULT',
  PROXY_LOCATION = 'PROXY_LOCATION',
  USER_IP = 'USER_IP'
}

export type projection__RpaConnection = {
  connectionId: Scalars['String']['output'];
  connectionStatus?: Maybe<projection__RpaConnectionStatus>;
  id: Scalars['ID']['output'];
  inspectUrl?: Maybe<Scalars['String']['output']>;
  lostReason?: Maybe<Scalars['String']['output']>;
  session?: Maybe<projection__RpaSession>;
  startedAt: Scalars['String']['output'];
  tasks?: Maybe<Array<projection__RpaTask>>;
};


export type projection__RpaConnectionsessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSession>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSession>;
};


export type projection__RpaConnectiontasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaTask>;
};

export enum projection__RpaConnectionStatus {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  LOST = 'LOST'
}

export type projection__RpaConnection_Type = BaseObject & Object & projection__RpaConnection & {
  __typename: 'projection__RpaConnection_Type';
  connectionId: Scalars['String']['output'];
  connectionStatus?: Maybe<projection__RpaConnectionStatus>;
  id: Scalars['ID']['output'];
  inspectUrl?: Maybe<Scalars['String']['output']>;
  lostReason?: Maybe<Scalars['String']['output']>;
  session?: Maybe<projection__RpaSession>;
  startedAt: Scalars['String']['output'];
  tasks?: Maybe<Array<projection__RpaTask>>;
};


export type projection__RpaConnection_TypesessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSession>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSession>;
};


export type projection__RpaConnection_TypetasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaTask>;
};

export type projection__RpaEgressIp = {
  connectionId: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  schemaVersion: Scalars['Int64']['output'];
  sessionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type projection__RpaEgressIp_Type = BaseObject & Object & projection__RpaEgressIp & {
  __typename: 'projection__RpaEgressIp_Type';
  connectionId: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  schemaVersion: Scalars['Int64']['output'];
  sessionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type projection__RpaExperimentView = {
  data: Scalars['JSON']['output'];
  experimentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  schemaVersion: Scalars['Int64']['output'];
  startedAt: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stoppedAt?: Maybe<Scalars['String']['output']>;
};

export type projection__RpaExperimentView_Type = BaseObject & Object & projection__RpaExperimentView & {
  __typename: 'projection__RpaExperimentView_Type';
  data: Scalars['JSON']['output'];
  experimentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  schemaVersion: Scalars['Int64']['output'];
  startedAt: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stoppedAt?: Maybe<Scalars['String']['output']>;
};

export type projection__RpaLinkView = {
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  linkId: Scalars['String']['output'];
  schemaVersion: Scalars['Int64']['output'];
};

export type projection__RpaLinkView_Type = BaseObject & Object & projection__RpaLinkView & {
  __typename: 'projection__RpaLinkView_Type';
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  linkId: Scalars['String']['output'];
  schemaVersion: Scalars['Int64']['output'];
};

export type projection__RpaProviderAttempt = {
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  provider: projection__CdpProvider;
  session: projection__RpaSession;
  success: Scalars['Boolean']['output'];
};


export type projection__RpaProviderAttemptsessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSession>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSession>;
};

export type projection__RpaProviderAttempt_Type = BaseObject & Object & projection__RpaProviderAttempt & {
  __typename: 'projection__RpaProviderAttempt_Type';
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  provider: projection__CdpProvider;
  session: projection__RpaSession;
  success: Scalars['Boolean']['output'];
};


export type projection__RpaProviderAttempt_TypesessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSession>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSession>;
};

export type projection__RpaSession = {
  cancelledAt?: Maybe<Scalars['String']['output']>;
  cdpProviderSessionId?: Maybe<Scalars['String']['output']>;
  connections?: Maybe<Array<projection__RpaConnection>>;
  endpointId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<projection__CdpProvider>;
  providerAttempts?: Maybe<Array<projection__RpaProviderAttempt>>;
  proxyStrategy?: Maybe<projection__ProxyStrategy>;
  sessionId: Scalars['String']['output'];
  sessionStatus?: Maybe<projection__RpaSessionStatus>;
  startedAt: Scalars['String']['output'];
  stealthStrategy?: Maybe<projection__StealthStrategy>;
  timeline?: Maybe<Array<projection__RpaTimelineEntry>>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type projection__RpaSessionconnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaConnection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaConnection>;
};


export type projection__RpaSessionproviderAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaProviderAttempt>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaProviderAttempt>;
};


export type projection__RpaSessiontimelineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaTimelineEntry>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaTimelineEntry>;
};

export enum projection__RpaSessionStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  SUCCEEDED = 'SUCCEEDED'
}

export type projection__RpaSessionSummary = {
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  linkId: Scalars['String']['output'];
  schemaVersion: Scalars['Int64']['output'];
  sessionId: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
};

export type projection__RpaSessionSummary_Type = BaseObject & Object & projection__RpaSessionSummary & {
  __typename: 'projection__RpaSessionSummary_Type';
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  linkId: Scalars['String']['output'];
  schemaVersion: Scalars['Int64']['output'];
  sessionId: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
};

export type projection__RpaSessionTimeline = {
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  schemaVersion: Scalars['Int64']['output'];
  sessionId: Scalars['String']['output'];
};

export type projection__RpaSessionTimeline_Type = BaseObject & Object & projection__RpaSessionTimeline & {
  __typename: 'projection__RpaSessionTimeline_Type';
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  schemaVersion: Scalars['Int64']['output'];
  sessionId: Scalars['String']['output'];
};

export type projection__RpaSession_Type = BaseObject & Object & projection__RpaSession & {
  __typename: 'projection__RpaSession_Type';
  cancelledAt?: Maybe<Scalars['String']['output']>;
  cdpProviderSessionId?: Maybe<Scalars['String']['output']>;
  connections?: Maybe<Array<projection__RpaConnection>>;
  endpointId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<projection__CdpProvider>;
  providerAttempts?: Maybe<Array<projection__RpaProviderAttempt>>;
  proxyStrategy?: Maybe<projection__ProxyStrategy>;
  sessionId: Scalars['String']['output'];
  sessionStatus?: Maybe<projection__RpaSessionStatus>;
  startedAt: Scalars['String']['output'];
  stealthStrategy?: Maybe<projection__StealthStrategy>;
  timeline?: Maybe<Array<projection__RpaTimelineEntry>>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type projection__RpaSession_TypeconnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaConnection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaConnection>;
};


export type projection__RpaSession_TypeproviderAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaProviderAttempt>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaProviderAttempt>;
};


export type projection__RpaSession_TypetimelineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaTimelineEntry>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaTimelineEntry>;
};

export type projection__RpaTask = {
  classifyActionTaken?: Maybe<Scalars['Boolean']['output']>;
  classifyClassification?: Maybe<Scalars['String']['output']>;
  connection?: Maybe<projection__RpaConnection>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<projection__RpaTaskKind>;
  signInPhase?: Maybe<Scalars['String']['output']>;
  signInPhaseDetail?: Maybe<Scalars['JSON']['output']>;
  startedAt: Scalars['String']['output'];
  status?: Maybe<projection__RpaTaskStatus>;
  taskId: Scalars['String']['output'];
};


export type projection__RpaTaskconnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaConnection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaConnection>;
};

export enum projection__RpaTaskKind {
  CLASSIFY = 'CLASSIFY',
  CRAWL = 'CRAWL',
  SIGN_IN = 'SIGN_IN',
  TAILGATE = 'TAILGATE'
}

export enum projection__RpaTaskStatus {
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCEEDED = 'SUCCEEDED'
}

export type projection__RpaTask_Type = BaseObject & Object & projection__RpaTask & {
  __typename: 'projection__RpaTask_Type';
  classifyActionTaken?: Maybe<Scalars['Boolean']['output']>;
  classifyClassification?: Maybe<Scalars['String']['output']>;
  connection?: Maybe<projection__RpaConnection>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<projection__RpaTaskKind>;
  signInPhase?: Maybe<Scalars['String']['output']>;
  signInPhaseDetail?: Maybe<Scalars['JSON']['output']>;
  startedAt: Scalars['String']['output'];
  status?: Maybe<projection__RpaTaskStatus>;
  taskId: Scalars['String']['output'];
};


export type projection__RpaTask_TypeconnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaConnection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaConnection>;
};

export type projection__RpaTimelineEntry = {
  eventDetail?: Maybe<Scalars['JSON']['output']>;
  eventTag: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  session?: Maybe<projection__RpaSession>;
};


export type projection__RpaTimelineEntrysessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSession>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSession>;
};

export type projection__RpaTimelineEntry_Type = BaseObject & Object & projection__RpaTimelineEntry & {
  __typename: 'projection__RpaTimelineEntry_Type';
  eventDetail?: Maybe<Scalars['JSON']['output']>;
  eventTag: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  session?: Maybe<projection__RpaSession>;
};


export type projection__RpaTimelineEntry_TypesessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSession>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSession>;
};

export enum projection__StealthStrategy {
  ADVANCED_STEALTH = 'ADVANCED_STEALTH',
  BASIC_STEALTH = 'BASIC_STEALTH',
  DEFAULT = 'DEFAULT'
}

export type projection__UserDataView = {
  createdAt: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Int64']['output'];
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserDataViewuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__UserDataView_Type = BaseObject & Object & projection__UserDataView & {
  __typename: 'projection__UserDataView_Type';
  createdAt: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Int64']['output'];
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserDataView_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__UserEligibilityView = {
  createdAt: Scalars['String']['output'];
  enrolledAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastCheckDispatchReason?: Maybe<projection__EligibilityCheckDispatchReason>;
  lastCheckOutcome?: Maybe<projection__EligibilityCheckOutcome>;
  lastCheckVendorResponseId?: Maybe<Scalars['String']['output']>;
  lastCheckedAt?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserEligibilityViewuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__UserEligibilityView_Type = BaseObject & Object & projection__UserEligibilityView & {
  __typename: 'projection__UserEligibilityView_Type';
  createdAt: Scalars['String']['output'];
  enrolledAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastCheckDispatchReason?: Maybe<projection__EligibilityCheckDispatchReason>;
  lastCheckOutcome?: Maybe<projection__EligibilityCheckOutcome>;
  lastCheckVendorResponseId?: Maybe<Scalars['String']['output']>;
  lastCheckedAt?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserEligibilityView_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__UserEnrichmentData = {
  confidence?: Maybe<projection__EnrichmentConfidence>;
  createdAt: Scalars['String']['output'];
  enrichments?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  overallPriceRating?: Maybe<projection__EnrichmentPriceRating>;
  schemaVersion: Scalars['Int64']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserEnrichmentDatauserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__UserEnrichmentData_Type = BaseObject & Object & projection__UserEnrichmentData & {
  __typename: 'projection__UserEnrichmentData_Type';
  confidence?: Maybe<projection__EnrichmentConfidence>;
  createdAt: Scalars['String']['output'];
  enrichments?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  overallPriceRating?: Maybe<projection__EnrichmentPriceRating>;
  schemaVersion: Scalars['Int64']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserEnrichmentData_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__UserMemory = {
  createdAt: Scalars['String']['output'];
  entries: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserMemoryuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__UserMemory_Type = BaseObject & Object & projection__UserMemory & {
  __typename: 'projection__UserMemory_Type';
  createdAt: Scalars['String']['output'];
  entries: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserMemory_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum provider__ContactKind {
  Email = 'Email',
  Fax = 'Fax',
  Phone = 'Phone',
  Portal = 'Portal',
  Website = 'Website'
}

export type provider__ContactPoint = {
  id: Scalars['ID']['output'];
  kind: provider__ContactKind;
  lastVerified?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  purpose: provider__ContactPurpose;
  source?: Maybe<provider__Source>;
  value: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  verifiedBy?: Maybe<User>;
};


export type provider__ContactPointverifiedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type provider__ContactPoint_Type = BaseObject & Object & provider__ContactPoint & {
  __typename: 'provider__ContactPoint_Type';
  id: Scalars['ID']['output'];
  kind: provider__ContactKind;
  lastVerified?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  purpose: provider__ContactPurpose;
  source?: Maybe<provider__Source>;
  value: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  verifiedBy?: Maybe<User>;
};


export type provider__ContactPoint_TypeverifiedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum provider__ContactPurpose {
  Billing = 'Billing',
  FinancialAssistance = 'FinancialAssistance',
  General = 'General',
  MedicalRecords = 'MedicalRecords',
  Other = 'Other'
}

export type provider__FilterContactPoint = {
  and?: InputMaybe<Array<provider__FilterContactPoint>>;
  id?: InputMaybe<FilterID>;
  kind?: InputMaybe<Filterprovider__ContactKind>;
  lastVerified?: InputMaybe<FilterString>;
  not?: InputMaybe<provider__FilterContactPoint>;
  notes?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<provider__FilterContactPoint>>;
  purpose?: InputMaybe<Filterprovider__ContactPurpose>;
  source?: InputMaybe<Filterprovider__Source>;
  value?: InputMaybe<FilterString>;
  verified?: InputMaybe<FilterBoolean>;
  verifiedBy?: InputMaybe<NestedFilterUser>;
};

export type provider__FilterNegotiationProfile = {
  and?: InputMaybe<Array<provider__FilterNegotiationProfile>>;
  discountPctMax?: InputMaybe<FilterInt>;
  discountPctMin?: InputMaybe<FilterInt>;
  hipaaTurnaroundDays?: InputMaybe<FilterInt>;
  id?: InputMaybe<FilterID>;
  insuredStance?: InputMaybe<Filterprovider__NegotiationStance>;
  lastVerified?: InputMaybe<FilterString>;
  not?: InputMaybe<provider__FilterNegotiationProfile>;
  offersPaymentPlans?: InputMaybe<FilterBoolean>;
  or?: InputMaybe<Array<provider__FilterNegotiationProfile>>;
  paymentPlanMaxMonths?: InputMaybe<FilterInt>;
  pricingVsMarket?: InputMaybe<FilterFloat>;
  verified?: InputMaybe<FilterBoolean>;
  verifiedBy?: InputMaybe<NestedFilterUser>;
};

export type provider__FilterProvider = {
  addressLine1?: InputMaybe<FilterString>;
  addressLine2?: InputMaybe<FilterString>;
  aliases?: InputMaybe<FilterString>;
  and?: InputMaybe<Array<provider__FilterProvider>>;
  ccn?: InputMaybe<FilterString>;
  city?: InputMaybe<FilterString>;
  contactPoints?: InputMaybe<provider__NestedFilterContactPoint>;
  county?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  faPolicy?: InputMaybe<FilterJSON>;
  faPolicyUrl?: InputMaybe<FilterString>;
  facilities?: InputMaybe<provider__NestedFilterProvider>;
  forms?: InputMaybe<provider__NestedFilterProviderForm>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  isNonprofit?: InputMaybe<FilterBoolean>;
  kind?: InputMaybe<Filterprovider__ProviderKind>;
  lastSyncedAt?: InputMaybe<FilterString>;
  negotiation?: InputMaybe<provider__NestedFilterNegotiationProfile>;
  not?: InputMaybe<provider__FilterProvider>;
  npi?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<provider__FilterProvider>>;
  ownership?: InputMaybe<Filterprovider__Ownership>;
  ownershipRaw?: InputMaybe<FilterString>;
  partOf?: InputMaybe<provider__NestedFilterProvider>;
  postalCode?: InputMaybe<FilterString>;
  slug?: InputMaybe<FilterString>;
  source?: InputMaybe<Filterprovider__Source>;
  state?: InputMaybe<FilterString>;
  systemName?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type provider__FilterProviderForm = {
  and?: InputMaybe<Array<provider__FilterProviderForm>>;
  calibratedAt?: InputMaybe<FilterString>;
  calibratedBy?: InputMaybe<NestedFilterUser>;
  contentHash?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  detectedAt?: InputMaybe<FilterString>;
  fields?: InputMaybe<FilterJSON>;
  formType?: InputMaybe<Filterprovider__FormType>;
  formUrl?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  internalTemplate?: InputMaybe<FilterJSON>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<provider__FilterProviderForm>;
  or?: InputMaybe<Array<provider__FilterProviderForm>>;
  provider?: InputMaybe<provider__NestedFilterProvider>;
  revision?: InputMaybe<FilterInt>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
  submissionChannel?: InputMaybe<Filterprovider__SubmissionChannel>;
  submitTo?: InputMaybe<provider__NestedFilterContactPoint>;
  updatedAt?: InputMaybe<FilterString>;
};

export enum provider__FormType {
  Appeal = 'Appeal',
  Catastrophic = 'Catastrophic',
  FaApplication = 'FaApplication',
  Other = 'Other'
}

export type provider__NegotiationProfile = {
  discountPctMax?: Maybe<Scalars['Int']['output']>;
  discountPctMin?: Maybe<Scalars['Int']['output']>;
  hipaaTurnaroundDays?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  insuredStance?: Maybe<provider__NegotiationStance>;
  lastVerified?: Maybe<Scalars['String']['output']>;
  offersPaymentPlans?: Maybe<Scalars['Boolean']['output']>;
  paymentPlanMaxMonths?: Maybe<Scalars['Int']['output']>;
  pricingVsMarket?: Maybe<Scalars['Float']['output']>;
  verified: Scalars['Boolean']['output'];
  verifiedBy?: Maybe<User>;
};


export type provider__NegotiationProfileverifiedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type provider__NegotiationProfile_Type = BaseObject & Object & provider__NegotiationProfile & {
  __typename: 'provider__NegotiationProfile_Type';
  discountPctMax?: Maybe<Scalars['Int']['output']>;
  discountPctMin?: Maybe<Scalars['Int']['output']>;
  hipaaTurnaroundDays?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  insuredStance?: Maybe<provider__NegotiationStance>;
  lastVerified?: Maybe<Scalars['String']['output']>;
  offersPaymentPlans?: Maybe<Scalars['Boolean']['output']>;
  paymentPlanMaxMonths?: Maybe<Scalars['Int']['output']>;
  pricingVsMarket?: Maybe<Scalars['Float']['output']>;
  verified: Scalars['Boolean']['output'];
  verifiedBy?: Maybe<User>;
};


export type provider__NegotiationProfile_TypeverifiedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum provider__NegotiationStance {
  DoesNotNegotiate = 'DoesNotNegotiate',
  NegotiatesAll = 'NegotiatesAll',
  Restricted = 'Restricted',
  SelfPayOnly = 'SelfPayOnly'
}

export type provider__NestedFilterContactPoint = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  kind?: InputMaybe<Filterprovider__ContactKind>;
  lastVerified?: InputMaybe<FilterString>;
  notes?: InputMaybe<FilterString>;
  purpose?: InputMaybe<Filterprovider__ContactPurpose>;
  source?: InputMaybe<Filterprovider__Source>;
  value?: InputMaybe<FilterString>;
  verified?: InputMaybe<FilterBoolean>;
  verifiedBy?: InputMaybe<NestedFilterUser>;
};

export type provider__NestedFilterNegotiationProfile = {
  discountPctMax?: InputMaybe<FilterInt>;
  discountPctMin?: InputMaybe<FilterInt>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  hipaaTurnaroundDays?: InputMaybe<FilterInt>;
  id?: InputMaybe<FilterID>;
  insuredStance?: InputMaybe<Filterprovider__NegotiationStance>;
  lastVerified?: InputMaybe<FilterString>;
  offersPaymentPlans?: InputMaybe<FilterBoolean>;
  paymentPlanMaxMonths?: InputMaybe<FilterInt>;
  pricingVsMarket?: InputMaybe<FilterFloat>;
  verified?: InputMaybe<FilterBoolean>;
  verifiedBy?: InputMaybe<NestedFilterUser>;
};

export type provider__NestedFilterProvider = {
  addressLine1?: InputMaybe<FilterString>;
  addressLine2?: InputMaybe<FilterString>;
  aliases?: InputMaybe<FilterString>;
  ccn?: InputMaybe<FilterString>;
  city?: InputMaybe<FilterString>;
  contactPoints?: InputMaybe<provider__NestedFilterContactPoint>;
  county?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  faPolicy?: InputMaybe<FilterJSON>;
  faPolicyUrl?: InputMaybe<FilterString>;
  facilities?: InputMaybe<provider__NestedFilterProvider>;
  forms?: InputMaybe<provider__NestedFilterProviderForm>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  isNonprofit?: InputMaybe<FilterBoolean>;
  kind?: InputMaybe<Filterprovider__ProviderKind>;
  lastSyncedAt?: InputMaybe<FilterString>;
  negotiation?: InputMaybe<provider__NestedFilterNegotiationProfile>;
  npi?: InputMaybe<FilterString>;
  ownership?: InputMaybe<Filterprovider__Ownership>;
  ownershipRaw?: InputMaybe<FilterString>;
  partOf?: InputMaybe<provider__NestedFilterProvider>;
  postalCode?: InputMaybe<FilterString>;
  slug?: InputMaybe<FilterString>;
  source?: InputMaybe<Filterprovider__Source>;
  state?: InputMaybe<FilterString>;
  systemName?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type provider__NestedFilterProviderForm = {
  calibratedAt?: InputMaybe<FilterString>;
  calibratedBy?: InputMaybe<NestedFilterUser>;
  contentHash?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  detectedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<FilterJSON>;
  formType?: InputMaybe<Filterprovider__FormType>;
  formUrl?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  internalTemplate?: InputMaybe<FilterJSON>;
  name?: InputMaybe<FilterString>;
  provider?: InputMaybe<provider__NestedFilterProvider>;
  revision?: InputMaybe<FilterInt>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
  submissionChannel?: InputMaybe<Filterprovider__SubmissionChannel>;
  submitTo?: InputMaybe<provider__NestedFilterContactPoint>;
  updatedAt?: InputMaybe<FilterString>;
};

export type provider__OrderContactPoint = {
  id?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  lastVerified?: InputMaybe<Ordering>;
  notes?: InputMaybe<Ordering>;
  purpose?: InputMaybe<Ordering>;
  source?: InputMaybe<Ordering>;
  value?: InputMaybe<Ordering>;
  verified?: InputMaybe<Ordering>;
  verifiedBy?: InputMaybe<OrderUser>;
};

export type provider__OrderNegotiationProfile = {
  discountPctMax?: InputMaybe<Ordering>;
  discountPctMin?: InputMaybe<Ordering>;
  hipaaTurnaroundDays?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  insuredStance?: InputMaybe<Ordering>;
  lastVerified?: InputMaybe<Ordering>;
  offersPaymentPlans?: InputMaybe<Ordering>;
  paymentPlanMaxMonths?: InputMaybe<Ordering>;
  pricingVsMarket?: InputMaybe<Ordering>;
  verified?: InputMaybe<Ordering>;
  verifiedBy?: InputMaybe<OrderUser>;
};

export type provider__OrderProvider = {
  addressLine1?: InputMaybe<Ordering>;
  addressLine2?: InputMaybe<Ordering>;
  ccn?: InputMaybe<Ordering>;
  city?: InputMaybe<Ordering>;
  county?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  displayName?: InputMaybe<Ordering>;
  faPolicy?: InputMaybe<Ordering>;
  faPolicyUrl?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  isNonprofit?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  lastSyncedAt?: InputMaybe<Ordering>;
  negotiation?: InputMaybe<provider__OrderNegotiationProfile>;
  npi?: InputMaybe<Ordering>;
  ownership?: InputMaybe<Ordering>;
  ownershipRaw?: InputMaybe<Ordering>;
  partOf?: InputMaybe<provider__OrderProvider>;
  postalCode?: InputMaybe<Ordering>;
  slug?: InputMaybe<Ordering>;
  source?: InputMaybe<Ordering>;
  state?: InputMaybe<Ordering>;
  systemName?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type provider__OrderProviderForm = {
  calibratedAt?: InputMaybe<Ordering>;
  calibratedBy?: InputMaybe<OrderUser>;
  contentHash?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  detectedAt?: InputMaybe<Ordering>;
  fields?: InputMaybe<Ordering>;
  formType?: InputMaybe<Ordering>;
  formUrl?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  internalTemplate?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  provider?: InputMaybe<provider__OrderProvider>;
  revision?: InputMaybe<Ordering>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
  submissionChannel?: InputMaybe<Ordering>;
  submitTo?: InputMaybe<provider__OrderContactPoint>;
  updatedAt?: InputMaybe<Ordering>;
};

export enum provider__Ownership {
  ForProfit = 'ForProfit',
  Government = 'Government',
  Nonprofit = 'Nonprofit'
}

export type provider__Provider = {
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  aliases?: Maybe<Array<Scalars['String']['output']>>;
  ccn?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactPoints?: Maybe<Array<provider__ContactPoint>>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  faPolicy?: Maybe<Scalars['JSON']['output']>;
  faPolicyUrl?: Maybe<Scalars['String']['output']>;
  facilities?: Maybe<Array<provider__Provider>>;
  forms?: Maybe<Array<provider__ProviderForm>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isNonprofit: Scalars['Boolean']['output'];
  kind: provider__ProviderKind;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  negotiation?: Maybe<provider__NegotiationProfile>;
  notes?: Maybe<Array<Scalars['String']['output']>>;
  npi?: Maybe<Scalars['String']['output']>;
  ownership?: Maybe<provider__Ownership>;
  ownershipRaw?: Maybe<Scalars['String']['output']>;
  partOf?: Maybe<provider__Provider>;
  postalCode?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  source?: Maybe<provider__Source>;
  state?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};


export type provider__ProvidercontactPointsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderContactPoint>;
};


export type provider__ProviderfacilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type provider__ProviderformsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProviderForm>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProviderForm>;
};


export type provider__ProvidernegotiationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterNegotiationProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderNegotiationProfile>;
};


export type provider__ProviderpartOfArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};

export type provider__ProviderForm = {
  calibratedAt?: Maybe<Scalars['String']['output']>;
  calibratedBy?: Maybe<User>;
  contentHash?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  detectedAt?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Scalars['JSON']['output']>;
  formType: provider__FormType;
  formUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalTemplate?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  provider: provider__Provider;
  revision: Scalars['Int']['output'];
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  submissionChannel?: Maybe<provider__SubmissionChannel>;
  submitTo?: Maybe<provider__ContactPoint>;
  updatedAt: Scalars['String']['output'];
};


export type provider__ProviderFormcalibratedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type provider__ProviderFormproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type provider__ProviderFormsubmitToArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderContactPoint>;
};

export type provider__ProviderForm_Type = BaseObject & Object & provider__ProviderForm & {
  __typename: 'provider__ProviderForm_Type';
  calibratedAt?: Maybe<Scalars['String']['output']>;
  calibratedBy?: Maybe<User>;
  contentHash?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  detectedAt?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Scalars['JSON']['output']>;
  formType: provider__FormType;
  formUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalTemplate?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  provider: provider__Provider;
  revision: Scalars['Int']['output'];
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  submissionChannel?: Maybe<provider__SubmissionChannel>;
  submitTo?: Maybe<provider__ContactPoint>;
  updatedAt: Scalars['String']['output'];
};


export type provider__ProviderForm_TypecalibratedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type provider__ProviderForm_TypeproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type provider__ProviderForm_TypesubmitToArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderContactPoint>;
};

export enum provider__ProviderKind {
  HealthSystem = 'HealthSystem',
  Hospital = 'Hospital',
  ImagingCenter = 'ImagingCenter',
  Lab = 'Lab',
  Other = 'Other',
  Pharmacy = 'Pharmacy',
  PhysicianGroup = 'PhysicianGroup'
}

export type provider__Provider_Type = BaseObject & Object & Slugged & provider__Provider & {
  __typename: 'provider__Provider_Type';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  aliases?: Maybe<Array<Scalars['String']['output']>>;
  ccn?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactPoints?: Maybe<Array<provider__ContactPoint>>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  faPolicy?: Maybe<Scalars['JSON']['output']>;
  faPolicyUrl?: Maybe<Scalars['String']['output']>;
  facilities?: Maybe<Array<provider__Provider>>;
  forms?: Maybe<Array<provider__ProviderForm>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isNonprofit: Scalars['Boolean']['output'];
  kind: provider__ProviderKind;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  negotiation?: Maybe<provider__NegotiationProfile>;
  notes?: Maybe<Array<Scalars['String']['output']>>;
  npi?: Maybe<Scalars['String']['output']>;
  ownership?: Maybe<provider__Ownership>;
  ownershipRaw?: Maybe<Scalars['String']['output']>;
  partOf?: Maybe<provider__Provider>;
  postalCode?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  source?: Maybe<provider__Source>;
  state?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};


export type provider__Provider_TypecontactPointsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderContactPoint>;
};


export type provider__Provider_TypefacilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type provider__Provider_TypeformsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProviderForm>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProviderForm>;
};


export type provider__Provider_TypenegotiationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterNegotiationProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderNegotiationProfile>;
};


export type provider__Provider_TypepartOfArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};

export enum provider__Source {
  ahrq = 'ahrq',
  cms = 'cms',
  ha = 'ha',
  imported = 'imported',
  notion = 'notion',
  research = 'research'
}

export enum provider__SubmissionChannel {
  Email = 'Email',
  Fax = 'Fax',
  InPerson = 'InPerson',
  Mail = 'Mail',
  Phone = 'Phone',
  PortalStructured = 'PortalStructured',
  PortalUpload = 'PortalUpload'
}

export type reprocessResourceAnalysisInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type segment__FilterSegment = {
  and?: InputMaybe<Array<segment__FilterSegment>>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  key?: InputMaybe<FilterString>;
  not?: InputMaybe<segment__FilterSegment>;
  or?: InputMaybe<Array<segment__FilterSegment>>;
  owningTeam?: InputMaybe<FilterString>;
  status?: InputMaybe<Filtersegment__SegmentStatus>;
  updatedAt?: InputMaybe<FilterString>;
};

export type segment__FilterUserSegment = {
  and?: InputMaybe<Array<segment__FilterUserSegment>>;
  assignedBy?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  effectiveFrom?: InputMaybe<FilterString>;
  effectiveTo?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<segment__FilterUserSegment>;
  or?: InputMaybe<Array<segment__FilterUserSegment>>;
  reason?: InputMaybe<FilterString>;
  segment?: InputMaybe<segment__NestedFilterSegment>;
  source?: InputMaybe<Filtersegment__SegmentSource>;
  user?: InputMaybe<NestedFilterUser>;
};

export type segment__NestedFilterSegment = {
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  key?: InputMaybe<FilterString>;
  owningTeam?: InputMaybe<FilterString>;
  status?: InputMaybe<Filtersegment__SegmentStatus>;
  updatedAt?: InputMaybe<FilterString>;
};

export type segment__OrderSegment = {
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  displayName?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  key?: InputMaybe<Ordering>;
  owningTeam?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type segment__OrderUserSegment = {
  assignedBy?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  effectiveFrom?: InputMaybe<Ordering>;
  effectiveTo?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  reason?: InputMaybe<Ordering>;
  segment?: InputMaybe<segment__OrderSegment>;
  source?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

/** Canonical governed list of named segments (e.g. touchcare_partner, pregnancy_icp). Managed by admins; serves as the source of truth for valid segment keys. */
export type segment__Segment = {
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  owningTeam: Scalars['String']['output'];
  status: segment__SegmentStatus;
  updatedAt: Scalars['String']['output'];
};

export enum segment__SegmentSource {
  EXTERNAL_ENRICHMENT = 'EXTERNAL_ENRICHMENT',
  MANUAL_OVERRIDE = 'MANUAL_OVERRIDE',
  UTM_SIGNUP = 'UTM_SIGNUP'
}

export enum segment__SegmentStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DEPRECATED = 'DEPRECATED'
}

/** Canonical governed list of named segments (e.g. touchcare_partner, pregnancy_icp). Managed by admins; serves as the source of truth for valid segment keys. */
export type segment__Segment_Type = BaseObject & Object & segment__Segment & {
  __typename: 'segment__Segment_Type';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  owningTeam: Scalars['String']['output'];
  status: segment__SegmentStatus;
  updatedAt: Scalars['String']['output'];
};

/** Junction between users and segments. Soft-deleted via isActive / effectiveTo rather than hard-deletes. Deduplicated on (user, segment, source) — upsert semantics for cron jobs. */
export type segment__UserSegment = {
  assignedBy: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  effectiveFrom: Scalars['String']['output'];
  effectiveTo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  segment: segment__Segment;
  source: segment__SegmentSource;
  user: User;
};


/** Junction between users and segments. Soft-deleted via isActive / effectiveTo rather than hard-deletes. Deduplicated on (user, segment, source) — upsert semantics for cron jobs. */
export type segment__UserSegmentsegmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderSegment>;
};


/** Junction between users and segments. Soft-deleted via isActive / effectiveTo rather than hard-deletes. Deduplicated on (user, segment, source) — upsert semantics for cron jobs. */
export type segment__UserSegmentuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** Junction between users and segments. Soft-deleted via isActive / effectiveTo rather than hard-deletes. Deduplicated on (user, segment, source) — upsert semantics for cron jobs. */
export type segment__UserSegment_Type = BaseObject & Object & segment__UserSegment & {
  __typename: 'segment__UserSegment_Type';
  assignedBy: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  effectiveFrom: Scalars['String']['output'];
  effectiveTo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  segment: segment__Segment;
  source: segment__SegmentSource;
  user: User;
};


/** Junction between users and segments. Soft-deleted via isActive / effectiveTo rather than hard-deletes. Deduplicated on (user, segment, source) — upsert semantics for cron jobs. */
export type segment__UserSegment_TypesegmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderSegment>;
};


/** Junction between users and segments. Soft-deleted via isActive / effectiveTo rather than hard-deletes. Deduplicated on (user, segment, source) — upsert semantics for cron jobs. */
export type segment__UserSegment_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type suggestion__FilterSuggestedAction = {
  actionPayload?: InputMaybe<FilterJSON>;
  and?: InputMaybe<Array<suggestion__FilterSuggestedAction>>;
  comment?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  executedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<suggestion__FilterSuggestedAction>;
  or?: InputMaybe<Array<suggestion__FilterSuggestedAction>>;
  respondedAt?: InputMaybe<FilterString>;
  reviewer?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<Filtersuggestion__SuggestedActionStatus>;
  type?: InputMaybe<FilterString>;
};

export type suggestion__NestedFilterSuggestedAction = {
  actionPayload?: InputMaybe<FilterJSON>;
  comment?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  executedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  respondedAt?: InputMaybe<FilterString>;
  reviewer?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<Filtersuggestion__SuggestedActionStatus>;
  type?: InputMaybe<FilterString>;
};

export type suggestion__OrderSuggestedAction = {
  actionPayload?: InputMaybe<Ordering>;
  comment?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  executedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  respondedAt?: InputMaybe<Ordering>;
  reviewer?: InputMaybe<OrderUser>;
  status?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
};

export type suggestion__SuggestedAction = {
  actionPayload: Scalars['JSON']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  executedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  respondedAt?: Maybe<Scalars['String']['output']>;
  reviewer?: Maybe<User>;
  status: suggestion__SuggestedActionStatus;
  type: Scalars['String']['output'];
};


export type suggestion__SuggestedActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type suggestion__SuggestedActionreviewerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** Status of a suggested action */
export enum suggestion__SuggestedActionStatus {
  ACCEPTED = 'ACCEPTED',
  MODIFIED = 'MODIFIED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type suggestion__SuggestedAction_Type = BaseObject & Object & suggestion__SuggestedAction & {
  __typename: 'suggestion__SuggestedAction_Type';
  actionPayload: Scalars['JSON']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  executedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  respondedAt?: Maybe<Scalars['String']['output']>;
  reviewer?: Maybe<User>;
  status: suggestion__SuggestedActionStatus;
  type: Scalars['String']['output'];
};


export type suggestion__SuggestedAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type suggestion__SuggestedAction_TypereviewerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type taskManagement__DataQualityFlagTask = {
  assignee?: Maybe<User>;
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  resource: fhirext__ResourceVersion;
  sourceName: Scalars['String']['output'];
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__DataQualityFlagTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__DataQualityFlagTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__DataQualityFlagTaskcreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__DataQualityFlagTaskresourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};

export type taskManagement__DataQualityFlagTask_Type = BaseObject & Object & taskManagement__DataQualityFlagTask & taskManagement__Task & {
  __typename: 'taskManagement__DataQualityFlagTask_Type';
  assignee?: Maybe<User>;
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  resource: fhirext__ResourceVersion;
  sourceName: Scalars['String']['output'];
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__DataQualityFlagTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__DataQualityFlagTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__DataQualityFlagTask_TypecreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__DataQualityFlagTask_TyperesourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};

/** Task created during data quality assessment of FHIR resources */
export type taskManagement__DataQualityTask = {
  assessment: dataQuality__Assessment;
  assignee?: Maybe<User>;
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['JSON']['output']>;
  dimension: dataQuality__Dimension;
  dueDate?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  rule?: Maybe<dataQuality__BusinessRule>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


/** Task created during data quality assessment of FHIR resources */
export type taskManagement__DataQualityTaskassessmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<dataQuality__FilterAssessment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<dataQuality__OrderAssessment>;
};


/** Task created during data quality assessment of FHIR resources */
export type taskManagement__DataQualityTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Task created during data quality assessment of FHIR resources */
export type taskManagement__DataQualityTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


/** Task created during data quality assessment of FHIR resources */
export type taskManagement__DataQualityTaskcreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Task created during data quality assessment of FHIR resources */
export type taskManagement__DataQualityTaskruleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<dataQuality__FilterBusinessRule>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<dataQuality__OrderBusinessRule>;
};

/** Task created during data quality assessment of FHIR resources */
export type taskManagement__DataQualityTask_Type = BaseObject & Object & taskManagement__DataQualityTask & taskManagement__Task & {
  __typename: 'taskManagement__DataQualityTask_Type';
  assessment: dataQuality__Assessment;
  assignee?: Maybe<User>;
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['JSON']['output']>;
  dimension: dataQuality__Dimension;
  dueDate?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  rule?: Maybe<dataQuality__BusinessRule>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


/** Task created during data quality assessment of FHIR resources */
export type taskManagement__DataQualityTask_TypeassessmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<dataQuality__FilterAssessment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<dataQuality__OrderAssessment>;
};


/** Task created during data quality assessment of FHIR resources */
export type taskManagement__DataQualityTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Task created during data quality assessment of FHIR resources */
export type taskManagement__DataQualityTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


/** Task created during data quality assessment of FHIR resources */
export type taskManagement__DataQualityTask_TypecreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Task created during data quality assessment of FHIR resources */
export type taskManagement__DataQualityTask_TyperuleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<dataQuality__FilterBusinessRule>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<dataQuality__OrderBusinessRule>;
};

export type taskManagement__FilterDataQualityFlagTask = {
  and?: InputMaybe<Array<taskManagement__FilterDataQualityFlagTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  createdBy?: InputMaybe<NestedFilterUser>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterDataQualityFlagTask>;
  or?: InputMaybe<Array<taskManagement__FilterDataQualityFlagTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  resource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  sourceName?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterDataQualityTask = {
  and?: InputMaybe<Array<taskManagement__FilterDataQualityTask>>;
  assessment?: InputMaybe<dataQuality__NestedFilterAssessment>;
  assignee?: InputMaybe<NestedFilterUser>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  createdBy?: InputMaybe<NestedFilterUser>;
  description?: InputMaybe<FilterString>;
  details?: InputMaybe<FilterJSON>;
  dimension?: InputMaybe<FilterdataQuality__Dimension>;
  dueDate?: InputMaybe<FilterString>;
  field?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterDataQualityTask>;
  or?: InputMaybe<Array<taskManagement__FilterDataQualityTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  rule?: InputMaybe<dataQuality__NestedFilterBusinessRule>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterFollowUpClosurePendingIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterFollowUpClosurePendingIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterFollowUpClosurePendingIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterFollowUpClosurePendingIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterFollowUpUserUnresponsiveIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterFollowUpUserUnresponsiveIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterFollowUpUserUnresponsiveIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterFollowUpUserUnresponsiveIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterGeneralIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterGeneralIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterGeneralIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterGeneralIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterIssueResearchTask = {
  and?: InputMaybe<Array<taskManagement__FilterIssueResearchTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterIssueResearchTask>;
  or?: InputMaybe<Array<taskManagement__FilterIssueResearchTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterIssueUserMessagingTask = {
  and?: InputMaybe<Array<taskManagement__FilterIssueUserMessagingTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterIssueUserMessagingTask>;
  or?: InputMaybe<Array<taskManagement__FilterIssueUserMessagingTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterPhoneCall = {
  aircallId?: InputMaybe<FilterString>;
  aircallSessionId?: InputMaybe<FilterString>;
  and?: InputMaybe<Array<taskManagement__FilterPhoneCall>>;
  callDate?: InputMaybe<FilterString>;
  callType?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  duration?: InputMaybe<FilterFloat>;
  duration_minutes?: InputMaybe<FilterFloat>;
  hasVoicemail?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  isInbound?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<taskManagement__FilterPhoneCall>;
  or?: InputMaybe<Array<taskManagement__FilterPhoneCall>>;
  owner?: InputMaybe<NestedFilterUser>;
  resolved?: InputMaybe<FilterBoolean>;
  task?: InputMaybe<taskManagement__NestedFilterTask>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterPhoneCallIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterPhoneCallIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterPhoneCallIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterPhoneCallIssueTask>>;
  phoneCall?: InputMaybe<taskManagement__NestedFilterPhoneCall>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterProcessCustomerBillPaymentIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterProcessCustomerBillPaymentIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterProcessCustomerBillPaymentIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterProcessCustomerBillPaymentIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterReviewCaseIntakeIssueTask = {
  additionalDetailsRequested?: InputMaybe<FilterString>;
  and?: InputMaybe<Array<taskManagement__FilterReviewCaseIntakeIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  hasAllInformation?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterReviewCaseIntakeIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterReviewCaseIntakeIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterReviewEscalatedCaseTask = {
  additionalDetailsRequested?: InputMaybe<FilterString>;
  and?: InputMaybe<Array<taskManagement__FilterReviewEscalatedCaseTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  hasAllInformation?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterReviewEscalatedCaseTask>;
  or?: InputMaybe<Array<taskManagement__FilterReviewEscalatedCaseTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterReviewFindingTask = {
  and?: InputMaybe<Array<taskManagement__FilterReviewFindingTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  finding?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterReviewFindingTask>;
  or?: InputMaybe<Array<taskManagement__FilterReviewFindingTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterReviewIssueChatTask = {
  and?: InputMaybe<Array<taskManagement__FilterReviewIssueChatTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterReviewIssueChatTask>;
  or?: InputMaybe<Array<taskManagement__FilterReviewIssueChatTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterReviewPaymentAcceptanceIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterReviewPaymentAcceptanceIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterReviewPaymentAcceptanceIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterReviewPaymentAcceptanceIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterReviewSuggestionTask = {
  and?: InputMaybe<Array<taskManagement__FilterReviewSuggestionTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterReviewSuggestionTask>;
  or?: InputMaybe<Array<taskManagement__FilterReviewSuggestionTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  suggestedAction?: InputMaybe<suggestion__NestedFilterSuggestedAction>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterSendFormIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterSendFormIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  formSender?: InputMaybe<FilterString>;
  formType?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterSendFormIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterSendFormIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  sendingMethod?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterTask = {
  and?: InputMaybe<Array<taskManagement__FilterTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterTask>;
  or?: InputMaybe<Array<taskManagement__FilterTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterTaskComment = {
  and?: InputMaybe<Array<taskManagement__FilterTaskComment>>;
  canEdit?: InputMaybe<FilterBoolean>;
  comment?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  createdBy?: InputMaybe<NestedFilterUser>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<taskManagement__FilterTaskComment>;
  or?: InputMaybe<Array<taskManagement__FilterTaskComment>>;
  pinned?: InputMaybe<FilterBoolean>;
  task?: InputMaybe<taskManagement__NestedFilterTask>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FollowUpClosurePendingIssueTask = {
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__FollowUpClosurePendingIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__FollowUpClosurePendingIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__FollowUpClosurePendingIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__FollowUpClosurePendingIssueTask_Type = BaseObject & Object & taskManagement__FollowUpClosurePendingIssueTask & taskManagement__IssueTask & taskManagement__Task & {
  __typename: 'taskManagement__FollowUpClosurePendingIssueTask_Type';
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__FollowUpClosurePendingIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__FollowUpClosurePendingIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__FollowUpClosurePendingIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__FollowUpUserUnresponsiveIssueTask = {
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__FollowUpUserUnresponsiveIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__FollowUpUserUnresponsiveIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__FollowUpUserUnresponsiveIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__FollowUpUserUnresponsiveIssueTask_Type = BaseObject & Object & taskManagement__FollowUpUserUnresponsiveIssueTask & taskManagement__IssueTask & taskManagement__Task & {
  __typename: 'taskManagement__FollowUpUserUnresponsiveIssueTask_Type';
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__FollowUpUserUnresponsiveIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__FollowUpUserUnresponsiveIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__FollowUpUserUnresponsiveIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__GeneralIssueTask = {
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__GeneralIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__GeneralIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__GeneralIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__GeneralIssueTask_Type = BaseObject & Object & taskManagement__GeneralIssueTask & taskManagement__IssueTask & taskManagement__Task & {
  __typename: 'taskManagement__GeneralIssueTask_Type';
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__GeneralIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__GeneralIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__GeneralIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__IssueResearchTask = {
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__IssueResearchTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__IssueResearchTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__IssueResearchTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__IssueResearchTask_Type = BaseObject & Object & taskManagement__IssueResearchTask & taskManagement__IssueTask & taskManagement__Task & {
  __typename: 'taskManagement__IssueResearchTask_Type';
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__IssueResearchTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__IssueResearchTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__IssueResearchTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__IssueTask = {
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__IssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__IssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__IssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__IssueTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__Task & {
  __typename: 'taskManagement__IssueTask_Type';
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__IssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__IssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__IssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__IssueUserMessagingTask = {
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__IssueUserMessagingTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__IssueUserMessagingTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__IssueUserMessagingTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__IssueUserMessagingTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__IssueUserMessagingTask & taskManagement__Task & {
  __typename: 'taskManagement__IssueUserMessagingTask_Type';
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__IssueUserMessagingTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__IssueUserMessagingTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__IssueUserMessagingTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__NestedFilterDataQualityTask = {
  assessment?: InputMaybe<dataQuality__NestedFilterAssessment>;
  assignee?: InputMaybe<NestedFilterUser>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  createdBy?: InputMaybe<NestedFilterUser>;
  description?: InputMaybe<FilterString>;
  details?: InputMaybe<FilterJSON>;
  dimension?: InputMaybe<FilterdataQuality__Dimension>;
  dueDate?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  field?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  minutesSpent?: InputMaybe<FilterInt>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  rule?: InputMaybe<dataQuality__NestedFilterBusinessRule>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__NestedFilterIssueTask = {
  assignee?: InputMaybe<NestedFilterUser>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__NestedFilterPhoneCall = {
  aircallId?: InputMaybe<FilterString>;
  aircallSessionId?: InputMaybe<FilterString>;
  callDate?: InputMaybe<FilterString>;
  callType?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  duration?: InputMaybe<FilterFloat>;
  duration_minutes?: InputMaybe<FilterFloat>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasVoicemail?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  isInbound?: InputMaybe<FilterBoolean>;
  owner?: InputMaybe<NestedFilterUser>;
  resolved?: InputMaybe<FilterBoolean>;
  task?: InputMaybe<taskManagement__NestedFilterTask>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__NestedFilterTask = {
  assignee?: InputMaybe<NestedFilterUser>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  minutesSpent?: InputMaybe<FilterInt>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__NestedFilterTaskComment = {
  canEdit?: InputMaybe<FilterBoolean>;
  comment?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  createdBy?: InputMaybe<NestedFilterUser>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  pinned?: InputMaybe<FilterBoolean>;
  task?: InputMaybe<taskManagement__NestedFilterTask>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__OrderDataQualityFlagTask = {
  assignee?: InputMaybe<OrderUser>;
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  resource?: InputMaybe<fhirext__OrderResourceVersion>;
  sourceName?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderDataQualityTask = {
  assessment?: InputMaybe<dataQuality__OrderAssessment>;
  assignee?: InputMaybe<OrderUser>;
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  description?: InputMaybe<Ordering>;
  details?: InputMaybe<Ordering>;
  dimension?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  field?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  rule?: InputMaybe<dataQuality__OrderBusinessRule>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderFollowUpClosurePendingIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderFollowUpUserUnresponsiveIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderGeneralIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderIssueResearchTask = {
  assignee?: InputMaybe<OrderUser>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderIssueUserMessagingTask = {
  assignee?: InputMaybe<OrderUser>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderPhoneCall = {
  aircallId?: InputMaybe<Ordering>;
  aircallSessionId?: InputMaybe<Ordering>;
  callDate?: InputMaybe<Ordering>;
  callType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  duration?: InputMaybe<Ordering>;
  duration_minutes?: InputMaybe<Ordering>;
  hasVoicemail?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isInbound?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  resolved?: InputMaybe<Ordering>;
  task?: InputMaybe<taskManagement__OrderTask>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderPhoneCallIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  phoneCall?: InputMaybe<taskManagement__OrderPhoneCall>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderProcessCustomerBillPaymentIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderReviewCaseIntakeIssueTask = {
  additionalDetailsRequested?: InputMaybe<Ordering>;
  assignee?: InputMaybe<OrderUser>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  hasAllInformation?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderReviewEscalatedCaseTask = {
  additionalDetailsRequested?: InputMaybe<Ordering>;
  assignee?: InputMaybe<OrderUser>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  hasAllInformation?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderReviewFindingTask = {
  assignee?: InputMaybe<OrderUser>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  finding?: InputMaybe<fhirext__OrderFinding>;
  id?: InputMaybe<Ordering>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderReviewIssueChatTask = {
  assignee?: InputMaybe<OrderUser>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderReviewPaymentAcceptanceIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderReviewSuggestionTask = {
  assignee?: InputMaybe<OrderUser>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  suggestedAction?: InputMaybe<suggestion__OrderSuggestedAction>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderSendFormIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  formSender?: InputMaybe<Ordering>;
  formType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  sendingMethod?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderTask = {
  assignee?: InputMaybe<OrderUser>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderTaskComment = {
  canEdit?: InputMaybe<Ordering>;
  comment?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  pinned?: InputMaybe<Ordering>;
  task?: InputMaybe<taskManagement__OrderTask>;
  updatedAt?: InputMaybe<Ordering>;
};

/** Represents a phone call associated with a task */
export type taskManagement__PhoneCall = {
  aircallId: Scalars['String']['output'];
  aircallSessionId?: Maybe<Scalars['String']['output']>;
  callDate: Scalars['String']['output'];
  callType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  duration_minutes?: Maybe<Scalars['Float']['output']>;
  hasVoicemail: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isInbound: Scalars['Boolean']['output'];
  owner: User;
  resolved: Scalars['Boolean']['output'];
  task: taskManagement__Task;
  updatedAt: Scalars['String']['output'];
};


/** Represents a phone call associated with a task */
export type taskManagement__PhoneCallownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Represents a phone call associated with a task */
export type taskManagement__PhoneCalltaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTask>;
};

export type taskManagement__PhoneCallIssueTask = {
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  phoneCall?: Maybe<taskManagement__PhoneCall>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__PhoneCallIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__PhoneCallIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__PhoneCallIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type taskManagement__PhoneCallIssueTaskphoneCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterPhoneCall>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderPhoneCall>;
};

export type taskManagement__PhoneCallIssueTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__PhoneCallIssueTask & taskManagement__Task & {
  __typename: 'taskManagement__PhoneCallIssueTask_Type';
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  phoneCall?: Maybe<taskManagement__PhoneCall>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__PhoneCallIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__PhoneCallIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__PhoneCallIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type taskManagement__PhoneCallIssueTask_TypephoneCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterPhoneCall>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderPhoneCall>;
};

/** Represents a phone call associated with a task */
export type taskManagement__PhoneCall_Type = BaseObject & Object & Owned & taskManagement__PhoneCall & {
  __typename: 'taskManagement__PhoneCall_Type';
  aircallId: Scalars['String']['output'];
  aircallSessionId?: Maybe<Scalars['String']['output']>;
  callDate: Scalars['String']['output'];
  callType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  duration_minutes?: Maybe<Scalars['Float']['output']>;
  hasVoicemail: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isInbound: Scalars['Boolean']['output'];
  owner: User;
  resolved: Scalars['Boolean']['output'];
  task: taskManagement__Task;
  updatedAt: Scalars['String']['output'];
};


/** Represents a phone call associated with a task */
export type taskManagement__PhoneCall_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Represents a phone call associated with a task */
export type taskManagement__PhoneCall_TypetaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTask>;
};

export type taskManagement__ProcessCustomerBillPaymentIssueTask = {
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ProcessCustomerBillPaymentIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ProcessCustomerBillPaymentIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ProcessCustomerBillPaymentIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ProcessCustomerBillPaymentIssueTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__ProcessCustomerBillPaymentIssueTask & taskManagement__Task & {
  __typename: 'taskManagement__ProcessCustomerBillPaymentIssueTask_Type';
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ProcessCustomerBillPaymentIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ProcessCustomerBillPaymentIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ProcessCustomerBillPaymentIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewCaseIntakeIssueTask = {
  additionalDetailsRequested?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hasAllInformation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewCaseIntakeIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewCaseIntakeIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewCaseIntakeIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewCaseIntakeIssueTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__ReviewCaseIntakeIssueTask & taskManagement__Task & {
  __typename: 'taskManagement__ReviewCaseIntakeIssueTask_Type';
  additionalDetailsRequested?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hasAllInformation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewCaseIntakeIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewCaseIntakeIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewCaseIntakeIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewEscalatedCaseTask = {
  additionalDetailsRequested?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hasAllInformation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewEscalatedCaseTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewEscalatedCaseTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewEscalatedCaseTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewEscalatedCaseTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__ReviewEscalatedCaseTask & taskManagement__Task & {
  __typename: 'taskManagement__ReviewEscalatedCaseTask_Type';
  additionalDetailsRequested?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hasAllInformation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewEscalatedCaseTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewEscalatedCaseTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewEscalatedCaseTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewFindingTask = {
  assignee?: Maybe<User>;
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  finding: fhirext__Finding;
  id: Scalars['ID']['output'];
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewFindingTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewFindingTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewFindingTaskfindingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};

export type taskManagement__ReviewFindingTask_Type = BaseObject & Object & taskManagement__ReviewFindingTask & taskManagement__Task & {
  __typename: 'taskManagement__ReviewFindingTask_Type';
  assignee?: Maybe<User>;
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  finding: fhirext__Finding;
  id: Scalars['ID']['output'];
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewFindingTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewFindingTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewFindingTask_TypefindingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};

export type taskManagement__ReviewIssueChatTask = {
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewIssueChatTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewIssueChatTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewIssueChatTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewIssueChatTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__ReviewIssueChatTask & taskManagement__Task & {
  __typename: 'taskManagement__ReviewIssueChatTask_Type';
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewIssueChatTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewIssueChatTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewIssueChatTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewPaymentAcceptanceIssueTask = {
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewPaymentAcceptanceIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewPaymentAcceptanceIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewPaymentAcceptanceIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewPaymentAcceptanceIssueTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__ReviewPaymentAcceptanceIssueTask & taskManagement__Task & {
  __typename: 'taskManagement__ReviewPaymentAcceptanceIssueTask_Type';
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewPaymentAcceptanceIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewPaymentAcceptanceIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewPaymentAcceptanceIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewSuggestionTask = {
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  suggestedAction: suggestion__SuggestedAction;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewSuggestionTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewSuggestionTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewSuggestionTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type taskManagement__ReviewSuggestionTasksuggestedActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<suggestion__FilterSuggestedAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<suggestion__OrderSuggestedAction>;
};

export type taskManagement__ReviewSuggestionTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__ReviewSuggestionTask & taskManagement__Task & {
  __typename: 'taskManagement__ReviewSuggestionTask_Type';
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  suggestedAction: suggestion__SuggestedAction;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewSuggestionTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewSuggestionTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewSuggestionTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type taskManagement__ReviewSuggestionTask_TypesuggestedActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<suggestion__FilterSuggestedAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<suggestion__OrderSuggestedAction>;
};

export type taskManagement__SendFormIssueTask = {
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  formSender: Scalars['String']['output'];
  formType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  sendingMethod: Scalars['String']['output'];
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__SendFormIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__SendFormIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__SendFormIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__SendFormIssueTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__SendFormIssueTask & taskManagement__Task & {
  __typename: 'taskManagement__SendFormIssueTask_Type';
  assignee?: Maybe<User>;
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  formSender: Scalars['String']['output'];
  formType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  sendingMethod: Scalars['String']['output'];
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__SendFormIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__SendFormIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__SendFormIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__Task = {
  assignee?: Maybe<User>;
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__TaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__TaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};

export type taskManagement__TaskComment = {
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  comment: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  pinned: Scalars['Boolean']['output'];
  task: taskManagement__Task;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__TaskCommentcreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__TaskCommenttaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTask>;
};

export type taskManagement__TaskComment_Type = BaseObject & Object & taskManagement__TaskComment & {
  __typename: 'taskManagement__TaskComment_Type';
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  comment: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  pinned: Scalars['Boolean']['output'];
  task: taskManagement__Task;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__TaskComment_TypecreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__TaskComment_TypetaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTask>;
};

export enum taskManagement__TaskStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED'
}

export enum taskManagement__TaskType {
  DATA_QUALITY_FLAG = 'DATA_QUALITY_FLAG',
  DATA_QUALITY_TASK = 'DATA_QUALITY_TASK',
  FOLLOW_UP_CLOSURE_PENDING = 'FOLLOW_UP_CLOSURE_PENDING',
  FOLLOW_UP_USER_UNRESPONSIVE = 'FOLLOW_UP_USER_UNRESPONSIVE',
  GENERAL = 'GENERAL',
  ISSUE = 'ISSUE',
  ISSUE_RESEARCH = 'ISSUE_RESEARCH',
  ISSUE_USER_MESSAGING = 'ISSUE_USER_MESSAGING',
  OTHER = 'OTHER',
  PHONE_CALL = 'PHONE_CALL',
  PROCESS_CUSTOMER_BILL_PAYMENT = 'PROCESS_CUSTOMER_BILL_PAYMENT',
  RESEARCH = 'RESEARCH',
  REVIEW_CASE_INTAKE = 'REVIEW_CASE_INTAKE',
  REVIEW_ESCALATED_CASE = 'REVIEW_ESCALATED_CASE',
  REVIEW_FINDING_TASK = 'REVIEW_FINDING_TASK',
  REVIEW_ISSUE_CHAT = 'REVIEW_ISSUE_CHAT',
  REVIEW_PAYMENT_ACCEPTANCE = 'REVIEW_PAYMENT_ACCEPTANCE',
  REVIEW_SUGGESTED_ACTION = 'REVIEW_SUGGESTED_ACTION',
  SEND_FORM = 'SEND_FORM',
  USER_MESSAGING = 'USER_MESSAGING'
}

export type taskManagement__Task_Type = BaseObject & Object & taskManagement__Task & {
  __typename: 'taskManagement__Task_Type';
  assignee?: Maybe<User>;
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__Task_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__Task_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};

export type user__Email = {
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  stytchId?: Maybe<Scalars['String']['output']>;
  user: User;
};


export type user__EmailuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type user__Email_Type = BaseObject & Object & user__Email & {
  __typename: 'user__Email_Type';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  stytchId?: Maybe<Scalars['String']['output']>;
  user: User;
};


export type user__Email_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type user__FilterEmail = {
  and?: InputMaybe<Array<user__FilterEmail>>;
  email?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<user__FilterEmail>;
  or?: InputMaybe<Array<user__FilterEmail>>;
  stytchId?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type user__FilterProfile = {
  and?: InputMaybe<Array<user__FilterProfile>>;
  fullName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<user__FilterProfile>;
  or?: InputMaybe<Array<user__FilterProfile>>;
  user?: InputMaybe<NestedFilterUser>;
};

export type user__FilterSegmentationData = {
  and?: InputMaybe<Array<user__FilterSegmentationData>>;
  createdAt?: InputMaybe<FilterString>;
  hasInsurance?: InputMaybe<FilterBoolean>;
  heardAboutUsFrom?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<user__FilterSegmentationData>;
  or?: InputMaybe<Array<user__FilterSegmentationData>>;
  owner?: InputMaybe<NestedFilterUser>;
  updatedAt?: InputMaybe<FilterString>;
  usageScope?: InputMaybe<FilterString>;
};

export type user__NestedFilterEmail = {
  email?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  stytchId?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type user__NestedFilterProfile = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type user__NestedFilterSegmentationData = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasInsurance?: InputMaybe<FilterBoolean>;
  heardAboutUsFrom?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  updatedAt?: InputMaybe<FilterString>;
  usageScope?: InputMaybe<FilterString>;
};

export type user__OrderEmail = {
  email?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  stytchId?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type user__OrderProfile = {
  fullName?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type user__OrderSegmentationData = {
  createdAt?: InputMaybe<Ordering>;
  hasInsurance?: InputMaybe<Ordering>;
  heardAboutUsFrom?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  updatedAt?: InputMaybe<Ordering>;
  usageScope?: InputMaybe<Ordering>;
};

/** A user's profile, intended to contain less-sensitive information that may be shared with other users. */
export type user__Profile = {
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};


/** A user's profile, intended to contain less-sensitive information that may be shared with other users. */
export type user__ProfileuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** A user's profile, intended to contain less-sensitive information that may be shared with other users. */
export type user__Profile_Type = BaseObject & Object & user__Profile & {
  __typename: 'user__Profile_Type';
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};


/** A user's profile, intended to contain less-sensitive information that may be shared with other users. */
export type user__Profile_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type user__SegmentationData = {
  createdAt: Scalars['String']['output'];
  features?: Maybe<Array<Scalars['String']['output']>>;
  hasInsurance?: Maybe<Scalars['Boolean']['output']>;
  heardAboutUsFrom?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  updatedAt: Scalars['String']['output'];
  usageScope?: Maybe<Scalars['String']['output']>;
  usageScopes?: Maybe<Array<Scalars['String']['output']>>;
  useCases?: Maybe<Array<Scalars['String']['output']>>;
};


export type user__SegmentationDataownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type user__SegmentationData_Type = BaseObject & Object & Owned & user__SegmentationData & {
  __typename: 'user__SegmentationData_Type';
  createdAt: Scalars['String']['output'];
  features?: Maybe<Array<Scalars['String']['output']>>;
  hasInsurance?: Maybe<Scalars['Boolean']['output']>;
  heardAboutUsFrom?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  updatedAt: Scalars['String']['output'];
  usageScope?: Maybe<Scalars['String']['output']>;
  usageScopes?: Maybe<Array<Scalars['String']['output']>>;
  useCases?: Maybe<Array<Scalars['String']['output']>>;
};


export type user__SegmentationData_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__AiConversationLogArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
};


export type webAgent__AiConversationLogArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__AiConversationLogArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__AiConversationLogArtifact_Type = BaseObject & Object & Owned & webAgent__AiConversationLogArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__AiConversationLogArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
};


export type webAgent__AiConversationLogArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__AiConversationLogArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__AiDiscoveryCrawl = {
  categorization?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  endedAt?: Maybe<Scalars['String']['output']>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  objectives?: Maybe<Array<webAgent__AiDiscoveryCrawlObjective>>;
  owner: User;
  status: webAgent__AiDiscoveryCrawlStatus;
  successfulExtractions: Scalars['Int64']['output'];
  successfulObjectives?: Maybe<Array<webAgent__AiDiscoveryCrawlObjective>>;
  successfulObjectivesCount: Scalars['Int64']['output'];
  successfulProbes: Scalars['Int64']['output'];
  totalObjectivesCount: Scalars['Int64']['output'];
};


export type webAgent__AiDiscoveryCrawlexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__AiDiscoveryCrawlobjectivesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type webAgent__AiDiscoveryCrawlownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__AiDiscoveryCrawlsuccessfulObjectivesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};

export type webAgent__AiDiscoveryCrawlObjective = {
  abortReasons?: Maybe<Array<Scalars['JSON']['output']>>;
  agentLogArtifact?: Maybe<webAgent__WebAgentArtifact>;
  categorization?: Maybe<Scalars['String']['output']>;
  crawl: webAgent__AiDiscoveryCrawl;
  createdAt: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  dataSlug?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<document__Document>>;
  endedAt?: Maybe<Scalars['String']['output']>;
  failureCause?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  objectiveType: webAgent__AiDiscoveryCrawlObjectiveType;
  owner: User;
  parentObjective?: Maybe<webAgent__AiDiscoveryCrawlObjective>;
  status?: Maybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
  traceArtifact?: Maybe<webAgent__PlaywrightTraceArtifact>;
};


export type webAgent__AiDiscoveryCrawlObjectiveagentLogArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentArtifact>;
};


export type webAgent__AiDiscoveryCrawlObjectivecrawlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
};


export type webAgent__AiDiscoveryCrawlObjectivedocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type webAgent__AiDiscoveryCrawlObjectiveownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__AiDiscoveryCrawlObjectiveparentObjectiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type webAgent__AiDiscoveryCrawlObjectivetraceArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterPlaywrightTraceArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderPlaywrightTraceArtifact>;
};

export enum webAgent__AiDiscoveryCrawlObjectiveResult {
  ABORTED = 'ABORTED',
  DIED = 'DIED',
  DISABLED = 'DISABLED',
  FAILED = 'FAILED',
  RUNNING = 'RUNNING',
  SUCCESS = 'SUCCESS'
}

export enum webAgent__AiDiscoveryCrawlObjectiveType {
  AI = 'AI',
  CLASSIC = 'CLASSIC',
  PROBE = 'PROBE'
}

export type webAgent__AiDiscoveryCrawlObjective_Type = BaseObject & Object & Owned & webAgent__AiDiscoveryCrawlObjective & {
  __typename: 'webAgent__AiDiscoveryCrawlObjective_Type';
  abortReasons?: Maybe<Array<Scalars['JSON']['output']>>;
  agentLogArtifact?: Maybe<webAgent__WebAgentArtifact>;
  categorization?: Maybe<Scalars['String']['output']>;
  crawl: webAgent__AiDiscoveryCrawl;
  createdAt: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  dataSlug?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<document__Document>>;
  endedAt?: Maybe<Scalars['String']['output']>;
  failureCause?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  objectiveType: webAgent__AiDiscoveryCrawlObjectiveType;
  owner: User;
  parentObjective?: Maybe<webAgent__AiDiscoveryCrawlObjective>;
  status?: Maybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
  traceArtifact?: Maybe<webAgent__PlaywrightTraceArtifact>;
};


export type webAgent__AiDiscoveryCrawlObjective_TypeagentLogArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentArtifact>;
};


export type webAgent__AiDiscoveryCrawlObjective_TypecrawlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
};


export type webAgent__AiDiscoveryCrawlObjective_TypedocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type webAgent__AiDiscoveryCrawlObjective_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__AiDiscoveryCrawlObjective_TypeparentObjectiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type webAgent__AiDiscoveryCrawlObjective_TypetraceArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterPlaywrightTraceArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderPlaywrightTraceArtifact>;
};

export enum webAgent__AiDiscoveryCrawlStatus {
  COMPLETED = 'COMPLETED',
  CRASHED = 'CRASHED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PARTIAL = 'PARTIAL'
}

export type webAgent__AiDiscoveryCrawl_Type = BaseObject & Object & Owned & webAgent__AiDiscoveryCrawl & {
  __typename: 'webAgent__AiDiscoveryCrawl_Type';
  categorization?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  endedAt?: Maybe<Scalars['String']['output']>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  objectives?: Maybe<Array<webAgent__AiDiscoveryCrawlObjective>>;
  owner: User;
  status: webAgent__AiDiscoveryCrawlStatus;
  successfulExtractions: Scalars['Int64']['output'];
  successfulObjectives?: Maybe<Array<webAgent__AiDiscoveryCrawlObjective>>;
  successfulObjectivesCount: Scalars['Int64']['output'];
  successfulProbes: Scalars['Int64']['output'];
  totalObjectivesCount: Scalars['Int64']['output'];
};


export type webAgent__AiDiscoveryCrawl_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__AiDiscoveryCrawl_TypeobjectivesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type webAgent__AiDiscoveryCrawl_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__AiDiscoveryCrawl_TypesuccessfulObjectivesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};

/** The proxy strategy to use for Browserbase. */
export enum webAgent__BrowserbaseProxyStrategy {
  DEFAULT = 'DEFAULT',
  PROXY_LOCATION = 'PROXY_LOCATION',
  USER_IP = 'USER_IP'
}

/** The stealth strategy to use for Browserbase. */
export enum webAgent__BrowserbaseStealthStrategy {
  ADVANCED_STEALTH = 'ADVANCED_STEALTH',
  BASIC_STEALTH = 'BASIC_STEALTH',
  DEFAULT = 'DEFAULT'
}

export enum webAgent__CDPProvider {
  BRIGHTDATA = 'BRIGHTDATA',
  BROWSERBASE = 'BROWSERBASE',
  BROWSERLESS = 'BROWSERLESS',
  LOCAL = 'LOCAL',
  STEEL = 'STEEL'
}

export type webAgent__CrawlDataSummaryArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  crawlType: webAgent__CrawlType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  summary: Scalars['JSON']['output'];
};


export type webAgent__CrawlDataSummaryArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__CrawlDataSummaryArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__CrawlDataSummaryArtifact_Type = BaseObject & Object & Owned & webAgent__CrawlDataSummaryArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__CrawlDataSummaryArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  crawlType: webAgent__CrawlType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  summary: Scalars['JSON']['output'];
};


export type webAgent__CrawlDataSummaryArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__CrawlDataSummaryArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__CrawlType {
  AI = 'AI',
  CLASSIC = 'CLASSIC'
}

export enum webAgent__DataLatency {
  DEFERRED = 'DEFERRED',
  IMMEDIATE = 'IMMEDIATE'
}

export enum webAgent__DataType {
  CLAIMS = 'CLAIMS',
  EOBS = 'EOBS',
  PLAN_DOCUMENTS = 'PLAN_DOCUMENTS'
}

export type webAgent__Endpoint = {
  capabilities?: Maybe<Array<webAgent__EndpointCapability>>;
  cdpProvider: webAgent__CDPProvider;
  currentSupportLevel?: Maybe<webAgent__EndpointSupportLevelHistory>;
  dashboardUrl?: Maybe<Scalars['String']['output']>;
  defaultProxy?: Maybe<webAgent__ProxyConfig>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayUrl: Scalars['String']['output'];
  externalIds: Array<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  ingestionSupportedSince?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAuthenticationRequired: Scalars['Boolean']['output'];
  isIngestionSupported: Scalars['Boolean']['output'];
  loginUrl: Scalars['String']['output'];
  managedMfaConfiguration?: Maybe<webAgent__ManagedMfaConfiguration>;
  metadata: Array<Scalars['JSON']['output']>;
  organization?: Maybe<integration__Organization>;
  planDocumentsDataLatency: webAgent__DataLatency;
  planDocumentsSupported: Scalars['Boolean']['output'];
  portalGuideUrl?: Maybe<Scalars['String']['output']>;
  preferredProxyGeolocationState?: Maybe<geolocation__State>;
  slug?: Maybe<Scalars['String']['output']>;
  supportLevelHistory?: Maybe<Array<webAgent__EndpointSupportLevelHistory>>;
  type: webAgent__EndpointType;
};


export type webAgent__EndpointcapabilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpointCapability>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpointCapability>;
};


export type webAgent__EndpointcurrentSupportLevelArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpointSupportLevelHistory>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpointSupportLevelHistory>;
};


export type webAgent__EndpointdefaultProxyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterProxyConfig>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderProxyConfig>;
};


export type webAgent__EndpointmanagedMfaConfigurationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaConfiguration>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaConfiguration>;
};


export type webAgent__EndpointorganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};


export type webAgent__EndpointsupportLevelHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpointSupportLevelHistory>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpointSupportLevelHistory>;
};

export type webAgent__EndpointCapability = {
  createdAt: Scalars['String']['output'];
  dataLatency: webAgent__DataLatency;
  dataType: webAgent__DataType;
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  isSupported: Scalars['Boolean']['output'];
};


export type webAgent__EndpointCapabilityendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};

export type webAgent__EndpointCapability_Type = BaseObject & Object & webAgent__EndpointCapability & {
  __typename: 'webAgent__EndpointCapability_Type';
  createdAt: Scalars['String']['output'];
  dataLatency: webAgent__DataLatency;
  dataType: webAgent__DataType;
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  isSupported: Scalars['Boolean']['output'];
};


export type webAgent__EndpointCapability_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};

export enum webAgent__EndpointSupportLevel {
  P0 = 'P0',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3'
}

export type webAgent__EndpointSupportLevelHistory = {
  createdAt: Scalars['String']['output'];
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  supportLevel: webAgent__EndpointSupportLevel;
  updatedBy: User;
};


export type webAgent__EndpointSupportLevelHistoryendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};


export type webAgent__EndpointSupportLevelHistoryupdatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__EndpointSupportLevelHistory_Type = BaseObject & Object & webAgent__EndpointSupportLevelHistory & {
  __typename: 'webAgent__EndpointSupportLevelHistory_Type';
  createdAt: Scalars['String']['output'];
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  supportLevel: webAgent__EndpointSupportLevel;
  updatedBy: User;
};


export type webAgent__EndpointSupportLevelHistory_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};


export type webAgent__EndpointSupportLevelHistory_TypeupdatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__EndpointType {
  EHR = 'EHR',
  INSURANCE = 'INSURANCE'
}

export type webAgent__Endpoint_Type = BaseObject & Object & integration__BaseEndpoint & webAgent__Endpoint & {
  __typename: 'webAgent__Endpoint_Type';
  capabilities?: Maybe<Array<webAgent__EndpointCapability>>;
  cdpProvider: webAgent__CDPProvider;
  currentSupportLevel?: Maybe<webAgent__EndpointSupportLevelHistory>;
  dashboardUrl?: Maybe<Scalars['String']['output']>;
  defaultProxy?: Maybe<webAgent__ProxyConfig>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayUrl: Scalars['String']['output'];
  externalIds: Array<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  ingestionSupportedSince?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAuthenticationRequired: Scalars['Boolean']['output'];
  isIngestionSupported: Scalars['Boolean']['output'];
  loginUrl: Scalars['String']['output'];
  managedMfaConfiguration?: Maybe<webAgent__ManagedMfaConfiguration>;
  metadata: Array<Scalars['JSON']['output']>;
  organization?: Maybe<integration__Organization>;
  planDocumentsDataLatency: webAgent__DataLatency;
  planDocumentsSupported: Scalars['Boolean']['output'];
  portalGuideUrl?: Maybe<Scalars['String']['output']>;
  preferredProxyGeolocationState?: Maybe<geolocation__State>;
  slug?: Maybe<Scalars['String']['output']>;
  supportLevelHistory?: Maybe<Array<webAgent__EndpointSupportLevelHistory>>;
  type: webAgent__EndpointType;
};


export type webAgent__Endpoint_TypecapabilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpointCapability>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpointCapability>;
};


export type webAgent__Endpoint_TypecurrentSupportLevelArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpointSupportLevelHistory>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpointSupportLevelHistory>;
};


export type webAgent__Endpoint_TypedefaultProxyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterProxyConfig>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderProxyConfig>;
};


export type webAgent__Endpoint_TypemanagedMfaConfigurationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaConfiguration>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaConfiguration>;
};


export type webAgent__Endpoint_TypeorganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};


export type webAgent__Endpoint_TypesupportLevelHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpointSupportLevelHistory>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpointSupportLevelHistory>;
};

export enum webAgent__ExecutionOrigin {
  USER_LINK = 'USER_LINK',
  USER_RELINK = 'USER_RELINK'
}

export type webAgent__FilterAiConversationLogArtifact = {
  and?: InputMaybe<Array<webAgent__FilterAiConversationLogArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterAiConversationLogArtifact>;
  or?: InputMaybe<Array<webAgent__FilterAiConversationLogArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__FilterAiDiscoveryCrawl = {
  and?: InputMaybe<Array<webAgent__FilterAiDiscoveryCrawl>>;
  categorization?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  endedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  notes?: InputMaybe<FilterString>;
  objectives?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  or?: InputMaybe<Array<webAgent__FilterAiDiscoveryCrawl>>;
  owner?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<FilterwebAgent__AiDiscoveryCrawlStatus>;
  successfulExtractions?: InputMaybe<FilterInt64>;
  successfulObjectives?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  successfulObjectivesCount?: InputMaybe<FilterInt64>;
  successfulProbes?: InputMaybe<FilterInt64>;
  totalObjectivesCount?: InputMaybe<FilterInt64>;
};

export type webAgent__FilterAiDiscoveryCrawlObjective = {
  agentLogArtifact?: InputMaybe<webAgent__NestedFilterWebAgentArtifact>;
  and?: InputMaybe<Array<webAgent__FilterAiDiscoveryCrawlObjective>>;
  categorization?: InputMaybe<FilterString>;
  crawl?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawl>;
  createdAt?: InputMaybe<FilterString>;
  data?: InputMaybe<FilterJSON>;
  dataSlug?: InputMaybe<FilterString>;
  documents?: InputMaybe<document__NestedFilterDocument>;
  endedAt?: InputMaybe<FilterString>;
  failureCause?: InputMaybe<FilterString>;
  failureReason?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  notes?: InputMaybe<FilterString>;
  objectiveType?: InputMaybe<FilterwebAgent__AiDiscoveryCrawlObjectiveType>;
  or?: InputMaybe<Array<webAgent__FilterAiDiscoveryCrawlObjective>>;
  owner?: InputMaybe<NestedFilterUser>;
  parentObjective?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  status?: InputMaybe<FilterwebAgent__AiDiscoveryCrawlObjectiveResult>;
  traceArtifact?: InputMaybe<webAgent__NestedFilterPlaywrightTraceArtifact>;
};

export type webAgent__FilterCrawlDataSummaryArtifact = {
  and?: InputMaybe<Array<webAgent__FilterCrawlDataSummaryArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  crawlType?: InputMaybe<FilterwebAgent__CrawlType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterCrawlDataSummaryArtifact>;
  or?: InputMaybe<Array<webAgent__FilterCrawlDataSummaryArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  summary?: InputMaybe<FilterJSON>;
};

export type webAgent__FilterEndpoint = {
  and?: InputMaybe<Array<webAgent__FilterEndpoint>>;
  capabilities?: InputMaybe<webAgent__NestedFilterEndpointCapability>;
  cdpProvider?: InputMaybe<FilterwebAgent__CDPProvider>;
  currentSupportLevel?: InputMaybe<webAgent__NestedFilterEndpointSupportLevelHistory>;
  dashboardUrl?: InputMaybe<FilterString>;
  defaultProxy?: InputMaybe<webAgent__NestedFilterProxyConfig>;
  displayName?: InputMaybe<FilterString>;
  displayUrl?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  ingestionSupportedSince?: InputMaybe<FilterString>;
  isActive?: InputMaybe<FilterBoolean>;
  isAuthenticationRequired?: InputMaybe<FilterBoolean>;
  isIngestionSupported?: InputMaybe<FilterBoolean>;
  loginUrl?: InputMaybe<FilterString>;
  managedMfaConfiguration?: InputMaybe<webAgent__NestedFilterManagedMfaConfiguration>;
  not?: InputMaybe<webAgent__FilterEndpoint>;
  or?: InputMaybe<Array<webAgent__FilterEndpoint>>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  planDocumentsDataLatency?: InputMaybe<FilterwebAgent__DataLatency>;
  planDocumentsSupported?: InputMaybe<FilterBoolean>;
  portalGuideUrl?: InputMaybe<FilterString>;
  preferredProxyGeolocationState?: InputMaybe<Filtergeolocation__State>;
  slug?: InputMaybe<FilterString>;
  supportLevelHistory?: InputMaybe<webAgent__NestedFilterEndpointSupportLevelHistory>;
  type?: InputMaybe<FilterwebAgent__EndpointType>;
};

export type webAgent__FilterEndpointCapability = {
  and?: InputMaybe<Array<webAgent__FilterEndpointCapability>>;
  createdAt?: InputMaybe<FilterString>;
  dataLatency?: InputMaybe<FilterwebAgent__DataLatency>;
  dataType?: InputMaybe<FilterwebAgent__DataType>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  id?: InputMaybe<FilterID>;
  isSupported?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<webAgent__FilterEndpointCapability>;
  or?: InputMaybe<Array<webAgent__FilterEndpointCapability>>;
};

export type webAgent__FilterEndpointSupportLevelHistory = {
  and?: InputMaybe<Array<webAgent__FilterEndpointSupportLevelHistory>>;
  createdAt?: InputMaybe<FilterString>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterEndpointSupportLevelHistory>;
  or?: InputMaybe<Array<webAgent__FilterEndpointSupportLevelHistory>>;
  supportLevel?: InputMaybe<FilterwebAgent__EndpointSupportLevel>;
  updatedBy?: InputMaybe<NestedFilterUser>;
};

export type webAgent__FilterInitialPageLoadSpan = {
  and?: InputMaybe<Array<webAgent__FilterInitialPageLoadSpan>>;
  endedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<webAgent__FilterInitialPageLoadSpan>;
  or?: InputMaybe<Array<webAgent__FilterInitialPageLoadSpan>>;
  startedAt?: InputMaybe<FilterString>;
};

export type webAgent__FilterLink = {
  active?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<webAgent__FilterLink>>;
  createdAt?: InputMaybe<FilterString>;
  deactivatedAt?: InputMaybe<FilterString>;
  deactivatedReason?: InputMaybe<FilterwebAgent__LinkDeactivatedReason>;
  defaultProxy?: InputMaybe<webAgent__NestedFilterProxyConfig>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  executions?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  hasManagedMfa?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  lastSyncedAt?: InputMaybe<FilterString>;
  latestExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  latestIngestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  mfaReceiver?: InputMaybe<webAgent__NestedFilterMfaReceiver>;
  not?: InputMaybe<webAgent__FilterLink>;
  or?: InputMaybe<Array<webAgent__FilterLink>>;
  owner?: InputMaybe<NestedFilterUser>;
  patientDOB?: InputMaybe<FilterString>;
  patientId?: InputMaybe<FilterString>;
  patientName?: InputMaybe<FilterString>;
  plans?: InputMaybe<plan__NestedFilterPlan>;
  providerProfiles?: InputMaybe<webAgent__NestedFilterLinkProviderProfile>;
  secrets?: InputMaybe<webAgent__NestedFilterLinkSecret>;
  userId?: InputMaybe<FilterString>;
};

export type webAgent__FilterLinkProviderProfile = {
  and?: InputMaybe<Array<webAgent__FilterLinkProviderProfile>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  not?: InputMaybe<webAgent__FilterLinkProviderProfile>;
  or?: InputMaybe<Array<webAgent__FilterLinkProviderProfile>>;
  owner?: InputMaybe<NestedFilterUser>;
  profileId?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
  vendor?: InputMaybe<FilterwebAgent__CDPProvider>;
};

export type webAgent__FilterLinkSecret = {
  and?: InputMaybe<Array<webAgent__FilterLinkSecret>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  key?: InputMaybe<FilterString>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  not?: InputMaybe<webAgent__FilterLinkSecret>;
  or?: InputMaybe<Array<webAgent__FilterLinkSecret>>;
  owner?: InputMaybe<NestedFilterUser>;
  value?: InputMaybe<FilterJSON>;
};

export type webAgent__FilterManagedMfaConfiguration = {
  and?: InputMaybe<Array<webAgent__FilterManagedMfaConfiguration>>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  id?: InputMaybe<FilterID>;
  isSupported?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<webAgent__FilterManagedMfaConfiguration>;
  or?: InputMaybe<Array<webAgent__FilterManagedMfaConfiguration>>;
};

export type webAgent__FilterManagedMfaConfigured = {
  and?: InputMaybe<Array<webAgent__FilterManagedMfaConfigured>>;
  configurationEndedAt?: InputMaybe<FilterString>;
  configurationStartedAt?: InputMaybe<FilterString>;
  configuredMethod?: InputMaybe<FilterwebAgent__MfaMethod>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterManagedMfaConfigured>;
  or?: InputMaybe<Array<webAgent__FilterManagedMfaConfigured>>;
  owner?: InputMaybe<NestedFilterUser>;
  type?: InputMaybe<FilterwebAgent__ManagedMfaOutcomeType>;
};

export type webAgent__FilterManagedMfaFailed = {
  and?: InputMaybe<Array<webAgent__FilterManagedMfaFailed>>;
  configurationEndedAt?: InputMaybe<FilterString>;
  configurationStartedAt?: InputMaybe<FilterString>;
  error?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterManagedMfaFailed>;
  or?: InputMaybe<Array<webAgent__FilterManagedMfaFailed>>;
  owner?: InputMaybe<NestedFilterUser>;
  type?: InputMaybe<FilterwebAgent__ManagedMfaOutcomeType>;
};

export type webAgent__FilterManagedMfaOutcome = {
  and?: InputMaybe<Array<webAgent__FilterManagedMfaOutcome>>;
  configurationEndedAt?: InputMaybe<FilterString>;
  configurationStartedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterManagedMfaOutcome>;
  or?: InputMaybe<Array<webAgent__FilterManagedMfaOutcome>>;
  owner?: InputMaybe<NestedFilterUser>;
  type?: InputMaybe<FilterwebAgent__ManagedMfaOutcomeType>;
};

export type webAgent__FilterManagedMfaRejected = {
  and?: InputMaybe<Array<webAgent__FilterManagedMfaRejected>>;
  configurationEndedAt?: InputMaybe<FilterString>;
  configurationStartedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterManagedMfaRejected>;
  or?: InputMaybe<Array<webAgent__FilterManagedMfaRejected>>;
  owner?: InputMaybe<NestedFilterUser>;
  type?: InputMaybe<FilterwebAgent__ManagedMfaOutcomeType>;
};

export type webAgent__FilterMfaCodeRequest = {
  and?: InputMaybe<Array<webAgent__FilterMfaCodeRequest>>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  isValid?: InputMaybe<FilterBoolean>;
  mfaReceiver?: InputMaybe<webAgent__NestedFilterMfaReceiver>;
  not?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  or?: InputMaybe<Array<webAgent__FilterMfaCodeRequest>>;
  usedAt?: InputMaybe<FilterString>;
};

export type webAgent__FilterMfaConfigurationSummaryArtifact = {
  and?: InputMaybe<Array<webAgent__FilterMfaConfigurationSummaryArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  authenticatorAppSupport?: InputMaybe<FilterwebAgent__MfaSupportLevel>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  emailSupport?: InputMaybe<FilterwebAgent__MfaSupportLevel>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  isMfaRequired?: InputMaybe<FilterwebAgent__MfaRequirement>;
  not?: InputMaybe<webAgent__FilterMfaConfigurationSummaryArtifact>;
  or?: InputMaybe<Array<webAgent__FilterMfaConfigurationSummaryArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  phoneSupport?: InputMaybe<FilterwebAgent__MfaSupportLevel>;
  smsSupport?: InputMaybe<FilterwebAgent__MfaSupportLevel>;
  success?: InputMaybe<FilterBoolean>;
  wasPromptedForMfa?: InputMaybe<FilterBoolean>;
};

export type webAgent__FilterMfaEmail = {
  and?: InputMaybe<Array<webAgent__FilterMfaEmail>>;
  codeRequests?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  email?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  latestCodeRequest?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  not?: InputMaybe<webAgent__FilterMfaEmail>;
  or?: InputMaybe<Array<webAgent__FilterMfaEmail>>;
};

export type webAgent__FilterMfaNumber = {
  and?: InputMaybe<Array<webAgent__FilterMfaNumber>>;
  backupNumber?: InputMaybe<FilterString>;
  codeRequests?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  isStopped?: InputMaybe<FilterBoolean>;
  latestCodeRequest?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  not?: InputMaybe<webAgent__FilterMfaNumber>;
  number?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<webAgent__FilterMfaNumber>>;
  stopRequestedAt?: InputMaybe<FilterString>;
};

export type webAgent__FilterMfaReceiver = {
  and?: InputMaybe<Array<webAgent__FilterMfaReceiver>>;
  codeRequests?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  latestCodeRequest?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  not?: InputMaybe<webAgent__FilterMfaReceiver>;
  or?: InputMaybe<Array<webAgent__FilterMfaReceiver>>;
};

export type webAgent__FilterNavigatorSpecialistInstructions = {
  and?: InputMaybe<Array<webAgent__FilterNavigatorSpecialistInstructions>>;
  createdAt?: InputMaybe<FilterString>;
  dataSlug?: InputMaybe<FilterString>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  id?: InputMaybe<FilterID>;
  instructions?: InputMaybe<FilterString>;
  isActive?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<webAgent__FilterNavigatorSpecialistInstructions>;
  or?: InputMaybe<Array<webAgent__FilterNavigatorSpecialistInstructions>>;
};

export type webAgent__FilterNavigatorSpecialistPageDiscovery = {
  and?: InputMaybe<Array<webAgent__FilterNavigatorSpecialistPageDiscovery>>;
  createdAt?: InputMaybe<FilterString>;
  dataSlug?: InputMaybe<FilterString>;
  discovery?: InputMaybe<FilterJSON>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<webAgent__FilterNavigatorSpecialistPageDiscovery>;
  or?: InputMaybe<Array<webAgent__FilterNavigatorSpecialistPageDiscovery>>;
};

export type webAgent__FilterPlaywrightHarArtifact = {
  and?: InputMaybe<Array<webAgent__FilterPlaywrightHarArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterPlaywrightHarArtifact>;
  or?: InputMaybe<Array<webAgent__FilterPlaywrightHarArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__FilterPlaywrightInterceptedResponsesArtifact = {
  and?: InputMaybe<Array<webAgent__FilterPlaywrightInterceptedResponsesArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterPlaywrightInterceptedResponsesArtifact>;
  or?: InputMaybe<Array<webAgent__FilterPlaywrightInterceptedResponsesArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__FilterPlaywrightPageSourceArtifact = {
  and?: InputMaybe<Array<webAgent__FilterPlaywrightPageSourceArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  llmSummary?: InputMaybe<FilterString>;
  not?: InputMaybe<webAgent__FilterPlaywrightPageSourceArtifact>;
  or?: InputMaybe<Array<webAgent__FilterPlaywrightPageSourceArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__FilterPlaywrightScreenshotArtifact = {
  and?: InputMaybe<Array<webAgent__FilterPlaywrightScreenshotArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterPlaywrightScreenshotArtifact>;
  or?: InputMaybe<Array<webAgent__FilterPlaywrightScreenshotArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__FilterPlaywrightTraceArtifact = {
  and?: InputMaybe<Array<webAgent__FilterPlaywrightTraceArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterPlaywrightTraceArtifact>;
  or?: InputMaybe<Array<webAgent__FilterPlaywrightTraceArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__FilterProxyConfig = {
  and?: InputMaybe<Array<webAgent__FilterProxyConfig>>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterProxyConfig>;
  or?: InputMaybe<Array<webAgent__FilterProxyConfig>>;
  password?: InputMaybe<FilterString>;
  server?: InputMaybe<FilterString>;
  username?: InputMaybe<FilterString>;
};

export type webAgent__FilterRecipeFinishedEvent = {
  and?: InputMaybe<Array<webAgent__FilterRecipeFinishedEvent>>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterRecipeFinishedEvent>;
  or?: InputMaybe<Array<webAgent__FilterRecipeFinishedEvent>>;
  owner?: InputMaybe<NestedFilterUser>;
  playwrightTraceS3bucket?: InputMaybe<FilterString>;
  playwrightTraceS3key?: InputMaybe<FilterString>;
  recipeDuration?: InputMaybe<FilterString>;
  result?: InputMaybe<FilterJSON>;
  screenshotS3bucket?: InputMaybe<FilterString>;
  screenshotS3key?: InputMaybe<FilterString>;
  startEvent?: InputMaybe<webAgent__NestedFilterRecipeStartedEvent>;
};

export type webAgent__FilterRecipeStartedEvent = {
  and?: InputMaybe<Array<webAgent__FilterRecipeStartedEvent>>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterRecipeStartedEvent>;
  or?: InputMaybe<Array<webAgent__FilterRecipeStartedEvent>>;
  owner?: InputMaybe<NestedFilterUser>;
  recipeName?: InputMaybe<FilterString>;
};

export type webAgent__FilterRequestResponseSpan = {
  and?: InputMaybe<Array<webAgent__FilterRequestResponseSpan>>;
  endedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<webAgent__FilterRequestResponseSpan>;
  or?: InputMaybe<Array<webAgent__FilterRequestResponseSpan>>;
  requestType?: InputMaybe<FilterString>;
  responseType?: InputMaybe<FilterString>;
  startedAt?: InputMaybe<FilterString>;
};

export type webAgent__FilterRobotFinishedEvent = {
  and?: InputMaybe<Array<webAgent__FilterRobotFinishedEvent>>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterRobotFinishedEvent>;
  or?: InputMaybe<Array<webAgent__FilterRobotFinishedEvent>>;
  owner?: InputMaybe<NestedFilterUser>;
  result?: InputMaybe<FilterJSON>;
  robotDuration?: InputMaybe<FilterString>;
  startEvent?: InputMaybe<webAgent__NestedFilterRobotStartedEvent>;
};

export type webAgent__FilterRobotStartedEvent = {
  and?: InputMaybe<Array<webAgent__FilterRobotStartedEvent>>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterRobotStartedEvent>;
  or?: InputMaybe<Array<webAgent__FilterRobotStartedEvent>>;
  owner?: InputMaybe<NestedFilterUser>;
  robotName?: InputMaybe<FilterString>;
};

export type webAgent__FilterSignInReview = {
  and?: InputMaybe<Array<webAgent__FilterSignInReview>>;
  categorization?: InputMaybe<FilterwebAgent__SignInAnalysisCategory>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterSignInReview>;
  notes?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<webAgent__FilterSignInReview>>;
};

export type webAgent__FilterSignInRobotResultArtifact = {
  and?: InputMaybe<Array<webAgent__FilterSignInRobotResultArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterSignInRobotResultArtifact>;
  or?: InputMaybe<Array<webAgent__FilterSignInRobotResultArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  recipeResults?: InputMaybe<FilterJSON>;
  result?: InputMaybe<FilterJSON>;
  success?: InputMaybe<FilterBoolean>;
};

export type webAgent__FilterSpan = {
  and?: InputMaybe<Array<webAgent__FilterSpan>>;
  endedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<webAgent__FilterSpan>;
  or?: InputMaybe<Array<webAgent__FilterSpan>>;
  startedAt?: InputMaybe<FilterString>;
};

export type webAgent__FilterUrlOpenedEvent = {
  and?: InputMaybe<Array<webAgent__FilterUrlOpenedEvent>>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterUrlOpenedEvent>;
  or?: InputMaybe<Array<webAgent__FilterUrlOpenedEvent>>;
  owner?: InputMaybe<NestedFilterUser>;
  url?: InputMaybe<FilterString>;
};

export type webAgent__FilterUserExitInsuranceLinkFeedback = {
  and?: InputMaybe<Array<webAgent__FilterUserExitInsuranceLinkFeedback>>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  feedback?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterUserExitInsuranceLinkFeedback>;
  or?: InputMaybe<Array<webAgent__FilterUserExitInsuranceLinkFeedback>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type webAgent__FilterWebAgentArtifact = {
  and?: InputMaybe<Array<webAgent__FilterWebAgentArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  category?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterWebAgentArtifact>;
  or?: InputMaybe<Array<webAgent__FilterWebAgentArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__FilterWebAgentExecution = {
  and?: InputMaybe<Array<webAgent__FilterWebAgentExecution>>;
  artifacts?: InputMaybe<webAgent__NestedFilterWebAgentExecutionArtifact>;
  audioTokenCount?: InputMaybe<FilterInt64>;
  browserbaseProxyStrategy?: InputMaybe<FilterwebAgent__BrowserbaseProxyStrategy>;
  browserbaseStealthStrategy?: InputMaybe<FilterwebAgent__BrowserbaseStealthStrategy>;
  cachedTokenCount?: InputMaybe<FilterInt64>;
  cdpInspectUrl?: InputMaybe<FilterString>;
  cdpProvider?: InputMaybe<FilterwebAgent__CDPProvider>;
  cdpProviderProfileId?: InputMaybe<FilterString>;
  cdpProviderSessionId?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  discoveryCrawls?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawl>;
  documents?: InputMaybe<document__NestedFilterDocument>;
  endpoint?: InputMaybe<integration__NestedFilterBaseEndpoint>;
  events?: InputMaybe<webAgent__NestedFilterWebAgentExecutionEvent>;
  id?: InputMaybe<FilterID>;
  ingestions?: InputMaybe<ingestion__NestedFilterIngestion>;
  initiatedBy?: InputMaybe<NestedFilterUser>;
  initiatorRole?: InputMaybe<FilterParticipant>;
  inputTokenCount?: InputMaybe<FilterInt64>;
  isFailedProviderAttempt?: InputMaybe<FilterBoolean>;
  lastUserMfaMethods?: InputMaybe<FilterwebAgent__MfaMethod>;
  latestDiscoveryCrawl?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawl>;
  latestIngestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  latestManagedMfaOutcome?: InputMaybe<webAgent__NestedFilterManagedMfaOutcome>;
  latestStatus?: InputMaybe<FilterwebAgent__WebExecutionStatus>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  managedMfaOutcomes?: InputMaybe<webAgent__NestedFilterManagedMfaOutcome>;
  millisBlockedOnUser?: InputMaybe<FilterInt>;
  not?: InputMaybe<webAgent__FilterWebAgentExecution>;
  or?: InputMaybe<Array<webAgent__FilterWebAgentExecution>>;
  origin?: InputMaybe<FilterwebAgent__ExecutionOrigin>;
  originalExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  otelTraceId?: InputMaybe<FilterString>;
  outputTokenCount?: InputMaybe<FilterInt64>;
  owner?: InputMaybe<NestedFilterUser>;
  proxy?: InputMaybe<webAgent__NestedFilterProxyConfig>;
  signInActivityTimedOutAt?: InputMaybe<FilterString>;
  signInClientTimedOutAt?: InputMaybe<FilterString>;
  signInErroredAt?: InputMaybe<FilterString>;
  signInPhaseAtFailure?: InputMaybe<FilterString>;
  signInReview?: InputMaybe<webAgent__NestedFilterSignInReview>;
  signInRobotType?: InputMaybe<FilterwebAgent__SignInRobotType>;
  signInSucceededAt?: InputMaybe<FilterString>;
  type?: InputMaybe<FilterwebAgent__WebExecutionType>;
};

export type webAgent__FilterWebAgentExecutionArtifact = {
  and?: InputMaybe<Array<webAgent__FilterWebAgentExecutionArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterWebAgentExecutionArtifact>;
  or?: InputMaybe<Array<webAgent__FilterWebAgentExecutionArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type webAgent__FilterWebAgentExecutionEvent = {
  and?: InputMaybe<Array<webAgent__FilterWebAgentExecutionEvent>>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterWebAgentExecutionEvent>;
  or?: InputMaybe<Array<webAgent__FilterWebAgentExecutionEvent>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type webAgent__InitialPageLoadSpan = {
  endedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
};


export type webAgent__InitialPageLoadSpanexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type webAgent__InitialPageLoadSpan_Type = BaseObject & Object & webAgent__InitialPageLoadSpan & webAgent__Span & {
  __typename: 'webAgent__InitialPageLoadSpan_Type';
  endedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
};


export type webAgent__InitialPageLoadSpan_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type webAgent__Link = {
  active: Scalars['Boolean']['output'];
  clientGeoLocation?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['String']['output'];
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  deactivatedReason?: Maybe<webAgent__LinkDeactivatedReason>;
  defaultProxy?: Maybe<webAgent__ProxyConfig>;
  endpoint: webAgent__Endpoint;
  executions?: Maybe<Array<webAgent__WebAgentExecution>>;
  hasManagedMfa: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  latestExecution?: Maybe<webAgent__WebAgentExecution>;
  latestIngestion?: Maybe<ingestion__Ingestion>;
  mfaReceiver?: Maybe<webAgent__MfaReceiver>;
  owner: User;
  patientDOB?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  plans?: Maybe<Array<plan__Plan>>;
  providerProfiles?: Maybe<Array<webAgent__LinkProviderProfile>>;
  secrets?: Maybe<Array<webAgent__LinkSecret>>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type webAgent__LinkdefaultProxyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterProxyConfig>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderProxyConfig>;
};


export type webAgent__LinkendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};


export type webAgent__LinkexecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__LinklatestExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__LinklatestIngestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type webAgent__LinkmfaReceiverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaReceiver>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaReceiver>;
};


export type webAgent__LinkownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__LinkplansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type webAgent__LinkproviderProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLinkProviderProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLinkProviderProfile>;
};


export type webAgent__LinksecretsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLinkSecret>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLinkSecret>;
};

export enum webAgent__LinkDeactivatedReason {
  FORCED_BY_ADMIN = 'FORCED_BY_ADMIN',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  MFA_REQUIRED = 'MFA_REQUIRED'
}

export type webAgent__LinkProviderProfile = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  link: webAgent__Link;
  owner: User;
  profileId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  vendor: webAgent__CDPProvider;
};


export type webAgent__LinkProviderProfilelinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type webAgent__LinkProviderProfileownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__LinkProviderProfile_Type = BaseObject & Object & Owned & webAgent__LinkProviderProfile & {
  __typename: 'webAgent__LinkProviderProfile_Type';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  link: webAgent__Link;
  owner: User;
  profileId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  vendor: webAgent__CDPProvider;
};


export type webAgent__LinkProviderProfile_TypelinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type webAgent__LinkProviderProfile_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__LinkSecret = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  link: webAgent__Link;
  owner: User;
  value: Scalars['JSON']['output'];
};


export type webAgent__LinkSecretlinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type webAgent__LinkSecretownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__LinkSecret_Type = BaseObject & Object & Owned & webAgent__LinkSecret & {
  __typename: 'webAgent__LinkSecret_Type';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  link: webAgent__Link;
  owner: User;
  value: Scalars['JSON']['output'];
};


export type webAgent__LinkSecret_TypelinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type webAgent__LinkSecret_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__Link_Type = BaseObject & Object & Owned & integration__BaseLink & webAgent__Link & {
  __typename: 'webAgent__Link_Type';
  active: Scalars['Boolean']['output'];
  clientGeoLocation?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['String']['output'];
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  deactivatedReason?: Maybe<webAgent__LinkDeactivatedReason>;
  defaultProxy?: Maybe<webAgent__ProxyConfig>;
  endpoint: webAgent__Endpoint;
  executions?: Maybe<Array<webAgent__WebAgentExecution>>;
  hasManagedMfa: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  latestExecution?: Maybe<webAgent__WebAgentExecution>;
  latestIngestion?: Maybe<ingestion__Ingestion>;
  mfaReceiver?: Maybe<webAgent__MfaReceiver>;
  owner: User;
  patientDOB?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  plans?: Maybe<Array<plan__Plan>>;
  providerProfiles?: Maybe<Array<webAgent__LinkProviderProfile>>;
  secrets?: Maybe<Array<webAgent__LinkSecret>>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type webAgent__Link_TypedefaultProxyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterProxyConfig>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderProxyConfig>;
};


export type webAgent__Link_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};


export type webAgent__Link_TypeexecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__Link_TypelatestExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__Link_TypelatestIngestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type webAgent__Link_TypemfaReceiverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaReceiver>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaReceiver>;
};


export type webAgent__Link_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__Link_TypeplansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type webAgent__Link_TypeproviderProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLinkProviderProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLinkProviderProfile>;
};


export type webAgent__Link_TypesecretsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLinkSecret>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLinkSecret>;
};

export type webAgent__ManagedMfaConfiguration = {
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  isSupported: Scalars['Boolean']['output'];
  supportedMethods?: Maybe<Array<webAgent__MfaMethod>>;
};


export type webAgent__ManagedMfaConfigurationendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};

export type webAgent__ManagedMfaConfiguration_Type = BaseObject & Object & webAgent__ManagedMfaConfiguration & {
  __typename: 'webAgent__ManagedMfaConfiguration_Type';
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  isSupported: Scalars['Boolean']['output'];
  supportedMethods?: Maybe<Array<webAgent__MfaMethod>>;
};


export type webAgent__ManagedMfaConfiguration_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};

export type webAgent__ManagedMfaConfigured = {
  configurationEndedAt: Scalars['String']['output'];
  configurationStartedAt: Scalars['String']['output'];
  configuredMethod?: Maybe<webAgent__MfaMethod>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  type: webAgent__ManagedMfaOutcomeType;
};


export type webAgent__ManagedMfaConfiguredexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__ManagedMfaConfiguredownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__ManagedMfaConfigured_Type = BaseObject & Object & Owned & webAgent__ManagedMfaConfigured & webAgent__ManagedMfaOutcome & {
  __typename: 'webAgent__ManagedMfaConfigured_Type';
  configurationEndedAt: Scalars['String']['output'];
  configurationStartedAt: Scalars['String']['output'];
  configuredMethod?: Maybe<webAgent__MfaMethod>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  type: webAgent__ManagedMfaOutcomeType;
};


export type webAgent__ManagedMfaConfigured_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__ManagedMfaConfigured_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__ManagedMfaFailed = {
  configurationEndedAt: Scalars['String']['output'];
  configurationStartedAt: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  type: webAgent__ManagedMfaOutcomeType;
};


export type webAgent__ManagedMfaFailedexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__ManagedMfaFailedownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__ManagedMfaFailed_Type = BaseObject & Object & Owned & webAgent__ManagedMfaFailed & webAgent__ManagedMfaOutcome & {
  __typename: 'webAgent__ManagedMfaFailed_Type';
  configurationEndedAt: Scalars['String']['output'];
  configurationStartedAt: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  type: webAgent__ManagedMfaOutcomeType;
};


export type webAgent__ManagedMfaFailed_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__ManagedMfaFailed_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__ManagedMfaOutcome = {
  configurationEndedAt: Scalars['String']['output'];
  configurationStartedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  type: webAgent__ManagedMfaOutcomeType;
};


export type webAgent__ManagedMfaOutcomeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__ManagedMfaOutcomeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__ManagedMfaOutcomeType {
  CONFIGURED = 'CONFIGURED',
  FAILED = 'FAILED',
  REJECTED = 'REJECTED'
}

export type webAgent__ManagedMfaRejected = {
  configurationEndedAt: Scalars['String']['output'];
  configurationStartedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  type: webAgent__ManagedMfaOutcomeType;
};


export type webAgent__ManagedMfaRejectedexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__ManagedMfaRejectedownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__ManagedMfaRejected_Type = BaseObject & Object & Owned & webAgent__ManagedMfaOutcome & webAgent__ManagedMfaRejected & {
  __typename: 'webAgent__ManagedMfaRejected_Type';
  configurationEndedAt: Scalars['String']['output'];
  configurationStartedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  type: webAgent__ManagedMfaOutcomeType;
};


export type webAgent__ManagedMfaRejected_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__ManagedMfaRejected_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__MfaCodeRequest = {
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  mfaReceiver: webAgent__MfaReceiver;
  usedAt?: Maybe<Scalars['String']['output']>;
};


export type webAgent__MfaCodeRequestexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__MfaCodeRequestmfaReceiverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaReceiver>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaReceiver>;
};

export type webAgent__MfaCodeRequest_Type = BaseObject & Object & webAgent__MfaCodeRequest & {
  __typename: 'webAgent__MfaCodeRequest_Type';
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  mfaReceiver: webAgent__MfaReceiver;
  usedAt?: Maybe<Scalars['String']['output']>;
};


export type webAgent__MfaCodeRequest_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__MfaCodeRequest_TypemfaReceiverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaReceiver>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaReceiver>;
};

export type webAgent__MfaConfigurationSummaryArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  authenticatorAppSupport?: Maybe<webAgent__MfaSupportLevel>;
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  emailSupport?: Maybe<webAgent__MfaSupportLevel>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  isMfaRequired?: Maybe<webAgent__MfaRequirement>;
  owner: User;
  phoneSupport?: Maybe<webAgent__MfaSupportLevel>;
  smsSupport?: Maybe<webAgent__MfaSupportLevel>;
  success: Scalars['Boolean']['output'];
  wasPromptedForMfa?: Maybe<Scalars['Boolean']['output']>;
};


export type webAgent__MfaConfigurationSummaryArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__MfaConfigurationSummaryArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__MfaConfigurationSummaryArtifact_Type = BaseObject & Object & Owned & webAgent__MfaConfigurationSummaryArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__MfaConfigurationSummaryArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  authenticatorAppSupport?: Maybe<webAgent__MfaSupportLevel>;
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  emailSupport?: Maybe<webAgent__MfaSupportLevel>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  isMfaRequired?: Maybe<webAgent__MfaRequirement>;
  owner: User;
  phoneSupport?: Maybe<webAgent__MfaSupportLevel>;
  smsSupport?: Maybe<webAgent__MfaSupportLevel>;
  success: Scalars['Boolean']['output'];
  wasPromptedForMfa?: Maybe<Scalars['Boolean']['output']>;
};


export type webAgent__MfaConfigurationSummaryArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__MfaConfigurationSummaryArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__MfaEmail = {
  codeRequests?: Maybe<Array<webAgent__MfaCodeRequest>>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  latestCodeRequest?: Maybe<webAgent__MfaCodeRequest>;
  link?: Maybe<webAgent__Link>;
};


export type webAgent__MfaEmailcodeRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaEmaillatestCodeRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaEmaillinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};

export type webAgent__MfaEmail_Type = BaseObject & Object & webAgent__MfaEmail & webAgent__MfaReceiver & {
  __typename: 'webAgent__MfaEmail_Type';
  codeRequests?: Maybe<Array<webAgent__MfaCodeRequest>>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  latestCodeRequest?: Maybe<webAgent__MfaCodeRequest>;
  link?: Maybe<webAgent__Link>;
};


export type webAgent__MfaEmail_TypecodeRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaEmail_TypelatestCodeRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaEmail_TypelinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};

export enum webAgent__MfaMethod {
  AUTHENTICATOR = 'AUTHENTICATOR',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  SMS = 'SMS'
}

export type webAgent__MfaNumber = {
  backupNumber?: Maybe<Scalars['String']['output']>;
  codeRequests?: Maybe<Array<webAgent__MfaCodeRequest>>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isStopped: Scalars['Boolean']['output'];
  latestCodeRequest?: Maybe<webAgent__MfaCodeRequest>;
  link?: Maybe<webAgent__Link>;
  number: Scalars['String']['output'];
  stopRequestedAt?: Maybe<Scalars['String']['output']>;
};


export type webAgent__MfaNumbercodeRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaNumberlatestCodeRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaNumberlinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};

export type webAgent__MfaNumber_Type = BaseObject & Object & webAgent__MfaNumber & webAgent__MfaReceiver & {
  __typename: 'webAgent__MfaNumber_Type';
  backupNumber?: Maybe<Scalars['String']['output']>;
  codeRequests?: Maybe<Array<webAgent__MfaCodeRequest>>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isStopped: Scalars['Boolean']['output'];
  latestCodeRequest?: Maybe<webAgent__MfaCodeRequest>;
  link?: Maybe<webAgent__Link>;
  number: Scalars['String']['output'];
  stopRequestedAt?: Maybe<Scalars['String']['output']>;
};


export type webAgent__MfaNumber_TypecodeRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaNumber_TypelatestCodeRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaNumber_TypelinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};

export type webAgent__MfaReceiver = {
  codeRequests?: Maybe<Array<webAgent__MfaCodeRequest>>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  latestCodeRequest?: Maybe<webAgent__MfaCodeRequest>;
  link?: Maybe<webAgent__Link>;
};


export type webAgent__MfaReceivercodeRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaReceiverlatestCodeRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaReceiverlinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};

export enum webAgent__MfaRequirement {
  OPTIONAL = 'OPTIONAL',
  REQUIRED = 'REQUIRED',
  UNKNOWN = 'UNKNOWN'
}

export enum webAgent__MfaSupportLevel {
  MULTIPLE = 'MULTIPLE',
  SINGLE = 'SINGLE',
  UNKNOWN = 'UNKNOWN',
  UNSUPPORTED = 'UNSUPPORTED'
}

export type webAgent__NavigatorSpecialistInstructions = {
  createdAt: Scalars['String']['output'];
  dataSlug?: Maybe<Scalars['String']['output']>;
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
};


export type webAgent__NavigatorSpecialistInstructionsendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};

export type webAgent__NavigatorSpecialistInstructions_Type = BaseObject & Object & webAgent__NavigatorSpecialistInstructions & {
  __typename: 'webAgent__NavigatorSpecialistInstructions_Type';
  createdAt: Scalars['String']['output'];
  dataSlug?: Maybe<Scalars['String']['output']>;
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
};


export type webAgent__NavigatorSpecialistInstructions_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};

export type webAgent__NavigatorSpecialistPageDiscovery = {
  createdAt: Scalars['String']['output'];
  dataSlug: Scalars['String']['output'];
  discovery?: Maybe<Scalars['JSON']['output']>;
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
};


export type webAgent__NavigatorSpecialistPageDiscoveryendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};

export type webAgent__NavigatorSpecialistPageDiscovery_Type = BaseObject & Object & webAgent__NavigatorSpecialistPageDiscovery & {
  __typename: 'webAgent__NavigatorSpecialistPageDiscovery_Type';
  createdAt: Scalars['String']['output'];
  dataSlug: Scalars['String']['output'];
  discovery?: Maybe<Scalars['JSON']['output']>;
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
};


export type webAgent__NavigatorSpecialistPageDiscovery_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};

export type webAgent__NestedFilterAiDiscoveryCrawl = {
  categorization?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  endedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  notes?: InputMaybe<FilterString>;
  objectives?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  owner?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<FilterwebAgent__AiDiscoveryCrawlStatus>;
  successfulExtractions?: InputMaybe<FilterInt64>;
  successfulObjectives?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  successfulObjectivesCount?: InputMaybe<FilterInt64>;
  successfulProbes?: InputMaybe<FilterInt64>;
  totalObjectivesCount?: InputMaybe<FilterInt64>;
};

export type webAgent__NestedFilterAiDiscoveryCrawlObjective = {
  agentLogArtifact?: InputMaybe<webAgent__NestedFilterWebAgentArtifact>;
  categorization?: InputMaybe<FilterString>;
  crawl?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawl>;
  createdAt?: InputMaybe<FilterString>;
  data?: InputMaybe<FilterJSON>;
  dataSlug?: InputMaybe<FilterString>;
  documents?: InputMaybe<document__NestedFilterDocument>;
  endedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  failureCause?: InputMaybe<FilterString>;
  failureReason?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  notes?: InputMaybe<FilterString>;
  objectiveType?: InputMaybe<FilterwebAgent__AiDiscoveryCrawlObjectiveType>;
  owner?: InputMaybe<NestedFilterUser>;
  parentObjective?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  status?: InputMaybe<FilterwebAgent__AiDiscoveryCrawlObjectiveResult>;
  traceArtifact?: InputMaybe<webAgent__NestedFilterPlaywrightTraceArtifact>;
};

export type webAgent__NestedFilterEndpoint = {
  capabilities?: InputMaybe<webAgent__NestedFilterEndpointCapability>;
  cdpProvider?: InputMaybe<FilterwebAgent__CDPProvider>;
  currentSupportLevel?: InputMaybe<webAgent__NestedFilterEndpointSupportLevelHistory>;
  dashboardUrl?: InputMaybe<FilterString>;
  defaultProxy?: InputMaybe<webAgent__NestedFilterProxyConfig>;
  displayName?: InputMaybe<FilterString>;
  displayUrl?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  ingestionSupportedSince?: InputMaybe<FilterString>;
  isActive?: InputMaybe<FilterBoolean>;
  isAuthenticationRequired?: InputMaybe<FilterBoolean>;
  isIngestionSupported?: InputMaybe<FilterBoolean>;
  loginUrl?: InputMaybe<FilterString>;
  managedMfaConfiguration?: InputMaybe<webAgent__NestedFilterManagedMfaConfiguration>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  planDocumentsDataLatency?: InputMaybe<FilterwebAgent__DataLatency>;
  planDocumentsSupported?: InputMaybe<FilterBoolean>;
  portalGuideUrl?: InputMaybe<FilterString>;
  preferredProxyGeolocationState?: InputMaybe<Filtergeolocation__State>;
  slug?: InputMaybe<FilterString>;
  supportLevelHistory?: InputMaybe<webAgent__NestedFilterEndpointSupportLevelHistory>;
  type?: InputMaybe<FilterwebAgent__EndpointType>;
};

export type webAgent__NestedFilterEndpointCapability = {
  createdAt?: InputMaybe<FilterString>;
  dataLatency?: InputMaybe<FilterwebAgent__DataLatency>;
  dataType?: InputMaybe<FilterwebAgent__DataType>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isSupported?: InputMaybe<FilterBoolean>;
};

export type webAgent__NestedFilterEndpointSupportLevelHistory = {
  createdAt?: InputMaybe<FilterString>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  supportLevel?: InputMaybe<FilterwebAgent__EndpointSupportLevel>;
  updatedBy?: InputMaybe<NestedFilterUser>;
};

export type webAgent__NestedFilterLink = {
  active?: InputMaybe<FilterBoolean>;
  createdAt?: InputMaybe<FilterString>;
  deactivatedAt?: InputMaybe<FilterString>;
  deactivatedReason?: InputMaybe<FilterwebAgent__LinkDeactivatedReason>;
  defaultProxy?: InputMaybe<webAgent__NestedFilterProxyConfig>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  executions?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasManagedMfa?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  lastSyncedAt?: InputMaybe<FilterString>;
  latestExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  latestIngestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  mfaReceiver?: InputMaybe<webAgent__NestedFilterMfaReceiver>;
  owner?: InputMaybe<NestedFilterUser>;
  patientDOB?: InputMaybe<FilterString>;
  patientId?: InputMaybe<FilterString>;
  patientName?: InputMaybe<FilterString>;
  plans?: InputMaybe<plan__NestedFilterPlan>;
  providerProfiles?: InputMaybe<webAgent__NestedFilterLinkProviderProfile>;
  secrets?: InputMaybe<webAgent__NestedFilterLinkSecret>;
  userId?: InputMaybe<FilterString>;
};

export type webAgent__NestedFilterLinkProviderProfile = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  owner?: InputMaybe<NestedFilterUser>;
  profileId?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
  vendor?: InputMaybe<FilterwebAgent__CDPProvider>;
};

export type webAgent__NestedFilterLinkSecret = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  key?: InputMaybe<FilterString>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  owner?: InputMaybe<NestedFilterUser>;
  value?: InputMaybe<FilterJSON>;
};

export type webAgent__NestedFilterManagedMfaConfiguration = {
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isSupported?: InputMaybe<FilterBoolean>;
};

export type webAgent__NestedFilterManagedMfaOutcome = {
  configurationEndedAt?: InputMaybe<FilterString>;
  configurationStartedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  type?: InputMaybe<FilterwebAgent__ManagedMfaOutcomeType>;
};

export type webAgent__NestedFilterMfaCodeRequest = {
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isValid?: InputMaybe<FilterBoolean>;
  mfaReceiver?: InputMaybe<webAgent__NestedFilterMfaReceiver>;
  usedAt?: InputMaybe<FilterString>;
};

export type webAgent__NestedFilterMfaReceiver = {
  codeRequests?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  latestCodeRequest?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
};

export type webAgent__NestedFilterPlaywrightTraceArtifact = {
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__NestedFilterProxyConfig = {
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  password?: InputMaybe<FilterString>;
  server?: InputMaybe<FilterString>;
  username?: InputMaybe<FilterString>;
};

export type webAgent__NestedFilterRecipeStartedEvent = {
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  recipeName?: InputMaybe<FilterString>;
};

export type webAgent__NestedFilterRobotStartedEvent = {
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  robotName?: InputMaybe<FilterString>;
};

export type webAgent__NestedFilterSignInReview = {
  categorization?: InputMaybe<FilterwebAgent__SignInAnalysisCategory>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  notes?: InputMaybe<FilterString>;
};

export type webAgent__NestedFilterUserExitInsuranceLinkFeedback = {
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  feedback?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type webAgent__NestedFilterWebAgentArtifact = {
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  category?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__NestedFilterWebAgentExecution = {
  artifacts?: InputMaybe<webAgent__NestedFilterWebAgentExecutionArtifact>;
  audioTokenCount?: InputMaybe<FilterInt64>;
  browserbaseProxyStrategy?: InputMaybe<FilterwebAgent__BrowserbaseProxyStrategy>;
  browserbaseStealthStrategy?: InputMaybe<FilterwebAgent__BrowserbaseStealthStrategy>;
  cachedTokenCount?: InputMaybe<FilterInt64>;
  cdpInspectUrl?: InputMaybe<FilterString>;
  cdpProvider?: InputMaybe<FilterwebAgent__CDPProvider>;
  cdpProviderProfileId?: InputMaybe<FilterString>;
  cdpProviderSessionId?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  discoveryCrawls?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawl>;
  documents?: InputMaybe<document__NestedFilterDocument>;
  endpoint?: InputMaybe<integration__NestedFilterBaseEndpoint>;
  events?: InputMaybe<webAgent__NestedFilterWebAgentExecutionEvent>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  ingestions?: InputMaybe<ingestion__NestedFilterIngestion>;
  initiatedBy?: InputMaybe<NestedFilterUser>;
  initiatorRole?: InputMaybe<FilterParticipant>;
  inputTokenCount?: InputMaybe<FilterInt64>;
  isFailedProviderAttempt?: InputMaybe<FilterBoolean>;
  lastUserMfaMethods?: InputMaybe<FilterwebAgent__MfaMethod>;
  latestDiscoveryCrawl?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawl>;
  latestIngestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  latestManagedMfaOutcome?: InputMaybe<webAgent__NestedFilterManagedMfaOutcome>;
  latestStatus?: InputMaybe<FilterwebAgent__WebExecutionStatus>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  managedMfaOutcomes?: InputMaybe<webAgent__NestedFilterManagedMfaOutcome>;
  millisBlockedOnUser?: InputMaybe<FilterInt>;
  origin?: InputMaybe<FilterwebAgent__ExecutionOrigin>;
  originalExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  otelTraceId?: InputMaybe<FilterString>;
  outputTokenCount?: InputMaybe<FilterInt64>;
  owner?: InputMaybe<NestedFilterUser>;
  proxy?: InputMaybe<webAgent__NestedFilterProxyConfig>;
  signInActivityTimedOutAt?: InputMaybe<FilterString>;
  signInClientTimedOutAt?: InputMaybe<FilterString>;
  signInErroredAt?: InputMaybe<FilterString>;
  signInPhaseAtFailure?: InputMaybe<FilterString>;
  signInReview?: InputMaybe<webAgent__NestedFilterSignInReview>;
  signInRobotType?: InputMaybe<FilterwebAgent__SignInRobotType>;
  signInSucceededAt?: InputMaybe<FilterString>;
  type?: InputMaybe<FilterwebAgent__WebExecutionType>;
};

export type webAgent__NestedFilterWebAgentExecutionArtifact = {
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type webAgent__NestedFilterWebAgentExecutionEvent = {
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type webAgent__OrderAiConversationLogArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
};

export type webAgent__OrderAiDiscoveryCrawl = {
  categorization?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  endedAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  notes?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  status?: InputMaybe<Ordering>;
  successfulExtractions?: InputMaybe<Ordering>;
  successfulObjectivesCount?: InputMaybe<Ordering>;
  successfulProbes?: InputMaybe<Ordering>;
  totalObjectivesCount?: InputMaybe<Ordering>;
};

export type webAgent__OrderAiDiscoveryCrawlObjective = {
  agentLogArtifact?: InputMaybe<webAgent__OrderWebAgentArtifact>;
  categorization?: InputMaybe<Ordering>;
  crawl?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
  createdAt?: InputMaybe<Ordering>;
  data?: InputMaybe<Ordering>;
  dataSlug?: InputMaybe<Ordering>;
  endedAt?: InputMaybe<Ordering>;
  failureCause?: InputMaybe<Ordering>;
  failureReason?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  notes?: InputMaybe<Ordering>;
  objectiveType?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  parentObjective?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
  status?: InputMaybe<Ordering>;
  traceArtifact?: InputMaybe<webAgent__OrderPlaywrightTraceArtifact>;
};

export type webAgent__OrderCrawlDataSummaryArtifact = {
  artifactType?: InputMaybe<Ordering>;
  crawlType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  summary?: InputMaybe<Ordering>;
};

export type webAgent__OrderEndpoint = {
  cdpProvider?: InputMaybe<Ordering>;
  currentSupportLevel?: InputMaybe<webAgent__OrderEndpointSupportLevelHistory>;
  dashboardUrl?: InputMaybe<Ordering>;
  defaultProxy?: InputMaybe<webAgent__OrderProxyConfig>;
  displayName?: InputMaybe<Ordering>;
  displayUrl?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestionSupportedSince?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  isAuthenticationRequired?: InputMaybe<Ordering>;
  isIngestionSupported?: InputMaybe<Ordering>;
  loginUrl?: InputMaybe<Ordering>;
  managedMfaConfiguration?: InputMaybe<webAgent__OrderManagedMfaConfiguration>;
  organization?: InputMaybe<integration__OrderOrganization>;
  planDocumentsDataLatency?: InputMaybe<Ordering>;
  planDocumentsSupported?: InputMaybe<Ordering>;
  portalGuideUrl?: InputMaybe<Ordering>;
  preferredProxyGeolocationState?: InputMaybe<Ordering>;
  slug?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
};

export type webAgent__OrderEndpointCapability = {
  createdAt?: InputMaybe<Ordering>;
  dataLatency?: InputMaybe<Ordering>;
  dataType?: InputMaybe<Ordering>;
  endpoint?: InputMaybe<webAgent__OrderEndpoint>;
  id?: InputMaybe<Ordering>;
  isSupported?: InputMaybe<Ordering>;
};

export type webAgent__OrderEndpointSupportLevelHistory = {
  createdAt?: InputMaybe<Ordering>;
  endpoint?: InputMaybe<webAgent__OrderEndpoint>;
  id?: InputMaybe<Ordering>;
  supportLevel?: InputMaybe<Ordering>;
  updatedBy?: InputMaybe<OrderUser>;
};

export type webAgent__OrderInitialPageLoadSpan = {
  endedAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
};

export type webAgent__OrderLink = {
  active?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  deactivatedAt?: InputMaybe<Ordering>;
  deactivatedReason?: InputMaybe<Ordering>;
  defaultProxy?: InputMaybe<webAgent__OrderProxyConfig>;
  endpoint?: InputMaybe<webAgent__OrderEndpoint>;
  hasManagedMfa?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  lastSyncedAt?: InputMaybe<Ordering>;
  latestExecution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  latestIngestion?: InputMaybe<ingestion__OrderIngestion>;
  mfaReceiver?: InputMaybe<webAgent__OrderMfaReceiver>;
  owner?: InputMaybe<OrderUser>;
  patientDOB?: InputMaybe<Ordering>;
  patientId?: InputMaybe<Ordering>;
  patientName?: InputMaybe<Ordering>;
  userId?: InputMaybe<Ordering>;
};

export type webAgent__OrderLinkProviderProfile = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  link?: InputMaybe<webAgent__OrderLink>;
  owner?: InputMaybe<OrderUser>;
  profileId?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  vendor?: InputMaybe<Ordering>;
};

export type webAgent__OrderLinkSecret = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  key?: InputMaybe<Ordering>;
  link?: InputMaybe<webAgent__OrderLink>;
  owner?: InputMaybe<OrderUser>;
  value?: InputMaybe<Ordering>;
};

export type webAgent__OrderManagedMfaConfiguration = {
  endpoint?: InputMaybe<webAgent__OrderEndpoint>;
  id?: InputMaybe<Ordering>;
  isSupported?: InputMaybe<Ordering>;
};

export type webAgent__OrderManagedMfaConfigured = {
  configurationEndedAt?: InputMaybe<Ordering>;
  configurationStartedAt?: InputMaybe<Ordering>;
  configuredMethod?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  type?: InputMaybe<Ordering>;
};

export type webAgent__OrderManagedMfaFailed = {
  configurationEndedAt?: InputMaybe<Ordering>;
  configurationStartedAt?: InputMaybe<Ordering>;
  error?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  type?: InputMaybe<Ordering>;
};

export type webAgent__OrderManagedMfaOutcome = {
  configurationEndedAt?: InputMaybe<Ordering>;
  configurationStartedAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  type?: InputMaybe<Ordering>;
};

export type webAgent__OrderManagedMfaRejected = {
  configurationEndedAt?: InputMaybe<Ordering>;
  configurationStartedAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  type?: InputMaybe<Ordering>;
};

export type webAgent__OrderMfaCodeRequest = {
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  isValid?: InputMaybe<Ordering>;
  mfaReceiver?: InputMaybe<webAgent__OrderMfaReceiver>;
  usedAt?: InputMaybe<Ordering>;
};

export type webAgent__OrderMfaConfigurationSummaryArtifact = {
  artifactType?: InputMaybe<Ordering>;
  authenticatorAppSupport?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  emailSupport?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  isMfaRequired?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  phoneSupport?: InputMaybe<Ordering>;
  smsSupport?: InputMaybe<Ordering>;
  success?: InputMaybe<Ordering>;
  wasPromptedForMfa?: InputMaybe<Ordering>;
};

export type webAgent__OrderMfaEmail = {
  email?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  latestCodeRequest?: InputMaybe<webAgent__OrderMfaCodeRequest>;
  link?: InputMaybe<webAgent__OrderLink>;
};

export type webAgent__OrderMfaNumber = {
  backupNumber?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  isStopped?: InputMaybe<Ordering>;
  latestCodeRequest?: InputMaybe<webAgent__OrderMfaCodeRequest>;
  link?: InputMaybe<webAgent__OrderLink>;
  number?: InputMaybe<Ordering>;
  stopRequestedAt?: InputMaybe<Ordering>;
};

export type webAgent__OrderMfaReceiver = {
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  latestCodeRequest?: InputMaybe<webAgent__OrderMfaCodeRequest>;
  link?: InputMaybe<webAgent__OrderLink>;
};

export type webAgent__OrderNavigatorSpecialistInstructions = {
  createdAt?: InputMaybe<Ordering>;
  dataSlug?: InputMaybe<Ordering>;
  endpoint?: InputMaybe<webAgent__OrderEndpoint>;
  id?: InputMaybe<Ordering>;
  instructions?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
};

export type webAgent__OrderNavigatorSpecialistPageDiscovery = {
  createdAt?: InputMaybe<Ordering>;
  dataSlug?: InputMaybe<Ordering>;
  discovery?: InputMaybe<Ordering>;
  endpoint?: InputMaybe<webAgent__OrderEndpoint>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
};

export type webAgent__OrderPlaywrightHarArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
};

export type webAgent__OrderPlaywrightInterceptedResponsesArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
};

export type webAgent__OrderPlaywrightPageSourceArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  llmSummary?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
};

export type webAgent__OrderPlaywrightScreenshotArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
};

export type webAgent__OrderPlaywrightTraceArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
};

export type webAgent__OrderProxyConfig = {
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  password?: InputMaybe<Ordering>;
  server?: InputMaybe<Ordering>;
  username?: InputMaybe<Ordering>;
};

export type webAgent__OrderRecipeFinishedEvent = {
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  playwrightTraceS3bucket?: InputMaybe<Ordering>;
  playwrightTraceS3key?: InputMaybe<Ordering>;
  recipeDuration?: InputMaybe<Ordering>;
  result?: InputMaybe<Ordering>;
  screenshotS3bucket?: InputMaybe<Ordering>;
  screenshotS3key?: InputMaybe<Ordering>;
  startEvent?: InputMaybe<webAgent__OrderRecipeStartedEvent>;
};

export type webAgent__OrderRecipeStartedEvent = {
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  recipeName?: InputMaybe<Ordering>;
};

export type webAgent__OrderRequestResponseSpan = {
  endedAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  requestType?: InputMaybe<Ordering>;
  responseType?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
};

export type webAgent__OrderRobotFinishedEvent = {
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  result?: InputMaybe<Ordering>;
  robotDuration?: InputMaybe<Ordering>;
  startEvent?: InputMaybe<webAgent__OrderRobotStartedEvent>;
};

export type webAgent__OrderRobotStartedEvent = {
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  robotName?: InputMaybe<Ordering>;
};

export type webAgent__OrderSignInReview = {
  categorization?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  notes?: InputMaybe<Ordering>;
};

export type webAgent__OrderSignInRobotResultArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  recipeResults?: InputMaybe<Ordering>;
  result?: InputMaybe<Ordering>;
  success?: InputMaybe<Ordering>;
};

export type webAgent__OrderSpan = {
  endedAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
};

export type webAgent__OrderUrlOpenedEvent = {
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  url?: InputMaybe<Ordering>;
};

export type webAgent__OrderUserExitInsuranceLinkFeedback = {
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  feedback?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type webAgent__OrderWebAgentArtifact = {
  artifactType?: InputMaybe<Ordering>;
  category?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
};

export type webAgent__OrderWebAgentExecution = {
  audioTokenCount?: InputMaybe<Ordering>;
  browserbaseProxyStrategy?: InputMaybe<Ordering>;
  browserbaseStealthStrategy?: InputMaybe<Ordering>;
  cachedTokenCount?: InputMaybe<Ordering>;
  cdpInspectUrl?: InputMaybe<Ordering>;
  cdpProvider?: InputMaybe<Ordering>;
  cdpProviderProfileId?: InputMaybe<Ordering>;
  cdpProviderSessionId?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  endpoint?: InputMaybe<integration__OrderBaseEndpoint>;
  id?: InputMaybe<Ordering>;
  initiatedBy?: InputMaybe<OrderUser>;
  initiatorRole?: InputMaybe<Ordering>;
  inputTokenCount?: InputMaybe<Ordering>;
  isFailedProviderAttempt?: InputMaybe<Ordering>;
  latestIngestion?: InputMaybe<ingestion__OrderIngestion>;
  latestManagedMfaOutcome?: InputMaybe<webAgent__OrderManagedMfaOutcome>;
  latestStatus?: InputMaybe<Ordering>;
  link?: InputMaybe<webAgent__OrderLink>;
  millisBlockedOnUser?: InputMaybe<Ordering>;
  origin?: InputMaybe<Ordering>;
  originalExecution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  otelTraceId?: InputMaybe<Ordering>;
  outputTokenCount?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  proxy?: InputMaybe<webAgent__OrderProxyConfig>;
  signInActivityTimedOutAt?: InputMaybe<Ordering>;
  signInClientTimedOutAt?: InputMaybe<Ordering>;
  signInErroredAt?: InputMaybe<Ordering>;
  signInPhaseAtFailure?: InputMaybe<Ordering>;
  signInReview?: InputMaybe<webAgent__OrderSignInReview>;
  signInRobotType?: InputMaybe<Ordering>;
  signInSucceededAt?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
};

export type webAgent__OrderWebAgentExecutionArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type webAgent__OrderWebAgentExecutionEvent = {
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightHarArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightHarArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightHarArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightHarArtifact_Type = BaseObject & Object & Owned & webAgent__PlaywrightHarArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__PlaywrightHarArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightHarArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightHarArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightInterceptedResponsesArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightInterceptedResponsesArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightInterceptedResponsesArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightInterceptedResponsesArtifact_Type = BaseObject & Object & Owned & webAgent__PlaywrightInterceptedResponsesArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__PlaywrightInterceptedResponsesArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightInterceptedResponsesArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightInterceptedResponsesArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightPageSourceArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  llmSummary?: Maybe<Scalars['String']['output']>;
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightPageSourceArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightPageSourceArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightPageSourceArtifact_Type = BaseObject & Object & Owned & webAgent__PlaywrightPageSourceArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__PlaywrightPageSourceArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  llmSummary?: Maybe<Scalars['String']['output']>;
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightPageSourceArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightPageSourceArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightScreenshotArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightScreenshotArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightScreenshotArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightScreenshotArtifact_Type = BaseObject & Object & Owned & webAgent__PlaywrightScreenshotArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__PlaywrightScreenshotArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightScreenshotArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightScreenshotArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightTraceArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightTraceArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightTraceArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightTraceArtifact_Type = BaseObject & Object & Owned & webAgent__PlaywrightTraceArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__PlaywrightTraceArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightTraceArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightTraceArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__ProxyConfig = {
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  password: Scalars['String']['output'];
  server: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type webAgent__ProxyConfig_Type = BaseObject & Object & webAgent__ProxyConfig & {
  __typename: 'webAgent__ProxyConfig_Type';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  password: Scalars['String']['output'];
  server: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type webAgent__RecipeFinishedEvent = {
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  playwrightTraceS3bucket?: Maybe<Scalars['String']['output']>;
  playwrightTraceS3key?: Maybe<Scalars['String']['output']>;
  recipeDuration: Scalars['String']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
  screenshotS3bucket?: Maybe<Scalars['String']['output']>;
  screenshotS3key?: Maybe<Scalars['String']['output']>;
  startEvent: webAgent__RecipeStartedEvent;
};


export type webAgent__RecipeFinishedEventexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RecipeFinishedEventownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__RecipeFinishedEventstartEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRecipeStartedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRecipeStartedEvent>;
};

export type webAgent__RecipeFinishedEvent_Type = BaseObject & Object & Owned & webAgent__RecipeFinishedEvent & webAgent__WebAgentExecutionEvent & {
  __typename: 'webAgent__RecipeFinishedEvent_Type';
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  playwrightTraceS3bucket?: Maybe<Scalars['String']['output']>;
  playwrightTraceS3key?: Maybe<Scalars['String']['output']>;
  recipeDuration: Scalars['String']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
  screenshotS3bucket?: Maybe<Scalars['String']['output']>;
  screenshotS3key?: Maybe<Scalars['String']['output']>;
  startEvent: webAgent__RecipeStartedEvent;
};


export type webAgent__RecipeFinishedEvent_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RecipeFinishedEvent_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__RecipeFinishedEvent_TypestartEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRecipeStartedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRecipeStartedEvent>;
};

export type webAgent__RecipeStartedEvent = {
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  recipeName: Scalars['String']['output'];
};


export type webAgent__RecipeStartedEventexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RecipeStartedEventownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__RecipeStartedEvent_Type = BaseObject & Object & Owned & webAgent__RecipeStartedEvent & webAgent__WebAgentExecutionEvent & {
  __typename: 'webAgent__RecipeStartedEvent_Type';
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  recipeName: Scalars['String']['output'];
};


export type webAgent__RecipeStartedEvent_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RecipeStartedEvent_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__RequestResponseSpan = {
  endedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  requestType: Scalars['String']['output'];
  responseType: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
};


export type webAgent__RequestResponseSpanexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type webAgent__RequestResponseSpan_Type = BaseObject & Object & webAgent__RequestResponseSpan & webAgent__Span & {
  __typename: 'webAgent__RequestResponseSpan_Type';
  endedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  requestType: Scalars['String']['output'];
  responseType: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
};


export type webAgent__RequestResponseSpan_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type webAgent__RobotFinishedEvent = {
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  result?: Maybe<Scalars['JSON']['output']>;
  robotDuration: Scalars['String']['output'];
  startEvent: webAgent__RobotStartedEvent;
};


export type webAgent__RobotFinishedEventexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RobotFinishedEventownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__RobotFinishedEventstartEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRobotStartedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRobotStartedEvent>;
};

export type webAgent__RobotFinishedEvent_Type = BaseObject & Object & Owned & webAgent__RobotFinishedEvent & webAgent__WebAgentExecutionEvent & {
  __typename: 'webAgent__RobotFinishedEvent_Type';
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  result?: Maybe<Scalars['JSON']['output']>;
  robotDuration: Scalars['String']['output'];
  startEvent: webAgent__RobotStartedEvent;
};


export type webAgent__RobotFinishedEvent_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RobotFinishedEvent_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__RobotFinishedEvent_TypestartEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRobotStartedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRobotStartedEvent>;
};

export type webAgent__RobotStartedEvent = {
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  robotName: Scalars['String']['output'];
};


export type webAgent__RobotStartedEventexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RobotStartedEventownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__RobotStartedEvent_Type = BaseObject & Object & Owned & webAgent__RobotStartedEvent & webAgent__WebAgentExecutionEvent & {
  __typename: 'webAgent__RobotStartedEvent_Type';
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  robotName: Scalars['String']['output'];
};


export type webAgent__RobotStartedEvent_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RobotStartedEvent_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__SignInAnalysisCategory {
  ABANDONED_ONLY = 'ABANDONED_ONLY',
  AGENT_ERROR = 'AGENT_ERROR',
  EMAIL_LINK_REQUIRED = 'EMAIL_LINK_REQUIRED',
  HARD_BLOCK = 'HARD_BLOCK',
  NEEDS_CUSTOM_USER_INPUT = 'NEEDS_CUSTOM_USER_INPUT',
  REJECTED_CREDENTIALS = 'REJECTED_CREDENTIALS',
  SOFT_BLOCK = 'SOFT_BLOCK',
  SUCCESS = 'SUCCESS',
  UNKNOWN = 'UNKNOWN'
}

export type webAgent__SignInReview = {
  categorization?: Maybe<webAgent__SignInAnalysisCategory>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
};


export type webAgent__SignInReviewexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type webAgent__SignInReview_Type = BaseObject & Object & webAgent__SignInReview & {
  __typename: 'webAgent__SignInReview_Type';
  categorization?: Maybe<webAgent__SignInAnalysisCategory>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
};


export type webAgent__SignInReview_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type webAgent__SignInRobotResultArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  recipeResults?: Maybe<Scalars['JSON']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};


export type webAgent__SignInRobotResultArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__SignInRobotResultArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__SignInRobotResultArtifact_Type = BaseObject & Object & Owned & webAgent__SignInRobotResultArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__SignInRobotResultArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  recipeResults?: Maybe<Scalars['JSON']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};


export type webAgent__SignInRobotResultArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__SignInRobotResultArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__SignInRobotType {
  AI = 'AI',
  CLASSIC = 'CLASSIC',
  MOCK = 'MOCK',
  NEOCLASSICAL = 'NEOCLASSICAL',
  NO_AUTH = 'NO_AUTH'
}

export type webAgent__Span = {
  endedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
};


export type webAgent__SpanexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type webAgent__UrlOpenedEvent = {
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  url: Scalars['String']['output'];
};


export type webAgent__UrlOpenedEventexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__UrlOpenedEventownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__UrlOpenedEvent_Type = BaseObject & Object & Owned & webAgent__UrlOpenedEvent & webAgent__WebAgentExecutionEvent & {
  __typename: 'webAgent__UrlOpenedEvent_Type';
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  url: Scalars['String']['output'];
};


export type webAgent__UrlOpenedEvent_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__UrlOpenedEvent_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__UserExitInsuranceLinkFeedback = {
  createdAt: Scalars['String']['output'];
  execution?: Maybe<webAgent__WebAgentExecution>;
  feedback: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
};


export type webAgent__UserExitInsuranceLinkFeedbackexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__UserExitInsuranceLinkFeedbackownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__UserExitInsuranceLinkFeedback_Type = BaseObject & Object & Owned & webAgent__UserExitInsuranceLinkFeedback & {
  __typename: 'webAgent__UserExitInsuranceLinkFeedback_Type';
  createdAt: Scalars['String']['output'];
  execution?: Maybe<webAgent__WebAgentExecution>;
  feedback: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
};


export type webAgent__UserExitInsuranceLinkFeedback_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__UserExitInsuranceLinkFeedback_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__WebAgentArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  category: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__WebAgentArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__WebAgentArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__WebAgentArtifact_Type = BaseObject & Object & Owned & webAgent__WebAgentArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__WebAgentArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  category: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__WebAgentArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__WebAgentArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__WebAgentExecution = {
  analysisResults?: Maybe<Scalars['JSON']['output']>;
  artifacts?: Maybe<Array<webAgent__WebAgentExecutionArtifact>>;
  audioTokenCount?: Maybe<Scalars['Int64']['output']>;
  browserbaseProxyStrategy?: Maybe<webAgent__BrowserbaseProxyStrategy>;
  browserbaseStealthStrategy?: Maybe<webAgent__BrowserbaseStealthStrategy>;
  cachedTokenCount?: Maybe<Scalars['Int64']['output']>;
  cdpInspectUrl?: Maybe<Scalars['String']['output']>;
  cdpProvider?: Maybe<webAgent__CDPProvider>;
  cdpProviderProfileId?: Maybe<Scalars['String']['output']>;
  cdpProviderSessionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  discoveryCrawls?: Maybe<Array<webAgent__AiDiscoveryCrawl>>;
  documents?: Maybe<Array<document__Document>>;
  endpoint?: Maybe<integration__BaseEndpoint>;
  events?: Maybe<Array<webAgent__WebAgentExecutionEvent>>;
  id: Scalars['ID']['output'];
  ingestions?: Maybe<Array<ingestion__Ingestion>>;
  initiatedBy?: Maybe<User>;
  initiatorRole?: Maybe<Participant>;
  inputTokenCount?: Maybe<Scalars['Int64']['output']>;
  isFailedProviderAttempt: Scalars['Boolean']['output'];
  lastUserMfaMethods?: Maybe<Array<webAgent__MfaMethod>>;
  latestDiscoveryCrawl?: Maybe<Array<webAgent__AiDiscoveryCrawl>>;
  latestIngestion?: Maybe<ingestion__Ingestion>;
  latestManagedMfaOutcome?: Maybe<webAgent__ManagedMfaOutcome>;
  latestStatus?: Maybe<webAgent__WebExecutionStatus>;
  link?: Maybe<webAgent__Link>;
  managedMfaOutcomes?: Maybe<Array<webAgent__ManagedMfaOutcome>>;
  millisBlockedOnUser?: Maybe<Scalars['Int']['output']>;
  origin?: Maybe<webAgent__ExecutionOrigin>;
  originalExecution?: Maybe<webAgent__WebAgentExecution>;
  otelTraceId?: Maybe<Scalars['String']['output']>;
  outputTokenCount?: Maybe<Scalars['Int64']['output']>;
  owner: User;
  proxy?: Maybe<webAgent__ProxyConfig>;
  signInActivityTimedOutAt?: Maybe<Scalars['String']['output']>;
  signInClientTimedOutAt?: Maybe<Scalars['String']['output']>;
  signInErroredAt?: Maybe<Scalars['String']['output']>;
  signInPhaseAtFailure?: Maybe<Scalars['String']['output']>;
  signInReview?: Maybe<webAgent__SignInReview>;
  signInRobotType?: Maybe<webAgent__SignInRobotType>;
  signInSucceededAt?: Maybe<Scalars['String']['output']>;
  type?: Maybe<webAgent__WebExecutionType>;
  unrecoverableErrorReports?: Maybe<Array<Scalars['JSON']['output']>>;
};


export type webAgent__WebAgentExecutionartifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecutionArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecutionArtifact>;
};


export type webAgent__WebAgentExecutiondiscoveryCrawlsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
};


export type webAgent__WebAgentExecutiondocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type webAgent__WebAgentExecutionendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseEndpoint>;
};


export type webAgent__WebAgentExecutioneventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecutionEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecutionEvent>;
};


export type webAgent__WebAgentExecutioningestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type webAgent__WebAgentExecutioninitiatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__WebAgentExecutionlatestDiscoveryCrawlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
};


export type webAgent__WebAgentExecutionlatestIngestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type webAgent__WebAgentExecutionlatestManagedMfaOutcomeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaOutcome>;
};


export type webAgent__WebAgentExecutionlinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type webAgent__WebAgentExecutionmanagedMfaOutcomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaOutcome>;
};


export type webAgent__WebAgentExecutionoriginalExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__WebAgentExecutionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__WebAgentExecutionproxyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterProxyConfig>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderProxyConfig>;
};


export type webAgent__WebAgentExecutionsignInReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterSignInReview>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderSignInReview>;
};

export type webAgent__WebAgentExecutionArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
};


export type webAgent__WebAgentExecutionArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__WebAgentExecutionArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__WebAgentExecutionArtifactType {
  AI_CONVERSATION_LOG = 'AI_CONVERSATION_LOG',
  CRAWL_DATA_SUMMARY = 'CRAWL_DATA_SUMMARY',
  MFA_CONFIGURATION_SUMMARY = 'MFA_CONFIGURATION_SUMMARY',
  PLAYWRIGHT_HAR = 'PLAYWRIGHT_HAR',
  PLAYWRIGHT_INTERCEPTED_RESPONSES = 'PLAYWRIGHT_INTERCEPTED_RESPONSES',
  PLAYWRIGHT_PAGE_SOURCE = 'PLAYWRIGHT_PAGE_SOURCE',
  PLAYWRIGHT_SCREENSHOT = 'PLAYWRIGHT_SCREENSHOT',
  PLAYWRIGHT_TRACE = 'PLAYWRIGHT_TRACE',
  SIGN_IN_ROBOT_RESULT = 'SIGN_IN_ROBOT_RESULT',
  WEB_AGENT_ARTIFACT = 'WEB_AGENT_ARTIFACT'
}

export type webAgent__WebAgentExecutionEvent = {
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
};


export type webAgent__WebAgentExecutionEventexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__WebAgentExecutionEventownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__WebAgentExecutionEventType {
  RECIPE_FINISHED = 'RECIPE_FINISHED',
  RECIPE_STARTED = 'RECIPE_STARTED',
  ROBOT_FINISHED = 'ROBOT_FINISHED',
  ROBOT_STARTED = 'ROBOT_STARTED',
  URL_OPENED = 'URL_OPENED'
}

export type webAgent__WebAgentExecution_Type = BaseObject & Object & Owned & webAgent__WebAgentExecution & {
  __typename: 'webAgent__WebAgentExecution_Type';
  analysisResults?: Maybe<Scalars['JSON']['output']>;
  artifacts?: Maybe<Array<webAgent__WebAgentExecutionArtifact>>;
  audioTokenCount?: Maybe<Scalars['Int64']['output']>;
  browserbaseProxyStrategy?: Maybe<webAgent__BrowserbaseProxyStrategy>;
  browserbaseStealthStrategy?: Maybe<webAgent__BrowserbaseStealthStrategy>;
  cachedTokenCount?: Maybe<Scalars['Int64']['output']>;
  cdpInspectUrl?: Maybe<Scalars['String']['output']>;
  cdpProvider?: Maybe<webAgent__CDPProvider>;
  cdpProviderProfileId?: Maybe<Scalars['String']['output']>;
  cdpProviderSessionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  discoveryCrawls?: Maybe<Array<webAgent__AiDiscoveryCrawl>>;
  documents?: Maybe<Array<document__Document>>;
  endpoint?: Maybe<integration__BaseEndpoint>;
  events?: Maybe<Array<webAgent__WebAgentExecutionEvent>>;
  id: Scalars['ID']['output'];
  ingestions?: Maybe<Array<ingestion__Ingestion>>;
  initiatedBy?: Maybe<User>;
  initiatorRole?: Maybe<Participant>;
  inputTokenCount?: Maybe<Scalars['Int64']['output']>;
  isFailedProviderAttempt: Scalars['Boolean']['output'];
  lastUserMfaMethods?: Maybe<Array<webAgent__MfaMethod>>;
  latestDiscoveryCrawl?: Maybe<Array<webAgent__AiDiscoveryCrawl>>;
  latestIngestion?: Maybe<ingestion__Ingestion>;
  latestManagedMfaOutcome?: Maybe<webAgent__ManagedMfaOutcome>;
  latestStatus?: Maybe<webAgent__WebExecutionStatus>;
  link?: Maybe<webAgent__Link>;
  managedMfaOutcomes?: Maybe<Array<webAgent__ManagedMfaOutcome>>;
  millisBlockedOnUser?: Maybe<Scalars['Int']['output']>;
  origin?: Maybe<webAgent__ExecutionOrigin>;
  originalExecution?: Maybe<webAgent__WebAgentExecution>;
  otelTraceId?: Maybe<Scalars['String']['output']>;
  outputTokenCount?: Maybe<Scalars['Int64']['output']>;
  owner: User;
  proxy?: Maybe<webAgent__ProxyConfig>;
  signInActivityTimedOutAt?: Maybe<Scalars['String']['output']>;
  signInClientTimedOutAt?: Maybe<Scalars['String']['output']>;
  signInErroredAt?: Maybe<Scalars['String']['output']>;
  signInPhaseAtFailure?: Maybe<Scalars['String']['output']>;
  signInReview?: Maybe<webAgent__SignInReview>;
  signInRobotType?: Maybe<webAgent__SignInRobotType>;
  signInSucceededAt?: Maybe<Scalars['String']['output']>;
  type?: Maybe<webAgent__WebExecutionType>;
  unrecoverableErrorReports?: Maybe<Array<Scalars['JSON']['output']>>;
};


export type webAgent__WebAgentExecution_TypeartifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecutionArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecutionArtifact>;
};


export type webAgent__WebAgentExecution_TypediscoveryCrawlsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
};


export type webAgent__WebAgentExecution_TypedocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type webAgent__WebAgentExecution_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseEndpoint>;
};


export type webAgent__WebAgentExecution_TypeeventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecutionEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecutionEvent>;
};


export type webAgent__WebAgentExecution_TypeingestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type webAgent__WebAgentExecution_TypeinitiatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__WebAgentExecution_TypelatestDiscoveryCrawlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
};


export type webAgent__WebAgentExecution_TypelatestIngestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type webAgent__WebAgentExecution_TypelatestManagedMfaOutcomeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaOutcome>;
};


export type webAgent__WebAgentExecution_TypelinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type webAgent__WebAgentExecution_TypemanagedMfaOutcomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaOutcome>;
};


export type webAgent__WebAgentExecution_TypeoriginalExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__WebAgentExecution_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__WebAgentExecution_TypeproxyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterProxyConfig>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderProxyConfig>;
};


export type webAgent__WebAgentExecution_TypesignInReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterSignInReview>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderSignInReview>;
};

export enum webAgent__WebExecutionStatus {
  ERRORED = 'ERRORED',
  FAILED_LOGIN_MAX_REACHED = 'FAILED_LOGIN_MAX_REACHED',
  FILLING_CREDENTIALS = 'FILLING_CREDENTIALS',
  FILLING_MFA_CODE = 'FILLING_MFA_CODE',
  FILLING_SECURITY_ANSWER = 'FILLING_SECURITY_ANSWER',
  LOADING_LOGIN_URL = 'LOADING_LOGIN_URL',
  LOGGED_IN = 'LOGGED_IN',
  PROMPTING_CREDENTIALS = 'PROMPTING_CREDENTIALS',
  PROMPTING_MFA_CODE = 'PROMPTING_MFA_CODE',
  PROMPTING_MFA_METHOD = 'PROMPTING_MFA_METHOD',
  PROMPTING_SECURITY_ANSWER = 'PROMPTING_SECURITY_ANSWER',
  REPROMPTING_CREDENTIALS = 'REPROMPTING_CREDENTIALS',
  REPROMPTING_MFA_CODE = 'REPROMPTING_MFA_CODE',
  REPROMPTING_SECURITY_ANSWER = 'REPROMPTING_SECURITY_ANSWER',
  SELECTING_MFA_METHOD = 'SELECTING_MFA_METHOD',
  USER_TIMEOUT = 'USER_TIMEOUT'
}

export enum webAgent__WebExecutionType {
  HEALTH_CHECK = 'HEALTH_CHECK',
  MANAGED_SIGN_IN_AND_CRAWL = 'MANAGED_SIGN_IN_AND_CRAWL',
  RPA_DEBUG = 'RPA_DEBUG',
  SHADOW_SIGN_IN = 'SHADOW_SIGN_IN',
  SIGN_IN_AND_CRAWL = 'SIGN_IN_AND_CRAWL',
  SIGN_IN_AND_LINK = 'SIGN_IN_AND_LINK',
  SIGN_IN_AND_RESTORE_MFA = 'SIGN_IN_AND_RESTORE_MFA'
}

export type AddressAutocompleteQueryVariables = Exact<{
  input: AddressAutocompleteInput;
}>;


export type AddressAutocompleteQuery = { __typename: 'Query', addressAutocomplete?: { __typename: 'AddressAutocompleteResponse', count: number, predictions: Array<{ __typename: 'AddressPrediction', placeId: string, description: string, mainText: string, secondaryText: string, types: Array<string> }> } | null };

export type AddressDetailsQueryVariables = Exact<{
  input: AddressDetailsInput;
}>;


export type AddressDetailsQuery = { __typename: 'Query', addressDetails?: { __typename: 'AddressDetails', placeId: string, formattedAddress: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, latitude: number, longitude: number } | null };

export type PrimaryPersonQueryVariables = Exact<{ [key: string]: never; }>;


export type PrimaryPersonQuery = { __typename: 'Query', me?: { __typename: 'User_Type', primaryPerson?: { __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null } | null } | null };

export type getPaymentProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type getPaymentProfileQuery = { __typename: 'Query', getPaymentProfile?: { __typename: 'PaymentProfile', id: string, hasPaymentMethod: boolean } | null };

export type AcceptBillPaymentEventMutationVariables = Exact<{
  input: AcceptBillPaymentEventInput;
}>;


export type AcceptBillPaymentEventMutation = { __typename: 'Mutation', acceptBillPaymentEvent?: { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | null };

export type GetPaymentProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentProfileQuery = { __typename: 'Query', getPaymentProfile?: { __typename: 'PaymentProfile', id: string, stripeCustomerId: string, stripePaymentMethodId?: string | null, createdAt: string, updatedAt: string, hasPaymentMethod: boolean, paymentMethodType?: string | null, state?: string | null, zip?: string | null, country?: string | null, cardDetails?: { __typename: 'CardDetails', brand: string, last4: string, walletType?: string | null } | null } | null };

export type UpdatePaymentAgreementEventMutationVariables = Exact<{
  input: UpdatePaymentAgreementEventInput;
}>;


export type UpdatePaymentAgreementEventMutation = { __typename: 'Mutation', updatePaymentAgreementEvent?: { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | null };

export type AcceptBillPayMutationVariables = Exact<{
  input: AcceptBillPayInput;
}>;


export type AcceptBillPayMutation = { __typename: 'Mutation', acceptBillPay?: { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | null };

export type ApplyPromoCodeUsageMutationVariables = Exact<{
  input: ApplyPromoCodeUsageInput;
}>;


export type ApplyPromoCodeUsageMutation = { __typename: 'Mutation', applyPromoCodeUsage: { __typename: 'ApplyPromoCodeUsageSuccess', promoCodeUsage: { __typename: 'PromoCodeUsageInfo', id: string, issueId?: string | null, usedAt?: string | null, promoCode: { __typename: 'payment__PromoCode_Type', id: string, code: string, isActive: boolean } } } | { __typename: 'FormError', message?: string | null } };

export type MarkPromoCodeUsageAsUnusedMutationVariables = Exact<{
  input: MarkPromoCodeUsageAsUnusedInput;
}>;


export type MarkPromoCodeUsageAsUnusedMutation = { __typename: 'Mutation', markPromoCodeUsageAsUnused?: { __typename: 'MarkPromoCodeUsageAsUnusedResponse', promoCodeUsage?: { __typename: 'PromoCodeUsageInfo', id: string, issueId?: string | null, usedAt?: string | null, promoCode: { __typename: 'payment__PromoCode_Type', id: string, code: string, isActive: boolean } } | null } | null };

export type SendMagicLinkMutationVariables = Exact<{
  input: SendMagicLinkInput;
}>;


export type SendMagicLinkMutation = { __typename: 'Mutation', sendMagicLink: { __typename: 'FormError', message?: string | null, fields?: Array<{ __typename: 'FieldError', path: string, message: string }> | null } | { __typename: 'SendMagicLinkResponse', created: boolean, user: { __typename: 'AuthUser', id: string, isAdmin: boolean, isShadow: boolean, adminUserId?: string | null } } };

export type ResendMagicLinkMutationVariables = Exact<{
  input: ResendMagicLinkInput;
}>;


export type ResendMagicLinkMutation = { __typename: 'Mutation', resendMagicLink: { __typename: 'ResendMagicLinkResult', success: boolean } };

export type AuthenticateMutationVariables = Exact<{
  input: AuthenticateInput;
}>;


export type AuthenticateMutation = { __typename: 'Mutation', authenticate: { __typename: 'AuthenticateError', success: boolean, errorType: AuthenticateResultErrorType } | { __typename: 'AuthenticateSuccess', success: boolean, firstAuthentication: boolean, email?: string | null, user: { __typename: 'AuthUser', id: string, isAdmin: boolean, isShadow: boolean, adminUserId?: string | null } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename: 'Mutation', logout: boolean };

export type ShadowLoginMutationVariables = Exact<{
  input: ShadowLoginInput;
}>;


export type ShadowLoginMutation = { __typename: 'Mutation', shadowLogin: { __typename: 'AuthUser', id: string, isAdmin: boolean, isShadow: boolean, adminUserId?: string | null } | { __typename: 'FormError', fields?: Array<{ __typename: 'FieldError', path: string, message: string }> | null } };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, isAdmin: boolean, primaryEmail?: string | null, createdAt: string, lastAuthenticatedAt?: string | null, profile: { __typename: 'user__Profile_Type', name?: string | null }, segmentationData?: { __typename: 'user__SegmentationData_Type', features?: Array<string> | null } | null } | null };

export type ClientSupportedVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientSupportedVersionQuery = { __typename: 'Query', clientSupportedVersion: { __typename: 'ClientSupportedVersionResponse', supportedClientVersion: string, supportedClientUpdateId?: string | null, latestClientVersion: string } };

export type InsuranceLinkAttemptMutationVariables = Exact<{
  input: TrackInsuranceLinkAttemptInput;
}>;


export type InsuranceLinkAttemptMutation = { __typename: 'Mutation', trackInsuranceLinkAttempt: { __typename: 'EventTrackingResult', success: boolean } };

export type GetTemplateReleaseQueryVariables = Exact<{
  input: GetTemplateReleaseInput;
}>;


export type GetTemplateReleaseQuery = { __typename: 'Query', getTemplateRelease: { __typename: 'GetTemplateReleaseResult', templateId: string, templateOrgSlug?: string | null, templateOrgDisplayUrl?: string | null, templateOrgLoginUrl?: string | null, templateOrgDisplayName?: string | null, templateName: string, templateFields: Array<{ __typename: 'FieldAttributes', name: string, label: string }>, templateAdditionalSections: Array<{ __typename: 'AdditionalSection', name: string, fields: Array<{ __typename: 'FieldAttributes', name: string, label: string }> }> } };

export type CreateDocumentMutationVariables = Exact<{
  input: CreateDocumentInput;
}>;


export type CreateDocumentMutation = { __typename: 'Mutation', createDocument: { __typename: 'CreateDocumentResult', url: string, s3Key: string, document: { __typename: 'document__Document_Type', id: string } } };

export type FinalizeDocumentMutationVariables = Exact<{
  input: FinalizeDocumentInput;
}>;


export type FinalizeDocumentMutation = { __typename: 'Mutation', finalizeDocument: { __typename: 'FinalizeDocumentResult', document: { __typename: 'document__Document_Type', id: string } } };

export type SignAndSaveTemplateMutationVariables = Exact<{
  input: SignAndSaveTemplateInput;
}>;


export type SignAndSaveTemplateMutation = { __typename: 'Mutation', signAndSaveTemplate: { __typename: 'SignAndSaveTemplateResult', success: boolean } };

export type CreateSetupIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSetupIntentMutation = { __typename: 'Mutation', createSetupIntent: { __typename: 'CreateSetupIntentResponse', clientSecret: string } };

export type CreateMultiFileDocumentMutationVariables = Exact<{
  input: CreateMultiFileDocumentInput;
}>;


export type CreateMultiFileDocumentMutation = { __typename: 'Mutation', createMultiFileDocument: { __typename: 'CreateMultiFileDocumentResult', document: { __typename: 'document__Document_Type', id: string }, files: Array<{ __typename: 'CreateFileResult', s3Key: string, url: string, name: string }> } };

export type GetUnreadIssuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadIssuesQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, issues?: Array<{ __typename: 'issue__Issue_Type', id: string, firstUnseenEvent?: { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string } | null }> | null } | null };

export type DirectLoginToInstitutionMutationVariables = Exact<{
  input: LoginToInstitutionInput;
}>;


export type DirectLoginToInstitutionMutation = { __typename: 'Mutation', directLoginToInstitution: { __typename: 'FailedLoginMaxReached', signInUrl: string } | { __typename: 'InvalidCredentials', workflowId: string, success: boolean, error: { __typename: 'FormError', fields?: Array<{ __typename: 'FieldError', path: string, message: string }> | null } } | { __typename: 'LoginSuccess', success: boolean, workflowId: string, linkId: string } | { __typename: 'MfaRequired', success: boolean, workflowId: string, mfaOptions: Array<{ __typename: 'MfaOption', id: number, method: MfaMethodType, display?: string | null }> } | { __typename: 'RpaError', cause: string, errorSignInUrl?: string | null } | { __typename: 'SecurityQuestionRequired', securityQuestions: Array<string>, success: boolean, workflowId: string } | { __typename: 'SelectMfaMethodResponse' } };

export type DirectSubmitMfaCodeMutationVariables = Exact<{
  input: SubmitMfaCodeInput;
}>;


export type DirectSubmitMfaCodeMutation = { __typename: 'Mutation', directSubmitMfaCode: { __typename: 'InvalidCredentials', workflowId: string, success: boolean, error: { __typename: 'FormError', fields?: Array<{ __typename: 'FieldError', path: string, message: string }> | null } } | { __typename: 'LoginSuccess', success: boolean, workflowId: string, linkId: string } | { __typename: 'RpaError', cause: string, errorSignInUrl?: string | null } };

export type DirectRequestNewMfaCodeMutationVariables = Exact<{
  input: RequestNewMfaCodeInput;
}>;


export type DirectRequestNewMfaCodeMutation = { __typename: 'Mutation', directRequestNewMfaCode: { __typename: 'RpaError' } | { __typename: 'SelectMfaMethodResponse', success: boolean } };

export type DirectSelectMfaMethodMutationVariables = Exact<{
  input: SelectMfaMethodInput;
}>;


export type DirectSelectMfaMethodMutation = { __typename: 'Mutation', directSelectMfaMethod: { __typename: 'RpaError', cause: string, errorSignInUrl?: string | null } | { __typename: 'SelectMfaMethodResponse', success: boolean } };

export type PlanDocumentsLoadingQueryVariables = Exact<{
  executionId: Scalars['ID']['input'];
}>;


export type PlanDocumentsLoadingQuery = { __typename: 'Query', getAttemptStatus: { __typename: 'AttemptStatus', dataTypes: { __typename: 'DataTypesStatus', planDocuments: { __typename: 'BenefitSummaryCreated', status: DataTypeStatus, caseId: string } | { __typename: 'DataTypeNotSupported', status: DataTypeStatus } | { __typename: 'DataTypeProcessing', status: DataTypeStatus } } } };

export type DirectSubmitSecurityAnswerMutationVariables = Exact<{
  input: SubmitSecurityAnswerInput;
}>;


export type DirectSubmitSecurityAnswerMutation = { __typename: 'Mutation', directSubmitSecurityAnswer: { __typename: 'LoginSuccess', success: boolean, workflowId: string, linkId: string } | { __typename: 'RpaError', cause: string, errorSignInUrl?: string | null } | { __typename: 'SecurityQuestionRequired', securityQuestions: Array<string>, success: boolean, workflowId: string } };

export type CreateFlexpaLinkMutationVariables = Exact<{
  input?: InputMaybe<CreateFlexpaLinkInput>;
}>;


export type CreateFlexpaLinkMutation = { __typename: 'Mutation', createFlexpaLink?: { __typename: 'flexpa__Link_Type', id: string } | null };

export type DirectStartLinkCreationMutationVariables = Exact<{
  input: StartLinkCreationInput;
}>;


export type DirectStartLinkCreationMutation = { __typename: 'Mutation', directStartLinkCreation: { __typename: 'StartLinkCreationResult', workflowId: string } };

export type GetLinkEndpointQueryVariables = Exact<{
  linkId: Scalars['ID']['input'];
}>;


export type GetLinkEndpointQuery = { __typename: 'Query', webAgent__Link?: Array<{ __typename: 'webAgent__Link_Type', endpoint: { __typename: 'webAgent__Endpoint_Type', id: string, displayName?: string | null, displayUrl: string, slug?: string | null, cdpProvider: webAgent__CDPProvider, loginUrl: string, isIngestionSupported: boolean, isAuthenticationRequired: boolean, planDocumentsDataLatency: webAgent__DataLatency, planDocumentsSupported: boolean, metadata: Array<string>, isActive: boolean, type: webAgent__EndpointType } }> | null };

export type DirectStartRelinkMutationVariables = Exact<{
  input: StartLinkRelinkInput;
}>;


export type DirectStartRelinkMutation = { __typename: 'Mutation', directStartRelink: { __typename: 'DirectStartRelinkResult', workflowId: string } };

export type DirectAwaitLoginResultMutationVariables = Exact<{
  input: DirectAwaitLoginResultInput;
}>;


export type DirectAwaitLoginResultMutation = { __typename: 'Mutation', directAwaitLoginResult: { __typename: 'FailedLoginMaxReached', signInUrl: string } | { __typename: 'InvalidCredentials', workflowId: string, success: boolean, error: { __typename: 'FormError', fields?: Array<{ __typename: 'FieldError', path: string, message: string }> | null } } | { __typename: 'LoginSuccess', configureManagedMfa?: boolean | null, success: boolean, workflowId: string, linkId: string } | { __typename: 'MfaRequired', success: boolean, workflowId: string, mfaOptions: Array<{ __typename: 'MfaOption', id: number, method: MfaMethodType, display?: string | null }> } | { __typename: 'RpaError', cause: string, errorSignInUrl?: string | null } | { __typename: 'SecurityQuestionRequired', securityQuestions: Array<string>, success: boolean, workflowId: string } | { __typename: 'SelectMfaMethodResponse' } };

export type CheckBenefitsSummaryQueryVariables = Exact<{
  linkId: Scalars['ID']['input'];
}>;


export type CheckBenefitsSummaryQuery = { __typename: 'Query', webAgent__Link?: Array<{ __typename: 'webAgent__Link_Type', id: string, plans?: Array<{ __typename: 'plan__Plan_Type', id: string, benefitsSummaryResults?: Array<{ __typename: 'plan__BenefitsSummaryResult_Type', id: string, schemaVersion: number }> | null }> | null }> | null };

export type GetInsuranceLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsuranceLinksQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, flexpaLinks?: Array<{ __typename: 'flexpa__Link_Type', id: string, active: boolean, createdAt: string, lastSyncedAt?: string | null, patientName?: string | null, patientDOB?: string | null, deactivatedReason?: flexpa__LinkDeactivatedReason | null, endpoint: { __typename: 'flexpa__Endpoint_Type', displayName?: string | null, id: string, slug?: string | null, isActive: boolean, organization?: { __typename: 'integration__Organization_Type', id: string, displayName: string, slug?: string | null } | null } }> | null, webAgentLinks?: Array<{ __typename: 'webAgent__Link_Type', id: string, active: boolean, createdAt: string, lastSyncedAt?: string | null, patientName?: string | null, patientId?: string | null, patientDOB?: string | null, deactivatedAt?: string | null, deactivatedReason?: webAgent__LinkDeactivatedReason | null, latestExecution?: { __typename: 'webAgent__WebAgentExecution_Type', id: string, ingestions?: Array<{ __typename: 'ingestion__Ingestion_Type', id: string, startedAt: string, endedAt?: string | null, status: ingestion__IngestionStatus, resources?: Array<{ __typename: 'fhirext__AccountVersion_Type', id: string } | { __typename: 'fhirext__CoverageVersion_Type', id: string } | { __typename: 'fhirext__EncounterVersion_Type', id: string } | { __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string } | { __typename: 'fhirext__InvoiceVersion_Type', id: string } | { __typename: 'fhirext__PatientVersion_Type', id: string } | { __typename: 'fhirext__PractitionerVersion_Type', id: string }> | null }> | null } | null, executions?: Array<{ __typename: 'webAgent__WebAgentExecution_Type', id: string, createdAt: string, ingestions?: Array<{ __typename: 'ingestion__Ingestion_Type', id: string, startedAt: string, endedAt?: string | null, status: ingestion__IngestionStatus }> | null }> | null, endpoint: { __typename: 'webAgent__Endpoint_Type', displayName?: string | null, id: string, slug?: string | null, isActive: boolean, organization?: { __typename: 'integration__Organization_Type', id: string, displayName: string, slug?: string | null } | null } }> | null } | null };

export type GetWebAgentEndpointsP012QueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebAgentEndpointsP012Query = { __typename: 'Query', webAgent__Endpoint?: Array<{ __typename: 'webAgent__Endpoint_Type', isActive: boolean, id: string, type: webAgent__EndpointType, displayName?: string | null, displayUrl: string, isIngestionSupported: boolean, slug?: string | null, loginUrl: string, portalGuideUrl?: string | null, metadata: Array<string>, planDocumentsDataLatency: webAgent__DataLatency, planDocumentsSupported: boolean, currentSupportLevel?: { __typename: 'webAgent__EndpointSupportLevelHistory_Type', supportLevel: webAgent__EndpointSupportLevel } | null, organization?: { __typename: 'integration__Organization_Type', id: string, displayName: string, slug?: string | null } | null }> | null };

export type GetWebAgentEndpointsAllQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebAgentEndpointsAllQuery = { __typename: 'Query', webAgent__Endpoint?: Array<{ __typename: 'webAgent__Endpoint_Type', id: string, type: webAgent__EndpointType, isActive: boolean, displayName?: string | null, displayUrl: string, isIngestionSupported: boolean, slug?: string | null, loginUrl: string, metadata: Array<string>, portalGuideUrl?: string | null, planDocumentsDataLatency: webAgent__DataLatency, planDocumentsSupported: boolean, currentSupportLevel?: { __typename: 'webAgent__EndpointSupportLevelHistory_Type', supportLevel: webAgent__EndpointSupportLevel } | null, organization?: { __typename: 'integration__Organization_Type', id: string, displayName: string, slug?: string | null } | null }> | null };

export type GetFlexpaEndpointsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFlexpaEndpointsQuery = { __typename: 'Query', flexpa__Endpoint?: Array<{ __typename: 'flexpa__Endpoint_Type', isActive: boolean, id: string, displayName?: string | null, flexpaId: string, name: string, slug?: string | null, label?: Array<string> | null, mode: flexpa__EndpointMode, organization?: { __typename: 'integration__Organization_Type', id: string, displayName: string, slug?: string | null } | null }> | null };

export type GetUserIssuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserIssuesQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, issues?: Array<{ __typename: 'issue__Issue_Type', id: string }> | null } | null };

export type CheckAllInsuranceLinksMutationVariables = Exact<{ [key: string]: never; }>;


export type CheckAllInsuranceLinksMutation = { __typename: 'Mutation', checkAllInsuranceLinks?: boolean | null };

export type OpenBillDisputeIssueMutationMutationVariables = Exact<{
  input: OpenNewIssueInput;
}>;


export type OpenBillDisputeIssueMutationMutation = { __typename: 'Mutation', openNewIssue?: { __typename: 'issue__Issue_Type', id: string } | null };

export type GetBillPreviewEobQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  resourceId: Scalars['String']['input'];
}>;


export type GetBillPreviewEobQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, issues?: Array<{ __typename: 'issue__Issue_Type', id: string, eobId?: string | null, title?: string | null, lastSeenAt?: string | null, openedAt: string, closedAt?: string | null, firstUnseenEvent?: { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string } | null }> | null, explanationOfBenefits?: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, title?: string | null, resourceId: string, created?: string | null, status: fhir__ExplanationOfBenefitStatus, billablePeriod?: string | null, serviceDate?: string | null, type?: { __typename: 'fhir__CodeableConcept_Type', coding?: Array<{ __typename: 'fhir__Coding_Type', display?: string | null }> | null } | null, decision?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null, network?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null, person?: { __typename: 'Person_Type', primaryAddress?: { __typename: 'person__Address_Type', state: string } | null } | null, owner: { __typename: 'User_Type', primaryPerson?: { __typename: 'Person_Type', primaryAddress?: { __typename: 'person__Address_Type', state: string } | null } | null }, item?: Array<{ __typename: 'fhir__ExplanationOfBenefitItem_Type', id: string, productOrService?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null, display?: string | null, system?: string | null }> | null } | null, quantity?: { __typename: 'fhir__Quantity_Type', value?: string | null } | null, adjudication?: Array<{ __typename: 'fhir__ExplanationOfBenefitItemAdjudication_Type', category: { __typename: 'fhir__CodeableConcept_Type', coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null }, amount?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null }> | null, reviewOutcome?: { __typename: 'fhir__ExplanationOfBenefitItemReviewOutcome_Type', decision?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null, reason?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null } | null } | null }> | null, patient?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, diagnosis?: Array<{ __typename: 'fhir__ExplanationOfBenefitDiagnosis_Type', diagnosisCodeableConcept?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null }> | null, provider?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, facility?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, totalsByType?: { __typename: 'fhirext__ExplanationOfBenefitTotalsByType_Type', coinsurance?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, copay?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, deductible?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, memberLiability?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, nonCovered?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, benefit?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, discount?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, eligible?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, paidByPatient?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, paidToPatient?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, submitted?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null } | null, findings?: Array<{ __typename: 'fhirext__Finding_Type', id: string, explanation?: string | null, userDismissed: boolean, type: fhirext__FindingType }> | null, fairMarketValue?: Array<{ __typename: 'FairMarketValueResponse', code: string, percentile50: { __typename: 'SimpleMoney', value: string, currency: string } }> | null }> | null } | null };

export type GetFlaggedEobsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFlaggedEobsQuery = { __typename: 'Query', queryFlaggedExplanationOfBenefits: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, title?: string | null, status: fhir__ExplanationOfBenefitStatus, created?: string | null, resourceId: string, billablePeriod?: string | null, serviceDate?: string | null, totalsByType?: { __typename: 'fhirext__ExplanationOfBenefitTotalsByType_Type', memberLiability?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null } | null, decision?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null, item?: Array<{ __typename: 'fhir__ExplanationOfBenefitItem_Type', id: string, productOrService?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null, display?: string | null }> | null } | null, reviewOutcome?: { __typename: 'fhir__ExplanationOfBenefitItemReviewOutcome_Type', decision?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null } | null, reason?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null } | null } | null }> | null, total?: Array<{ __typename: 'fhir__ExplanationOfBenefitTotal_Type', category: { __typename: 'fhir__CodeableConcept_Type', coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null }, amount: { __typename: 'fhir__Money_Type', currency?: string | null, value?: string | null } }> | null, patient?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, provider?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, facility?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, findings?: Array<{ __typename: 'fhirext__Finding_Type', id: string, explanation?: string | null, userDismissed: boolean, lastReviewStatus?: fhirext__ReviewStatus | null, type: fhirext__FindingType, note?: string | null }> | null }> };

export type GetFlaggedEobsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFlaggedEobsCountQuery = { __typename: 'Query', countFlaggedExplanationOfBenefits: number };

export type GetInsuranceLinkStatusQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsuranceLinkStatusQueryQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, flexpaLinks?: Array<{ __typename: 'flexpa__Link_Type', id: string, active: boolean, lastSyncedAt?: string | null, createdAt: string, endpoint: { __typename: 'flexpa__Endpoint_Type', displayName?: string | null, slug?: string | null }, imports?: Array<{ __typename: 'flexpa__FlexpaImport_Type', id: string, status: flexpa__FlexpaImportStatus }> | null }> | null, webAgentLinks?: Array<{ __typename: 'webAgent__Link_Type', id: string, active: boolean, createdAt: string, endpoint: { __typename: 'webAgent__Endpoint_Type', type: webAgent__EndpointType, displayName?: string | null, slug?: string | null }, latestExecution?: { __typename: 'webAgent__WebAgentExecution_Type', ingestions?: Array<{ __typename: 'ingestion__Ingestion_Type', status: ingestion__IngestionStatus }> | null } | null }> | null, explanationOfBenefits?: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string }> | null } | null };

export type GetEobsQueryV2QueryVariables = Exact<{
  inNetwork?: InputMaybe<Scalars['Boolean']['input']>;
  outOfNetwork?: InputMaybe<Scalars['Boolean']['input']>;
  denied?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEobsQueryV2Query = { __typename: 'Query', queryExplanationOfBenefitsV2?: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, title?: string | null, status: fhir__ExplanationOfBenefitStatus, created?: string | null, resourceId: string, billablePeriod?: string | null, serviceDate?: string | null, totalsByType?: { __typename: 'fhirext__ExplanationOfBenefitTotalsByType_Type', memberLiability?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null } | null, decision?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null, item?: Array<{ __typename: 'fhir__ExplanationOfBenefitItem_Type', id: string, productOrService?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null, display?: string | null }> | null } | null, reviewOutcome?: { __typename: 'fhir__ExplanationOfBenefitItemReviewOutcome_Type', decision?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null } | null, reason?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null } | null } | null }> | null, total?: Array<{ __typename: 'fhir__ExplanationOfBenefitTotal_Type', category: { __typename: 'fhir__CodeableConcept_Type', coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null }, amount: { __typename: 'fhir__Money_Type', currency?: string | null, value?: string | null } }> | null, patient?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, provider?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, facility?: { __typename: 'fhir__Reference_Type', display?: string | null } | null }> | null };

export type GetUserEobsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserEobsQuery = { __typename: 'Query', queryUserEobs: Array<{ __typename: 'UserHealthRecord', key: string, kind: string, data: string, enrichment?: string | null, updatedAt: Date }> };

export type GetUserInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInvoicesQuery = { __typename: 'Query', queryUserInvoices: Array<{ __typename: 'UserHealthRecord', key: string, kind: string, data: string, enrichment?: string | null, updatedAt: Date }> };

export type GetUserEobQueryVariables = Exact<{
  key: Scalars['ID']['input'];
}>;


export type GetUserEobQuery = { __typename: 'Query', queryUserEob?: { __typename: 'UserHealthRecord', key: string, kind: string, data: string, enrichment?: string | null, updatedAt: Date } | null };

export type GetUserInvoiceQueryVariables = Exact<{
  key: Scalars['ID']['input'];
}>;


export type GetUserInvoiceQuery = { __typename: 'Query', queryUserInvoice?: { __typename: 'UserHealthRecord', key: string, kind: string, data: string, enrichment?: string | null, updatedAt: Date } | null };

export type GetDocumentAnalysisEventStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDocumentAnalysisEventStatusQuery = { __typename: 'Query', issue__Event?: Array<{ __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', status: issue__DocumentAnalysisStatus, errorMessage?: string | null, errorIsRetriable?: boolean | null, id: string, document: { __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null } } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string }> | null };

export type RetryDocumentAnalysisForEventMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type RetryDocumentAnalysisForEventMutation = { __typename: 'Mutation', processDocumentForAnalysis: { __typename: 'ProcessDocumentForAnalysisResult', success: boolean, event?: { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, status: issue__DocumentAnalysisStatus, errorMessage?: string | null, errorIsRetriable?: boolean | null, document: { __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null } } | null } };

export type GetCompletedPostEscalationActionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetCompletedPostEscalationActionsQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, completedPostEscalationActions: Array<issue__PostEscalationActionType> }> | null };

export type GetIssueDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetIssueDetailsQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, title?: string | null, openedAt: string, closedAt?: string | null, additionalDetails?: string | null, caseType?: string | null, benefitsQuestionType?: string | null, billDisputeType?: string | null, benefitsInclude?: Array<string> | null, benefitsPrice?: string | null, benefitsCoverage?: string | null, userVisibleEvents?: Array<{ __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', eobId?: string | null, id: string, eob?: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, title?: string | null, status: fhir__ExplanationOfBenefitStatus, resourceId: string, billablePeriod?: string | null, serviceDate?: string | null, item?: Array<{ __typename: 'fhir__ExplanationOfBenefitItem_Type', productOrService?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null } | null }> | null, patient?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, provider?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, facility?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, decision?: { __typename: 'fhir__CodeableConcept_Type', id: string, text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', id: string, code?: string | null }> | null } | null, totalsByType?: { __typename: 'fhirext__ExplanationOfBenefitTotalsByType_Type', id: string, memberLiability?: { __typename: 'fhir__Money_Type', id: string, value?: string | null, currency?: string | null } | null } | null }> | null } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string }> | null, person?: { __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string } | null, documents?: Array<{ __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null, createdAt: string, files?: Array<{ __typename: 'document__File_Type', id: string, sizeBytes?: number | null, contentType?: string | null }> | null }> | null, benefitsContext?: { __typename: 'issue__BenefitsContext_Type', id: string, selectedPlan?: { __typename: 'plan__Plan_Type', id: string, planLabel?: string | null, planType?: plan__PlanType | null, isActive?: boolean | null, sbc?: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, sizeBytes?: number | null, contentType?: string | null }> | null } | null, coc?: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, sizeBytes?: number | null, contentType?: string | null }> | null } | null, spd?: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, sizeBytes?: number | null, contentType?: string | null }> | null } | null } | null } | null }> | null };

export type GetIssueQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  benefitsSummarySchemaVersion: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetIssueQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, title?: string | null, openedAt: string, closedAt?: string | null, caseType?: string | null, benefitsQuestionType?: string | null, billDisputeType?: string | null, additionalDetails?: string | null, benefitsInclude?: Array<string> | null, benefitsPrice?: string | null, isEscalated: boolean, completedPostEscalationActions: Array<issue__PostEscalationActionType>, hasStaffParticipant: boolean, benefitsCoverage?: string | null, userVisibleEvents?: Array<{ __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, userVisible?: boolean | null, plan: { __typename: 'plan__Plan_Type', id: string, planLabel?: string | null, link?: { __typename: 'webAgent__Link_Type', id: string, endpoint: { __typename: 'webAgent__Endpoint_Type', id: string, slug?: string | null } } | null, benefitsSummaryResults?: Array<{ __typename: 'plan__BenefitsSummaryResult_Type', id: string, summary: string }> | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillDisputeEvent_Type', eobId?: string | null, healthRecordKind?: string | null, healthRecordKey?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, eob?: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, resourceId: string, serviceDate?: string | null, provider?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, facility?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, decision?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null, findings?: Array<{ __typename: 'fhirext__Finding_Type', id: string, type: fhirext__FindingType }> | null }> | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPayRequestedEvent_Type', declinedAt?: string | null, availableMinimumDiscountOptions: Array<number>, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, billPayAcceptedAt?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaySuccessEvent_Type', negotiatedBillAmount: string, originalBillAmount: string, successFeeAmount: string, successFeePercent: number, totalCharged: string, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentRequestedEvent_Type', billPaid: boolean, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, billPaymentAcceptedAt?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', stripePaymentIntentId: string, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, billPaymentRequest: { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, feedback?: { __typename: 'feedback__IssueFeedback_Type', id: string, rating: number } | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null, successFee?: string | null, chargeDelayDays?: number | null, sentAt: string, chargeDate?: string | null, id: string, eventType: issue__EventType, participant: Participant, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CommentEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, endpointType: webAgent__EndpointType, buttonText: string, showSkipButton?: boolean | null, eventType: issue__EventType, participant: Participant, userVisible?: boolean | null, connectAccountMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, insuranceLinkMessage?: string | null, eventType: issue__EventType, participant: Participant, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentAnalysisEvent_Type', status: issue__DocumentAnalysisStatus, errorMessage?: string | null, errorIsRetriable?: boolean | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentUploadedEvent_Type', uploading?: boolean | null, uploadFailed?: boolean | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, document: { __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null, createdAt: string, latestIngestion?: { __typename: 'ingestion__Ingestion_Type', endedAt?: string | null, resources?: Array<{ __typename: 'fhirext__AccountVersion_Type', id: string } | { __typename: 'fhirext__CoverageVersion_Type', id: string } | { __typename: 'fhirext__EncounterVersion_Type', id: string } | { __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, eobTitle?: string | null } | { __typename: 'fhirext__InvoiceVersion_Type', id: string, invoiceTitle?: string | null } | { __typename: 'fhirext__PatientVersion_Type', id: string } | { __typename: 'fhirext__PractitionerVersion_Type', id: string }> | null } | null, files?: Array<{ __typename: 'document__File_Type', id: string, sizeBytes?: number | null, contentType?: string | null }> | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HAAssignedEvent_Type', assigneeAverageCaseRating?: number | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, assigneeProfile: { __typename: 'user__Profile_Type', name?: string | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, hipaaRelease: { __typename: 'consent__HipaaRelease_Type', id: string, name?: string | null, dateOfBirth?: string | null, createdAt: string, grantedAt?: string | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', userAccepted?: boolean | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, selectedPlan?: { __typename: 'plan__Plan_Type', id: string } | null, options?: Array<{ __typename: 'plan__Plan_Type', id: string, planLabel?: string | null }> | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actions?: Array<{ __typename: 'issue__BillPayPostEscalationAction_Type', isRequired: boolean, billPayLinkedEvent: { __typename: 'issue__BillPayRequestedEvent_Type', id: string, acceptedAt?: string | null, declinedAt?: string | null, availableMinimumDiscountOptions: Array<number> } } | { __typename: 'issue__ConnectEhrPostEscalationAction_Type', isRequired: boolean, ehrLinkedEvent: { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, endpointType: webAgent__EndpointType } } | { __typename: 'issue__ConnectInsurancePostEscalationAction_Type', isRequired: boolean, insLinkedEvent: { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, endpointType: webAgent__EndpointType } } | { __typename: 'issue__PaymentAgreementPostEscalationAction_Type', isRequired: boolean, payLinkedEvent: { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, userAccepted?: boolean | null } } | { __typename: 'issue__SignTemplatePostEscalationAction_Type', isRequired: boolean, signLinkedEvent: { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, release?: { __typename: 'consent__TemplateRelease_Type', id: string } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType, displayName: string } } } | { __typename: 'issue__UploadBillPostEscalationAction_Type', isRequired: boolean, uploadBillLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null } | { __typename: 'issue__UploadEobPostEscalationAction_Type', isRequired: boolean, uploadEobLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null } | { __typename: 'issue__UploadMemberIdPostEscalationAction_Type', isRequired: boolean, uploadMemberIdLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null }> | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ReopenedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, release?: { __typename: 'consent__TemplateRelease_Type', id: string, createdAt: string, grantedAt?: string | null } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType, displayName: string, description: string }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, multiMessage?: string | null, multiOptions: Array<string>, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, stringMessage?: string | null, stringOptions: Array<string>, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null }> | null, lastEvent?: { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', acceptedAt?: string | null, billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null, successFee?: string | null, chargeDelayDays?: number | null, sentAt: string, id: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', status: issue__DocumentAnalysisStatus, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | null, lastNonUserEvent?: { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, participant: Participant } | { __typename: 'issue__ChatEvent_Type', id: string, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, participant: Participant } | null, firstUnseenEvent?: { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', acceptedAt?: string | null, billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | null }> | null, me?: { __typename: 'User_Type', id: string, webAgentLinks?: Array<{ __typename: 'webAgent__Link_Type', id: string, endpoint: { __typename: 'webAgent__Endpoint_Type', type: webAgent__EndpointType }, executions?: Array<{ __typename: 'webAgent__WebAgentExecution_Type', id: string, createdAt: string, signInSucceededAt?: string | null, latestStatus?: webAgent__WebExecutionStatus | null, endpoint?: { __typename: 'flexpa__Endpoint_Type' } | { __typename: 'webAgent__Endpoint_Type', type: webAgent__EndpointType } | null }> | null }> | null } | null };

export type SendMessageMutationVariables = Exact<{
  input: CreateIssueChatEventInput;
  userId: Scalars['ID']['input'];
}>;


export type SendMessageMutation = { __typename: 'Mutation', createIssueChatEvent?: { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | null };

export type MarkIssueAsSeenMutationVariables = Exact<{
  input: UpdateIssueInput;
}>;


export type MarkIssueAsSeenMutation = { __typename: 'Mutation', updateIssue?: { __typename: 'issue__Issue_Type', id: string } | null };

export type selectPlanForEventMutationVariables = Exact<{
  input: SelectPlanForEventInput;
}>;


export type selectPlanForEventMutation = { __typename: 'Mutation', selectPlanForEvent?: { __typename: 'issue__PlanSelectionEvent_Type', id: string } | null };

export type RecordIssueChatEventFeedbackMutationVariables = Exact<{
  input: RecordIssueEventFeedbackInput;
}>;


export type RecordIssueChatEventFeedbackMutation = { __typename: 'Mutation', recordIssueEventFeedback: { __typename: 'CreateFeedbackResult', success: boolean } };

export type ConversationEventsSubscriptionVariables = Exact<{
  issueId: Scalars['String']['input'];
}>;


export type ConversationEventsSubscription = { __typename: 'Subscription', conversationEvents: { __typename: 'ConversationSubscriptionEvent', type: ConversationEventType, turnId: string, token?: string | null, error?: string | null, toolName?: string | null } };

export type GetChatEventFeedbackOptionsQueryVariables = Exact<{
  area: feedback__AreaType;
}>;


export type GetChatEventFeedbackOptionsQuery = { __typename: 'Query', feedback__Option?: Array<{ __typename: 'feedback__Option_Type', id: string, value: string, sentiment: feedback__SentimentType }> | null };

export type QueryIssuesV2QueryVariables = Exact<{
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
}>;


export type QueryIssuesV2Query = { __typename: 'Query', queryIssuesV2?: Array<{ __typename: 'issue__Issue_Type', id: string, title?: string | null, openedAt: string, closedAt?: string | null, lastEvent?: { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', acceptedAt?: string | null, billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', insuranceLinkMessage?: string | null, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, multiMessage?: string | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, stringMessage?: string | null } | null, firstUnseenEvent?: { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', acceptedAt?: string | null, billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', insuranceLinkMessage?: string | null, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, multiMessage?: string | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, stringMessage?: string | null } | null }> | null };

export type OpenNewIssueFromPreviewMutationVariables = Exact<{
  input: OpenNewIssueFromPreviewInput;
  benefitsSummarySchemaVersion?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
}>;


export type OpenNewIssueFromPreviewMutation = { __typename: 'Mutation', openNewIssueFromPreview?: { __typename: 'issue__Issue_Type', id: string, title?: string | null, openedAt: string, closedAt?: string | null, caseType?: string | null, benefitsQuestionType?: string | null, billDisputeType?: string | null, additionalDetails?: string | null, benefitsInclude?: Array<string> | null, benefitsPrice?: string | null, benefitsCoverage?: string | null, isEscalated: boolean, completedPostEscalationActions: Array<issue__PostEscalationActionType>, hasStaffParticipant: boolean, userVisibleEvents?: Array<{ __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, userVisible?: boolean | null, plan: { __typename: 'plan__Plan_Type', id: string, planLabel?: string | null, link?: { __typename: 'webAgent__Link_Type', id: string, endpoint: { __typename: 'webAgent__Endpoint_Type', id: string, slug?: string | null } } | null, benefitsSummaryResults?: Array<{ __typename: 'plan__BenefitsSummaryResult_Type', id: string, summary: string }> | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillDisputeEvent_Type', eobId?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, eob?: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, resourceId: string, serviceDate?: string | null, provider?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, facility?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, decision?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null, findings?: Array<{ __typename: 'fhirext__Finding_Type', id: string, type: fhirext__FindingType }> | null }> | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPayRequestedEvent_Type', declinedAt?: string | null, availableMinimumDiscountOptions: Array<number>, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, billPayAcceptedAt?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaySuccessEvent_Type', negotiatedBillAmount: string, originalBillAmount: string, successFeeAmount: string, totalCharged: string, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentRequestedEvent_Type', billPaid: boolean, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, billPaymentAcceptedAt?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', stripePaymentIntentId: string, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, billPaymentRequest: { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, feedback?: { __typename: 'feedback__IssueFeedback_Type', id: string, rating: number } | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null, successFee?: string | null, chargeDelayDays?: number | null, sentAt: string, chargeDate?: string | null, id: string, eventType: issue__EventType, participant: Participant, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CommentEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, endpointType: webAgent__EndpointType, buttonText: string, showSkipButton?: boolean | null, eventType: issue__EventType, participant: Participant, userVisible?: boolean | null, connectAccountMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, insuranceLinkMessage?: string | null, eventType: issue__EventType, participant: Participant, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentAnalysisEvent_Type', status: issue__DocumentAnalysisStatus, errorMessage?: string | null, errorIsRetriable?: boolean | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, document: { __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null, createdAt: string, latestIngestion?: { __typename: 'ingestion__Ingestion_Type', endedAt?: string | null, resources?: Array<{ __typename: 'fhirext__AccountVersion_Type', id: string } | { __typename: 'fhirext__CoverageVersion_Type', id: string } | { __typename: 'fhirext__EncounterVersion_Type', id: string } | { __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, eobTitle?: string | null } | { __typename: 'fhirext__InvoiceVersion_Type', id: string, invoiceTitle?: string | null } | { __typename: 'fhirext__PatientVersion_Type', id: string } | { __typename: 'fhirext__PractitionerVersion_Type', id: string }> | null } | null, files?: Array<{ __typename: 'document__File_Type', id: string, sizeBytes?: number | null, contentType?: string | null }> | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HAAssignedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, hipaaRelease: { __typename: 'consent__HipaaRelease_Type', id: string, name?: string | null, dateOfBirth?: string | null, createdAt: string, grantedAt?: string | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', userAccepted?: boolean | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, selectedPlan?: { __typename: 'plan__Plan_Type', id: string } | null, options?: Array<{ __typename: 'plan__Plan_Type', id: string, planLabel?: string | null }> | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actions?: Array<{ __typename: 'issue__BillPayPostEscalationAction_Type', isRequired: boolean, billPayLinkedEvent: { __typename: 'issue__BillPayRequestedEvent_Type', id: string, acceptedAt?: string | null, declinedAt?: string | null, availableMinimumDiscountOptions: Array<number> } } | { __typename: 'issue__ConnectEhrPostEscalationAction_Type', isRequired: boolean, ehrLinkedEvent: { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, endpointType: webAgent__EndpointType } } | { __typename: 'issue__ConnectInsurancePostEscalationAction_Type', isRequired: boolean, insLinkedEvent: { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, endpointType: webAgent__EndpointType } } | { __typename: 'issue__PaymentAgreementPostEscalationAction_Type', isRequired: boolean, payLinkedEvent: { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, userAccepted?: boolean | null } } | { __typename: 'issue__SignTemplatePostEscalationAction_Type', isRequired: boolean, signLinkedEvent: { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, release?: { __typename: 'consent__TemplateRelease_Type', id: string } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType, displayName: string, description: string } } } | { __typename: 'issue__UploadBillPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__UploadEobPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__UploadMemberIdPostEscalationAction_Type', isRequired: boolean }> | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ReopenedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, release?: { __typename: 'consent__TemplateRelease_Type', id: string, createdAt: string, grantedAt?: string | null } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType, displayName: string, description: string }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, message?: string | null, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, stringOptions: Array<string>, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null }> | null, lastEvent?: { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', acceptedAt?: string | null, billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null, successFee?: string | null, chargeDelayDays?: number | null, sentAt: string, id: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', status: issue__DocumentAnalysisStatus, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | null, lastNonUserEvent?: { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, participant: Participant } | { __typename: 'issue__ChatEvent_Type', id: string, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, participant: Participant } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, participant: Participant } | null, firstUnseenEvent?: { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', acceptedAt?: string | null, billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | null } | null };

export type GetFileIdsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFileIdsQuery = { __typename: 'Query', document__Document?: Array<{ __typename: 'document__Document_Type', id: string, files?: Array<{ __typename: 'document__File_Type', id: string, name: string, contentType?: string | null }> | null }> | null };

export type getFeedbackOptionsQueryVariables = Exact<{
  area: feedback__AreaType;
}>;


export type getFeedbackOptionsQuery = { __typename: 'Query', feedback__Option?: Array<{ __typename: 'feedback__Option_Type', sentiment: feedback__SentimentType, value: string, id: string }> | null };

export type CreateIssueFeedbackMutationVariables = Exact<{
  input: CreateIssueFeedbackInput;
}>;


export type CreateIssueFeedbackMutation = { __typename: 'Mutation', createIssueFeedback: { __typename: 'CreateFeedbackResult', success: boolean } };

export type CheckInsuranceLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckInsuranceLinksQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, flexpaLinks?: Array<{ __typename: 'flexpa__Link_Type', id: string, active: boolean }> | null, webAgentLinks?: Array<{ __typename: 'webAgent__Link_Type', id: string, active: boolean }> | null } | null };

export type GetWelcomePromptsQueryVariables = Exact<{
  benefitsSummaryCaseType: Scalars['String']['input'];
}>;


export type GetWelcomePromptsQuery = { __typename: 'Query', getWelcomePrompts: Array<{ __typename: 'WelcomePrompt', type: WelcomePromptType, completed: boolean }>, mostRecentBenefitsSummaryCase?: { __typename: 'User_Type', issues?: Array<{ __typename: 'issue__Issue_Type', id: string }> | null } | null };

export type GetPersonalizedPromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonalizedPromptsQuery = { __typename: 'Query', getPersonalizedPrompts: { __typename: 'GetPersonalizedPromptsResponse', prompts: Array<{ __typename: 'PersonalizedPrompt', id: string, text: string, response: string, caseType: string }> } };

export type GetIssuesWithActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIssuesWithActionsQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, issues?: Array<{ __typename: 'issue__Issue_Type', id: string, title?: string | null, openedAt: string, caseType?: string | null, actions?: Array<{ __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__BillDisputeEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__ChatEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__ClosedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__CommentEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__HAAssignedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__ReopenedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean }> | null }> | null } | null };

export type MostRecentIssueWithClosedEventWithoutFeedbackQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type MostRecentIssueWithClosedEventWithoutFeedbackQuery = { __typename: 'Query', issue__ClosedEvent?: Array<{ __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, openedAt: string, caseType?: string | null, dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null } }> | null };

export type ShowWelcomeScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type ShowWelcomeScreenQuery = { __typename: 'Query', showWelcomeScreen: boolean };

export type MergePersonsMutationVariables = Exact<{
  input: MergePersonsInput;
}>;


export type MergePersonsMutation = { __typename: 'Mutation', mergePersons?: { __typename: 'FormError', message?: string | null, fields?: Array<{ __typename: 'FieldError', path: string, message: string }> | null } | { __typename: 'Person_Type', id: string } | null };

export type CreatePersonMutationVariables = Exact<{
  input: CreatePersonInput;
}>;


export type CreatePersonMutation = { __typename: 'Mutation', createPerson?: { __typename: 'FormError', message?: string | null, fields?: Array<{ __typename: 'FieldError', message: string, path: string }> | null } | { __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string, primary: boolean } | null };

export type UpdatePersonFormMutationVariables = Exact<{
  input: UpdatePersonInput;
}>;


export type UpdatePersonFormMutation = { __typename: 'Mutation', updatePerson?: { __typename: 'FormError', message?: string | null, fields?: Array<{ __typename: 'FieldError', message: string, path: string }> | null } | { __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string, primary: boolean } | null };

export type CheckPersonMatchMutationVariables = Exact<{
  input: CheckPersonMatchInput;
}>;


export type CheckPersonMatchMutation = { __typename: 'Mutation', checkPersonMatch?: { __typename: 'FormError', message?: string | null, fields?: Array<{ __typename: 'FieldError', message: string, path: string }> | null } | { __typename: 'NoMatchingPerson' } | { __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string, primary: boolean, phoneNumber?: string | null, emailAddress?: string | null, addresses?: Array<{ __typename: 'person__Address_Type', id: string, street: string, city: string, state: string, zip: string, primary: boolean }> | null } | null };

export type GetPersonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonsQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, persons?: Array<{ __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string, primary: boolean, phoneNumber?: string | null, emailAddress?: string | null, addresses?: Array<{ __typename: 'person__Address_Type', id: string, street: string, street2?: string | null, city: string, state: string, zip: string, primary: boolean }> | null }> | null } | null };

export type GetPersonQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPersonQuery = { __typename: 'Query', Person?: Array<{ __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string, phoneNumber?: string | null, emailAddress?: string | null, primary: boolean, addresses?: Array<{ __typename: 'person__Address_Type', id: string, street: string, city: string, state: string, zip: string, primary: boolean }> | null }> | null };

export type GetSignedHipaaReleaseQueryVariables = Exact<{
  templateReleaseId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSignedHipaaReleaseQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, templateReleases?: Array<{ __typename: 'consent__TemplateRelease_Type', id: string, grantedAt?: string | null, document: { __typename: 'document__Document_Type', id: string, template?: { __typename: 'document__Template_Type', id: string, displayName: string, default: boolean, organization?: { __typename: 'integration__Organization_Type', slug?: string | null } | null } | null } }> | null } | null };

export type ViewReleaseDocumentQueryVariables = Exact<{
  input: ViewDocumentInput;
}>;


export type ViewReleaseDocumentQuery = { __typename: 'Query', viewDocument: { __typename: 'ViewDocumentResult', documentId: string, documentUrl: string } };

export type InitiateAccountDeletionV2MutationVariables = Exact<{ [key: string]: never; }>;


export type InitiateAccountDeletionV2Mutation = { __typename: 'Mutation', initiateAccountDeletionV2: { __typename: 'AccountDeletionFailure', error: AccountDeletionError } | { __typename: 'AccountDeletionSuccess', userId: string } };

export type GetUserPaymentsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUserPaymentsQuery = { __typename: 'Query', payment__PaymentTransaction?: Array<{ __typename: 'payment__PaymentTransaction_Type', id: string, amount: string, currency: string, stripePaymentIntentId?: string | null, stripeReceiptUrl?: string | null, status: payment__PaymentStatus, createdAt: string, issue?: { __typename: 'issue__Issue_Type', id: string, title?: string | null } | null }> | null, getPaymentProfile?: { __typename: 'PaymentProfile', id: string, hasPaymentMethod: boolean } | null };

export type GetReleasesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReleasesQuery = { __typename: 'Query', me?: { __typename: 'User_Type', templateReleases?: Array<{ __typename: 'consent__TemplateRelease_Type', id: string, grantedAt?: string | null, template: { __typename: 'document__Template_Type', id: string, displayName: string, default: boolean, organization?: { __typename: 'integration__Organization_Type', id: string, slug?: string | null } | null } }> | null } | null, document__Template?: Array<{ __typename: 'document__Template_Type', id: string, displayName: string }> | null };


export const AddressAutocompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AddressAutocomplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressAutocompleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressAutocomplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"predictions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainText"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryText"}},{"kind":"Field","name":{"kind":"Name","value":"types"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<AddressAutocompleteQuery, AddressAutocompleteQueryVariables>;
export const AddressDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AddressDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]} as unknown as DocumentNode<AddressDetailsQuery, AddressDetailsQueryVariables>;
export const PrimaryPersonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PrimaryPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}}]}}]}}]}}]} as unknown as DocumentNode<PrimaryPersonQuery, PrimaryPersonQueryVariables>;
export const getPaymentProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPaymentProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPaymentProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasPaymentMethod"}}]}}]}}]} as unknown as DocumentNode<getPaymentProfileQuery, getPaymentProfileQueryVariables>;
export const AcceptBillPaymentEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptBillPaymentEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcceptBillPaymentEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptBillPaymentEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AcceptBillPaymentEventMutation, AcceptBillPaymentEventMutationVariables>;
export const GetPaymentProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPaymentProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPaymentProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"stripePaymentMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"hasPaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodType"}},{"kind":"Field","name":{"kind":"Name","value":"cardDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"walletType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]} as unknown as DocumentNode<GetPaymentProfileQuery, GetPaymentProfileQueryVariables>;
export const UpdatePaymentAgreementEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePaymentAgreementEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePaymentAgreementEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePaymentAgreementEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePaymentAgreementEventMutation, UpdatePaymentAgreementEventMutationVariables>;
export const AcceptBillPayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptBillPay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcceptBillPayInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptBillPay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AcceptBillPayMutation, AcceptBillPayMutationVariables>;
export const ApplyPromoCodeUsageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApplyPromoCodeUsage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApplyPromoCodeUsageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applyPromoCodeUsage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ApplyPromoCodeUsageSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promoCodeUsage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"promoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ApplyPromoCodeUsageMutation, ApplyPromoCodeUsageMutationVariables>;
export const MarkPromoCodeUsageAsUnusedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkPromoCodeUsageAsUnused"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkPromoCodeUsageAsUnusedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markPromoCodeUsageAsUnused"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promoCodeUsage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"promoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAt"}}]}}]}}]}}]} as unknown as DocumentNode<MarkPromoCodeUsageAsUnusedMutation, MarkPromoCodeUsageAsUnusedMutationVariables>;
export const SendMagicLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendMagicLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendMagicLinkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMagicLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SendMagicLinkResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isShadow"}},{"kind":"Field","name":{"kind":"Name","value":"adminUserId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SendMagicLinkMutation, SendMagicLinkMutationVariables>;
export const ResendMagicLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendMagicLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResendMagicLinkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendMagicLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ResendMagicLinkMutation, ResendMagicLinkMutationVariables>;
export const AuthenticateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Authenticate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthenticateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthenticateSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"firstAuthentication"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isShadow"}},{"kind":"Field","name":{"kind":"Name","value":"adminUserId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthenticateError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errorType"}}]}}]}}]}}]} as unknown as DocumentNode<AuthenticateMutation, AuthenticateMutationVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const ShadowLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShadowLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShadowLoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shadowLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isShadow"}},{"kind":"Field","name":{"kind":"Name","value":"adminUserId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ShadowLoginMutation, ShadowLoginMutationVariables>;
export const ProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastAuthenticatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"segmentationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"features"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileQuery, ProfileQueryVariables>;
export const ClientSupportedVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientSupportedVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSupportedVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportedClientVersion"}},{"kind":"Field","name":{"kind":"Name","value":"supportedClientUpdateId"}},{"kind":"Field","name":{"kind":"Name","value":"latestClientVersion"}}]}}]}}]} as unknown as DocumentNode<ClientSupportedVersionQuery, ClientSupportedVersionQueryVariables>;
export const InsuranceLinkAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsuranceLinkAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrackInsuranceLinkAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackInsuranceLinkAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<InsuranceLinkAttemptMutation, InsuranceLinkAttemptMutationVariables>;
export const GetTemplateReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTemplateRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetTemplateReleaseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTemplateRelease"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"templateOrgSlug"}},{"kind":"Field","name":{"kind":"Name","value":"templateOrgDisplayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"templateOrgLoginUrl"}},{"kind":"Field","name":{"kind":"Name","value":"templateOrgDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}},{"kind":"Field","name":{"kind":"Name","value":"templateFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"templateAdditionalSections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTemplateReleaseQuery, GetTemplateReleaseQueryVariables>;
export const CreateDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const FinalizeDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FinalizeDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeDocumentMutation, FinalizeDocumentMutationVariables>;
export const SignAndSaveTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignAndSaveTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignAndSaveTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signAndSaveTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SignAndSaveTemplateMutation, SignAndSaveTemplateMutationVariables>;
export const CreateSetupIntentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSetupIntent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSetupIntent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}}]}}]}}]} as unknown as DocumentNode<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;
export const CreateMultiFileDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMultiFileDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMultiFileDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMultiFileDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMultiFileDocumentMutation, CreateMultiFileDocumentMutationVariables>;
export const GetUnreadIssuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnreadIssues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstUnseenEvent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"closedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstUnseenEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUnreadIssuesQuery, GetUnreadIssuesQueryVariables>;
export const DirectLoginToInstitutionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectLoginToInstitution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginToInstitutionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directLoginToInstitution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoginSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"linkId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MfaRequired"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mfaOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityQuestionRequired"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"securityQuestions"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FailedLoginMaxReached"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signInUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RpaError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}},{"kind":"Field","alias":{"kind":"Name","value":"errorSignInUrl"},"name":{"kind":"Name","value":"signInUrl"}}]}}]}}]}}]} as unknown as DocumentNode<DirectLoginToInstitutionMutation, DirectLoginToInstitutionMutationVariables>;
export const DirectSubmitMfaCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectSubmitMfaCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitMfaCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directSubmitMfaCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoginSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"linkId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RpaError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}},{"kind":"Field","alias":{"kind":"Name","value":"errorSignInUrl"},"name":{"kind":"Name","value":"signInUrl"}}]}}]}}]}}]} as unknown as DocumentNode<DirectSubmitMfaCodeMutation, DirectSubmitMfaCodeMutationVariables>;
export const DirectRequestNewMfaCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectRequestNewMfaCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestNewMfaCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directRequestNewMfaCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectMfaMethodResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<DirectRequestNewMfaCodeMutation, DirectRequestNewMfaCodeMutationVariables>;
export const DirectSelectMfaMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectSelectMfaMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SelectMfaMethodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directSelectMfaMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectMfaMethodResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RpaError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}},{"kind":"Field","alias":{"kind":"Name","value":"errorSignInUrl"},"name":{"kind":"Name","value":"signInUrl"}}]}}]}}]}}]} as unknown as DocumentNode<DirectSelectMfaMethodMutation, DirectSelectMfaMethodMutationVariables>;
export const PlanDocumentsLoadingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlanDocumentsLoading"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"executionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAttemptStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"executionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataTypeProcessing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataTypeNotSupported"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitSummaryCreated"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PlanDocumentsLoadingQuery, PlanDocumentsLoadingQueryVariables>;
export const DirectSubmitSecurityAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectSubmitSecurityAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitSecurityAnswerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directSubmitSecurityAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoginSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"linkId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityQuestionRequired"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"securityQuestions"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RpaError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}},{"kind":"Field","alias":{"kind":"Name","value":"errorSignInUrl"},"name":{"kind":"Name","value":"signInUrl"}}]}}]}}]}}]} as unknown as DocumentNode<DirectSubmitSecurityAnswerMutation, DirectSubmitSecurityAnswerMutationVariables>;
export const CreateFlexpaLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFlexpaLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFlexpaLinkInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFlexpaLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateFlexpaLinkMutation, CreateFlexpaLinkMutationVariables>;
export const DirectStartLinkCreationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectStartLinkCreation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartLinkCreationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directStartLinkCreation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}}]}}]} as unknown as DocumentNode<DirectStartLinkCreationMutation, DirectStartLinkCreationMutationVariables>;
export const GetLinkEndpointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLinkEndpoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webAgent__Link"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"webAgent__Endpoint_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"cdpProvider"}},{"kind":"Field","name":{"kind":"Name","value":"loginUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isIngestionSupported"}},{"kind":"Field","name":{"kind":"Name","value":"isAuthenticationRequired"}},{"kind":"Field","name":{"kind":"Name","value":"planDocumentsDataLatency"}},{"kind":"Field","name":{"kind":"Name","value":"planDocumentsSupported"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLinkEndpointQuery, GetLinkEndpointQueryVariables>;
export const DirectStartRelinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectStartRelink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartLinkRelinkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directStartRelink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}}]}}]} as unknown as DocumentNode<DirectStartRelinkMutation, DirectStartRelinkMutationVariables>;
export const DirectAwaitLoginResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectAwaitLoginResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DirectAwaitLoginResultInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directAwaitLoginResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoginSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configureManagedMfa"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"linkId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MfaRequired"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mfaOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityQuestionRequired"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"securityQuestions"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FailedLoginMaxReached"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signInUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RpaError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}},{"kind":"Field","alias":{"kind":"Name","value":"errorSignInUrl"},"name":{"kind":"Name","value":"signInUrl"}}]}}]}}]}}]} as unknown as DocumentNode<DirectAwaitLoginResultMutation, DirectAwaitLoginResultMutationVariables>;
export const CheckBenefitsSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckBenefitsSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webAgent__Link"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsSummaryResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schemaVersion"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CheckBenefitsSummaryQuery, CheckBenefitsSummaryQueryVariables>;
export const GetInsuranceLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInsuranceLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flexpaLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"patientName"}},{"kind":"Field","name":{"kind":"Name","value":"patientDOB"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedReason"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"webAgentLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"patientName"}},{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"patientDOB"}},{"kind":"Field","name":{"kind":"Name","value":"latestExecution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ingestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"executions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ingestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"COMPLETED"},{"kind":"EnumValue","value":"PARTIAL"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedReason"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInsuranceLinksQuery, GetInsuranceLinksQueryVariables>;
export const GetWebAgentEndpointsP012Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWebAgentEndpointsP012"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webAgent__Endpoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currentSupportLevel"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"supportLevel"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"P0"},{"kind":"EnumValue","value":"P1"},{"kind":"EnumValue","value":"P2"}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isIngestionSupported"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"loginUrl"}},{"kind":"Field","name":{"kind":"Name","value":"portalGuideUrl"}},{"kind":"Field","name":{"kind":"Name","value":"currentSupportLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"planDocumentsDataLatency"}},{"kind":"Field","name":{"kind":"Name","value":"planDocumentsSupported"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<GetWebAgentEndpointsP012Query, GetWebAgentEndpointsP012QueryVariables>;
export const GetWebAgentEndpointsAllDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWebAgentEndpointsAll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webAgent__Endpoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isIngestionSupported"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"loginUrl"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"portalGuideUrl"}},{"kind":"Field","name":{"kind":"Name","value":"currentSupportLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planDocumentsDataLatency"}},{"kind":"Field","name":{"kind":"Name","value":"planDocumentsSupported"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<GetWebAgentEndpointsAllQuery, GetWebAgentEndpointsAllQueryVariables>;
export const GetFlexpaEndpointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFlexpaEndpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flexpa__Endpoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"flexpaId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<GetFlexpaEndpointsQuery, GetFlexpaEndpointsQueryVariables>;
export const GetUserIssuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserIssues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserIssuesQuery, GetUserIssuesQueryVariables>;
export const CheckAllInsuranceLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckAllInsuranceLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkAllInsuranceLinks"}}]}}]} as unknown as DocumentNode<CheckAllInsuranceLinksMutation, CheckAllInsuranceLinksMutationVariables>;
export const OpenBillDisputeIssueMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OpenBillDisputeIssueMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpenNewIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openNewIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<OpenBillDisputeIssueMutationMutation, OpenBillDisputeIssueMutationMutationVariables>;
export const GetBillPreviewEobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBillPreviewEob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eobId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eobId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstUnseenEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"explanationOfBenefits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resourceId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"network"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productOrService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"display"}},{"kind":"Field","name":{"kind":"Name","value":"system"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adjudication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewOutcome"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diagnosis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diagnosisCodeableConcept"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billablePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"serviceDate"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalsByType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coinsurance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deductible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberLiability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nonCovered"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eligible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paidByPatient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paidToPatient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"submitted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"findings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"explanation"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastReviewStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"ACCEPTED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userDismissed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"explanation"}},{"kind":"Field","name":{"kind":"Name","value":"userDismissed"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fairMarketValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"percentile50"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBillPreviewEobQuery, GetBillPreviewEobQueryVariables>;
export const GetFlaggedEobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFlaggedEobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryFlaggedExplanationOfBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"totalsByType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberLiability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productOrService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"display"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewOutcome"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billablePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceDate"}},{"kind":"Field","name":{"kind":"Name","value":"findings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"explanation"}},{"kind":"Field","name":{"kind":"Name","value":"userDismissed"}},{"kind":"Field","name":{"kind":"Name","value":"lastReviewStatus"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}}]}}]} as unknown as DocumentNode<GetFlaggedEobsQuery, GetFlaggedEobsQueryVariables>;
export const GetFlaggedEobsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFlaggedEobsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countFlaggedExplanationOfBenefits"}}]}}]} as unknown as DocumentNode<GetFlaggedEobsCountQuery, GetFlaggedEobsCountQueryVariables>;
export const GetInsuranceLinkStatusQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInsuranceLinkStatusQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flexpaLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"webAgentLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestExecution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ingestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"explanationOfBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetInsuranceLinkStatusQueryQuery, GetInsuranceLinkStatusQueryQueryVariables>;
export const GetEobsQueryV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEobsQueryV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inNetwork"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"outOfNetwork"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"denied"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryExplanationOfBenefitsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inNetwork"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inNetwork"}}},{"kind":"Argument","name":{"kind":"Name","value":"outOfNetwork"},"value":{"kind":"Variable","name":{"kind":"Name","value":"outOfNetwork"}}},{"kind":"Argument","name":{"kind":"Name","value":"denied"},"value":{"kind":"Variable","name":{"kind":"Name","value":"denied"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"totalsByType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberLiability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productOrService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"display"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewOutcome"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billablePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceDate"}}]}}]}}]} as unknown as DocumentNode<GetEobsQueryV2Query, GetEobsQueryV2QueryVariables>;
export const GetUserEobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserEobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryUserEobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"enrichment"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetUserEobsQuery, GetUserEobsQueryVariables>;
export const GetUserInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryUserInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"enrichment"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetUserInvoicesQuery, GetUserInvoicesQueryVariables>;
export const GetUserEobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserEob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryUserEob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"enrichment"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetUserEobQuery, GetUserEobQueryVariables>;
export const GetUserInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryUserInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"enrichment"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetUserInvoiceQuery, GetUserInvoiceQueryVariables>;
export const GetDocumentAnalysisEventStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocumentAnalysisEventStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"errorIsRetriable"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentAnalysisEventStatusQuery, GetDocumentAnalysisEventStatusQueryVariables>;
export const RetryDocumentAnalysisForEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetryDocumentAnalysisForEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processDocumentForAnalysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isRetry"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"errorIsRetriable"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RetryDocumentAnalysisForEventMutation, RetryDocumentAnalysisForEventMutationVariables>;
export const GetCompletedPostEscalationActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompletedPostEscalationActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedPostEscalationActions"}}]}}]}}]} as unknown as DocumentNode<GetCompletedPostEscalationActionsQuery, GetCompletedPostEscalationActionsQueryVariables>;
export const GetIssueDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIssueDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDetails"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsQuestionType"}},{"kind":"Field","name":{"kind":"Name","value":"billDisputeType"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsInclude"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsPrice"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"userVisibleEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"BILL_DISPUTE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillDisputeEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eobId"}},{"kind":"Field","name":{"kind":"Name","value":"eob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productOrService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billablePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceDate"}},{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalsByType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberLiability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsContext"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"selectedPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}},{"kind":"Field","name":{"kind":"Name","value":"planType"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"sbc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"spd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetIssueDetailsQuery, GetIssueDetailsQueryVariables>;
export const GetIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsQuestionType"}},{"kind":"Field","name":{"kind":"Name","value":"billDisputeType"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDetails"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsInclude"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isEscalated"}},{"kind":"Field","name":{"kind":"Name","value":"completedPostEscalationActions"}},{"kind":"Field","name":{"kind":"Name","value":"hasStaffParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"userVisibleEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"sentByProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentUploadedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploading"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"uploadFailed"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestIngestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isLatest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fhirext__InvoiceVersion_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"invoiceTitle"},"name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fhirext__ExplanationOfBenefitVersion_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"eobTitle"},"name":{"kind":"Name","value":"title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HipaaReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hipaaRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillDisputeEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eobId"}},{"kind":"Field","name":{"kind":"Name","value":"healthRecordKind"}},{"kind":"Field","name":{"kind":"Name","value":"healthRecordKey"}},{"kind":"Field","name":{"kind":"Name","value":"eob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceDate"}},{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"findings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"explanation"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastReviewStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"ACCEPTED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userDismissed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentAgreementRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccepted"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosurePaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFee"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDelayDays"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDate"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BenefitsSummaryGeneratedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsSummaryResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaVersion"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PlanSelectionEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"selectedPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"stringMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","alias":{"kind":"Name","value":"stringOptions"},"name":{"kind":"Name","value":"options"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserMultiSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"multiMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","alias":{"kind":"Name","value":"multiOptions"},"name":{"kind":"Name","value":"options"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsuranceRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceLinkMessage"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectAccountRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","alias":{"kind":"Name","value":"connectAccountMessage"},"name":{"kind":"Name","value":"chatBody"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"showSkipButton"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPayRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPayAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"availableMinimumDiscountOptions"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaySuccessEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiatedBillAmount"}},{"kind":"Field","name":{"kind":"Name","value":"originalBillAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFeeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFeePercent"}},{"kind":"Field","name":{"kind":"Name","value":"totalCharged"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentSuccessEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripePaymentIntentId"}},{"kind":"Field","name":{"kind":"Name","value":"billPaymentRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"errorIsRetriable"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HAAssignedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assigneeProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assigneeAverageCaseRating"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PostEscalationActionsEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isRequired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadBillPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadBillLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadEobPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadEobLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadMemberIdPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadMemberIdLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__SignTemplatePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"signLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentAgreementPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"payLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAccepted"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPayPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPayLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"availableMinimumDiscountOptions"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsurancePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"insLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectEhrPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ehrLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosurePaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFee"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDelayDays"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastNonUserEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstUnseenEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"webAgentLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"webAgent__Endpoint_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"executions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"signInSucceededAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"webAgent__Endpoint_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetIssueQuery, GetIssueQueryVariables>;
export const SendMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueChatEventInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssueChatEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"sentByProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}}]}}]}}]} as unknown as DocumentNode<SendMessageMutation, SendMessageMutationVariables>;
export const MarkIssueAsSeenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkIssueAsSeen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MarkIssueAsSeenMutation, MarkIssueAsSeenMutationVariables>;
export const selectPlanForEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"selectPlanForEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SelectPlanForEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectPlanForEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<selectPlanForEventMutation, selectPlanForEventMutationVariables>;
export const RecordIssueChatEventFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordIssueChatEventFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordIssueEventFeedbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordIssueEventFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RecordIssueChatEventFeedbackMutation, RecordIssueChatEventFeedbackMutationVariables>;
export const ConversationEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ConversationEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"turnId"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"toolName"}}]}}]}}]} as unknown as DocumentNode<ConversationEventsSubscription, ConversationEventsSubscriptionVariables>;
export const GetChatEventFeedbackOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChatEventFeedbackOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"area"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"feedback__AreaType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedback__Option"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"area"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"area"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"}}]}}]}}]} as unknown as DocumentNode<GetChatEventFeedbackOptionsQuery, GetChatEventFeedbackOptionsQueryVariables>;
export const QueryIssuesV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryIssuesV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"closed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unread"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"read"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"open"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryIssuesV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"closed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"closed"}}},{"kind":"Argument","name":{"kind":"Name","value":"unread"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unread"}}},{"kind":"Argument","name":{"kind":"Name","value":"read"},"value":{"kind":"Variable","name":{"kind":"Name","value":"read"}}},{"kind":"Argument","name":{"kind":"Name","value":"open"},"value":{"kind":"Variable","name":{"kind":"Name","value":"open"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsuranceRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceLinkMessage"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stringMessage"},"name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserMultiSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"multiMessage"},"name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstUnseenEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsuranceRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceLinkMessage"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stringMessage"},"name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserMultiSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"multiMessage"},"name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<QueryIssuesV2Query, QueryIssuesV2QueryVariables>;
export const OpenNewIssueFromPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OpenNewIssueFromPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpenNewIssueFromPreviewInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openNewIssueFromPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsQuestionType"}},{"kind":"Field","name":{"kind":"Name","value":"billDisputeType"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDetails"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsInclude"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsPrice"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"isEscalated"}},{"kind":"Field","name":{"kind":"Name","value":"completedPostEscalationActions"}},{"kind":"Field","name":{"kind":"Name","value":"hasStaffParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"userVisibleEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"sentByProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPayRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPayAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"availableMinimumDiscountOptions"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaySuccessEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiatedBillAmount"}},{"kind":"Field","name":{"kind":"Name","value":"originalBillAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFeeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCharged"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentSuccessEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripePaymentIntentId"}},{"kind":"Field","name":{"kind":"Name","value":"billPaymentRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentUploadedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestIngestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isLatest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fhirext__InvoiceVersion_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"invoiceTitle"},"name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fhirext__ExplanationOfBenefitVersion_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"eobTitle"},"name":{"kind":"Name","value":"title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HipaaReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hipaaRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillDisputeEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eobId"}},{"kind":"Field","name":{"kind":"Name","value":"eob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceDate"}},{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"findings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"explanation"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastReviewStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"ACCEPTED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userDismissed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentAgreementRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccepted"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosurePaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFee"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDelayDays"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDate"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BenefitsSummaryGeneratedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsSummaryResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaVersion"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PlanSelectionEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"selectedPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","alias":{"kind":"Name","value":"stringOptions"},"name":{"kind":"Name","value":"options"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsuranceRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceLinkMessage"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectAccountRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","alias":{"kind":"Name","value":"connectAccountMessage"},"name":{"kind":"Name","value":"chatBody"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"showSkipButton"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"errorIsRetriable"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PostEscalationActionsEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__SignTemplatePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"signLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentAgreementPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"payLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userAccepted"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPayPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPayLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"availableMinimumDiscountOptions"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsurancePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"insLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectEhrPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ehrLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosurePaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFee"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDelayDays"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastNonUserEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstUnseenEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OpenNewIssueFromPreviewMutation, OpenNewIssueFromPreviewMutationVariables>;
export const GetFileIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFileIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document__Document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]} as unknown as DocumentNode<GetFileIdsQuery, GetFileIdsQueryVariables>;
export const getFeedbackOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFeedbackOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"area"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"feedback__AreaType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedback__Option"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"area"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"area"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sentiment"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<getFeedbackOptionsQuery, getFeedbackOptionsQueryVariables>;
export const CreateIssueFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateIssueFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueFeedbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssueFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateIssueFeedbackMutation, CreateIssueFeedbackMutationVariables>;
export const CheckInsuranceLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckInsuranceLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flexpaLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"webAgentLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]} as unknown as DocumentNode<CheckInsuranceLinksQuery, CheckInsuranceLinksQueryVariables>;
export const GetWelcomePromptsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWelcomePrompts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummaryCaseType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getWelcomePrompts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mostRecentBenefitsSummaryCase"},"name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"caseType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummaryCaseType"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"events"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"BENEFITS_SUMMARY_GENERATED"}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"openedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetWelcomePromptsQuery, GetWelcomePromptsQueryVariables>;
export const GetPersonalizedPromptsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPersonalizedPrompts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPersonalizedPrompts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prompts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"response"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}}]}}]}}]}}]} as unknown as DocumentNode<GetPersonalizedPromptsQuery, GetPersonalizedPromptsQueryVariables>;
export const GetIssuesWithActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIssuesWithActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasActions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"closedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetIssuesWithActionsQuery, GetIssuesWithActionsQueryVariables>;
export const MostRecentIssueWithClosedEventWithoutFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MostRecentIssueWithClosedEventWithoutFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__ClosedEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedback"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"closedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}}]}}]}}]}}]} as unknown as DocumentNode<MostRecentIssueWithClosedEventWithoutFeedbackQuery, MostRecentIssueWithClosedEventWithoutFeedbackQueryVariables>;
export const ShowWelcomeScreenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShowWelcomeScreen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showWelcomeScreen"}}]}}]} as unknown as DocumentNode<ShowWelcomeScreenQuery, ShowWelcomeScreenQueryVariables>;
export const MergePersonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MergePersons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MergePersonsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mergePersons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MergePersonsMutation, MergePersonsMutationVariables>;
export const CreatePersonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePersonInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPerson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreatePersonMutation, CreatePersonMutationVariables>;
export const UpdatePersonFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePersonForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePersonInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePerson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePersonFormMutation, UpdatePersonFormMutationVariables>;
export const CheckPersonMatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckPersonMatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPersonMatchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPersonMatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CheckPersonMatchMutation, CheckPersonMatchMutationVariables>;
export const GetPersonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPersons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"persons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPersonsQuery, GetPersonsQueryVariables>;
export const GetPersonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Person"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]}}]} as unknown as DocumentNode<GetPersonQuery, GetPersonQueryVariables>;
export const GetSignedHipaaReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSignedHipaaRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateReleaseId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateReleases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateReleaseId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSignedHipaaReleaseQuery, GetSignedHipaaReleaseQueryVariables>;
export const ViewReleaseDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewReleaseDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}}]}}]}}]} as unknown as DocumentNode<ViewReleaseDocumentQuery, ViewReleaseDocumentQueryVariables>;
export const InitiateAccountDeletionV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitiateAccountDeletionV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiateAccountDeletionV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountDeletionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountDeletionFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<InitiateAccountDeletionV2Mutation, InitiateAccountDeletionV2MutationVariables>;
export const GetUserPaymentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserPayments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment__PaymentTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"stripePaymentIntentId"}},{"kind":"Field","name":{"kind":"Name","value":"stripeReceiptUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getPaymentProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasPaymentMethod"}}]}}]}}]} as unknown as DocumentNode<GetUserPaymentsQuery, GetUserPaymentsQueryVariables>;
export const GetReleasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReleases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateReleases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"document__Template"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"default"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"templateType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"HIPAA_RELEASE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<GetReleasesQuery, GetReleasesQueryVariables>;